
(function () {
  'use strict';

  (function () {
    if (document.getElementById('rdAlphaClean')) return;
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    host.innerHTML = '<svg width="0" height="0"><filter id="rdAlphaClean"><feComponentTransfer><feFuncA type="linear" slope="1.08" intercept="-0.045"/></feComponentTransfer></filter></svg>';
    (document.body || document.documentElement).appendChild(host);
  })();

  var VARIANT_MAP = {
    'canvas|0|0|0': 'canvas',
    'sem moldura|0|0|0': 'sem moldura',
    'padrão|0|0|0': 'padrão',
    'padrão|0|0|1': 'padrão com paspatur',
    'padrão|1|0|0': 'caixa',
    'padrão|1|0|1': 'caixa com paspatur',
    'padrão|0|1|0': 'slim',
    'padrão|0|1|1': 'slim com paspatur',
  };

  var MOLD_BY_SIZE = null;

  var PRICE_BY_SIZE = null;
  function loadMoldBySize(cb) {
    if (MOLD_BY_SIZE) { if (cb) cb(); return; }
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { MOLD_BY_SIZE = {}; PRICE_BY_SIZE = {}; if (cb) cb(); return; }
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var names = (p.options || []).map(function (o) { return (o && o.name) || o; });
        var molPos = names.findIndex(function (n) { return /tipo de moldura/i.test(n); });
        var sizePos = names.findIndex(function (n) { return /tamanho/i.test(n); });
        var map = {}, prices = {};
        if (molPos > -1 && sizePos > -1) {
          (p.variants || []).forEach(function (v) {
            var mol = v.options[molPos], sz = v.options[sizePos];
            /* (16/out) preço-fantasma (zero ou R$ 9.999) = variante ainda não
               lançada; o 20x20 sem moldura nunca é vendido */
            if (!(v.price > 0) || v.price === 99999 || v.price >= 999900) return;
            if (String(sz).replace(/\s/g, '').toLowerCase() === '20x20' && mol === 'sem moldura') return;
            (map[sz] = map[sz] || {})[mol] = true;
            (prices[sz] = prices[sz] || {})[mol] = v.price;
          });
        }
        MOLD_BY_SIZE = map;
        PRICE_BY_SIZE = prices;
        if (cb) cb();
      })
      .catch(function () { MOLD_BY_SIZE = {}; PRICE_BY_SIZE = {}; if (cb) cb(); });
  }

  function setupFrameFallback() {
    document.addEventListener('error', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'IMG') return;
      var src = t.src || '';
      if (src.indexOf('/jun26-') === -1) return;
      if (t.dataset.jun26FallbackTried) return;
      t.dataset.jun26FallbackTried = '1';
      var next = src.replace('/jun26-', '/');

      t.src = next;
    }, true);
  }

  function setupColorTool() {
    var params = new URLSearchParams(location.search);
    if (!params.has('colortool')) return;
    var target = params.get('colortool') || '1';
    var matchSrc = target === '1' ? 'pinus' : target;
    function injectPanel() {
      if (document.getElementById('jun26-color-tool')) return;
      var imgs = document.querySelectorAll('img[src*="' + matchSrc + '"]');
      if (!imgs.length) return;
      var panel = document.createElement('div');
      panel.id = 'jun26-color-tool';
      panel.style.cssText = 'position:fixed;top:80px;right:20px;background:#fff;border:1px solid #111;padding:16px;z-index:9999;font:12px Archivo,system-ui,sans-serif;width:300px;box-shadow:0 8px 24px rgba(0,0,0,.15);border-radius:4px';
      panel.innerHTML = ''
        + '<div style="font-weight:600;margin-bottom:12px;letter-spacing:.05em;text-transform:uppercase">Ajuste cor moldura — ' + matchSrc + '</div>'
        + '<div style="margin-bottom:10px"><label>Hue (matiz): <span id="ct-h">0</span>°</label><input id="ct-hue" type="range" min="-60" max="60" value="0" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Saturação: <span id="ct-s">1.00</span></label><input id="ct-sat" type="range" min="0" max="200" value="100" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Brilho: <span id="ct-b">1.00</span></label><input id="ct-br" type="range" min="50" max="150" value="100" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Sépia: <span id="ct-sp">0</span></label><input id="ct-sep" type="range" min="0" max="100" value="0" style="width:100%"></div>'
        + '<button id="ct-close" style="position:absolute;top:8px;right:8px;width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:14px Archivo;color:#999;padding:0;line-height:1" aria-label="Ocultar">×</button>'
        + '<div style="display:flex;gap:6px;flex-wrap:wrap">'
        + '<button id="ct-reset" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo">RESET</button>'
        + '<button id="ct-export" style="padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo">COPIAR</button>'
        + '</div>'
        + '<div id="ct-out" style="margin-top:8px;font-family:monospace;font-size:10px;background:#f4f4f5;padding:6px;display:none;word-break:break-all"></div>';
      document.body.appendChild(panel);
      function curImgs() { return document.querySelectorAll('img[src*="' + matchSrc + '"]'); }
      function buildFilter() {
        var h = panel.querySelector('#ct-hue').value;
        var s = (panel.querySelector('#ct-sat').value / 100).toFixed(2);
        var b = (panel.querySelector('#ct-br').value / 100).toFixed(2);
        var sp = (panel.querySelector('#ct-sep').value / 100).toFixed(2);
        panel.querySelector('#ct-h').textContent = h;
        panel.querySelector('#ct-s').textContent = s;
        panel.querySelector('#ct-b').textContent = b;
        panel.querySelector('#ct-sp').textContent = sp;
        return 'hue-rotate(' + h + 'deg) saturate(' + s + ') brightness(' + b + ') sepia(' + sp + ')';
      }
      function apply() {
        var f = buildFilter();
        curImgs().forEach(function(i){ i.style.filter = f; });
        return f;
      }
      panel.querySelectorAll('input').forEach(function(i){ i.addEventListener('input', apply); });
      panel.querySelector('#ct-reset').onclick = function() {
        panel.querySelector('#ct-hue').value = 0;
        panel.querySelector('#ct-sat').value = 100;
        panel.querySelector('#ct-br').value = 100;
        panel.querySelector('#ct-sep').value = 0;
        curImgs().forEach(function(i){ i.style.filter = ''; });
        apply();
      };
      panel.querySelector('#ct-export').onclick = function() {
        var f = buildFilter();
        panel.querySelector('#ct-out').textContent = f;
        panel.querySelector('#ct-out').style.display = 'block';
        if (navigator.clipboard) navigator.clipboard.writeText(f);
      };

      panel.style.position = 'fixed';
      panel.querySelector('#ct-close').onclick = function() {
        panel.style.display = 'none';
        var open = document.getElementById('jun26-ct-reopen');
        if (!open) {
          open = document.createElement('button');
          open.id = 'jun26-ct-reopen';
          open.textContent = 'AJUSTAR COR';
          open.style.cssText = 'position:fixed;top:80px;right:20px;padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:9999;border-radius:0;box-shadow:0 4px 12px rgba(0,0,0,.15)';
          document.body.appendChild(open);
          open.onclick = function() {
            panel.style.display = '';
            open.remove();
          };
        }
      };
    }

    injectPanel();
    var mo = new MutationObserver(function(){
      if (!document.getElementById('jun26-color-tool')) injectPanel();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function setupRuler() {
    var params = new URLSearchParams(location.search);
    if (!params.has('ruler')) return;
    var STORAGE = 'jun26-ruler-state';
    function getState() {
      try { return JSON.parse(localStorage.getItem(STORAGE) || '{}'); }
      catch (e) { return {}; }
    }

    function pxToPct(translateStr) {
      var stage = document.querySelector('.pp26__perspective-stage');
      if (!stage) return translateStr || '0% 0%';
      var sw = stage.offsetWidth || 1;
      var sh = stage.offsetHeight || 1;
      var parts = (translateStr || '0px 0px').trim().split(/\s+/);
      var x = parseFloat(parts[0]) || 0;
      var y = parseFloat(parts[1]) || 0;

      if ((parts[0] || '').indexOf('%') > -1) return parts.join(' ');
      return (x / sw * 100).toFixed(3) + '% ' + (y / sh * 100).toFixed(3) + '%';
    }

    function pctToPx(translateStr) {
      var stage = document.querySelector('.pp26__perspective-stage');
      if (!stage) return translateStr || '0px 0px';
      var sw = stage.offsetWidth || 1;
      var sh = stage.offsetHeight || 1;
      var parts = (translateStr || '0% 0%').trim().split(/\s+/);
      var raw0 = parts[0] || '0';
      var raw1 = parts[1] || '0';
      var x, y;
      if (raw0.indexOf('%') > -1) x = parseFloat(raw0) / 100 * sw;
      else x = parseFloat(raw0) || 0;
      if (raw1.indexOf('%') > -1) y = parseFloat(raw1) / 100 * sh;
      else y = parseFloat(raw1) || 0;
      return Math.round(x) + 'px ' + Math.round(y) + 'px';
    }
    function setStateVal(k, v) {
      var s = getState(); s[k] = v;
      localStorage.setItem(STORAGE, JSON.stringify(s));
    }

    function makeDraggable(panel, headerEl, storageKey) {

      var st = getState();
      var pos = st.panelPos && st.panelPos[storageKey];
      if (pos) {
        panel.style.top = pos.top + 'px';
        panel.style.left = pos.left + 'px';
        panel.style.right = 'auto';
      }
      headerEl.style.cursor = 'move';
      headerEl.style.userSelect = 'none';
      var dragging = false, sx, sy, sLeft, sTop;
      headerEl.addEventListener('mousedown', function (e) {

        if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
        dragging = true;
        sx = e.clientX; sy = e.clientY;
        var rect = panel.getBoundingClientRect();
        sLeft = rect.left; sTop = rect.top;

        panel.style.right = 'auto';
        panel.style.bottom = 'auto';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var nLeft = sLeft + (e.clientX - sx);
        var nTop = sTop + (e.clientY - sy);

        nLeft = Math.max(0, Math.min(window.innerWidth - 100, nLeft));
        nTop = Math.max(0, Math.min(window.innerHeight - 50, nTop));
        panel.style.left = nLeft + 'px';
        panel.style.top = nTop + 'px';
      });
      document.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        var st = getState();
        st.panelPos = st.panelPos || {};
        st.panelPos[storageKey] = {
          top: parseInt(panel.style.top, 10),
          left: parseInt(panel.style.left, 10)
        };
        localStorage.setItem(STORAGE, JSON.stringify(st));
      });
    }
    function attempt() {
      var stage = document.querySelector('.pp26__perspective-stage');
      var frame = stage && stage.querySelector('.pp26__frame');
      var art = stage && stage.querySelector('.pp26__art');
      if (!stage || !frame || !art) { setTimeout(attempt, 200); return; }
      injectGrid(stage);
      injectFrameInteractions(stage, frame);
      injectArtWarpHandles(stage, art);
      injectPanel(stage, art);
      hookJun26Checkboxes(frame);
    }

    function hookJun26Checkboxes(frame) { return setupHiddenVariantSim(frame); }

    function computeMatrix3d(w, h, dst) {
      function sysSolve(A, b) {

        var n = 8;
        for (var i = 0; i < n; i++) {
          var maxRow = i;
          for (var k = i + 1; k < n; k++) if (Math.abs(A[k][i]) > Math.abs(A[maxRow][i])) maxRow = k;
          var tmp = A[i]; A[i] = A[maxRow]; A[maxRow] = tmp;
          var tb = b[i]; b[i] = b[maxRow]; b[maxRow] = tb;
          for (var k2 = i + 1; k2 < n; k2++) {
            var f = A[k2][i] / A[i][i];
            for (var j = i; j < n; j++) A[k2][j] -= f * A[i][j];
            b[k2] -= f * b[i];
          }
        }
        var x = new Array(n);
        for (var i2 = n - 1; i2 >= 0; i2--) {
          var s = b[i2];
          for (var j2 = i2 + 1; j2 < n; j2++) s -= A[i2][j2] * x[j2];
          x[i2] = s / A[i2][i2];
        }
        return x;
      }
      var srcs = [[0, 0], [w, 0], [w, h], [0, h]];
      var A = [], b = [];
      for (var i = 0; i < 4; i++) {
        var sx = srcs[i][0], sy = srcs[i][1], dx = dst[i][0], dy = dst[i][1];
        A.push([sx, sy, 1, 0, 0, 0, -sx * dx, -sy * dx]);
        b.push(dx);
        A.push([0, 0, 0, sx, sy, 1, -sx * dy, -sy * dy]);
        b.push(dy);
      }
      var p = sysSolve(A, b);

      return [
        p[0], p[3], 0, p[6],
        p[1], p[4], 0, p[7],
        0,    0,    1, 0,
        p[2], p[5], 0, 1
      ];
    }

    function applyWarp(art, corners) {

      art.style.objectFit = 'fill';
      var w = art.offsetWidth || 100;
      var h = art.offsetHeight || 100;
      var m = computeMatrix3d(w, h, corners);
      art.style.transformOrigin = '0 0';
      art.style.transform = 'matrix3d(' + m.join(',') + ')';
      art.style.position = 'absolute';
      art.style.left = '0';
      art.style.top = '0';
    }

    function injectArtWarpHandles(stage, art) {

      var orient = (function () {
        var gal = document.querySelector('pp26-gallery');
        return (gal && gal.dataset.orientation) || 'vertical';
      })();
      var frameEl = stage.querySelector('.pp26__frame');
      function currentType() { return (frameEl && frameEl.dataset.frameType) || 'canvas'; }
      function warpKey(type) { return orient + '|' + (type || currentType()); }
      function loadWarp() {
        var st = getState();
        var byType = st.warpByOrientType || {};

        var w = byType[warpKey()];
        if (w && w.length === 4) return w;
        w = byType[orient + '|canvas'];
        if (w && w.length === 4) return w;

        if (st.warpByOrient && st.warpByOrient[orient] && st.warpByOrient[orient].length === 4) {
          return st.warpByOrient[orient];
        }

        return [
          [stage.offsetWidth * 0.05, stage.offsetHeight * 0.05],
          [stage.offsetWidth * 0.95, stage.offsetHeight * 0.05],
          [stage.offsetWidth * 0.95, stage.offsetHeight * 0.95],
          [stage.offsetWidth * 0.05, stage.offsetHeight * 0.95]
        ];
      }
      var corners = loadWarp();
      function saveWarp() {

        var allZero = corners.every(function (c) { return (c[0]||0) === 0 && (c[1]||0) === 0; });
        if (allZero) return;
        var st = getState();
        st.warpByOrientType = st.warpByOrientType || {};
        st.warpByOrientType[warpKey()] = corners;
        localStorage.setItem(STORAGE, JSON.stringify(st));
      }

      window.__rl_warp_reloadForType = function () {
        corners = loadWarp();
        applyWarp(art, corners);
        if (typeof positionAllHandles === 'function') positionAllHandles();
        if (window.__rl_updatePanel) window.__rl_updatePanel();
      };

      var labels = ['TL', 'TR', 'BR', 'BL'];
      var handles = [];
      function refresh() {
        applyWarp(art, corners);
        if (handles.length === 4) positionAllHandles();
        if (window.__rl_updatePanel) window.__rl_updatePanel();
      }

      window.__rl_reapplyArtWarp = function () { applyWarp(art, corners); };
      for (var i = 0; i < 4; i++) {
        (function (idx) {
          var h = document.createElement('div');
          h.className = 'jun26-warp-handle';
          h.textContent = labels[idx];
          h.dataset.idx = idx;
          h.style.cssText = 'position:absolute;width:12px;height:12px;background:#7c3aed;cursor:move;z-index:80;border:1.5px solid #fff;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.4);user-select:none';
          h.title = labels[idx];
          h.textContent = '';
          stage.appendChild(h);
          var dragging = false, sx, sy, scx, scy;
          h.addEventListener('mousedown', function (e) {
            dragging = true; sx = e.clientX; sy = e.clientY;
            scx = corners[idx][0]; scy = corners[idx][1];
            e.preventDefault(); e.stopPropagation();
          });
          document.addEventListener('mousemove', function (e) {
            if (!dragging) return;
            corners[idx] = [scx + (e.clientX - sx), scy + (e.clientY - sy)];
            refresh();
          });
          document.addEventListener('mouseup', function () { if (dragging) { dragging = false; saveWarp(); } });
          handles.push(h);
        })(i);
      }
      function positionAllHandles() {
        for (var i = 0; i < 4; i++) {
          if (!handles[i]) continue;
          handles[i].style.left = (corners[i][0] - 6) + 'px';
          handles[i].style.top = (corners[i][1] - 6) + 'px';
        }
      }

      function safeRefresh(tries) {
        tries = tries || 0;
        if ((art.offsetWidth > 0 && art.offsetHeight > 0) || tries > 30) {
          refresh();

          setTimeout(refresh, 200);
          setTimeout(refresh, 600);
          setTimeout(refresh, 1200);
        } else {
          setTimeout(function () { safeRefresh(tries + 1); }, 50);
        }
      }
      safeRefresh();
      art.addEventListener('load', function () { setTimeout(refresh, 30); });

      var artReapplyTimer = null;
      var lastAppliedTransform = '';
      new MutationObserver(function () {
        var cur = art.style.transform || '';
        if (cur === lastAppliedTransform) return;
        if (artReapplyTimer) clearTimeout(artReapplyTimer);
        artReapplyTimer = setTimeout(function () {
          applyWarp(art, corners);
          lastAppliedTransform = art.style.transform;
        }, 50);
      }).observe(art, { attributes: true, attributeFilter: ['style'] });

      window.__rl_warp_setMode = function (mode) {
        handles.forEach(function (h) { h.style.display = mode === 'warp' ? '' : 'none'; });
      };
      window.__rl_warp_reset = function () {
        corners = [
          [stage.offsetWidth * 0.10, stage.offsetHeight * 0.10],
          [stage.offsetWidth * 0.90, stage.offsetHeight * 0.10],
          [stage.offsetWidth * 0.90, stage.offsetHeight * 0.90],
          [stage.offsetWidth * 0.10, stage.offsetHeight * 0.90]
        ];
        saveWarp(); refresh();
      };
      window.__rl_warp_getCorners = function () {
        return {
          orient: orient,
          type: currentType(),
          cornersPx: corners.map(function (c) { return [Math.round(c[0]), Math.round(c[1])]; }),
          cornersPct: corners.map(function (c) {
            return [+(c[0] / stage.offsetWidth * 100).toFixed(2), +(c[1] / stage.offsetHeight * 100).toFixed(2)];
          })
        };
      };

      window.__rl_warp_save = function () { saveWarp(); };

      window.__rl_warp_setMode('warp');
    }
    function injectGrid(stage) {
      if (document.getElementById('jun26-grid')) return;
      var grid = document.createElement('div');
      grid.id = 'jun26-grid';
      grid.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:50;' +
        'background-image:' +
          'linear-gradient(to right, rgba(255,0,0,.10) 1px, transparent 1px),' +
          'linear-gradient(to bottom, rgba(255,0,0,.10) 1px, transparent 1px);' +
        'background-size:5% 5%';
      stage.style.position = stage.style.position || 'relative';
      stage.appendChild(grid);

      [25, 50, 75].forEach(function (p) {
        var v = document.createElement('div');
        v.style.cssText = 'position:absolute;top:0;bottom:0;left:' + p + '%;width:1px;background:rgba(255,0,0,.3);pointer-events:none;z-index:51';
        stage.appendChild(v);
        var h = document.createElement('div');
        h.style.cssText = 'position:absolute;left:0;right:0;top:' + p + '%;height:1px;background:rgba(255,0,0,.3);pointer-events:none;z-index:51';
        stage.appendChild(h);
      });
    }

    var TYPES_ORDER = ['canvas', 'padrao', 'padrao-com-paspatur', 'caixa', 'caixa-com-paspatur', 'slim', 'slim-com-paspatur', 'sem-moldura'];
    var CORES_ORDER = ['mel', 'preta', 'pinus', 'branca'];

    var COR_VALUE = { mel: 'madeira escura', preta: 'preta', pinus: 'madeira clara', branca: 'branca' };
    var TYPE_VALUE = {
      'canvas': 'canvas',
      'padrao': 'padrão',
      'paspatur': 'padrão com paspatur',
      'caixa': 'caixa',
      'caixa-paspatur': 'caixa com paspatur',
      'slim': 'slim',
      'slim-paspatur': 'slim com paspatur',
      'sem-moldura': 'sem moldura'
    };
    function comboIndex(type, cor) {
      var ti = TYPES_ORDER.indexOf(type);
      var ci = CORES_ORDER.indexOf(cor);
      if (ti < 0 || ci < 0) return -1;
      return ti * CORES_ORDER.length + ci;
    }
    function goToCombo(idx) {
      idx = ((idx % (TYPES_ORDER.length * CORES_ORDER.length)) +
             (TYPES_ORDER.length * CORES_ORDER.length)) %
            (TYPES_ORDER.length * CORES_ORDER.length);
      var ti = Math.floor(idx / CORES_ORDER.length);
      var ci = idx % CORES_ORDER.length;
      var type = TYPES_ORDER[ti];
      var cor = CORES_ORDER[ci];

      if (type === 'sem-moldura') {
        var gal = document.querySelector('pp26-gallery');
        if (gal && typeof gal.updateFrame === 'function') {
          gal.updateFrame('sem-moldura', 'default');
        }
        return;
      }
      var typeValue = TYPE_VALUE[type];
      var corValue = COR_VALUE[cor];
      var molFs = document.querySelector(':is([data-handle="escolha-o-tipo-de-moldura"],[data-pdp26-opcao="escolha-o-tipo-de-moldura"])');
      var corFs = document.querySelector(':is([data-handle="escolha-a-cor-da-moldura"],[data-pdp26-opcao="escolha-a-cor-da-moldura"])');
      var molInput = molFs && molFs.querySelector('input[value="' + typeValue + '"]');
      var corInput = corFs && corFs.querySelector('input[value="' + corValue + '"]');
      if (molInput && corInput) {
        molInput.checked = true; molInput.dispatchEvent(new Event('change', { bubbles: true }));
        var applyCor = function () {
          if (!corInput.checked) {
            corInput.checked = true;
            corInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        setTimeout(applyCor, 250);
        setTimeout(applyCor, 500);
        setTimeout(applyCor, 800);
        return;
      }

      var frame = document.querySelector('.pp26__frame');
      if (!frame) {
        console.warn('[jun26 ruler] Frame não encontrado pra simular', type, cor);
        return;
      }
      var baseMatch = frame.src.match(/(.+\/)jun26-[^/]+\.webp/);
      if (!baseMatch) {
        console.warn('[jun26 ruler] Não foi possível extrair base path pra simular');
        return;
      }
      var basePath = baseMatch[1];

      var gal = document.querySelector('pp26-gallery');
      var orient = (gal && gal.dataset.orientation) || 'vertical';
      var simSrc = basePath + 'jun26-' + orient + '-' + type + '-' + cor + '.webp';
      frame.src = simSrc;
      frame.dataset.frameType = type;
      frame.dataset.frameColor = cor;
      frame.removeAttribute('hidden');
      console.log('[jun26 ruler] Simulando variant oculta:', type, '/', cor, '→', simSrc);
    }

    function injectFrameInteractions(stage, frame) {
      frame.style.cursor = 'move';
      frame.style.zIndex = '60';
      frame.style.userSelect = 'none';
      frame.style.pointerEvents = 'auto';

      var warpRefs = [];
      for (var wi = 0; wi < 4; wi++) {
        var r = document.createElement('div');
        r.style.cssText = 'position:absolute;width:16px;height:16px;border:3px solid #3b82f6;border-radius:50%;pointer-events:none;z-index:85;display:none;background:rgba(255,255,255,.9);box-shadow:0 2px 6px rgba(0,0,0,.4)';
        stage.appendChild(r);
        warpRefs.push(r);
      }
      window.__rl_showWarpRefs = function (show) {
        var st = getState();
        var orient = (function () {
          var gal = document.querySelector('pp26-gallery');
          return (gal && gal.dataset.orientation) || 'vertical';
        })();
        var w = st.warpByOrient && st.warpByOrient[orient];
        if (show && w && w.length === 4) {
          for (var i = 0; i < 4; i++) {
            warpRefs[i].style.display = '';
            warpRefs[i].style.left = (w[i][0] - 8) + 'px';
            warpRefs[i].style.top = (w[i][1] - 8) + 'px';
          }
        } else {
          warpRefs.forEach(function (r) { r.style.display = 'none'; });
        }
      };

      function key() { return (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?'); }
      function restoreIfApproved() {
        var st = getState();
        var ap = st.approved && st.approved[key()];
        if (ap) {

          frame.style.translate = pctToPx(ap.translate || '0% 0%');
          frame.style.width = ap.width || '';
          frame.style.height = ap.height || '';
        }
      }
      restoreIfApproved();

      var dragging = false, sx, sy, stx, sty;
      frame.addEventListener('mousedown', function (e) {
        if (window.__rl_currentMode !== 'pos') return;
        if (e.target.classList && e.target.classList.contains('jun26-resize-handle')) return;
        dragging = true;
        sx = e.clientX; sy = e.clientY;
        var t = (frame.style.translate || '0px 0px').split(' ');
        stx = parseFloat(t[0]) || 0;
        sty = parseFloat(t[1]) || 0;
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) {
          frame.style.translate = (stx + (e.clientX - sx)) + 'px ' + (sty + (e.clientY - sy)) + 'px';
          updatePanel();
        }
      });
      document.addEventListener('mouseup', function () {
        if (dragging) { dragging = false; }
      });

      var handle = document.createElement('div');
      handle.className = 'jun26-resize-handle';
      handle.style.cssText = 'position:absolute;width:14px;height:14px;background:#7c3aed;border:2px solid #fff;cursor:nwse-resize;z-index:70;pointer-events:auto;box-shadow:0 1px 4px rgba(0,0,0,.3)';
      stage.appendChild(handle);
      function positionHandle() {
        var fr = frame.getBoundingClientRect();
        var sr = stage.getBoundingClientRect();
        handle.style.left = (fr.right - sr.left - 7) + 'px';
        handle.style.top = (fr.bottom - sr.top - 7) + 'px';
      }
      positionHandle();
      window.addEventListener('resize', positionHandle);
      new MutationObserver(positionHandle).observe(frame, { attributes: true, attributeFilter: ['style', 'src'] });
      var resizing = false, rsx, rsy, rsw, rsh;
      handle.addEventListener('mousedown', function (e) {
        if (window.__rl_currentMode !== 'pos') return;
        resizing = true;
        rsx = e.clientX; rsy = e.clientY;
        rsw = frame.offsetWidth; rsh = frame.offsetHeight;
        e.stopPropagation(); e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (resizing) {
          frame.style.width = Math.max(50, rsw + (e.clientX - rsx)) + 'px';
          frame.style.height = Math.max(50, rsh + (e.clientY - rsy)) + 'px';
          positionHandle();
          updatePanel();
        }
      });
      document.addEventListener('mouseup', function () { if (resizing) resizing = false; });

      new MutationObserver(function () {

        frame.style.translate = '';
        frame.style.width = '';
        frame.style.height = '';
        setTimeout(function () {
          restoreIfApproved();

          if (window.__rl_warp_reloadForType) window.__rl_warp_reloadForType();
          else if (window.__rl_reapplyArtWarp) window.__rl_reapplyArtWarp();

          if (window.__rl_currentMode === 'pos' && window.__rl_showWarpRefs) {
            window.__rl_showWarpRefs(true);
          }

          if (window.__rl_syncSliders) window.__rl_syncSliders();
        }, 80);
        setTimeout(updatePanel, 150);
      }).observe(frame, { attributes: true, attributeFilter: ['src', 'data-frame-type', 'data-frame-color'] });
    }
    function injectPanel(stage, art) {
      var frame = stage.querySelector('.pp26__frame');
      var panel = document.createElement('div');
      panel.id = 'jun26-ruler-panel';
      panel.style.cssText = 'position:fixed;top:80px;right:20px;background:#fff;border:1px solid #111;padding:16px;z-index:9999;font:12px Archivo,system-ui,sans-serif;width:320px;box-shadow:0 8px 24px rgba(0,0,0,.15)';
      panel.innerHTML = ''
        + '<div id="rl-header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;font-weight:600;letter-spacing:.05em;text-transform:uppercase">'
        + '<span>Régua</span>'
        + '<span style="display:flex;gap:2px">'
        + '<button id="rl-min" style="width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:16px Archivo;color:#999;padding:0;line-height:1" title="minimizar">−</button>'
        + '<button id="rl-close" style="width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:14px Archivo;color:#999;padding:0;line-height:1" title="fechar">×</button>'
        + '</span>'
        + '</div>'
        + '<div style="display:flex;gap:0;margin-bottom:12px;border:1px solid #d4d4d8">'
        + '<button id="rl-mode-warp" style="flex:1;padding:8px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600">WARP DA ARTE</button>'
        + '<button id="rl-mode-pos" style="flex:1;padding:8px;background:#fff;color:#111;border:none;cursor:pointer;font:11px Archivo">POSIÇÃO MOLDURA</button>'
        + '</div>'
        + '<div id="rl-status" style="font-size:11px;color:#666;margin-bottom:8px"></div>'
        + '<div id="rl-pos-sliders" style="display:none;margin-bottom:10px;padding:8px;background:#faf5ff;border:1px solid #e9d5ff;font-size:11px">'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="negativo = esquerda, positivo = direita">←→</label><input id="rl-sl-x" type="range" min="-200" max="200" value="0" style="flex:1"><input id="rl-sl-x-v" type="number" value="0" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">px</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="negativo = cima, positivo = baixo">↑↓</label><input id="rl-sl-y" type="range" min="-200" max="200" value="0" style="flex:1"><input id="rl-sl-y-v" type="number" value="0" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">px</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="largura">W</label><input id="rl-sl-w" type="range" min="50" max="200" value="100" style="flex:1"><input id="rl-sl-w-v" type="number" value="100" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">%</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px"><label style="width:50px" title="altura">H</label><input id="rl-sl-h" type="range" min="50" max="200" value="100" style="flex:1"><input id="rl-sl-h-v" type="number" value="100" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">%</span></div>'
        + '</div>'
        + '<div id="rl-values" style="font-family:monospace;font-size:10px;background:#f4f4f5;padding:6px;margin-bottom:10px;word-break:break-all;max-height:80px;overflow:auto"></div>'
        + '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">'
        + '<button id="rl-save" style="padding:8px 14px;background:#22c55e;color:#fff;border:none;cursor:pointer;font:12px Archivo;font-weight:600;pointer-events:auto;display:none">SALVAR</button>'
        + '<button id="rl-replicate" style="padding:8px 12px;background:#0ea5e9;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto;display:none" title="copia translate + width + height da última cor salva deste mesmo tipo (ex: padrao/mel → padrao/preta)">📋 REPLICAR</button>'
        + '<button id="rl-prev" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto;display:none">←</button>'
        + '<button id="rl-next" style="padding:6px 10px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto;display:none">→</button>'
        + '<button id="rl-reset" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto">RESET</button>'
        + '<button id="rl-hide-art" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="esconde a arte pra ver só a moldura">OCULTAR ARTE</button>'
        + '<button id="rl-add-vline" style="padding:6px 8px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="adiciona régua vertical">| RÉGUA V</button>'
        + '<button id="rl-add-hline" style="padding:6px 8px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="adiciona régua horizontal">— RÉGUA H</button>'
        + '<button id="rl-layers" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="mostra todas as molduras salvas sobrepostas pra comparar">CAMADAS</button>'
        + '<button id="rl-checkcolors" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="amostra a cor média de cada moldura e compara com a esperada">VERIFICAR CORES</button>'
        + '<button id="rl-export" style="padding:6px 10px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="gera JSON pra commitar no tema (cliente final vê)">⬇ EXPORTAR PRO TEMA</button>'
        + '<button id="rl-save-orient" style="padding:6px 10px;background:#0ea5e9;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="baixa um .json com só esta orientação (vertical/horizontal/quadrado)">💾 SALVAR ORIENT</button>'
        + '<button id="rl-load-orient" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="importa um .json salvo — NÃO sobrescreve as outras orientações nem o panelPos">📂 IMPORTAR</button>'
        + '<button id="rl-simulate" style="padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo;pointer-events:auto">SIMULAR</button>'
        + '<button id="rl-copy" style="padding:4px 8px;background:transparent;color:#999;border:1px solid #e4e4e7;cursor:pointer;font:10px Archivo;pointer-events:auto">copy</button>'
        + '<button id="rl-approve" style="padding:6px 10px;background:#22c55e;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto">SALVAR</button>'
        + '</div>';
      document.body.appendChild(panel);

      var bodyWrap = document.createElement('div');
      bodyWrap.id = 'rl-body-wrap';
      var children = Array.from(panel.children);
      children.slice(1).forEach(function (c) { bodyWrap.appendChild(c); });
      panel.appendChild(bodyWrap);

      makeDraggable(panel, panel.querySelector('#rl-header'), 'ruler');

      var minimized = false;
      panel.querySelector('#rl-min').onclick = function () {
        minimized = !minimized;
        bodyWrap.style.display = minimized ? 'none' : '';
        panel.style.width = minimized ? 'auto' : '320px';
        panel.style.padding = minimized ? '10px 16px' : '16px';
        panel.querySelector('#rl-min').textContent = minimized ? '+' : '−';
        panel.querySelector('#rl-min').title = minimized ? 'expandir' : 'minimizar';
      };
      panel.querySelector('#rl-close').onclick = function () {
        panel.style.display = 'none';
        var open = document.createElement('button');
        open.textContent = 'RÉGUA';
        open.style.cssText = 'position:fixed;top:80px;right:20px;padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:9999';
        document.body.appendChild(open);
        open.onclick = function () { panel.style.display = ''; open.remove(); };
      };
      var mode = 'warp';
      function setMode(m) {
        mode = m;
        window.__rl_currentMode = m;
        if (window.__rl_warp_setMode) window.__rl_warp_setMode(m);
        if (window.__rl_showWarpRefs) window.__rl_showWarpRefs(m === 'pos');
        panel.querySelector('#rl-mode-warp').style.background = m === 'warp' ? '#7c3aed' : '#fff';
        panel.querySelector('#rl-mode-warp').style.color = m === 'warp' ? '#fff' : '#111';
        panel.querySelector('#rl-mode-pos').style.background = m === 'pos' ? '#7c3aed' : '#fff';
        panel.querySelector('#rl-mode-pos').style.color = m === 'pos' ? '#fff' : '#111';
        var nextBtn = panel.querySelector('#rl-next');
        var prevBtn = panel.querySelector('#rl-prev');
        var saveBtn = panel.querySelector('#rl-save');
        var replicateBtn = panel.querySelector('#rl-replicate');
        var approveBtn = panel.querySelector('#rl-approve');
        if (nextBtn) nextBtn.style.display = m === 'pos' ? '' : 'none';
        if (prevBtn) prevBtn.style.display = m === 'pos' ? '' : 'none';
        if (saveBtn) saveBtn.style.display = m === 'pos' ? '' : 'none';
        if (replicateBtn) replicateBtn.style.display = m === 'pos' ? '' : 'none';
        if (approveBtn) approveBtn.style.display = m === 'warp' ? '' : 'none';
        var sliders = panel.querySelector('#rl-pos-sliders');
        if (sliders) sliders.style.display = m === 'pos' ? '' : 'none';

        frame.style.cursor = m === 'pos' ? 'move' : 'default';
        document.querySelectorAll('.jun26-resize-handle').forEach(function (h) {
          h.style.display = m === 'pos' ? '' : 'none';
        });

        if (m === 'pos') syncSlidersFromFrame();
        updatePanel();
      }

      function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
      function applyFromValues(x, y, w, h) {
        x = clamp(Math.round(x), -200, 200);
        y = clamp(Math.round(y), -200, 200);
        w = clamp(Math.round(w), 50, 200);
        h = clamp(Math.round(h), 50, 200);
        panel.querySelector('#rl-sl-x').value = x;
        panel.querySelector('#rl-sl-y').value = y;
        panel.querySelector('#rl-sl-w').value = w;
        panel.querySelector('#rl-sl-h').value = h;
        panel.querySelector('#rl-sl-x-v').value = x;
        panel.querySelector('#rl-sl-y-v').value = y;
        panel.querySelector('#rl-sl-w-v').value = w;
        panel.querySelector('#rl-sl-h-v').value = h;
        frame.style.translate = x + 'px ' + y + 'px';
        frame.style.width = (w === 100 ? '' : w + '%');
        frame.style.height = (h === 100 ? '' : h + '%');
        updatePanel();
      }
      function applySliders() {
        applyFromValues(
          panel.querySelector('#rl-sl-x').value,
          panel.querySelector('#rl-sl-y').value,
          panel.querySelector('#rl-sl-w').value,
          panel.querySelector('#rl-sl-h').value
        );
      }
      function applyInputs() {
        applyFromValues(
          panel.querySelector('#rl-sl-x-v').value,
          panel.querySelector('#rl-sl-y-v').value,
          panel.querySelector('#rl-sl-w-v').value,
          panel.querySelector('#rl-sl-h-v').value
        );
      }
      function syncSlidersFromFrame() {
        var t = (frame.style.translate || '0px 0px').split(' ');
        var x = Math.round(parseFloat(t[0]) || 0);
        var y = Math.round(parseFloat(t[1]) || 0);
        var w = Math.round(parseFloat(frame.style.width) || 100);
        var h = Math.round(parseFloat(frame.style.height) || 100);
        panel.querySelector('#rl-sl-x').value = x;
        panel.querySelector('#rl-sl-y').value = y;
        panel.querySelector('#rl-sl-w').value = w;
        panel.querySelector('#rl-sl-h').value = h;
        panel.querySelector('#rl-sl-x-v').value = x;
        panel.querySelector('#rl-sl-y-v').value = y;
        panel.querySelector('#rl-sl-w-v').value = w;
        panel.querySelector('#rl-sl-h-v').value = h;
      }

      window.__rl_syncSliders = syncSlidersFromFrame;
      ['rl-sl-x', 'rl-sl-y', 'rl-sl-w', 'rl-sl-h'].forEach(function (id) {
        panel.querySelector('#' + id).addEventListener('input', applySliders);
      });
      ['rl-sl-x-v', 'rl-sl-y-v', 'rl-sl-w-v', 'rl-sl-h-v'].forEach(function (id) {
        panel.querySelector('#' + id).addEventListener('input', applyInputs);
        panel.querySelector('#' + id).addEventListener('change', applyInputs);
      });

      document.addEventListener('keydown', function (e) {
        if (mode !== 'pos') return;
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
        var step = e.shiftKey ? 10 : 1;
        var dx = 0, dy = 0;
        if (e.key === 'ArrowLeft') dx = -step;
        else if (e.key === 'ArrowRight') dx = step;
        else if (e.key === 'ArrowUp') dy = -step;
        else if (e.key === 'ArrowDown') dy = step;
        else return;
        e.preventDefault();
        var sx = panel.querySelector('#rl-sl-x');
        var sy = panel.querySelector('#rl-sl-y');
        sx.value = parseInt(sx.value, 10) + dx;
        sy.value = parseInt(sy.value, 10) + dy;
        applySliders();
      });
      panel.querySelector('#rl-mode-warp').onclick = function () { setMode('warp'); };
      panel.querySelector('#rl-mode-pos').onclick = function () { setMode('pos'); };

      panel.querySelector('#rl-reset').onclick = function () {
        if (mode === 'warp') {
          if (window.__rl_warp_reset) window.__rl_warp_reset();
        } else {
          frame.style.translate = ''; frame.style.width = ''; frame.style.height = '';
        }
        updatePanel();
      };
      panel.querySelector('#rl-copy').onclick = function () {
        var data;
        if (mode === 'warp') {
          data = window.__rl_warp_getCorners ? window.__rl_warp_getCorners() : {};
        } else {
          data = {
            type: frame.dataset.frameType,
            cor: frame.dataset.frameColor,
            translate: pxToPct(frame.style.translate),
            width: frame.style.width || 'auto',
            height: frame.style.height || 'auto'
          };
        }
        var txt = JSON.stringify(data, null, 2);
        if (navigator.clipboard) navigator.clipboard.writeText(txt);
        panel.querySelector('#rl-values').textContent = txt + '\n\n(copiado)';
      };
      panel.querySelector('#rl-approve').onclick = function () {
        var st = getState();
        if (mode === 'warp') {

          if (window.__rl_warp_save) window.__rl_warp_save();
          panel.querySelector('#rl-status').innerHTML = '<b style="color:#22c55e">✓ warp salvo · indo pra POSIÇÃO MOLDURA…</b>';
          setTimeout(function () { setMode('pos'); }, 300);
        } else {
          st.approved = st.approved || {};
          var k = (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?');
          st.approved[k] = {
            translate: pxToPct(frame.style.translate),
            width: frame.style.width || 'auto',
            height: frame.style.height || 'auto'
          };
          localStorage.setItem(STORAGE, JSON.stringify(st));
        }
        updatePanel();
      };
      panel.querySelector('#rl-save').onclick = function () {

        var st = getState(); st.approved = st.approved || {};
        var k = (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?');
        st.approved[k] = {
          translate: pxToPct(frame.style.translate),
          width: frame.style.width || 'auto',
          height: frame.style.height || 'auto'
        };
        localStorage.setItem(STORAGE, JSON.stringify(st));

        var btn = panel.querySelector('#rl-save');
        var originalText = btn.textContent;
        var originalBg = btn.style.background;
        btn.textContent = '✓ SALVO ' + k.split('|').pop().toUpperCase();
        btn.style.background = '#15803d';
        btn.style.transform = 'scale(1.05)';
        btn.style.transition = 'transform 200ms ease-out';
        setTimeout(function () {
          btn.style.transform = '';
          updatePanel();
        }, 800);
      };

      panel.querySelector('#rl-replicate').onclick = function () {
        var st = getState();
        var approved = st.approved || {};
        var curType = frame.dataset.frameType || '?';
        var curCor = frame.dataset.frameColor || '?';

        var prefer = ['mel', 'preta', 'pinus', 'branca'];
        var source = null, sourceCor = null;
        for (var i = 0; i < prefer.length; i++) {
          var cor = prefer[i];
          if (cor === curCor) continue;
          if (approved[curType + '|' + cor]) {
            source = approved[curType + '|' + cor];
            sourceCor = cor;
            break;
          }
        }
        if (!source) {
          alert('Nenhuma outra cor do tipo "' + curType + '" foi salva ainda. Calibre pelo menos uma cor primeiro.');
          return;
        }

        frame.style.translate = pctToPx(source.translate || '0% 0%');
        frame.style.width = source.width === 'auto' ? '' : source.width;
        frame.style.height = source.height === 'auto' ? '' : source.height;

        if (window.__rl_syncSliders) window.__rl_syncSliders();
        updatePanel();

        var btn = panel.querySelector('#rl-replicate');
        var txt = btn.textContent;
        btn.textContent = '✓ COPIADO DE ' + sourceCor.toUpperCase();
        setTimeout(function () { btn.textContent = txt; }, 1500);
      };
      panel.querySelector('#rl-next').onclick = function () {

        var curIdx = comboIndex(frame.dataset.frameType, frame.dataset.frameColor);
        goToCombo(curIdx + 1);
      };
      panel.querySelector('#rl-prev').onclick = function () {
        var curIdx = comboIndex(frame.dataset.frameType, frame.dataset.frameColor);
        goToCombo(curIdx - 1);
      };

      var EXPECTED_COLORS = {
        mel:    { r: 110, g: 75, b: 45 },
        preta:  { r: 30,  g: 30, b: 30 },
        pinus:  { r: 195, g: 165, b: 105 },
        branca: { r: 220, g: 215, b: 205 }
      };
      function colorDist(a, b) {
        var dr = a.r - b.r, dg = a.g - b.g, db = a.b - b.b;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }
      function sampleMoldura(url) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = 100; canvas.height = 100;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, 100, 100);
            try {
              var data = ctx.getImageData(0, 0, 100, 100).data;
              var r = 0, g = 0, b = 0, n = 0;
              for (var i = 0; i < data.length; i += 4) {
                var a = data[i + 3];
                if (a < 200) continue;
                r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
              }
              if (!n) return resolve(null);
              resolve({ r: Math.round(r / n), g: Math.round(g / n), b: Math.round(b / n) });
            } catch (e) { resolve(null); }
          };
          img.onerror = function () { resolve(null); };
          img.src = url;
        });
      }
      panel.querySelector('#rl-checkcolors').onclick = function () {
        var st = getState();
        var approved = (st.approved || {});
        var keys = Object.keys(approved);
        if (!keys.length) { alert('Nenhuma moldura salva ainda.'); return; }
        var baseMatch = frame.src.match(/(.+\/)jun26-[^/]+\.webp/);
        if (!baseMatch) { alert('Não consegui detectar prefixo.'); return; }
        var basePath = baseMatch[1];
        var galC = document.querySelector('pp26-gallery');
        var orient = (galC && galC.dataset.orientation) || 'vertical';
        var btn = this;
        btn.textContent = 'AMOSTRANDO...';
        btn.disabled = true;
        Promise.all(keys.map(function (key) {
          var parts = key.split('|');
          var type = parts[0], cor = parts[1];
          var url = basePath + 'jun26-' + orient + '-' + type + '-' + cor + '.webp';
          return sampleMoldura(url).then(function (avg) {
            var expected = EXPECTED_COLORS[cor];
            var dist = avg && expected ? colorDist(avg, expected) : null;
            return { type: type, cor: cor, avg: avg, expected: expected, dist: dist };
          });
        })).then(function (results) {
          btn.textContent = 'VERIFICAR CORES';
          btn.disabled = false;
          var THRESHOLD = 80;
          var html = '<div style="font-weight:600;margin-bottom:6px">Verificação de cores</div>';
          html += '<div style="font-size:10px;color:#666;margin-bottom:8px">Desvios > ' + THRESHOLD + ' (distância RGB) marcados como suspeitos.</div>';
          var suspects = [];
          results.forEach(function (r) {
            var ok = r.dist != null && r.dist < THRESHOLD;
            if (!ok) suspects.push(r);
            var av = r.avg ? 'rgb(' + r.avg.r + ',' + r.avg.g + ',' + r.avg.b + ')' : 'falhou';
            var ex = r.expected ? 'rgb(' + r.expected.r + ',' + r.expected.g + ',' + r.expected.b + ')' : '—';
            html += '<div style="display:flex;align-items:center;gap:6px;font-size:10px;margin-bottom:3px">'
              + (ok ? '<span style="color:#22c55e">✓</span>' : '<span style="color:#ef4444">⚠</span>')
              + '<span style="width:60px;font-family:monospace">' + r.type + '</span>'
              + '<span style="width:50px;font-family:monospace">' + r.cor + '</span>'
              + '<span style="display:inline-block;width:14px;height:14px;border:1px solid #ccc;background:' + av + '"></span>'
              + '<span style="display:inline-block;width:14px;height:14px;border:1px solid #ccc;background:' + ex + '"></span>'
              + '<span style="font-family:monospace;color:' + (ok ? '#666' : '#ef4444') + '">Δ ' + (r.dist != null ? Math.round(r.dist) : '?') + '</span>'
              + '</div>';
          });
          if (suspects.length) {
            html = '<div style="background:#fef2f2;border:1px solid #fecaca;padding:6px;margin-bottom:8px;font-size:10px;color:#b91c1c"><b>' + suspects.length + ' suspeita(s)</b> — verifica se subiu o webp certo.</div>' + html;
          } else {
            html = '<div style="background:#f0fdf4;border:1px solid #bbf7d0;padding:6px;margin-bottom:8px;font-size:10px;color:#15803d"><b>Tudo dentro do esperado.</b></div>' + html;
          }

          var modal = document.createElement('div');
          modal.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border:1px solid #111;padding:16px;z-index:99999;width:400px;max-height:70vh;overflow:auto;box-shadow:0 8px 24px rgba(0,0,0,.2);font:11px Archivo';
          modal.innerHTML = html + '<button style="margin-top:10px;padding:6px 12px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo">FECHAR</button>';
          modal.querySelector('button').onclick = function () { modal.remove(); };
          document.body.appendChild(modal);
        });
      };

      panel.querySelector('#rl-export').onclick = function () {
        var st = getState();
        var galEx = document.querySelector('pp26-gallery');
        var orientEx = (galEx && galEx.dataset.orientation) || 'vertical';
        var data = {
          generatedAt: new Date().toISOString(),
          orient: orientEx,
          warpByOrient: st.warpByOrient || {},
          warpByOrientType: st.warpByOrientType || {},
          approved: st.approved || {}
        };
        var json = JSON.stringify(data, null, 2);

        if (navigator.clipboard) navigator.clipboard.writeText(json);

        var blob = new Blob([json], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'jun26-calibracao-' + Date.now() + '.json';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);

        var modal = document.createElement('div');
        modal.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border:1px solid #111;padding:20px;z-index:99999;width:480px;max-height:80vh;overflow:auto;box-shadow:0 8px 24px rgba(0,0,0,.3);font:12px Archivo';
        modal.innerHTML = ''
          + '<div style="font-weight:600;font-size:14px;margin-bottom:10px">⬇ Exportado pro tema</div>'
          + '<div style="background:#fef3c7;border:1px solid #fde68a;padding:8px;font-size:11px;color:#92400e;margin-bottom:10px">'
          + '<b>Próximos passos:</b><br>'
          + '1. JSON copiado pro clipboard + baixado em ~/Downloads/<br>'
          + '2. Manda pra Claude (eu) commitar no template `product.pdp-jun26.json` (setting `pp26_builder_json`)<br>'
          + '3. Após push, todos os clientes em qualquer device veem as calibrações.'
          + '</div>'
          + '<textarea readonly style="width:100%;height:200px;font-family:monospace;font-size:10px;border:1px solid #d4d4d8;padding:8px">' + json.replace(/</g, '&lt;') + '</textarea>'
          + '<div style="display:flex;gap:6px;margin-top:10px">'
          + '<button style="padding:8px 12px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo" onclick="this.previousElementSibling.previousElementSibling.select(); document.execCommand(\'copy\'); this.textContent=\'✓ COPIADO\'">COPIAR DE NOVO</button>'
          + '<button id="rl-export-close" style="padding:8px 12px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo">FECHAR</button>'
          + '</div>';
        modal.querySelector('#rl-export-close').onclick = function () { modal.remove(); };
        document.body.appendChild(modal);
      };

      panel.querySelector('#rl-save-orient').onclick = function () {
        var st = getState();
        var orient = 'vertical';
        var galleryEl = document.querySelector('pp26-gallery');
        if (galleryEl && galleryEl.dataset.orientation) orient = galleryEl.dataset.orientation;

        var snap = {
          orient: orient,
          generatedAt: new Date().toISOString(),
          warpByOrient: {},
          warpByOrientType: {},
          approved: st.approved || {},
          guides: {}
        };
        if (st.warpByOrient && st.warpByOrient[orient]) snap.warpByOrient[orient] = st.warpByOrient[orient];
        Object.keys(st.warpByOrientType || {}).forEach(function (k) {
          if (k.indexOf(orient + '|') === 0) snap.warpByOrientType[k] = st.warpByOrientType[k];
        });

        if (st.guides && st.guides[orient]) snap.guides[orient] = st.guides[orient];

        var blob = new Blob([JSON.stringify(snap, null, 2)], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'jun26-ruler-' + orient + '-' + Date.now() + '.json';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        var btn = panel.querySelector('#rl-save-orient');
        var txt = btn.textContent;
        btn.textContent = '✓ BAIXADO';
        setTimeout(function () { btn.textContent = txt; }, 1500);
      };

      panel.querySelector('#rl-load-orient').onclick = function () {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/json,.json';
        input.style.display = 'none';
        input.onchange = function (e) {
          var file = e.target.files && e.target.files[0];
          if (!file) return;
          var reader = new FileReader();
          reader.onload = function (ev) {
            try {
              var data = JSON.parse(ev.target.result);
              var current = getState();

              if (data.warpByOrient) {
                current.warpByOrient = current.warpByOrient || {};
                Object.assign(current.warpByOrient, data.warpByOrient);
              }

              if (data.warpByOrientType) {
                current.warpByOrientType = current.warpByOrientType || {};
                Object.assign(current.warpByOrientType, data.warpByOrientType);
              }

              if (data.approved) {
                current.approved = current.approved || {};
                Object.assign(current.approved, data.approved);
              }

              if (data.guides) {
                current.guides = current.guides || {};
                Object.assign(current.guides, data.guides);
              }
              localStorage.setItem(STORAGE, JSON.stringify(current));
              alert('Importado: ' + (data.orient || '?') +
                '\nWarp custom: ' + Object.keys(data.warpByOrientType || {}).length +
                '\nAprovados: ' + Object.keys(data.approved || {}).length +
                '\nGuides: ' + Object.keys(data.guides || {}).map(function (k) { return k + ':' + (data.guides[k] || []).length; }).join(', ') +
                '\n\nRecarregando a régua…');
              location.reload();
            } catch (err) {
              alert('Erro ao importar: ' + err.message);
            }
          };
          reader.readAsText(file);
        };
        document.body.appendChild(input);
        input.click();
        setTimeout(function () { input.remove(); }, 1000);
      };

      function getCurrentOrient() {
        var gal = document.querySelector('pp26-gallery');
        return (gal && gal.dataset.orientation) || 'vertical';
      }
      function saveGuides(arr) {
        var st = getState();
        st.guides = st.guides || {};
        st.guides[getCurrentOrient()] = arr;
        localStorage.setItem(STORAGE, JSON.stringify(st));
      }
      function getGuides() {
        var st = getState();
        return (st.guides && st.guides[getCurrentOrient()]) || [];
      }
      function addGuide(orient, presetPct, presetId) {
        var stage = document.querySelector('.pp26__perspective-stage');
        if (!stage) return;
        var line = document.createElement('div');
        line.className = 'jun26-guide jun26-guide-' + orient;
        var startPct = (typeof presetPct === 'number') ? presetPct : 50;
        var guideId = presetId || ('g' + Date.now() + Math.random().toString(36).slice(2, 6));
        line.dataset.guideId = guideId;
        if (orient === 'v') {
          line.style.cssText = 'position:absolute;top:0;bottom:0;width:1px;background:#06b6d4;left:' + startPct + '%;cursor:ew-resize;z-index:75;box-shadow:0 0 0 1px rgba(6,182,212,.3)';
        } else {
          line.style.cssText = 'position:absolute;left:0;right:0;height:1px;background:#06b6d4;top:' + startPct + '%;cursor:ns-resize;z-index:75;box-shadow:0 0 0 1px rgba(6,182,212,.3)';
        }
        var label = document.createElement('div');
        label.style.cssText = 'position:absolute;background:#06b6d4;color:#fff;font:10px Archivo;padding:2px 6px;white-space:nowrap;cursor:pointer;user-select:none;border-radius:2px';
        if (orient === 'v') { label.style.top = '8px'; label.style.left = '6px'; }
        else { label.style.left = '8px'; label.style.top = '-22px'; }
        label.innerHTML = '<span style="margin-right:6px">' + startPct.toFixed(1) + '%</span><span style="background:#dc2626;padding:0 4px;border-radius:2px;font-weight:700">×</span>';
        label.title = 'click no × pra deletar';
        line.appendChild(label);

        label.onclick = function (e) {
          e.stopPropagation();
          line.remove();
          var arr = getGuides().filter(function (g) { return g.id !== guideId; });
          saveGuides(arr);
        };
        var dragging = false;
        line.addEventListener('mousedown', function (e) {
          if (e.target === label) return;
          dragging = true; e.preventDefault();
        });
        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var stageRect = stage.getBoundingClientRect();
          var pct;
          if (orient === 'v') {
            pct = ((e.clientX - stageRect.left) / stageRect.width) * 100;
            pct = Math.max(0, Math.min(100, pct));
            line.style.left = pct + '%';
          } else {
            pct = ((e.clientY - stageRect.top) / stageRect.height) * 100;
            pct = Math.max(0, Math.min(100, pct));
            line.style.top = pct + '%';
          }
          label.innerHTML = '<span style="margin-right:6px">' + pct.toFixed(1) + '%</span><span style="background:#dc2626;padding:0 4px;border-radius:2px;font-weight:700">×</span>';

          var arr = getGuides().map(function (g) {
            return g.id === guideId ? { id: guideId, orient: orient, pct: pct } : g;
          });
          saveGuides(arr);
        });
        document.addEventListener('mouseup', function () { dragging = false; });
        stage.appendChild(line);

        if (!presetId) {
          var arr = getGuides();
          arr.push({ id: guideId, orient: orient, pct: startPct });
          saveGuides(arr);
        }
      }
      panel.querySelector('#rl-add-vline').onclick = function () { addGuide('v'); };
      panel.querySelector('#rl-add-hline').onclick = function () { addGuide('h'); };

      setTimeout(function () {
        getGuides().forEach(function (g) { addGuide(g.orient, g.pct, g.id); });
      }, 100);

      var artHidden = false;
      panel.querySelector('#rl-hide-art').onclick = function () {
        artHidden = !artHidden;
        art.style.visibility = artHidden ? 'hidden' : '';
        this.textContent = artHidden ? 'MOSTRAR ARTE' : 'OCULTAR ARTE';
        this.style.background = artHidden ? '#fbbf24' : '#fff';
        this.style.color = artHidden ? '#111' : '#111';
      };

      var layerPanel = null;
      panel.querySelector('#rl-layers').onclick = function () {
        if (layerPanel) {
          layerPanel.remove(); layerPanel = null;
          this.textContent = 'CAMADAS';
          this.style.background = '#fff';
          return;
        }
        this.textContent = 'FECHAR ÁRVORE';
        this.style.background = '#fbbf24';
        layerPanel = renderLayerTree();
      };
      function renderLayerTree() {
        var st = getState();
        var approved = st.approved || {};
        var warpByOT = st.warpByOrientType || {};
        var warpByO = st.warpByOrient || {};
        var galLT = document.querySelector('pp26-gallery');
        var orient = (galLT && galLT.dataset.orientation) || 'vertical';
        var hasGeral = !!warpByO[orient];
        var pnl = document.createElement('div');
        pnl.id = 'jun26-layers-panel';
        pnl.style.cssText = 'position:fixed;top:80px;right:340px;background:#fff;border:1px solid #111;color:#111;padding:0;z-index:9998;font:12px Archivo,system-ui,sans-serif;width:280px;box-shadow:0 8px 24px rgba(0,0,0,.15);max-height:75vh;overflow:auto';
        var html = '<div style="padding:10px 12px;background:#111;color:#fff;font-weight:600;letter-spacing:.05em;text-transform:uppercase;font-size:10px;display:flex;justify-content:space-between;align-items:center"><span>Calibração</span><button id="rl-l-close" style="background:transparent;border:none;color:#fff;cursor:pointer;font-size:16px;line-height:1;padding:0">×</button></div>';
        html += '<div style="padding:10px 12px"><div style="font-weight:600;font-size:11px;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px;color:#444">📐 Vertical</div>';

        html += '<div class="rl-l-node" data-act="goWarp" style="padding:6px 10px 6px 24px;cursor:pointer;display:flex;align-items:center;gap:6px;border-radius:3px" title="Define warp geral da orientação (fallback pros acabamentos sem customização)">' +
          '<span style="width:14px">└</span>' +
          '<span style="flex:1;font-size:11px"><b>Warp da arte geral</b></span>' +
          '<span style="font-size:10px;color:' + (hasGeral ? '#15803d' : '#999') + '">' + (hasGeral ? '✓' : '◯') + '</span>' +
          '</div>';

        TYPES_ORDER.forEach(function (type) {
          var hasCustom = !!warpByOT[orient + '|' + type];
          var collapsedState = (st.treeCollapsed || {})[type];
          var collapsed = !!collapsedState;
          html += '<div class="rl-l-type-group" data-type="' + type + '" style="padding:8px 10px 4px 24px;margin-top:4px;border-top:1px solid #f0f0f0">' +
            '<div class="rl-l-type-header" style="display:flex;align-items:center;gap:6px;font-weight:600;font-size:11px;padding:2px 4px;border-radius:3px">' +
            '<button class="rl-l-toggle" data-type="' + type + '" style="width:14px;background:transparent;border:none;cursor:pointer;font-size:10px;color:#999;padding:0" title="recolher/expandir">' + (collapsed ? '▸' : '▾') + '</button>' +
            '<span class="rl-l-type-name" data-type="' + type + '" style="flex:1;cursor:pointer" title="WARP deste acabamento">' + type + '</span>' +
            '<button class="rl-l-warp-toggle" data-type="' + type + '" style="font-size:10px;background:' + (hasCustom ? '#7c3aed' : '#f4f4f5') + ';color:' + (hasCustom ? '#fff' : '#666') + ';border:none;padding:2px 6px;cursor:pointer;border-radius:2px" title="' + (hasCustom ? 'warp customizado' : 'usa warp geral') + '">' + (hasCustom ? '🎨' : '↑') + '</button>' +
            '</div>';

          html += '<div class="rl-l-cores-wrap" data-type="' + type + '" style="display:' + (collapsed ? 'none' : 'block') + '">';
          CORES_ORDER.forEach(function (cor) {
            var key = type + '|' + cor;
            var ap = approved[key];
            html += '<div class="rl-l-node rl-l-cor" data-type="' + type + '" data-cor="' + cor + '" style="padding:4px 10px 4px 44px;cursor:pointer;display:flex;align-items:center;gap:6px;border-radius:3px" title="Calibrar posição moldura">' +
              '<span style="width:14px;color:#888">└</span>' +
              '<span style="flex:1;font-size:11px;color:#555">' + cor + '</span>' +
              '<span style="font-size:10px;color:' + (ap ? '#15803d' : '#bbb') + '">' + (ap ? '✓' : '◯') + '</span>' +
              '</div>';
          });
          html += '</div></div>';
        });
        html += '</div>';
        pnl.innerHTML = html;
        document.body.appendChild(pnl);

        makeDraggable(pnl, pnl.firstElementChild, 'tree');
        pnl.querySelector('#rl-l-close').onclick = function () {
          pnl.remove(); layerPanel = null;
          var btn = panel.querySelector('#rl-layers');
          btn.textContent = 'CAMADAS'; btn.style.background = '#fff';
        };

        pnl.querySelectorAll('.rl-l-cor, .rl-l-type-header, [data-act="goWarp"]').forEach(function (n) {
          n.onmouseover = function () { n.style.background = '#f4f4f5'; };
          n.onmouseout = function () { n.style.background = ''; };
        });

        pnl.querySelector('[data-act="goWarp"]').onclick = function () {
          setMode('warp');
          var ti = TYPES_ORDER.indexOf('canvas'), ci = CORES_ORDER.indexOf('mel');
          goToCombo(ti * CORES_ORDER.length + ci);
        };

        pnl.querySelectorAll('.rl-l-cor').forEach(function (node) {
          node.onclick = function () {
            var t = node.dataset.type, c = node.dataset.cor;
            var ti = TYPES_ORDER.indexOf(t), ci = CORES_ORDER.indexOf(c);
            if (ti < 0 || ci < 0) return;
            setMode('pos');
            goToCombo(ti * CORES_ORDER.length + ci);
            setTimeout(function () {
              if (layerPanel) { layerPanel.remove(); layerPanel = renderLayerTree(); }
            }, 800);
          };
        });

        pnl.querySelectorAll('.rl-l-type-name').forEach(function (node) {
          node.onclick = function (e) {
            e.stopPropagation();
            var t = node.dataset.type;
            var ti = TYPES_ORDER.indexOf(t);
            if (ti < 0) return;
            setMode('warp');
            goToCombo(ti * CORES_ORDER.length);
            setTimeout(function () {
              if (layerPanel) { layerPanel.remove(); layerPanel = renderLayerTree(); }
            }, 800);
          };
        });

        pnl.querySelectorAll('.rl-l-toggle').forEach(function (btn) {
          btn.onclick = function (e) {
            e.stopPropagation();
            var t = btn.dataset.type;
            var st2 = getState();
            st2.treeCollapsed = st2.treeCollapsed || {};
            st2.treeCollapsed[t] = !st2.treeCollapsed[t];
            localStorage.setItem(STORAGE, JSON.stringify(st2));
            var wrap = pnl.querySelector('.rl-l-cores-wrap[data-type="' + t + '"]');
            if (wrap) {
              var hidden = wrap.style.display === 'none';
              wrap.style.display = hidden ? 'block' : 'none';
              btn.textContent = hidden ? '▾' : '▸';
            }
          };
        });

        pnl.querySelectorAll('.rl-l-warp-toggle').forEach(function (btn) {
          btn.onclick = function (e) {
            e.stopPropagation();
            var t = btn.dataset.type;
            var st = getState();
            st.warpByOrientType = st.warpByOrientType || {};
            var k = orient + '|' + t;
            if (st.warpByOrientType[k]) {

              delete st.warpByOrientType[k];
            } else {

              var base = (st.warpByOrient && st.warpByOrient[orient]) ||
                st.warpByOrientType[orient + '|canvas'] ||
                [[5, 5], [95, 5], [95, 95], [5, 95]];
              st.warpByOrientType[k] = base.map(function (c) { return [c[0], c[1]]; });
            }
            localStorage.setItem(STORAGE, JSON.stringify(st));

            var curFrame = document.querySelector('.pp26__frame');
            if (curFrame && curFrame.dataset.frameType === t && window.__rl_warp_reloadForType) {
              window.__rl_warp_reloadForType();
            }

            layerPanel.remove();
            layerPanel = renderLayerTree();
          };
        });
        return pnl;
      }
      var simulating = false;
      panel.querySelector('#rl-simulate').onclick = function () {
        simulating = !simulating;

        var grid = document.getElementById('jun26-grid');
        if (grid) grid.style.display = simulating ? 'none' : '';
        stage.querySelectorAll('div[style*="rgba(255,0,0,.3)"]').forEach(function (el) {
          el.style.display = simulating ? 'none' : '';
        });
        document.querySelectorAll('.jun26-warp-handle, .jun26-resize-handle').forEach(function (el) {
          el.style.display = simulating ? 'none' : '';
        });
        if (window.__rl_showWarpRefs) window.__rl_showWarpRefs(!simulating && mode === 'pos');

        panel.style.opacity = simulating ? '0.3' : '';
        panel.style.pointerEvents = simulating ? 'auto' : '';
        this.textContent = simulating ? 'EDITAR' : 'SIMULAR';
        this.style.background = simulating ? '#7c3aed' : '#111';
      };

      window.__rl_updatePanel = updatePanel;
      updatePanel();
      function updatePanel() {
        var type = frame.dataset.frameType || '?';
        var cor = frame.dataset.frameColor || '?';
        var st = getState();
        if (mode === 'warp') {
          var w = (window.__rl_warp_getCorners && window.__rl_warp_getCorners()) || {};

          var warpKeyCur = (w.orient || '?') + '|' + (w.type || '?');
          var warpSaved = st.warpByOrientType && st.warpByOrientType[warpKeyCur];
          var savedTag = warpSaved
            ? '<span style="color:#15803d;background:#f0fdf4;padding:2px 6px;font-size:10px;font-weight:600;border:1px solid #bbf7d0">✓ SALVO</span>'
            : '<span style="color:#92400e;background:#fef3c7;padding:2px 6px;font-size:10px;font-weight:600;border:1px solid #fde68a">não salvo</span>';
          panel.querySelector('#rl-status').innerHTML =
            'Modo <b>WARP</b> · <b>' + (w.type || '?') + '</b> · orientação <b>' + (w.orient || '?') + '</b> ' + savedTag + '<br>' +
            '<span style="font-size:10px;color:#666">Define os 4 cantos arrastando os handles roxos. Salva sozinho. Clique SALVAR pra confirmar e ir pra posição da moldura.</span>';
          panel.querySelector('#rl-values').textContent =
            'orient: ' + (w.orient || '?') + '\n' +
            'corners (%):\n' + (w.cornersPct ? JSON.stringify(w.cornersPct, null, 2) : '?');
          var approveBtn = panel.querySelector('#rl-approve');
          if (approveBtn) {
            if (warpSaved) {
              approveBtn.textContent = '✓ SALVO';
              approveBtn.style.background = '#15803d';
            } else {
              approveBtn.textContent = 'SALVAR';
              approveBtn.style.background = '#22c55e';
            }
          }
        } else {
          var approved = (st.approved && Object.keys(st.approved).length) || 0;
          var ap = st.approved && st.approved[type + '|' + cor];
          var curIdx = comboIndex(type, cor);
          var posLabel = curIdx >= 0 ? (curIdx + 1) + ' / 28' : '?';
          panel.querySelector('#rl-status').innerHTML =
            'Modo <b>POSIÇÃO</b> — <b>' + posLabel + '</b> · <b>' + type + '</b> / <b>' + cor + '</b><br>' +
            'Salvas: <b>' + approved + '</b> / 28' +
            '<div style="font-size:10px;color:#666;margin-top:4px">Pontos azuis = warp aprovado. Encaixe as quinas internas neles.</div>';
          panel.querySelector('#rl-values').textContent =
            'translate: ' + (frame.style.translate || '0px 0px') + '\n' +
            'width: ' + (frame.style.width || 'auto') + '\n' +
            'height: ' + (frame.style.height || 'auto');

          var saveBtn = panel.querySelector('#rl-save');
          if (saveBtn) {

            function normalizeT(v) {
              var parts = (v || '0px 0px').trim().split(/\s+/);
              var x = Math.round(parseFloat(parts[0]) || 0);
              var y = Math.round(parseFloat(parts[1]) || 0);
              return x + 'px ' + y + 'px';
            }
            function normalizeDim(v) {
              if (!v || v === 'auto' || v === '') return 'auto';
              var n = parseFloat(v);
              return isNaN(n) ? 'auto' : Math.round(n) + (v.indexOf('%') > -1 ? '%' : 'px');
            }

            var curT = normalizeT(frame.style.translate);
            var curW = normalizeDim(frame.style.width);
            var curH = normalizeDim(frame.style.height);
            var apT = ap ? normalizeT(pctToPx(ap.translate)) : null;
            var apW = ap ? normalizeDim(ap.width) : null;
            var apH = ap ? normalizeDim(ap.height) : null;
            var modified = ap && (curT !== apT || curW !== apW || curH !== apH);
            if (modified) {
              saveBtn.textContent = '⚠ SALVAR MUDANÇAS';
              saveBtn.style.background = '#f59e0b';
            } else if (ap) {
              saveBtn.textContent = '✓ SALVO';
              saveBtn.style.background = '#15803d';
            } else {
              saveBtn.textContent = 'SALVAR';
              saveBtn.style.background = '#22c55e';
            }
          }
        }
      }
    }
    var updatePanel = function () { if (window.__rl_updatePanel) window.__rl_updatePanel(); };
    attempt();
  }

  function setupHiddenVariantSim(frameArg) {
    function getFrame() { return frameArg || document.querySelector('.pp26__frame'); }
    function recalcAndSimulate() {
      setTimeout(function () {
        var frame = getFrame();
        if (!frame) return;
        var activePill = document.querySelector('.jun26-pill--active');
        var primario = activePill && activePill.dataset.primario;
        if (!primario) return;
        if (primario === 'sem moldura' || primario === 'canvas') return;
        var mods = document.querySelectorAll('.jun26-mod input[type="checkbox"]');
        var prof = false, fino = false, pasp = false;
        mods.forEach(function (cb) {
          var label = cb.closest('label');
          var txt = label ? label.textContent.toLowerCase() : '';
          if (txt.indexOf('profundidade') !== -1) prof = cb.checked;
          else if (txt.indexOf('fino') !== -1) fino = cb.checked;
          else if (txt.indexOf('paspatur') !== -1) pasp = cb.checked;
        });
        var type = 'padrao';
        if (fino && pasp) type = 'slim-com-paspatur';
        else if (fino) type = 'slim';
        else if (prof && pasp) type = 'caixa-com-paspatur';
        else if (prof) type = 'caixa';
        else if (pasp) type = 'padrao-com-paspatur';

        var HIDDEN_TYPES = ['slim', 'slim-com-paspatur', 'caixa-com-paspatur'];
        if (HIDDEN_TYPES.indexOf(type) === -1) return;

        var molFs2 = document.querySelector(':is([data-handle="escolha-o-tipo-de-moldura"],[data-pdp26-opcao="escolha-o-tipo-de-moldura"])');
        var typeValueMap2 = {
          'slim': 'slim', 'slim-com-paspatur': 'slim com paspatur',
          'caixa-com-paspatur': 'caixa com paspatur'
        };
        var molRadio = molFs2 && molFs2.querySelector('input[value="' + typeValueMap2[type] + '"]');
        if (!molRadio) return;
        var corFs = document.querySelector(':is([data-handle="escolha-a-cor-da-moldura"],[data-pdp26-opcao="escolha-a-cor-da-moldura"])');
        var corInput = corFs && corFs.querySelector('input:checked');
        var corValueMap = {
          'madeira escura': 'mel', 'preta': 'preta',
          'madeira clara': 'pinus', 'branca': 'branca'
        };
        var corShort = corInput ? (corValueMap[corInput.value] || corInput.value) : 'mel';
        if (corShort === 'sem moldura') corShort = 'mel';

        if (frame.dataset.frameType === type && frame.dataset.frameColor === corShort) return;
        var gallery = frame.closest('pp26-gallery');
        if (gallery && typeof gallery.updateFrame === 'function') {
          gallery.updateFrame(type, corShort);
        }
      }, 300);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.jun26-pill') || e.target.closest('.jun26-mod') || e.target.closest('.jun26-swatch')) {
        recalcAndSimulate();
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.closest('.jun26-mod')) recalcAndSimulate();
    }, true);
  }

  var ARTIST_LOCATIONS = {
    'Agata Krolak': 'Gdańsk, Polônia',
    'Agus Buerba': 'Buenos Aires, Argentina',
    'Agus Minuto': 'Buenos Aires, Argentina',
    'Andrea Reichhart': 'St. Wendel, Alemanha',
    'Andreas Magnusson': 'Vendelsö (Estocolmo), Suécia',
    'Angela Seear': 'Vancouver, Canadá',
    'Anna Mielniczuk': 'Chicago, Estados Unidos',
    'Artur Chen': 'Taiwan',
    'Athene Fritsch': 'Panamá',
    'Avanesova Elena': 'Maiorca, Espanha',
    'Bellassai Art': 'Itália',
    'Bethany Young': 'Estados Unidos',
    'Breanna Megan Studio': 'Turlock (CA), Estados Unidos',
    'Camilla Aasen Jordanger': 'Sande (Vestfold), Noruega',
    'Cartissi': 'Cornualha, Reino Unido',
    'Catalina Somolinos': 'Frankfurt, Alemanha',
    'Charlotte Curd': 'Sydney, Austrália',
    'Christina Misuro': 'Polônia',
    'Dan Hobday': 'Devon, Reino Unido',
    'Danushka Abeygoda': 'Perth, Austrália',
    'David Diehl': 'Zurique, Suíça',
    'David Vineis': 'Paris, França',
    'Deb Chaney': 'Vancouver, Canadá',
    'Dianne Nicole Fernando': 'Manila, Filipinas',
    'Dorothy Fagan': 'Estados Unidos',
    'Eden Kalif': 'Tel Aviv, Israel',
    'Elena Shraibman': 'Israel',
    'Ellen Greup': 'Países Baixos',
    'Emma Bell': 'Atlanta (GA), Estados Unidos',
    'Enrique Larios': 'Cidade do México, México',
    'Esperanza Manzanera': 'Granada, Espanha',
    'Gemma Bardot': 'Portland (OR), Estados Unidos',
    'Hans-Wolfgang Hawerkamp': 'Düsseldorf, Alemanha',
    'Heike Wolters Wrase': 'Braunschweig, Alemanha',
    'Ibrahim Nabeel': 'Amã, Jordânia',
    'Isadora Sá': 'Brasil',
    'Jackie Stofsick': 'Itália',
    'Jazzberry Blue': 'Toronto, Canadá',
    'Joackim Schou Dahle': 'Noruega',
    'Jonas Weikel': 'Karlskrona, Suécia',
    'Julia Contacessi': 'Norwalk (CT), Estados Unidos',
    'Julia Purinton': 'Washington, DC, Estados Unidos',
    'Julita Elbe': 'Münster, Alemanha',
    'Kanat Ibragimov': 'São Francisco (CA), Estados Unidos',
    'Karin Kilb': 'Alemanha',
    'Karin Lauria': 'Estados Unidos',
    'Katy Tanis': 'Estados Unidos',
    'Leigh Viner': 'Denver, Estados Unidos',
    'Linda Wride': 'Oxford, Reino Unido',
    'Little Dean': 'Malásia',
    'Livia Frigo': 'São Paulo, Brasil',
    'Lucy Muss': 'Londres, Reino Unido',
    'Magdalena Krzak': 'Chicago, Estados Unidos',
    'Marina Nelson': 'Calgary, Canadá',
    'Marisol Evora': 'Espanha',
    'Marius Surleac': 'Bucareste, Romênia',
    'Mark Russell Jones': 'Los Angeles, Estados Unidos',
    'Mette Rix': 'Aarhus, Dinamarca',
    'Mowzu': 'Ballito, África do Sul',
    'Nikita Jariwala': 'Suíça',
    'Orly Ammon': 'Redruth (Cornualha), Reino Unido',
    'Paulo Abrantes': 'Coimbra, Portugal',
    'Pictufy Studio': 'Estocolmo, Suécia',
    'Rafael Campezato': 'Igrejinha (RS), Brasil',
    'Rafael Farias': 'Brasil',
    'Richard Gombar': 'Estados Unidos',
    'Rikard Martin': 'Suécia',
    'Rob Li': 'Filadélfia, Estados Unidos',
    'Rushati Chowdhury': 'Índia',
    'Shatha Al Dafai': 'Mascate, Omã',
    'Shot by Clint': 'África do Sul',
    'Streiff Marcel': 'Zurique, Suíça',
    'Tamara Jare': 'Liubliana, Eslovênia',
    'Tamas Dragon': 'Budapeste, Hungria',
    'Tetsuji Fujino': 'Fukuoka, Japão',
    'The Miuus Studio': 'Varsóvia, Polônia',
    'Tim Mossholder': 'Santa Maria (CA), Estados Unidos',
    'Tove Hoglund': 'Skurup, Suécia',
    'Uplusmestudio': 'Flensburg, Alemanha',
    'Vered Gersztenkorn': 'Israel',
    'Vitor Costa': 'Portugal'
  };

  function buildWorkHead(root) {
    var inner = root.querySelector('.product-information--inner') || root;
    var titleEl = inner.querySelector('h1.product-title');
    if (!titleEl || inner.querySelector('.jun26-workhead')) return;
    var titleContainer = titleEl.closest('.product-title-container') || titleEl.parentElement;

    var wh = document.createElement('div');
    wh.className = 'jun26-workhead';

    var artistMenu = inner.querySelector('.artist-menu.desktop') || inner.querySelector('.artist-menu');
    var artistName = (artistMenu && artistMenu.textContent.trim()) || '';
    var artistLink = artistMenu && artistMenu.querySelector('a');
    var artistHref = (artistLink && artistLink.getAttribute('href')) || '';

    var isRedesign = root.classList.contains('thb-product-detail--redesign');
    var eyebrowRow = document.createElement('div');
    eyebrowRow.className = 'jun26-wh-eyebrow';
    var creditEl = null;
    if (artistName) {
      creditEl = artistHref ? document.createElement('a') : document.createElement('span');
      creditEl.className = 'jun26-wh-artist';
      if (artistHref) creditEl.href = artistHref;
      creditEl.textContent = artistName;
      if (!isRedesign) eyebrowRow.appendChild(creditEl);
    }
    wh.appendChild(eyebrowRow);
    inner.querySelectorAll('.artist-menu').forEach(function (a) { a.style.display = 'none'; });

    var row = document.createElement('div');
    row.className = 'jun26-wh-row';

    var titleGroup = document.createElement('div');
    titleGroup.className = 'jun26-wh-titlegroup';

    var t = (titleEl.textContent || '').trim();
    /* o " by [artista]" agora é tratado no Liquid (snippet obrah-titulo-arte),
       condicional a 1x.com — não cortar aqui senão os 1x.com perdem o by (9/jul) */
    t = t.replace(/^\s*quadro\s+/i, '').trim();
    titleEl.textContent = t;
    titleEl.classList.add('jun26-wh-title');
    titleGroup.appendChild(titleEl);

    var rating = document.createElement('div');
    rating.className = 'jun26-wh-rating';
    rating.setAttribute('aria-label', '4,9 de 5');
    var stars = document.createElement('span');
    stars.className = 'jun26-wh-stars';
    stars.textContent = '★★★★★';
    var count = document.createElement('span');
    count.className = 'jun26-wh-count';

    /* 27/jul: a nota é SELO, não régua — "4,8" em vírgula (pt-BR) e sem denominador.
       Uma estrela em tinta ao lado basta; cinco estrelas repetiam o que o número
       já diz e disputavam a atenção com o título. Vale nas duas larguras. */
    /* 28/jul: volta a UMA estrela cheia. As cinco vieram como régua (glifo
       recortado na porcentagem da nota), mas régua e número dizem a mesma coisa
       duas vezes, e ao lado do título de uma obra isso pesa. Uma estrela é
       SELO: marca que existe avaliação, e o 4,8 diz quanto. Sem recorte —
       estrela cortada em 96% lê como defeito de desenho, não como 4,8. */
    /* 28/jul: a nota vira PORTA. Ela prometia 4,8 e não levava a lugar nenhum —
       a prova ficava escondida numa aba lá embaixo. Agora ela diz quantas
       avaliações existem e rola até elas. O número de avaliações entra depois,
       quando os dados chegam (a nota nasce antes do fetch). */
    if (isRedesign) {
      count.textContent = '4,8';
      stars.textContent = '★';
      stars.setAttribute('data-nota', '4.8');
      rating.classList.add('rd-nota-link');
      rating.setAttribute('role', 'link');
      rating.setAttribute('tabindex', '0');
      var vaiProsReviews = function () {
        var alvo = document.getElementById('rd-sec-avaliacoes') || document.querySelector('.rd-tabs');
        if (alvo) window.scrollTo({ top: alvo.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      };
      rating.addEventListener('click', vaiProsReviews);
      rating.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); vaiProsReviews(); }
      });
    }
    else count.textContent = '4,9';
    rating.append(stars, count);

    if (isRedesign) {

      rating.classList.add('jun26-wh-rating--link');
      rating.setAttribute('role', 'link');
      rating.setAttribute('tabindex', '0');
      rating.addEventListener('click', function () {
        var tab = null;
        root.querySelectorAll('.rd-tab').forEach(function (b) { if (/Avalia/.test(b.textContent)) tab = b; });
        if (tab) { tab.click(); tab.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });

      if (creditEl) eyebrowRow.appendChild(creditEl);
      eyebrowRow.appendChild(rating);
    } else {
      eyebrowRow.appendChild(rating);
    }
    row.appendChild(titleGroup);

    var titleCard = root.querySelector('.pp26-gallery__title-card');
    if (titleCard) titleCard.style.setProperty('display', 'none', 'important');

    wh.appendChild(row);

    if (titleContainer && titleContainer.parentElement) {
      titleContainer.parentElement.insertBefore(wh, titleContainer);
    } else {
      inner.insertBefore(wh, inner.firstChild);
    }

    var media = root.querySelector('.pp26-product-grid__media');
    if (media && media.parentElement) {
      var mq = window.matchMedia('(max-width: 959px)');
      var placeWorkHead = function () {
        if (mq.matches) {
          if (wh.nextElementSibling !== media || wh.parentElement !== media.parentElement) {
            media.parentElement.insertBefore(wh, media);
          }
        } else if (titleContainer && titleContainer.parentElement) {
          if (wh.nextElementSibling !== titleContainer || wh.parentElement !== titleContainer.parentElement) {
            titleContainer.parentElement.insertBefore(wh, titleContainer);
          }
        }
      };
      placeWorkHead();
      if (mq.addEventListener) mq.addEventListener('change', placeWorkHead);
      else if (mq.addListener) mq.addListener(placeWorkHead);
    }

  }

  function setupCopyProtection() {
    var params = new URLSearchParams(location.search);
    var EDIT_FLAGS = ['ruler', 'colortool', 'fxedit', 'posedit', 'calibrate', 'localframes'];
    for (var i = 0; i < EDIT_FLAGS.length; i++) {
      if (params.has(EDIT_FLAGS[i])) return;
    }
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    document.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    ['copy', 'cut'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {

        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return;
        e.preventDefault();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (!(e.ctrlKey || e.metaKey)) return;
      var k = (e.key || '').toLowerCase();

      if (k === 's' || k === 'u' || k === 'p') e.preventDefault();
    });

    function lockImgs() {
      document.querySelectorAll('img:not([draggable="false"])').forEach(function (im) {
        im.setAttribute('draggable', 'false');
      });
    }
    lockImgs();
    new MutationObserver(lockImgs).observe(document.body, { childList: true, subtree: true });
  }

  function setupWishlistHearts() {
    function origButton() {
      return document.querySelector(
        '.thb-product-detail--jun26 wishlist-button-product button, ' +
        '.thb-product-detail--jun26 wk-button button, ' +
        '.thb-product-detail--jun26 button.wk-button'
      );
    }
    function syncState() {
      var o = origButton();
      var on = !!(o && o.classList.contains('wk-selected'));
      document.querySelectorAll('.jun26-heart-slot').forEach(function (slot) {
        slot.classList.toggle('jun26-heart-on', on);
      });
    }
    function hookSync() {
      var wbp = document.querySelector('.thb-product-detail--jun26 wishlist-button-product');
      if (wbp && !wbp.__jun26Sync) {
        wbp.__jun26Sync = 1;
        new MutationObserver(syncState).observe(wbp, { attributes: true, subtree: true, childList: true });
        syncState();
        return true;
      }
      return !!wbp;
    }
    function fillAll() {
      var slots = Array.prototype.slice.call(document.querySelectorAll('.jun26-heart-slot:not(.is-loaded)'));
      if (!slots.length) return false;
      /* 25/jul: NÃO espera mais o app de wishlist pra DESENHAR — o botão é nosso (svg
         via CSS). Com `if (!origButton()) return false` aqui, o app atrasando deixava o
         sticky sem o salvar. O clique repassa pro botão do app quando ele existir, e a
         sincronização engata sozinha assim que ele aparecer. */
      slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jun26-heart-btn';
        btn.setAttribute('aria-label', 'Adicionar aos favoritos');
        btn.addEventListener('click', function () {
          var o = origButton();
          if (o) o.click();
        });
        slot.innerHTML = '';
        slot.appendChild(btn);
        slot.classList.add('is-loaded');
      });
      hookSync();
      return true;
    }
    fillAll();
    /* segue observando: slots que nasçam depois ganham botão, e o sync engata
       quando o componente do app subir */
    var mo = new MutationObserver(function () {
      fillAll();
      if (hookSync()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); fillAll(); hookSync(); }, 30000);
  }

  function buildArtistBadge(root) {
    var credit = root.querySelector('.jun26-wh-artist');
    var media = root.querySelector('.pp26-product-grid__media');
    if (!credit || !media || root.querySelector('.jun26-artist-badge')) return;
    var name = (credit.textContent || '').trim();
    if (!name) return;
    var loc = ARTIST_LOCATIONS[name];
    var sub = name === '1x.com' ? 'via 1x.com' : (loc ? 'Artista · ' + loc : 'Artista');
    var href = credit.getAttribute('href') || '';
    var m = href.match(/\/collections\/([^\/?#]+)/);
    var slug = m ? m[1] : name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    var cssLink = document.querySelector('link[href*="jun26"]');
    var base = cssLink ? cssLink.href.replace(/jun26[^\/]*\.css.*$/, '') : '';

    var badge = document.createElement(href ? 'a' : 'div');
    badge.className = 'jun26-artist-badge';
    if (href) badge.href = href;
    badge.innerHTML = ''
      + '<span class="jun26-artist-badge-avatar"><span class="jun26-artist-badge-initial"></span></span>'
      + '<span class="jun26-artist-badge-col">'
      + '<span class="jun26-artist-badge-name"></span>'
      + '<span class="jun26-artist-badge-sub"></span>'
      + '</span>';
    badge.querySelector('.jun26-artist-badge-name').textContent = name;
    badge.querySelector('.jun26-artist-badge-sub').textContent = sub;
    badge.querySelector('.jun26-artist-badge-initial').textContent = (name.charAt(0) || '').toUpperCase();
    if (base) {
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.addEventListener('error', function () { img.remove(); });
      img.src = base + 'artista-' + slug + '.jpg';
      badge.querySelector('.jun26-artist-badge-avatar').appendChild(img);
    }
    media.appendChild(badge);
  }

  function fadeGalleryImgs(root) {
    var imgs = root.querySelectorAll('.pp26__art, .pp26__frame');
    [].forEach.call(imgs, function (img) {
      if (img.complete && img.naturalWidth) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.25s ease';
      var show = function () { img.style.opacity = ''; };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    });
  }

  function setupTypeEdit() {
    var params = new URLSearchParams(location.search);

    if (!params.has('typeedit') && !/typeedit/.test(location.search)) return;
    var SCOPE = '.thb-product-detail--jun26 ';
    var STORE = 'jun26_typeedit';

    var TEXT = ['family', 'size', 'weight', 'ls', 'lh', 'transform', 'style', 'color'];
    var BOX = ['width', 'maxw', 'minh', 'height', 'bg', 'radius', 'bw', 'bcolor', 'padding', 'gap', 'margin'];
    var ALL = TEXT.concat(BOX);

    var TARGETS = [
      { k: 'secLabel', g: 'Configurador', label: 'Rótulo seção (MOLDURA/COR)', sel: '.jun26-acabamento-header', controls: TEXT },
      { k: 'secValue', g: 'Configurador', label: 'Valor seção (CANVAS…)', sel: '.jun26-label-value', controls: TEXT },
      { k: 'micro', g: 'Configurador', label: 'Descrição (microcopy)', sel: '.jun26-acabamento-micro', controls: TEXT },
      { k: 'tamLabel', g: 'Configurador', label: 'Rótulo "Tamanho"', sel: '.jun26-tamanho-header-new', pseudo: '::before', controls: TEXT },
      { k: 'tamValue', g: 'Configurador', label: 'Valor tamanho (30×42)', sel: '.jun26-tamanho-header-new', pseudo: '::after', controls: TEXT },
      { k: 'pillTxt', g: 'Pills moldura', label: 'Texto do pill', sel: '.jun26-pill-name', controls: TEXT },
      { k: 'pillBox', g: 'Pills moldura', label: 'Caixa do pill', sel: '.jun26-pill', controls: BOX },
      { k: 'pillBoxOn', g: 'Pills moldura', label: 'Caixa do pill ATIVO', sel: '.jun26-pill--active', controls: BOX },
      { k: 'badgeHot', g: 'Pills moldura', label: 'Badge "MAIS PEDIDO"', sel: '.jun26-pill-badge', controls: TEXT },
      { k: 'badgeNeu', g: 'Pills moldura', label: 'Badge "COM VIDRO"', sel: '.jun26-pill-badge--neutro', controls: TEXT },
      { k: 'chipTxt', g: 'Chips tamanho', label: 'Chip · dimensão (25×35)', sel: ':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) label.jun26-size-chip', pseudo: '::before', controls: TEXT },
      { k: 'chipName', g: 'Chips tamanho', label: 'Chip · nome (Pequeno)', sel: ':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) label.jun26-size-chip', pseudo: '::after', controls: TEXT },
      { k: 'chipBox', g: 'Chips tamanho', label: 'Caixa do chip', sel: ':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) label.jun26-size-chip', controls: BOX },
      { k: 'chipTxtOn', g: 'Chips tamanho', label: 'Texto do chip ATIVO', sel: ':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked + label.jun26-size-chip', pseudo: '::before', controls: TEXT },
      { k: 'chipBoxOn', g: 'Chips tamanho', label: 'Caixa do chip ATIVO', sel: ':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked + label.jun26-size-chip', controls: BOX },
      { k: 'tgTxt', g: 'Toggle ambiente', label: 'QUADRO/AMBIENTE', sel: '.jun26-stage-toggle button', controls: ALL },
      { k: 'tgOn', g: 'Toggle ambiente', label: 'QUADRO/AMBIENTE ativo', sel: '.jun26-stage-toggle button.is-on', controls: ALL },
      { k: 'envTxt', g: 'Toggle ambiente', label: 'HALL/SALA/QUARTO…', sel: '.jun26-stage-envs button', controls: ALL },
      { k: 'envOn', g: 'Toggle ambiente', label: 'HALL/SALA… ativo', sel: '.jun26-stage-envs button.is-on', controls: ALL }
    ];
    var TMAP = {};
    TARGETS.forEach(function (t) { TMAP[t.k] = t; });

    var root0 = document.querySelector('.thb-product-detail--jun26');
    var CUSTOM = {};
    function getT(k) { return TMAP[k] || CUSTOM[k]; }
    function pre(t) { return t.noscope ? '' : SCOPE; }

    var PROP = {
      family: 'font-family', size: 'font-size', weight: 'font-weight',
      ls: 'letter-spacing', lh: 'line-height', transform: 'text-transform',
      style: 'font-style', color: 'color', bg: 'background',
      radius: 'border-radius', bw: 'border-width', bcolor: 'border-color',
      padding: 'padding', gap: 'gap', margin: 'margin',
      width: 'width', maxw: 'max-width', minh: 'min-height', height: 'height'
    };
    var FONT_OPTS = [
      { label: 'Inter', value: '"Inter", system-ui, sans-serif' },
      { label: 'Inter Tight', value: '"Inter Tight", "Inter", system-ui, sans-serif' },
      { label: 'Fold Grotesque Pro', value: '"Fold Grotesque Pro", "Inter", sans-serif' },
      { label: 'Archivo', value: '"Archivo", system-ui, sans-serif' },
      { label: 'Archivo Narrow', value: '"Archivo Narrow", "Archivo", system-ui, sans-serif' },
      { label: 'Georgia', value: 'Georgia, "Times New Roman", serif' },
      { label: 'Courier', value: '"Courier New", monospace' }
    ];
    var CTRL = {
      family: { kind: 'select', label: 'Fonte', opts: FONT_OPTS },
      size: { kind: 'num', label: 'Tamanho (px)', step: 0.5, min: 6, max: 56 },
      weight: { kind: 'select', label: 'Peso', opts: ['300', '400', '500', '600', '700', '800'] },
      ls: { kind: 'range', label: 'Kerning (em)', min: -0.05, max: 0.4, step: 0.005 },
      lh: { kind: 'text', label: 'Line-height' },
      transform: { kind: 'select', label: 'Caixa', opts: ['none', 'uppercase', 'lowercase', 'capitalize'] },
      style: { kind: 'select', label: 'Estilo', opts: ['normal', 'italic'] },
      color: { kind: 'color', label: 'Cor do texto' },
      bg: { kind: 'color', label: 'Fundo', allowNone: true },
      radius: { kind: 'num', label: 'Border-radius (px)', step: 1, min: 0, max: 999 },
      bw: { kind: 'num', label: 'Espessura borda (px)', step: 0.5, min: 0, max: 8 },
      bcolor: { kind: 'color', label: 'Cor da borda' },
      padding: { kind: 'text', label: '🟢 Padding — verde (ex. 9px 14px)' },
      gap: { kind: 'text', label: '🟢 Gap — verde (ex. 8px)' },
      margin: { kind: 'text', label: '🟠 Margem — laranja (ex. 12px 0)' },
      width: { kind: 'text', label: '🔵 Largura — azul (ex. 500px / auto)' },
      maxw: { kind: 'text', label: '🔵 Max-width — azul (ex. 430px)' },
      minh: { kind: 'text', label: '🔵 Altura mín (ex. 56px)' },
      height: { kind: 'text', label: '🔵 Altura (ex. 60px / auto)' }
    };
    var FONTS = [
      '"Inter", system-ui, sans-serif',
      '"Inter Tight", "Inter", system-ui, sans-serif',
      '"Fold Grotesque Pro", "Inter", sans-serif',
      '"Archivo", system-ui, sans-serif',
      '"Archivo Narrow", "Archivo", system-ui, sans-serif',
      'Georgia, "Times New Roman", serif',
      '"Courier New", monospace'
    ];

    function cssVal(ck, v) {
      if (v === '' || v == null) return null;
      v = String(v).trim();
      if (v === '') return null;
      if (ck === 'size' || ck === 'radius' || ck === 'bw') return /[a-z%]/i.test(v) ? v : v + 'px';
      if (ck === 'ls') return /[a-z%]/i.test(v) ? v : v + 'em';
      return v;
    }

    var state = (function () { try { return JSON.parse(localStorage.getItem(STORE) || '{}'); } catch (e) { return {}; } })();

    Object.keys(state._custom || {}).forEach(function (k) { CUSTOM[k] = state._custom[k]; });
    function save() { localStorage.setItem(STORE, JSON.stringify(state)); }
    var curKey = (state._cur && getT(state._cur)) ? state._cur : TARGETS[0].k;

    var styleEl = document.getElementById('jun26-typeedit-style');
    if (!styleEl) { styleEl = document.createElement('style'); styleEl.id = 'jun26-typeedit-style'; document.head.appendChild(styleEl); }
    function rebuild() {
      var css = '';
      Object.keys(state).forEach(function (k) {
        var t = getT(k); if (!t) return;
        var o = state[k]; var decls = [];
        Object.keys(o).forEach(function (ck) {
          var cv = cssVal(ck, o[ck]); if (cv == null) return;
          decls.push(PROP[ck] + ':' + cv + ' !important');
        });
        if (decls.length) css += pre(t) + t.sel + (t.pseudo || '') + '{' + decls.join(';') + '}\n';
      });
      styleEl.textContent = css;
    }
    rebuild();

    function compVal(t, ck) {
      var p = pre(t);
      var el = document.querySelector(p + t.sel.replace(/:checked/g, '').replace(/\s*\+\s*/g, ' '));
      if (!el) el = document.querySelector(p + t.sel.split(' ').pop());
      if (!el) return '';
      var cs = getComputedStyle(el, t.pseudo || undefined);
      var fs = parseFloat(cs.fontSize) || 16;
      switch (ck) {
        case 'family': return cs.fontFamily;
        case 'size': return Math.round(fs * 10) / 10;
        case 'weight': return String(parseInt(cs.fontWeight, 10) || 400);
        case 'ls': var l = cs.letterSpacing === 'normal' ? 0 : parseFloat(cs.letterSpacing) || 0; return Math.round((l / fs) * 1000) / 1000;
        case 'lh': return cs.lineHeight;
        case 'transform': return cs.textTransform;
        case 'style': return cs.fontStyle;
        case 'color': return cs.color;
        case 'bg': return '';
        case 'radius': return Math.round(parseFloat(cs.borderTopLeftRadius) || 0);
        case 'bw': return Math.round((parseFloat(cs.borderTopWidth) || 0) * 10) / 10;
        case 'bcolor': return cs.borderTopColor;
        case 'padding': return cs.padding;
        case 'gap': return cs.gap === 'normal' ? '' : cs.gap;
        case 'margin': return cs.margin;
        case 'width': return cs.width;
        case 'maxw': return cs.maxWidth === 'none' ? '' : cs.maxWidth;
        case 'minh': return cs.minHeight === 'auto' ? '' : cs.minHeight;
        case 'height': return cs.height;
      }
      return '';
    }
    function dispVal(t, ck) {
      if (state[t.k] && state[t.k][ck] != null) return state[t.k][ck];
      return compVal(t, ck);
    }
    function rgbToHex(c) {
      var m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(c || '');
      if (!m) return /^#/.test(c) ? c : '#000000';
      return '#' + [m[1], m[2], m[3]].map(function (n) { return ('0' + (+n).toString(16)).slice(-2); }).join('');
    }
    function esc(s) { return String(s).replace(/"/g, '&quot;'); }

    function renderControls() {
      var t = getT(curKey);
      var html = '';
      t.controls.forEach(function (ck) {
        var c = CTRL[ck]; var v = dispVal(t, ck);
        html += '<div style="margin-bottom:9px">';
        html += '<label style="display:block;font-size:9px;letter-spacing:.04em;color:#888;margin-bottom:3px;text-transform:uppercase">' + c.label + '</label>';
        if (c.kind === 'num') {
          html += '<input type="number" data-ck="' + ck + '" value="' + esc(v) + '" step="' + c.step + '" min="' + c.min + '" max="' + c.max + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
        } else if (c.kind === 'range') {
          html += '<div style="display:flex;align-items:center;gap:8px">'
            + '<input type="range" data-ck="' + ck + '" value="' + esc(v) + '" min="' + c.min + '" max="' + c.max + '" step="' + c.step + '" style="flex:1">'
            + '<input type="text" class="te-ro" data-ro="' + ck + '" value="' + (+v).toFixed(3) + '" title="digite/copie o valor em em" style="width:60px;padding:5px 6px;border:1px solid #ddd;border-radius:3px;font:11px monospace;text-align:right">'
            + '<span style="font:10px monospace;color:#999">em</span>'
            + '</div>';
        } else if (c.kind === 'select') {
          html += '<select data-ck="' + ck + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
          var vfam = String(v).toLowerCase().replace(/["']/g, '').split(',')[0].trim();
          c.opts.forEach(function (o) {
            var val = (o && o.value != null) ? o.value : o, lab = (o && o.label != null) ? o.label : o;
            var ofam = String(val).toLowerCase().replace(/["']/g, '').split(',')[0].trim();
            var sel = (String(v) === String(val)) || (vfam && vfam === ofam);
            html += '<option value="' + esc(val) + '"' + (sel ? ' selected' : '') + '>' + esc(lab) + '</option>';
          });
          html += '</select>';
        } else if (c.kind === 'color') {
          html += '<div style="display:flex;gap:6px;align-items:center">';
          html += '<input type="color" data-ckc="' + ck + '" value="' + rgbToHex(v) + '" style="width:34px;height:30px;padding:0;border:1px solid #ddd;border-radius:3px;cursor:pointer">';
          html += '<input type="text" data-ck="' + ck + '" value="' + esc(v) + '"' + (c.allowNone ? ' placeholder="none / #hex / rgb()"' : '') + ' style="flex:1;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:11px monospace">';
          html += '</div>';
        } else {
          html += '<input type="text" data-ck="' + ck + '"' + (c.list ? ' list="jun26-te-fonts"' : '') + ' value="' + esc(v) + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
        }
        html += '</div>';
      });
      var body = panel.querySelector('#te-controls');
      body.innerHTML = html;
      body.querySelectorAll('[data-ck]').forEach(function (inp) {
        var ev = (inp.tagName === 'SELECT' || inp.type === 'range') ? 'input' : 'input';
        inp.addEventListener(ev, onEdit);
        if (inp.tagName !== 'SELECT') inp.addEventListener('change', onEdit);
      });
      body.querySelectorAll('[data-ckc]').forEach(function (pick) {
        pick.addEventListener('input', function () {
          var ck = pick.getAttribute('data-ckc');
          var txt = body.querySelector('input[data-ck="' + ck + '"]');
          if (txt) { txt.value = pick.value; onEditVal(ck, pick.value); }
        });
      });

      body.querySelectorAll('[data-ro]').forEach(function (ro) {
        ro.addEventListener('input', function () {
          var ck = ro.getAttribute('data-ro');
          var rng = body.querySelector('input[type="range"][data-ck="' + ck + '"]');
          if (rng && ro.value !== '' && !isNaN(+ro.value)) rng.value = ro.value;
          onEditVal(ck, ro.value);
        });
      });
    }
    function onEditVal(ck, v) {
      var o = state[curKey] = state[curKey] || {};
      if (v === '' || v == null) delete o[ck]; else o[ck] = v;
      if (Object.keys(o).length === 0) delete state[curKey];
      save(); rebuild();
    }
    function onEdit(e) {
      var ck = e.target.getAttribute('data-ck');
      onEditVal(ck, e.target.value);
      if (e.target.type === 'range') {
        var ro = e.target.parentNode.querySelector('.te-ro');
        if (ro) ro.value = (+e.target.value).toFixed(3);
      }
    }

    function grabFrom(el) {
      var cs = getComputedStyle(el);
      var t = getT(curKey);
      var fs = parseFloat(cs.fontSize) || 16;
      var src = {
        family: cs.fontFamily,
        size: Math.round(fs * 10) / 10,
        weight: String(parseInt(cs.fontWeight, 10) || 400),
        ls: Math.round(((cs.letterSpacing === 'normal' ? 0 : parseFloat(cs.letterSpacing) || 0) / fs) * 1000) / 1000,
        lh: cs.lineHeight,
        transform: cs.textTransform,
        style: cs.fontStyle,
        color: cs.color
      };
      var o = state[curKey] = state[curKey] || {};
      Object.keys(src).forEach(function (ck) { if (t.controls.indexOf(ck) >= 0) o[ck] = src[ck]; });
      save(); rebuild(); renderControls();
    }
    function startPick() {
      panel.style.opacity = '0.2'; panel.style.pointerEvents = 'none';
      var hi = document.createElement('div');
      hi.style.cssText = 'position:fixed;pointer-events:none;z-index:99998;border:2px solid #7c3aed;background:rgba(124,58,237,.12);transition:all 40ms';
      document.body.appendChild(hi);
      var tip = document.createElement('div');
      tip.textContent = 'Clique no elemento pra copiar a fonte · ESC cancela';
      tip.style.cssText = 'position:fixed;top:12px;left:50%;transform:translateX(-50%);background:#7c3aed;color:#fff;font:11px Archivo;padding:6px 12px;border-radius:999px;z-index:99999;pointer-events:none';
      document.body.appendChild(tip);
      var last = null;
      function mm(e) { var el = document.elementFromPoint(e.clientX, e.clientY); if (!el || el === hi || el === tip) return; last = el; var r = el.getBoundingClientRect(); hi.style.left = r.left + 'px'; hi.style.top = r.top + 'px'; hi.style.width = r.width + 'px'; hi.style.height = r.height + 'px'; }
      function clk(e) { e.preventDefault(); e.stopPropagation(); var el = last || document.elementFromPoint(e.clientX, e.clientY); cleanup(); if (el) grabFrom(el); }
      function key(e) { if (e.key === 'Escape') cleanup(); }
      function cleanup() { panel.style.opacity = ''; panel.style.pointerEvents = ''; hi.remove(); tip.remove(); document.removeEventListener('mousemove', mm, true); document.removeEventListener('click', clk, true); document.removeEventListener('keydown', key, true); }
      document.addEventListener('mousemove', mm, true);
      document.addEventListener('click', clk, true);
      document.addEventListener('keydown', key, true);
    }

    function selFor(el) {
      var inside = !!(root0 && root0.contains(el));
      if (el.id) return { sel: '#' + el.id, noscope: !inside };
      var cls = (el.getAttribute('class') || '').trim().split(/\s+/).filter(Boolean)
        .filter(function (c) { return !/^(is-on|active|selected|jun26-ready|jun26-amb-on|jun26-amb-active|swiper-|slick-|pp26-gallery--ready)/.test(c); });
      return { sel: el.tagName.toLowerCase() + (cls.length ? '.' + cls.join('.') : ''), noscope: !inside };
    }
    function makeCustom(el) {
      var info = selFor(el);
      var existing = TARGETS.filter(function (t) { return t.sel === info.sel && !t.pseudo; })[0];
      if (existing) { curKey = existing.k; }
      else {
        var dup = Object.keys(CUSTOM).filter(function (k) { return CUSTOM[k].sel === info.sel && !!CUSTOM[k].noscope === info.noscope; })[0];
        if (dup) { curKey = dup; }
        else {
          var key = 'custom_' + (Object.keys(CUSTOM).length + 1);
          var label = (info.noscope ? '⌖ ' : '') + (info.sel.length > 30 ? info.sel.slice(0, 29) + '…' : info.sel);
          CUSTOM[key] = { k: key, sel: info.sel, noscope: info.noscope, label: label, controls: ALL };
          state._custom = state._custom || {};
          state._custom[key] = CUSTOM[key];
          curKey = key;
        }
      }
      state._cur = curKey; save();
      refreshDropdown(); renderControls();
    }
    function startPickEdit() {
      panel.style.opacity = '0.2'; panel.style.pointerEvents = 'none';
      var hi = document.createElement('div');
      hi.style.cssText = 'position:fixed;pointer-events:none;z-index:99998;border:2px solid #0ea5a3;background:rgba(14,165,163,.14);transition:all 40ms';
      document.body.appendChild(hi);
      var tip = document.createElement('div');
      tip.textContent = 'Clique no elemento pra EDITAR · ESC cancela';
      tip.style.cssText = 'position:fixed;top:12px;left:50%;transform:translateX(-50%);background:#0ea5a3;color:#fff;font:11px Archivo;padding:6px 12px;border-radius:999px;z-index:99999;pointer-events:none';
      document.body.appendChild(tip);
      var last = null;
      function mm(e) { var el = document.elementFromPoint(e.clientX, e.clientY); if (!el || el === hi || el === tip) return; last = el; var r = el.getBoundingClientRect(); hi.style.left = r.left + 'px'; hi.style.top = r.top + 'px'; hi.style.width = r.width + 'px'; hi.style.height = r.height + 'px'; }
      function clk(e) { e.preventDefault(); e.stopPropagation(); var el = last || document.elementFromPoint(e.clientX, e.clientY); cleanup(); if (el) makeCustom(el); }
      function key(e) { if (e.key === 'Escape') cleanup(); }
      function cleanup() { panel.style.opacity = ''; panel.style.pointerEvents = ''; hi.remove(); tip.remove(); document.removeEventListener('mousemove', mm, true); document.removeEventListener('click', clk, true); document.removeEventListener('keydown', key, true); }
      document.addEventListener('mousemove', mm, true);
      document.addEventListener('click', clk, true);
      document.addEventListener('keydown', key, true);
    }

    function exportCSS() {
      var css = '/* ===== typeedit — colar no assets/jun26.css ===== */\n';
      Object.keys(state).forEach(function (k) {
        var t = getT(k); if (!t) return; var o = state[k]; var decls = [];
        Object.keys(o).forEach(function (ck) { var cv = cssVal(ck, o[ck]); if (cv == null) return; decls.push('  ' + PROP[ck] + ': ' + cv + ' !important;'); });
        if (decls.length) css += pre(t) + t.sel + (t.pseudo || '') + ' {\n' + decls.join('\n') + '\n}\n';
      });
      return css;
    }

    var panel = document.createElement('div');
    panel.id = 'jun26-typeedit';
    panel.style.cssText = 'position:fixed;top:12px;right:18px;background:#fff;border:1px solid #111;border-radius:6px;z-index:99990;font:12px Archivo,system-ui,sans-serif;width:300px;box-shadow:0 10px 30px rgba(0,0,0,.18);display:flex;flex-direction:column;max-height:calc(100vh - 24px)';
    var groups = [];
    TARGETS.forEach(function (t) { if (groups.indexOf(t.g) < 0) groups.push(t.g); });
    function buildOpts() {
      var html = groups.map(function (g) {
        return '<optgroup label="' + g + '">' + TARGETS.filter(function (t) { return t.g === g; }).map(function (t) {
          return '<option value="' + t.k + '"' + (t.k === curKey ? ' selected' : '') + '>' + t.label + '</option>';
        }).join('') + '</optgroup>';
      }).join('');
      var ck = Object.keys(CUSTOM);
      if (ck.length) {
        html += '<optgroup label="✏️ Selecionados">' + ck.map(function (k) {
          return '<option value="' + k + '"' + (k === curKey ? ' selected' : '') + '>' + esc(CUSTOM[k].label) + '</option>';
        }).join('') + '</optgroup>';
      }
      return html;
    }
    function refreshDropdown() {
      var sel = panel.querySelector('#te-target');
      if (sel) { sel.innerHTML = buildOpts(); sel.value = curKey; }
    }
    var optsHtml = buildOpts();
    panel.innerHTML = ''
      + '<div id="te-head" style="display:flex;align-items:center;justify-content:space-between;padding:11px 12px;border-bottom:1px solid #eee;cursor:move">'
      + '<b style="font-size:11px;letter-spacing:.1em;text-transform:uppercase">Editor de estilo</b>'
      + '<button id="te-x" style="width:22px;height:22px;border:none;background:transparent;cursor:pointer;font-size:16px;color:#999;line-height:1">×</button>'
      + '</div>'
      + '<div style="padding:11px 12px 0">'
      + '<button id="te-select" style="width:100%;padding:8px;margin-bottom:7px;background:#0ea5a3;color:#fff;border:none;border-radius:4px;cursor:pointer;font:11px Archivo;letter-spacing:.04em">✏️ SELECIONAR ELEMENTO</button>'
      + '<select id="te-target" style="width:100%;padding:6px 7px;border:1px solid #ccc;border-radius:4px;font:12px Archivo;margin-bottom:9px">' + optsHtml + '</select>'
      + '<div style="display:flex;gap:5px;margin-bottom:10px">'
      + '<button id="te-pick" style="flex:1;padding:6px 4px;background:#7c3aed;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.04em">🎯 PEGAR ESTILO</button>'
      + '<button id="te-refresh" title="Re-ler valores atuais" style="padding:6px 9px;background:#f4f4f5;border:1px solid #ddd;border-radius:4px;cursor:pointer;font:11px Archivo">↻</button>'
      + '<button id="te-reset" title="Resetar este alvo" style="padding:6px 9px;background:#f4f4f5;border:1px solid #ddd;border-radius:4px;cursor:pointer;font:10px Archivo">RESET</button>'
      + '</div>'
      + '</div>'
      + '<div id="te-controls" style="padding:0 12px;overflow:auto;flex:1"></div>'
      + '<div style="padding:10px 12px;border-top:1px solid #eee">'
      + '<div style="display:flex;gap:5px">'
      + '<button id="te-export" style="flex:1;padding:7px;background:#111;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.05em">EXPORTAR CSS</button>'
      + '<button id="te-resetall" style="padding:7px 9px;background:#fff;border:1px solid #d33;color:#d33;border-radius:4px;cursor:pointer;font:10px Archivo">LIMPAR TUDO</button>'
      + '</div>'
      + '<textarea id="te-out" readonly style="display:none;width:100%;height:120px;margin-top:8px;font:10px monospace;border:1px solid #ddd;border-radius:4px;padding:6px;resize:vertical;box-sizing:border-box"></textarea>'
      + '</div>'
      + '<datalist id="jun26-te-fonts">' + FONTS.map(function (f) { return '<option value="' + esc(f) + '">'; }).join('') + '</datalist>';
    document.body.appendChild(panel);

    var teScope = document.querySelector('.thb-product-detail--redesign') || document;
    var OV = {}, teHidden = false, teLastKey = curKey, teDragging = false, teHandle = null;

    document.addEventListener('keydown', function (e) {
      if (!document.getElementById('jun26-typeedit')) return;
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '');
      if (e.key === 'Escape') { teHidden = true; }
      else if ((e.key === 's' || e.key === 'S') && !typing) { e.preventDefault(); startPickEdit(); }
    });

    function ensureHandle() {
      if (teHandle) return;
      teHandle = document.createElement('div');
      teHandle.style.cssText = 'position:fixed;z-index:99983;width:10px;pointer-events:auto;cursor:ew-resize;display:none;background:#5A96EB;border-radius:5px;box-shadow:0 0 0 2px #fff';
      document.body.appendChild(teHandle);
      teHandle.addEventListener('mousedown', function (e) {
        e.preventDefault(); e.stopPropagation();
        var el = teCurEl(); if (!el) return;
        teDragging = true; document.body.style.cursor = 'ew-resize';
        var left = el.getBoundingClientRect().left, curW = Math.round(el.getBoundingClientRect().width);
        function mm(ev) { curW = Math.max(60, Math.round(ev.clientX - left)); el.style.setProperty('width', curW + 'px', 'important'); }
        function up() { teDragging = false; document.body.style.cursor = ''; document.removeEventListener('mousemove', mm, true); document.removeEventListener('mouseup', up, true); el.style.removeProperty('width'); onEditVal('width', curW + 'px'); }
        document.addEventListener('mousemove', mm, true); document.addEventListener('mouseup', up, true);
      });
    }
    function mkBox(bg) { var d = document.createElement('div'); d.style.cssText = 'position:fixed;pointer-events:none;z-index:99980;display:none;box-sizing:border-box;background:' + bg; document.body.appendChild(d); return d; }
    function box(d, x, y, w, h) { d.style.display = 'block'; d.style.left = x + 'px'; d.style.top = y + 'px'; d.style.width = Math.max(0, w) + 'px'; d.style.height = Math.max(0, h) + 'px'; }
    function teCurEl() { var t = getT(curKey); if (!t || t.pseudo) return null; try { return (t.noscope ? document : teScope).querySelector(t.sel); } catch (e) { return null; } }
    function teDrawOverlay() {
      if (!OV.m) {
        OV.m = mkBox('rgba(246,178,107,0.30)'); OV.p = mkBox('rgba(140,200,120,0.40)'); OV.c = mkBox('rgba(90,150,235,0.42)');
        OV.lbl = mkBox('rgba(20,18,16,0.92)'); OV.lbl.style.color = '#fff'; OV.lbl.style.font = '10px/1.5 monospace'; OV.lbl.style.padding = '2px 6px'; OV.lbl.style.whiteSpace = 'nowrap'; OV.lbl.style.zIndex = '99981';
      }
      if (teLastKey !== curKey) { teLastKey = curKey; teHidden = false; }
      var el = teHidden ? null : teCurEl();
      if (!el) { [OV.m, OV.p, OV.c, OV.lbl].forEach(function (d) { d.style.display = 'none'; }); if (teHandle) teHandle.style.display = 'none'; return; }
      var r = el.getBoundingClientRect(), cs = getComputedStyle(el), pf = function (v) { return parseFloat(v) || 0; };
      var mt = pf(cs.marginTop), mr = pf(cs.marginRight), mb = pf(cs.marginBottom), ml = pf(cs.marginLeft);
      var pt = pf(cs.paddingTop), pr = pf(cs.paddingRight), pb = pf(cs.paddingBottom), pl = pf(cs.paddingLeft);
      box(OV.m, r.left - ml, r.top - mt, r.width + ml + mr, r.height + mt + mb);
      box(OV.p, r.left, r.top, r.width, r.height);
      box(OV.c, r.left + pl, r.top + pt, r.width - pl - pr, r.height - pt - pb);
      OV.lbl.style.display = 'block'; OV.lbl.style.left = r.left + 'px'; OV.lbl.style.top = Math.max(0, r.top - 20) + 'px'; OV.lbl.style.width = 'auto'; OV.lbl.style.height = 'auto';
      OV.lbl.textContent = 'L ' + Math.round(r.width) + ' × A ' + Math.round(r.height) + '  ·  pad ' + Math.round(pt) + '/' + Math.round(pr) + '/' + Math.round(pb) + '/' + Math.round(pl);

      ensureHandle();
      teHandle.style.display = 'block'; teHandle.style.left = Math.round(r.left + r.width - 5) + 'px'; teHandle.style.top = Math.round(r.top) + 'px'; teHandle.style.height = Math.max(20, Math.round(r.height)) + 'px';
    }
    (function teLoop() { if (document.getElementById('jun26-typeedit')) teDrawOverlay(); requestAnimationFrame(teLoop); })();

    panel.querySelector('#te-target').addEventListener('change', function () { curKey = this.value; state._cur = curKey; save(); renderControls(); });
    panel.querySelector('#te-select').addEventListener('click', startPickEdit);
    panel.querySelector('#te-pick').addEventListener('click', startPick);
    panel.querySelector('#te-refresh').addEventListener('click', renderControls);
    panel.querySelector('#te-reset').addEventListener('click', function () { delete state[curKey]; save(); rebuild(); renderControls(); });
    panel.querySelector('#te-resetall').addEventListener('click', function () {
      if (!confirm('Limpar TODOS os overrides do typeedit?')) return;
      Object.keys(state).forEach(function (k) { if (k !== '_cur') delete state[k]; });
      CUSTOM = {};
      curKey = (getT(state._cur)) ? state._cur : TARGETS[0].k;
      state._cur = curKey;
      save(); rebuild(); refreshDropdown(); renderControls();
    });
    panel.querySelector('#te-export').addEventListener('click', function () {
      var out = panel.querySelector('#te-out'); out.value = exportCSS(); out.style.display = 'block'; out.select();
      if (navigator.clipboard) navigator.clipboard.writeText(out.value);
      this.textContent = 'COPIADO ✓'; var b = this; setTimeout(function () { b.textContent = 'EXPORTAR CSS'; }, 1400);
    });
    panel.querySelector('#te-x').addEventListener('click', function () {
      panel.style.display = 'none';
      var op = document.createElement('button');
      op.textContent = 'ESTILO'; op.style.cssText = 'position:fixed;top:70px;right:18px;padding:7px 11px;background:#111;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:99990';
      op.onclick = function () { panel.style.display = ''; op.remove(); };
      document.body.appendChild(op);
    });

    (function () {
      var head = panel.querySelector('#te-head'), drag = false, sx, sy, sl, st2;
      head.addEventListener('mousedown', function (e) {
        if (e.target.tagName === 'BUTTON') return;
        drag = true; sx = e.clientX; sy = e.clientY;
        var r = panel.getBoundingClientRect(); sl = r.left; st2 = r.top;
        panel.style.right = 'auto'; e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!drag) return;
        panel.style.left = Math.max(0, Math.min(window.innerWidth - 120, sl + e.clientX - sx)) + 'px';
        panel.style.top = Math.max(0, Math.min(window.innerHeight - 40, st2 + e.clientY - sy)) + 'px';
      });
      document.addEventListener('mouseup', function () { drag = false; });
    })();

    renderControls();

    [200, 500, 1000, 2000].forEach(function (ms) { setTimeout(renderControls, ms); });
  }

  function setupArtZoom(root) {
    var mqMobile = window.matchMedia('(max-width: 959px)');
    var media = function () { return root.querySelector('.pp26-product-grid__media'); };
    function isAmb() { var m = media(); return !!(m && m.classList.contains('jun26-amb-on')); }
    function srcNode() {
      return isAmb() ? root.querySelector('.jun26-amb') : root.querySelector('.pp26__perspective-stage');
    }
    function artSrc() {
      var a = root.querySelector('.pp26__art');
      var s = a && a.getAttribute('src');
      if (!s) return null;
      if (/[?&]width=/.test(s)) return s.replace(/([?&]width=)\d+/, function (m, p1) { return p1 + '1600'; });
      return s + (s.indexOf('?') < 0 ? '?' : '&') + 'width=1600';
    }
    function isSemMoldura() {
      var a = root.querySelector('.jun26-pill--active .jun26-pill-name');
      return !!(a && /sem\s*moldura/i.test(a.textContent));
    }

    var COPY = ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'box-sizing',
      'transform', 'transform-origin', 'perspective', 'perspective-origin', 'transform-style',
      'clip-path', '-webkit-clip-path',
      'background-color', 'background-image', 'background-size', 'background-position', 'background-repeat', 'background-blend-mode',
      'box-shadow', 'opacity', 'mix-blend-mode', 'filter', '-webkit-filter',
      'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
      'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style',
      'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
      'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius',
      'object-fit', 'object-position', 'overflow', 'z-index', 'display'];
    function copyComputed(src, clone) {
      var a = [src].concat([].slice.call(src.querySelectorAll('*')));
      var b = [clone].concat([].slice.call(clone.querySelectorAll('*')));
      for (var i = 0; i < a.length && i < b.length; i++) {
        var cs = getComputedStyle(a[i]);
        for (var j = 0; j < COPY.length; j++) {
          var v = cs.getPropertyValue(COPY[j]);
          if (v) b[i].style.setProperty(COPY[j], v);
        }
      }
    }
    function buildAmbClone() {
      var src = srcNode();
      if (!src) return null;

      var ow = src.offsetWidth, oh = src.offsetHeight;
      if (!ow || !oh) return null;
      var clone = src.cloneNode(true);
      copyComputed(src, clone);

      ['.jun26-amb-tex', '.jun26-amb-vao'].forEach(function (s) { var e = clone.querySelector(s); if (e) e.remove(); });

      clone.style.setProperty('position', 'relative');
      ['top', 'left', 'right', 'bottom'].forEach(function (p) { clone.style.setProperty(p, 'auto'); });
      clone.style.setProperty('margin', '0');
      clone.style.setProperty('display', 'block');
      clone.style.setProperty('width', ow + 'px');
      clone.style.setProperty('height', oh + 'px');
      clone.style.setProperty('visibility', 'visible');
      clone.style.setProperty('transform-origin', 'center center');

      clone.style.setProperty('border', '0', 'important');
      clone.style.setProperty('border-radius', '0', 'important');
      clone.style.setProperty('box-shadow', 'none', 'important');
      clone.style.setProperty('background', '#F1EFEA', 'important');
      clone.style.setProperty('touch-action', 'none');
      clone._w = ow; clone._h = oh;
      return clone;
    }
    function open() {
      if (!mqMobile.matches) return;
      if (document.querySelector('.jun26-artzoom')) return;
      var amb = isAmb();
      var ov = document.createElement('div');
      ov.className = 'jun26-artzoom' + (amb ? ' jun26-artzoom--amb' : '');
      /* 26/jul: MESMO X da gaveta do mega menu mobile — traço 1,22px, pontas retas,
         braço de 20,3px numa caixa de 15,22px (o hamburger virado). Sem caixa em volta. */
      ov.innerHTML = '<button class="jun26-artzoom__close" type="button" aria-label="Fechar">'
        + '<svg class="jun26-artzoom__x" viewBox="0 0 15.22 15.22" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.22" stroke-linecap="butt" aria-hidden="true"><path d="M0.61 0.61 L14.61 14.61 M14.61 0.61 L0.61 14.61"/></svg>'
        + '</button>'
        + '<div class="jun26-artzoom__stage"></div>'
        + (amb ? '<div class="jun26-artzoom__envs"></div>' : '');
      document.body.appendChild(ov);
      /* ═══ WHEEL DE CARREGAMENTO (4/ago, mobile) ═══
         O zoom abre antes da foto grande responder e ficava um limbo mudo —
         "não há resposta... indicando que vai abrir algo". Enquanto a imagem
         da vista atual não está completa, um véu claro congela a cena e uma
         wheel gira no centro; some sozinha quando a foto chega. Vale pra
         abertura E pra troca de cômodo (o vigia relê a cada 120ms). */
      var zoomLoadIv = null;
      if (window.matchMedia('(max-width: 767px)').matches) {
        var vLoad = document.createElement('div');
        vLoad.setAttribute('aria-hidden', 'true');
        vLoad.style.cssText = 'position:absolute;inset:0;z-index:3;display:flex;'
          + 'align-items:center;justify-content:center;pointer-events:none;'
          + 'background:rgba(241,239,234,.55);opacity:1;transition:opacity .22s ease;';
        /* anel que FECHA: progresso avança sozinho até ~92% (não há bytes de
           <img> pra medir) e crava 100% quando a foto responde — a roda
           fechando É o aviso de "vai abrir" (4/ago) */
        var anel = document.createElement('div');
        anel.style.cssText = 'width:32px;height:32px;border-radius:50%;'
          + '-webkit-mask:radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px));'
          + 'mask:radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px));';
        vLoad.appendChild(anel);
        ov.appendChild(vLoad);
        var zoomProg = 0, zoomSrc = '';
        zoomLoadIv = setInterval(function () {
          /* a vista de AMBIENTE é um CLONE da cena, sem .jun26-artzoom__img
             — mirar só nela deixava o véu eterno nos cômodos (4/ago, "não tá
             carregando por completo"). O critério certo: TODAS as <img> da
             ÚLTIMA camada (a ativa) completas. */
          var lays = ov.querySelectorAll('.jun26-artzoom__layer');
          var atual = lays.length ? lays[lays.length - 1] : null;
          var ims = atual ? atual.querySelectorAll('img') : [];
          var im = ims.length ? ims[0] : null;
          var srcAtual = im ? (im.currentSrc || im.src || '') : '';
          if (srcAtual !== zoomSrc) { zoomSrc = srcAtual; zoomProg = 0.08; }
          var pronto = ims.length > 0;
          for (var k = 0; k < ims.length; k++) {
            if (!(ims[k].complete && ims[k].naturalWidth > 0)) { pronto = false; break; }
          }
          zoomProg = pronto ? 1 : Math.min(0.92, zoomProg + (0.92 - zoomProg) * 0.14);
          anel.style.background = 'conic-gradient(from -90deg, #161310 '
            + Math.round(zoomProg * 360) + 'deg, rgba(22,19,16,.15) 0)';
          vLoad.style.opacity = pronto ? '0' : '1';
        }, 120);
      }
      /* (4/ago) no celular o X veste a MESMA pastilha do palco (bola branca,
         sombra curta): o zoom flutua sobre cena que muda de cor, e o X seco
         sumia sobre parede clara. Inline porque este overlay nasce no body,
         fora do alcance confiável das folhas do tema (a regra em CSS existia,
         batia no seletor e ainda assim perdia — cascata de CDN + hot-reload;
         inline não deve nada a ninguém). Desktop segue como está. */
      if (window.matchMedia('(max-width: 767px)').matches) {
        var xbtn = ov.querySelector('.jun26-artzoom__close');
        if (xbtn) {
          /* setProperty com important: há regra de tema com !important neste
             botão que vencia até inline comum (medido: o inline dizia 50% e
             o computado devolvia 0) */
          var xcss = {
            /* acima do véu de carregamento (z 3): o fechar fica sempre
               nítido e vivo, mesmo com a wheel girando. SEM mexer em
               position — a folha do tema já o ancora; um relative aqui o
               arrancava do canto (4/ago, "o x saiu de lugar"). */
            'z-index': '6',
            width: '34px', height: '34px', display: 'flex',
            'align-items': 'center', 'justify-content': 'center',
            padding: '0', border: '0', 'border-radius': '50%',
            background: '#FFFFFF', color: '#161310',
            'box-shadow': '0 1px 3px rgba(22,19,16,.12), 0 4px 12px rgba(22,19,16,.08)'
          };
          for (var xk in xcss) xbtn.style.setProperty(xk, xcss[xk], 'important');
          var xsvg = xbtn.querySelector('svg');
          if (xsvg) { xsvg.setAttribute('width', '13'); xsvg.setAttribute('height', '13'); }
        }
      }
      document.documentElement.style.overflow = 'hidden';

      function attachGesture(st, el, cw, ch, qcx, qcy, qw, qh, baseFactor, initMul, tx0, ty0) {
        var vw = window.innerWidth, vh = window.innerHeight;
        var SMOOTH = 'transform .34s cubic-bezier(.22,1,.36,1)';
        var minS = baseFactor, maxS = baseFactor * 4;
        var scale = Math.min(maxS, baseFactor * initMul);
        var tx = 0, ty = 0;
        function center() { tx = -(qcx - cw / 2) * scale; ty = -(qcy - ch / 2) * scale; }

        function clampT() {
          var moX = Math.max(0, cw * scale / 2 - vw / 2), moY = Math.max(0, ch * scale / 2 - vh / 2);
          tx = Math.max(-moX, Math.min(moX, tx));
          ty = Math.max(-moY, Math.min(moY, ty));
        }
        function apply() { el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
        el.style.transition = 'none';

        if (typeof tx0 === 'number') { tx = tx0; ty = (typeof ty0 === 'number' ? ty0 : 0); clampT(); }
        else { center(); }
        apply();
        requestAnimationFrame(function () { el.style.transition = SMOOTH; });
        st.style.cursor = 'grab';
        var pts = {}, pinch = null, lastTap = 0;
        function pcount() { var n = 0, k; for (k in pts) n++; return n; }
        st.onpointerdown = function (e) {
          pts[e.pointerId] = { x: e.clientX, y: e.clientY };
          try { st.setPointerCapture(e.pointerId); } catch (x) { }
          var ids = []; for (var k in pts) ids.push(k);
          if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]]; pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y) }; }
          el.style.transition = 'none';
          st.style.cursor = 'grabbing';
        };
        st.onpointermove = function (e) {
          if (!pts[e.pointerId]) return;
          var ids = []; for (var k in pts) ids.push(k);
          if (ids.length === 1) {
            var p = pts[e.pointerId];
            tx += e.clientX - p.x; ty += e.clientY - p.y;
            p.x = e.clientX; p.y = e.clientY;
            clampT(); apply();
          } else if (ids.length >= 2) {
            pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY;
            var a = pts[ids[0]], b = pts[ids[1]];
            var dist = Math.hypot(a.x - b.x, a.y - b.y);
            var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
            if (!pinch) { pinch = { dist: dist }; return; }
            var ns = Math.max(minS, Math.min(maxS, scale * dist / pinch.dist));
            var clmx = cw / 2 + (mx - vw / 2 - tx) / scale, clmy = ch / 2 + (my - vh / 2 - ty) / scale;
            scale = ns;
            tx = mx - vw / 2 - (clmx - cw / 2) * scale;
            ty = my - vh / 2 - (clmy - ch / 2) * scale;
            pinch.dist = dist; clampT(); apply();
          }
        };
        st.onpointerup = function (e) {
          delete pts[e.pointerId];
          if (pcount() < 2) pinch = null;
          if (pcount() === 0) {
            st.style.cursor = 'grab';
            el.style.transition = SMOOTH;
            var now = e.timeStamp || 0;
            if (now - lastTap < 300) {
              scale = (Math.abs(scale - minS) < 0.01) ? Math.min(maxS, baseFactor * Math.max(1.5, initMul)) : minS;
              center(); clampT(); apply(); lastTap = 0;
            } else { clampT(); apply(); lastTap = now; }
          }
        };
      }

      function renderStage(crossfade) {
        var st = ov.querySelector('.jun26-artzoom__stage');
        var vw = window.innerWidth, vh = window.innerHeight;
        var isPoster = (!amb && isSemMoldura());
        var el, cw, ch;
        if (isPoster) {
          el = document.createElement('img');
          var s = artSrc(); if (s) el.src = s;
          var ra = root.querySelector('.pp26__art');
          cw = (ra && ra.naturalWidth) || 1000; ch = (ra && ra.naturalHeight) || 1400;
          el.style.cssText = 'display:block;width:' + cw + 'px;height:' + ch + 'px;max-width:none;max-height:none;touch-action:none;-webkit-user-drag:none;user-select:none';
        } else {
          el = buildAmbClone(); if (!el) return; cw = el._w; ch = el._h;
        }
        var layer = document.createElement('div');
        layer.className = 'jun26-artzoom__layer';
        layer.appendChild(el);
        var olds = [].slice.call(st.children);
        if (crossfade) { layer.style.opacity = '0'; st.appendChild(layer); }
        else { st.innerHTML = ''; st.appendChild(layer); }

        var qcx, qcy, qw, qh, baseFactor, initMul, tx0 = null;
        if (isPoster) {

          qw = cw; qh = ch; qcx = cw / 2; qcy = ch / 2;
          baseFactor = Math.max(vw / cw, vh / ch); initMul = 1;
        } else if (amb) {

          qw = cw; qh = ch; qcx = cw / 2; qcy = ch / 2;
          baseFactor = Math.max(vw / cw, vh / ch); initMul = 1;
          var qd = el.querySelector('.jun26-amb-quadro');
          if (qd) {
            var cr2 = el.getBoundingClientRect(), qr2 = qd.getBoundingClientRect();
            var qsx = (qr2.left - cr2.left) + qr2.width / 2;
            tx0 = qsx - vw / 2 - (qsx - cw / 2) * baseFactor;
          }
        } else {
          var qx = 0, qy = 0; qw = cw; qh = ch;
          var artEl = el.querySelector('.pp26__art');
          if (artEl) {
            var cr0 = el.getBoundingClientRect(), ar0 = artEl.getBoundingClientRect();
            var pad = 0.14, aw = ar0.width, ah = ar0.height;
            qx = (ar0.left - cr0.left) - aw * pad; qy = (ar0.top - cr0.top) - ah * pad;
            qw = aw * (1 + 2 * pad); qh = ah * (1 + 2 * pad);
          }
          qcx = qx + qw / 2; qcy = qy + qh / 2;
          baseFactor = Math.min((vw - 20) / qw, (vh - 80) / qh); initMul = 1.5;
        }
        attachGesture(st, el, cw, ch, qcx, qcy, qw, qh, baseFactor, initMul, tx0);
        if (crossfade) {
          requestAnimationFrame(function () { layer.style.opacity = '1'; olds.forEach(function (o) { o.style.opacity = '0'; }); });
          setTimeout(function () { olds.forEach(function (o) { if (o.parentNode) o.remove(); }); }, 380);
        }
      }
      function renderEnvs(idxForcado) {
        if (!amb) return;
        var box = ov.querySelector('.jun26-artzoom__envs');
        /* (4/ago, mobile) a cena atrás recebe um esmaecimento no pé — as
           miniaturas ficam legíveis sem precisar de scrim pesado nelas */
        if (window.matchMedia('(max-width: 767px)').matches) {
          box.style.cssText += ';padding:28px 0 16px;bottom:0;z-index:6;'
            + 'background:linear-gradient(to top, rgba(22,19,16,.45), rgba(22,19,16,0));';
        }
        var realEnvs = root.querySelector('.jun26-stage-envs');
        if (!realEnvs) { box.style.display = 'none'; return; }
        var realBtns = [].slice.call(realEnvs.querySelectorAll('button'));
        var isRd = root.classList.contains('thb-product-detail--redesign');
        var bar = document.createElement('div');

        bar.style.cssText = isRd
          ? 'display:inline-flex;gap:0;box-shadow:0 6px 20px rgba(0,0,0,.3)'
          : 'display:inline-flex;gap:2px;padding:4px;border-radius:999px;background:rgba(40,40,40,.55);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);box-shadow:0 6px 20px rgba(0,0,0,.35)';
        var zoomMob = window.matchMedia('(max-width: 767px)').matches;
        if (isRd) bar.style.cssText = 'display:inline-flex;gap:' + (zoomMob ? '8px' : '6px') + ';';
        realBtns.forEach(function (rb, ri) {
          var b = document.createElement('button');
          b.type = 'button';
          /* clique OTIMISTA (4/ago): o is-on real só muda quando o fade do
             palco termina (0,9s) — a seleção parecia morta e pedia segundo
             toque. Com o índice forçado, a linha preta acende na hora. */
          var on = idxForcado != null ? (ri === idxForcado) : rb.classList.contains('is-on');
          /* 26/jul: no redesign as opções do zoom seguem o NOVO PADRÃO do palco —
             miniatura da foto do cômodo (sem nome), fio branco fino em todas e fio
             preto na ativa. Reaproveita a mesma imagem via --rd-envthumb. */
          var thumb = isRd ? rb.style.getPropertyValue('--rd-envthumb') : '';
          /* (4/ago) a fileira do palco carrega botões de vistas que no mobile
             não existem como foto — clonados, viravam azulejos cegos na barra
             ("2 imagens extras que não existem"). Sem miniatura e sem ser a
             vista ativa, fora. */
          if (zoomMob && isRd && !thumb && !on) return;
          if (isRd) b.setAttribute('aria-label', rb.getAttribute('aria-label') || rb.textContent.trim());
          else b.textContent = rb.textContent;
          /* no celular a miniatura cresce pro dedo (36×44) e ganha o mesmo
             descolamento de sombra da linguagem das pastilhas do palco */
          b.style.cssText = isRd
            ? ('width:' + (zoomMob ? '36px' : '28px') + ';height:' + (zoomMob ? '44px' : '34px') + ';padding:0;border:0;border-radius:0;cursor:pointer;flex:0 0 auto;'
              /* a inativa não fica transparente (a transparência deixava a
                 miniatura fantasma sobre fundo claro) — leva um SCRIM claro
                 POR CIMA da foto; a ativa mostra a foto limpa com fio preto */
              + 'background-image:' + (on ? '' : 'linear-gradient(rgba(22,19,16,.32), rgba(22,19,16,.32)),') + (thumb || 'none') + ';background-size:cover;background-position:50% 42%;background-color:#D9D5CD;'
              + 'transition:box-shadow .18s ease, background-image .18s ease;opacity:1;'
              + (on
                /* a MESMA linha fina em todas — só a cor diz quem está ativa:
                   branca nas quietas, preta na selecionada (4/ago, definitivo) */
                ? 'box-shadow:inset 0 0 0 1px #161310, 0 2px 8px rgba(20,18,14,.3);'
                : 'box-shadow:inset 0 0 0 1px rgba(255,255,255,.9), 0 2px 8px rgba(20,18,14,.3);'))
            : ('font:600 11px Archivo,system-ui,sans-serif;letter-spacing:.08em;padding:8px 14px;border:0;border-radius:999px;cursor:pointer;white-space:nowrap;transition:background .2s,color .2s;' + (on ? 'background:#fff;color:#141414' : 'background:transparent;color:#fff'));
          b.addEventListener('click', function () {

            function qkey() {
              var q = root.querySelector('.jun26-amb-quadro');
              if (!q) return '';
              var r = q.getBoundingClientRect();
              return Math.round(r.top) + ',' + Math.round(r.left) + ',' + Math.round(r.height);
            }
            var key0 = qkey();
            rb.click();
            renderEnvs(ri);

            var done = false, tries = 0, stable = 0, last = '';
            function finish() { if (done) return; done = true; renderStage(true); }
            function poll() {
              if (done) return;
              var photo = root.querySelector('.jun26-amb-photo');
              var ready = photo && photo.complete && photo.naturalWidth > 0;
              var k = qkey();
              if (k && k !== key0 && k === last) stable++; else stable = 0;
              last = k;
              if ((ready && stable >= 3) || tries > 90) finish();
              else { tries++; requestAnimationFrame(poll); }
            }
            requestAnimationFrame(poll);
          });
          bar.appendChild(b);
        });
        box.innerHTML = '';
        box.appendChild(bar);
      }
      renderStage();
      renderEnvs();
      void ov.offsetWidth;
      ov.classList.add('is-open');

      function close() {
        if (zoomLoadIv) { clearInterval(zoomLoadIv); zoomLoadIv = null; }
        /* as trocas feitas DENTRO do zoom se enfileiram no palco; fechar no
           meio deixava a procissão de fades executando à vista — "dai eu
           fecho... e AI SIM FICA SAMBANDO" (4/ago). Fechou, fila esvazia:
           só o fade em curso conclui (um dissolve, coberto pelo véu). */
        try { if (window.__slEsvaziaFila) window.__slEsvaziaFila(); } catch (e) {}
        ov.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { ov.remove(); }, 220);
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      ov.addEventListener('click', function (e) {
        if (e.target === ov
          || (e.target.closest && e.target.closest('.jun26-artzoom__close'))
          || e.target.classList.contains('jun26-artzoom__stage')) close();
      });
      document.addEventListener('keydown', onKey);
    }
    function bind(el) {
      if (!el || el._artzoom) return;
      el._artzoom = true;

      if (mqMobile.matches) el.style.cursor = 'zoom-in';
      el.addEventListener('click', function (e) {
        if (!mqMobile.matches) return;

        if (e.target.closest('.jun26-stage-toggle, .jun26-stage-envs, .jun26-zoom-btn, .jun26-sheet-grip')) return;
        /* arrastou o slider do palco agorinha? o clique é resíduo do gesto (26/jul) */
        if (Date.now() - (window.__jun26SlideGuard || 0) < 450) return;
        open();
      });
    }

    function ensureZoomBtn() {
      var media = root.querySelector('.pp26-product-grid__media');
      if (!media) return;
      var b = media.querySelector('.jun26-zoom-btn');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'jun26-zoom-btn';
        b.setAttribute('aria-label', 'Ampliar');

        b.innerHTML = '<svg viewBox="0 0 1200 1200" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="m239.65 418.15h-52.734v-231.23h231.23v52.734h-178.5z"/><path d="m418.15 1013.1h-231.23v-231.23h52.734v178.5h178.5z"/><path d="m1013.1 418.15h-52.734v-178.5h-178.5v-52.734h231.23z"/><path d="m1013.1 1013.1h-231.23v-52.734h178.5v-178.5h52.734z"/></svg>';   /* mesmo glifo do montador (13/jul) */
        b.addEventListener('click', function (e) { e.stopPropagation(); open(); });
        media.appendChild(b);
      }

      var tg = root.querySelector('.jun26-stage-toggle');
      if (tg) { var h = tg.offsetHeight; if (h) { b.style.width = h + 'px'; b.style.height = h + 'px'; } }
    }
    var tries = 0;
    (function retry() {

      bind(root.querySelector('.pp26-product-grid__media'));
      ensureZoomBtn();
      if (tries++ < 12) setTimeout(retry, 300);
    })();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var isSize = t.type === 'radio' && t.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
      var isPasp = t.type === 'checkbox' && t.closest('.jun26-mod--paspatur')
        && t.closest('.thb-product-detail--redesign');
      if (!isSize && !isPasp) return;
      var scope = t.closest('.thb-product-detail--jun26');
      if (!scope) return;
      var media = scope.querySelector('.pp26-product-grid__media');
      if (!media) return;

      /* 27/jul: no REDESIGN mobile quem cuida disso é o enquadraTamanho — este
         atalho antigo levava a tela pro TOPO do palco a cada troca, e aí a pessoa
         perdia os chips de vista, tinha que descer de novo, e ainda voltava pra um
         layout diferente (a gaveta reabre no topo). Enquadrar > teleportar. */
      if (mqMobile.matches && scope.classList.contains('thb-product-detail--redesign')) return;

      var y;
      if (mqMobile.matches) {

        var wh = scope.querySelector('.jun26-workhead') || media.previousElementSibling;
        y = wh ? (wh.getBoundingClientRect().top + window.scrollY + wh.offsetHeight)
               : (media.getBoundingClientRect().top + window.scrollY);
      } else {

        if (scope.classList.contains('thb-product-detail--redesign')) return;

        var grid = scope.querySelector('.pp26-product-grid') || media.parentElement;
        var stickyTop = parseInt(getComputedStyle(media).top, 10) || 0;
        y = grid.getBoundingClientRect().top + window.scrollY - stickyTop;
      }

      if (mqMobile.matches) {
        document.body.classList.add('jun26-progscroll');
        var target = Math.max(0, Math.round(y));
        var settled = 0, guard = 0;
        (function waitSettle() {

          var d = Math.abs(window.scrollY - target);
          if (d < 2) settled++; else settled = 0;
          if (settled >= 3 || guard++ > 120) {
            var hdr = document.querySelector('.header.mobile-product-show');
            if (hdr) hdr.classList.remove('mobile-product-show');
            document.body.classList.remove('jun26-progscroll');
            return;
          }
          requestAnimationFrame(waitSettle);
        })();
      }
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: 'smooth' });
    });
  }

  function init() {

    if (/[?&](ambedit|calibrate|posedit|fxedit|localframes|typeedit)/.test(location.search)) {
      var robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex,nofollow';
      document.head.appendChild(robots);
    }
    setupFrameFallback();
    setupColorTool();
    setupRuler();
    setupTypeEdit();
    setupHiddenVariantSim();
    var root = document.querySelector('.thb-product-detail--jun26');
    if (!root) return;

    /* ═══════════════════════════════════════════════════════════════════════
       1/ago — PDP 2026 (?view=pdp2026): O PALCO CONTINUA, A COLUNA NÃO.
       O view novo reusa esta seção inteira pelo palco (motor de moldura,
       ambientado, zoom, fallback), mas a coluna de compra dele já nasce
       marcada no Liquid, com CSS e JS próprios (`.pdp26-*`).
       Então tudo que AQUI existe para MONTAR a coluna antiga é pulado — não
       por override nem por `display:none`, mas por não rodar. O que sobra é
       exatamente o que a coluna nova consome como hook.
       Pulados: buildWorkHead e buildHeaderObra (leem a marcação do
       product-information, que a coluna nova não emite), setupJun26UI,
       setupRedesignBuyBox, setupRedesignTabs e setupLayoutEdit.
       Mantidos: cleanupPp26UI, setupAmbientado, setupArtZoom.
       ═══════════════════════════════════════════════════════════════════════ */
    var pdp2026 = root.dataset.pdp2026 === 'true';

    fadeGalleryImgs(root);
    setupCopyProtection();

    var sw = document.getElementById('support-widget');
    if (sw) sw.style.setProperty('display', 'none', 'important');

    if (!pdp2026) buildWorkHead(root);
    /* PDP mobile: no header, o menu de coleções sai e entra a linha da obra
       (artista · título · rating) — 13/jul: "inverte" */
    (function buildHeaderObra() {
      if (pdp2026) return;
      if (!document.body.classList.contains('template-product-redesign-2026')) return;
      var hd = document.querySelector('.header.obrah-style');
      if (!hd || hd.querySelector('.rd-hd-obra')) return;
      var artist = root.querySelector('.jun26-wh-artist');
      var title = root.querySelector('.jun26-wh-title');
      var row = document.createElement('div');
      row.className = 'rd-hd-obra';
      /* nome do artista LINKA pra coleção dele (24/jul) — reusa o href do workhead */
      var b;
      var artistHref = artist && artist.getAttribute ? artist.getAttribute('href') : null;
      if (artistHref) { b = document.createElement('a'); b.setAttribute('href', artistHref); }
      else { b = document.createElement('b'); }
      b.textContent = artist ? artist.textContent.trim() : '';
      var t = document.createElement('span'); t.className = 'rd-hd-obra-t'; t.textContent = title ? title.textContent.trim() : '';
      var r = document.createElement('span'); r.className = 'rd-hd-obra-r';
      r.innerHTML = '<span class="jun26-wh-stars" data-nota="4.8">★</span> 4.8/5';
      row.append(b, t, r);
      hd.appendChild(row);
    })();

    setupWishlistHearts();

    var tries = 0;
    function attempt() {
      /* a espera existe porque a UI antiga só monta depois que o fieldset do
         Shopify aparece. Na PDP 2026 esse fieldset existe com atributo PRÓPRIO
         (`data-pdp26-opcao`), justamente pra as ~30 regras legadas presas a
         `data-handle` não alcançarem a coluna nova.
         ⚠ POR ISSO OS SELETORES DESTE ARQUIVO USAM `:is([data-handle=…],
         [data-pdp26-opcao=…])`. O palco lê o tamanho e a moldura escolhidos por
         esses seletores — e quando eles enxergavam só `data-handle`, o
         ambientado ficava SEM O QUADRO: `curSize()` devolvia null, `layout()`
         desistia e a peça nunca era desenhada na parede. Ao mexer aqui, os dois
         atributos têm que continuar valendo. */
      var molduraFs = root.querySelector(':is([data-handle="escolha-o-tipo-de-moldura"],[data-pdp26-opcao="escolha-o-tipo-de-moldura"])');
      if (!molduraFs && !pdp2026) {
        if (tries++ < 20) return setTimeout(attempt, 50);
        return;
      }
      /* 27/jul — CADA SETUP É INDEPENDENTE.
         A cadeia era uma linha só: se qualquer um lançasse, tudo dali pra frente
         morria em silêncio — e foi exatamente isso que aconteceu (uma exceção no
         meio do setupAmbientado levou junto a caixa de compra inteira: doca, nota
         do tamanho, mini e bloco da obra sumiram da página sem erro visível).
         Agora um tropeço derruba só a própria peça, e o motivo fica em
         window.__jun26Err pra investigar. */
      window.__jun26Err = window.__jun26Err || [];
      var etapas = [
        ['cleanup', function () { cleanupPp26UI(root); }],
        ['ambientado', function () { setupAmbientado(root); }],
        ['zoom', function () { setupArtZoom(root); }]
      ];
      /* a coluna antiga: só quando NÃO é a PDP 2026 (ver nota no topo de init) */
      if (!pdp2026) etapas.splice(1, 0, ['ui', function () { setupJun26UI(root); }]);
      if (!pdp2026 && root.classList.contains('thb-product-detail--redesign')) {
        etapas.push(['tabs', function () { setupRedesignTabs(root); }]);
        etapas.push(['buybox', function () { setupRedesignBuyBox(root); }]);
        etapas.push(['layoutedit', function () { setupLayoutEdit(root); }]);
      }
      etapas.forEach(function (e) {
        try { e[1](); }
        catch (err) {
          window.__jun26Err.push(e[0] + ': ' + (err && err.message) + ' @ ' + ((err && err.stack) || '').split('\n')[1]);
          if (window.console && console.warn) console.warn('[jun26] ' + e[0] + ' falhou', err);
        }
      });
      root.classList.add('jun26-ready');
    }
    attempt();

    setTimeout(function () { root.classList.add('jun26-ready'); }, 2500);
  }

  function cleanupPp26UI(root) {

    var oldRow = root.querySelector('.pp26-moldura-cor-row');
    if (oldRow) {

      var molduraFs = oldRow.querySelector(':is([data-handle="escolha-o-tipo-de-moldura"],[data-pdp26-opcao="escolha-o-tipo-de-moldura"])');
      var parent = oldRow.parentElement;
      if (molduraFs && parent) parent.insertBefore(molduraFs, oldRow);
      oldRow.remove();
    }
    var oldCheck = root.querySelector('.pp26-paspatur-check');
    if (oldCheck) oldCheck.remove();

    var corFs = root.querySelector(':is([data-handle="escolha-a-cor-da-moldura"],[data-pdp26-opcao="escolha-a-cor-da-moldura"])');
    if (corFs) corFs.classList.remove('pp26-cor-original-hidden');
  }

  var SOFA_PATH_LEFT = 'M258.46,1000.33v-97.36c0-39.55,36.45-71.74,81.25-71.74h264.49v-13.81h4.81s-269.31-.05-269.31-.05c-26.27,0-49.96,9.32-67.38,24.11,18.23-28.12,52.47-47.08,91.74-47.08h0s240.14,0,240.14,0v-13.9l-240.15.02c-17.3,0-33.63,3.2-48.54,8.99v-78.66c.01-39.55,36.47-71.74,81.27-71.74h207.43v-13.84l-207.62.02c-51.98,0-94.26,36.36-96.59,81.7-13.2-14.96-33.75-24.98-57.01-24.98h-85.61c-61.61,0-111.69,43.83-112.3,98.06v234.1h559.14v-13.86h-345.74ZM60.67,1000.33v-220.24c.31-27.31,25.59-49.52,56.7-49.52h68.67c31.24,0,56.7,22.48,56.7,50.06v219.7s-182.07,0-182.07,0ZM185.92,716.71h-68.49c-10.87,0-21.05,2.22-30.19,5.96,17.61-16.36,42.4-26.76,70.08-26.76h0s85.61,0,85.61,0c31.24,0,56.7,22.48,56.7,50.06v50.93c-17.12,9.43-31.42,22.59-41.3,38.14v-54.39c0-35.22-32.52-63.93-72.41-63.93Z';
  var SOFA_PATH_RIGHT = 'M1060.66,682.03h-85.61c-23.27,0-43.82,10.02-57.01,24.98-2.33-45.35-44.61-81.7-96.59-81.7l-207.62-.02h-4.81s-4.81,0-4.81,0h0v13.84h217.04c44.8,0,81.25,32.18,81.25,71.74v78.66c-14.9-5.79-31.23-8.99-48.53-8.99l-240.15-.02h-4.81s-4.81,0-4.81,0h0v13.9h249.76c39.28,0,73.51,18.96,91.74,47.08-17.43-14.79-41.11-24.11-67.38-24.11l-269.31.05h-4.81v13.81h274.1c44.8,0,81.25,32.18,81.25,71.74v97.36h-355.36v13.86h568.75v-234.1c-.61-54.23-50.69-98.06-112.3-98.06ZM959.7,835.03c-9.88-15.55-24.18-28.71-41.3-38.14v-50.93c0-27.58,25.47-50.06,56.7-50.06h85.61,0c27.68,0,52.47,10.41,70.08,26.77-9.14-3.74-19.33-5.96-30.19-5.96h-68.49c-39.89,0-72.41,28.71-72.41,63.93v54.39ZM1157.35,1000.33h-182.08v-219.7c0-27.58,25.47-50.06,56.71-50.06h68.67c31.12,0,56.4,22.21,56.7,49.52v220.24Z';

  var QUADRO_REF_W = 110;
  var QUADRO_REF_TAMANHO = 25;
  var BOX_X_CENTER = 600;
  var BOX_Y_BOTTOM = 580;

  var PX_PER_CM = QUADRO_REF_W / QUADRO_REF_TAMANHO;

  var SOFA_SCALE = 0.70;
  var SOFA_COLOR = '#c4c4c4';

  function parseTamanho(val) {
    var m = String(val).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
  }

  function svgIconForTamanho(val, orient) {
    var d = parseTamanho(val);
    if (!d) return '';

    if (orient === 'horizontal' && d.h > d.w) {
      var t = d.w; d.w = d.h; d.h = t;
    }

    var w = d.w * PX_PER_CM;
    var h = d.h * PX_PER_CM;
    var x = BOX_X_CENTER - w / 2;
    var y = BOX_Y_BOTTOM - h;

    var sofaTransform = 'translate(' + BOX_X_CENTER + ' 1000) scale(' + SOFA_SCALE + ') translate(' + (-BOX_X_CENTER) + ' -1000)';
    return '<svg viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">' +
      '<rect x="' + x.toFixed(0) + '" y="' + y.toFixed(0) + '" width="' + w.toFixed(0) + '" height="' + h.toFixed(0) + '" fill="#151515" />' +
      '<g transform="' + sofaTransform + '">' +
        '<path d="' + SOFA_PATH_LEFT + '" fill="' + SOFA_COLOR + '" />' +
        '<path d="' + SOFA_PATH_RIGHT + '" fill="' + SOFA_COLOR + '" />' +
      '</g>' +
      '</svg>';
  }

  /* (16/out) na coluna 2026 quem decide o tamanho oculto é o SERVIDOR
     (pdp2026-coluna.liquid marca `pdp26-chipcel--oculto` pelo preço vendável).
     A lista fixa só vale pra marcação antiga, que não tem esse veredito. */
  var HIDDEN_TAMANHOS = ['20x20', '100x140'];
  function tamanhoOculto(input) {
    var cell = input.parentElement;
    if (cell && cell.classList.contains('pdp26-chipcel')) return cell.classList.contains('pdp26-chipcel--oculto');
    return HIDDEN_TAMANHOS.indexOf(input.value) !== -1;
  }
  function replaceTamanhoIcons(root) {
    var tamanhoFs = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
    if (!tamanhoFs) return;
    var galOrient = document.querySelector('pp26-gallery');
    var orient = (galOrient && galOrient.dataset.orientation) || 'vertical';

    tamanhoFs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (tamanhoOculto(input)) {
        input.style.display = 'none';
        var label = input.nextElementSibling;
        if (label) label.style.display = 'none';

        var cell = input.parentElement;
        if (cell) cell.style.display = 'none';

        if (input.checked) {
          var firstVisible = Array.prototype.find.call(
            tamanhoFs.querySelectorAll('input[type="radio"]'),
            function (r) { return !tamanhoOculto(r); }
          );
          if (firstVisible) {
            firstVisible.checked = true;
            firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    tamanhoFs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label) return;
      var img = label.querySelector('img');
      if (img) img.style.setProperty('display', 'none', 'important');
      label.classList.add('jun26-size-chip');
      label.setAttribute('data-size', String(input.value).replace(/\s*x\s*/i, '×'));

      label.style.setProperty('padding', 'var(--jun26-chip-pad, 9px 14px)', 'important');
    });
  }

  function setupJun26UI(root) {
    var molduraFs = root.querySelector(':is([data-handle="escolha-o-tipo-de-moldura"],[data-pdp26-opcao="escolha-o-tipo-de-moldura"])');
    var corFs = root.querySelector(':is([data-handle="escolha-a-cor-da-moldura"],[data-pdp26-opcao="escolha-a-cor-da-moldura"])');
    if (!molduraFs) return;

    replaceTamanhoIcons(root);

    var infoCol = root.querySelector('.pp26-product-grid__info');
    if (infoCol && !infoCol.querySelector('.jun26-sheet-grip')) {
      var grip = document.createElement('div');
      grip.className = 'jun26-sheet-grip';
      infoCol.insertBefore(grip, infoCol.firstChild);
      /* alça da folha (24/jul): estava só decorativa. Toque SOBE a folha de opções
         (a imagem é sticky) até logo abaixo do header; se já está em cima, RECOLHE ao topo. */
      grip.addEventListener('click', function () {
        /* a PDP mobile rola num CONTAINER próprio (o media é 100vh), não na janela —
           window.scrollTo não pegava (por isso "não rolava"). scrollIntoView acha o
           scroller certo sozinho: folha embaixo → sobe; senão → volta pra imagem (24/jul) */
        var media = root.querySelector('.pp26-product-grid__media');
        var r = infoCol.getBoundingClientRect();
        var alvo = (r.top > window.innerHeight * 0.45 || !media) ? infoCol : media;
        alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var tamHeaderEl = null;

    var SIZE_NAMES = {
      '20x20': 'Pequeno', '25x35': 'Pequeno',
      '30x30': 'Médio', '30x42': 'Médio', '35x50': 'Médio',
      '50x50': 'Grande', '50x70': 'Grande', '70x70': 'Grande',
      '70x100': 'Galeria',
      '100x100': 'Exposição', '100x140': 'Exposição'
    };

    var isRDsize = root.classList.contains('thb-product-detail--redesign');
    root.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label) return;
      var key = String(input.value).replace(/\s/g, '').toLowerCase();
      label.setAttribute('data-name', SIZE_NAMES[key] || '');

      if (isRDsize && !label.querySelector('.jun26-size-num')) {
        // sigla protagonista (PP/P/M/G/XG) + dimensão embaixo — o check no canto fica livre
        var SIGLAS_RD = { '25x35': 'PP', '30x42': 'P', '35x50': 'M', '50x70': 'G', '70x100': 'GG', '100x140': 'XG', '20x20': 'XP', '30x30': 'P', '50x50': 'M', '70x70': 'G', '100x100': 'XG' };
        var sig = document.createElement('span');
        sig.className = 'jun26-size-sigla';
        sig.textContent = SIGLAS_RD[key] || '';
        var num = document.createElement('span');
        num.className = 'jun26-size-num';
        num.textContent = String(input.value).replace(/\s*x\s*/i, ' × ');
        var nm = document.createElement('span');
        nm.className = 'jun26-size-name';
        nm.textContent = SIZE_NAMES[key] || '';
        label.insertBefore(nm, label.firstChild);
        label.insertBefore(num, label.firstChild);
        label.insertBefore(sig, label.firstChild);
      }
    });
    function fmtSize(v) { return (v || '').replace(/x/i, ' × ') + ' cm'; }
    function updateTamanhoHeader() {
      if (!tamHeaderEl) return;
      var s = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');

      var label = '';
      if (s) {
        label = fmtSize(s.value);
      }
      tamHeaderEl.setAttribute('data-size', label);
    }
    (function buildTamanhoHeader() {
      var fs = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
      if (!fs) return;

      var tamRow = document.createElement('div');
      tamRow.className = 'jun26-tamanho-row';
      tamHeaderEl = document.createElement('div');
      tamHeaderEl.className = 'jun26-tamanho-header-new';
      tamRow.appendChild(tamHeaderEl);
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'jun26-compare-link';

      if (!/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) {
        cmp.style.display = 'none';
      }
      cmp.innerHTML = ''
        + '<svg class="jun26-compare-sofa" aria-hidden="true" width="15" height="12" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">'
        + '<path d="M3 5V3.5A1.5 1.5 0 0 1 4.5 2h7A1.5 1.5 0 0 1 13 3.5V5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>'
        + '<path d="M2.5 10.5V8.8M13.5 10.5V8.8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>'
        + '<path d="M1.5 6.5A1.3 1.3 0 0 1 2.8 5.2c.72 0 1.3.58 1.3 1.3V7h7.8v-.5a1.3 1.3 0 0 1 1.3-1.3 1.3 1.3 0 0 1 1.3 1.3c0 .9-.55 1.6-1.3 1.85V9H2.8v-.65A1.95 1.95 0 0 1 1.5 6.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>'
        + '</svg>'
        + '<span class="jun26-compare-txt">' + (root.classList.contains('thb-product-detail--redesign') ? 'Compare com seu móvel' : 'Comparar<span class="jun26-compare-txt-extra"> com móvel</span>') + '</span>';

      var cmpAfterSizes = root.classList.contains('thb-product-detail--redesign');
      if (!cmpAfterSizes) tamRow.appendChild(cmp);
      if (fs.parentElement) fs.parentElement.insertBefore(tamRow, fs);
      else fs.insertBefore(tamRow, fs.firstChild);
      if (cmpAfterSizes && fs.parentElement) {
        cmp.classList.add('jun26-compare-link--below');
        fs.parentElement.insertBefore(cmp, fs.nextSibling);
      }
      updateTamanhoHeader();
    })();

    var molduraInputs = {};
    molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      molduraInputs[i.value] = i;
    });

    molduraFs.classList.add('jun26-moldura-original-hidden');

    var container = document.createElement('div');
    container.className = 'jun26-acabamento-row';

    var header = document.createElement('div');
    header.className = 'jun26-acabamento-header';
    var headerPrefix = document.createElement('span');
    headerPrefix.className = 'jun26-label-prefix';
    headerPrefix.textContent = 'Moldura';
    var headerSep = document.createElement('span');
    headerSep.className = 'jun26-label-sep';
    headerSep.textContent = '·';
    var headerValue = document.createElement('span');
    headerValue.className = 'jun26-label-value';

    header.append(headerPrefix);
    container.appendChild(header);

    var pillsRow = document.createElement('div');
    pillsRow.className = 'jun26-pills-row';
    container.appendChild(pillsRow);

    var pills = {};
    var PILL_NAMES = { 'canvas': 'Canvas', 'padrão': 'Padrão', 'sem moldura': 'Sem moldura' };
    var PRIMARIOS = ['canvas', 'padrão', 'sem moldura'];

    PRIMARIOS.forEach(function (primario) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jun26-pill';
      var nameEl = document.createElement('span');
      nameEl.className = 'jun26-pill-name';
      nameEl.textContent = PILL_NAMES[primario] || primario;
      btn.appendChild(nameEl);
      if (primario === 'canvas') {
        var dot = document.createElement('span');
        dot.className = 'jun26-pill-dot';
        var cap = document.createElement('span');
        cap.className = 'jun26-pill-badge';
        cap.textContent = 'Mais pedido';
        btn.append(dot, cap);
      }
      if (primario === 'padrão') {
        var dotV = document.createElement('span');
        dotV.className = 'jun26-pill-dot jun26-pill-dot--neutro';
        var capV = document.createElement('span');
        capV.className = 'jun26-pill-badge jun26-pill-badge--neutro';
        capV.textContent = 'Com vidro';
        btn.append(dotV, capV);
      }
      if (primario === 'sem moldura') {
        var capS = document.createElement('span');
        capS.className = 'jun26-pill-badge jun26-pill-badge--neutro';
        capS.textContent = 'Só a impressão';
        btn.appendChild(capS);
      }
      btn.dataset.primario = primario;
      btn.addEventListener('click', function () {
        state.primario = primario;
        state.profundidade = false;
        state.fino = false;
        state.paspatur = false;
        state._profForced = false;

        if (primario !== 'sem moldura' && corFs) {
          var target = lastCor || 'madeira escura';
          var corInput = corFs.querySelector('input[type="radio"][value="' + target + '"]');
          if (corInput && !corInput.checked) {
            corInput.checked = true;
            corInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        resolveAndSync();
      });
      pillsRow.appendChild(btn);
      pills[primario] = btn;
    });

    var isRDmicro = root.classList.contains('thb-product-detail--redesign');
    var MICROCOPY = isRDmicro ? {

      /* 28/jul: UMA linha cada. As anteriores tinham noventa e tantos caracteres
         e quebravam em duas — e duas linhas de especificação, logo abaixo de
         três cartões, viram parágrafo no meio de uma escolha rápida.
         Cada frase diz as três coisas que decidem: o que é a peça, se tem vidro
         e como ela chega. O resto (gramatura do papel, proteção UV, kit de
         instalação) mora na ficha, que é onde quem quer detalhe vai buscar. */
      'canvas': 'Tela sobre chassi · moldura flutuante sem vidro.',
      /* 28/jul: sem o "e vidro de proteção" — o próprio chip do Padrão já diz
         "Com vidro" logo acima, e a linha não precisa repetir o que a etiqueta
         do botão já afirmou. */
      'padrão': 'Moldura em madeira maciça.',
      'sem moldura': 'Impressão Canson® Satin 240 g/m².'
    } : {
      'canvas': 'Tela com moldura flutuante de madeira, pronta para pendurar.',
      'padrão': 'Moldura de madeira com vidro de proteção, pronta para pendurar.',
      'sem moldura': 'Impressão enrolada em tubo, pronta para ser emoldurada.'
    };

    var microWrap = isRDmicro ? document.createElement('div') : null;
    if (microWrap) { microWrap.className = 'jun26-desc-wrap'; container.appendChild(microWrap); }
    var microEl = document.createElement('div');
    microEl.className = 'jun26-acabamento-micro';
    (microWrap || container).appendChild(microEl);

    if (isRDmicro) {
      var fichaLink = document.createElement('button');
      fichaLink.type = 'button';
      fichaLink.className = 'jun26-ficha-link';

      /* 28/jul: "Saiba mais" nos dois lugares. Dois rótulos diferentes pra mesma
         promessa (moldura e extras) faziam a pessoa suspeitar que levavam a
         coisas diferentes. */
      fichaLink.innerHTML = '<span class="jun26-ficha-link__txt">Saiba' + String.fromCharCode(160) + 'mais</span>';
      fichaLink.addEventListener('click', function () {
        var tab = root.querySelector('.rd-tab[data-tab="ficha"]') || root.querySelector('.rd-tab');
        if (tab) { tab.click(); tab.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });

      microWrap.appendChild(document.createTextNode(' '));
      microWrap.appendChild(fichaLink);
    }

    var modsRow = document.createElement('div');
    modsRow.className = 'jun26-modificadores';

    var isRDmod = root.classList.contains('thb-product-detail--redesign');

    var MOD_RD = {
      'paspatur': { t: '+ Paspatur de 5 cm', d: 'Margem branca ao redor da arte. Adiciona 5 cm para cada lado.' },
      'profundidade': { t: '+ Profundidade de 3 cm', d: 'Moldura mais funda, com mais presença na parede.' },
      'fino': { t: 'Moldura slim', d: 'Perfil mais fino e discreto, encosta a arte na parede.' }
    };

    var MOD_ICO = {
      'profundidade': '<svg class="jun26-mod-ico-svg" viewBox="-30.24 -30.24 102.24 102.24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<rect x="-4.682" y="6.68" width="36.92" height="48.28" fill="none" stroke="#54504A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<polygon points="-4.682 6.68 9.518 -7.52 46.438 -7.52 32.238 6.68" fill="none" stroke="#54504A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<polygon points="32.238 6.68 46.438 -7.52 46.438 40.76 32.238 54.96" fill="#54504A" stroke="#54504A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>'
        + '</svg>',
      'paspatur': '<svg class="jun26-mod-ico-svg" viewBox="0 -28.8 100.8 100.8" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<rect x="21.004" y="-16.2" width="58.8" height="75.6" fill="none" stroke="#54504A" stroke-width="0.5" stroke-linejoin="round"/>'
        + '<rect x="26.605" y="-10.6" width="47.6" height="64.4" fill="#54504A" stroke="#54504A" stroke-width="0.5" stroke-linejoin="round"/>'
        + '<rect x="36.301" y="-0.575" width="28.224" height="44.352" fill="#FAF9F6" stroke="#54504A" stroke-width="0.5" stroke-linejoin="round"/>'
        + '</svg>',
      'fino': ''
    };
    function makeMod(key, label, hint) {
      var lbl = document.createElement('label');
      lbl.className = 'jun26-mod jun26-mod--' + key;
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      var col = document.createElement('span');
      col.className = 'jun26-mod-col';
      var txt = document.createElement('span');
      txt.className = 'jun26-mod-label';

      txt.textContent = (isRDmod && MOD_RD[key] ? MOD_RD[key].t : label).replace(/(\d)\s+cm\b/g, '$1' + String.fromCharCode(160) + 'cm');
      var hintEl = document.createElement('span');
      hintEl.className = 'jun26-mod-hint';
      hintEl.textContent = isRDmod && MOD_RD[key] ? MOD_RD[key].d : hint;
      col.append(txt, hintEl);
      var priceEl = document.createElement('span');
      priceEl.className = 'jun26-mod-price';
      if (isRDmod) {

        var icoWrap = document.createElement('span');
        icoWrap.className = 'jun26-mod-ico';
        icoWrap.innerHTML = MOD_ICO[key] || '';
        lbl.append(icoWrap, col, priceEl, cb);
      } else {
        lbl.append(cb, col, priceEl);
      }
      cb.addEventListener('change', function () {
        if (key === 'profundidade' && cb.checked) state.fino = false;
        if (key === 'fino' && cb.checked) state.profundidade = false;

        if (key === 'profundidade') state._profForced = false;
        state[key] = cb.checked;
        resolveAndSync();
      });
      modsRow.appendChild(lbl);
      return { label: lbl, checkbox: cb, price: priceEl };
    }

    var modPasp = makeMod('paspatur', '+ Paspatur', 'Acréscimo de 5 cm de margem branca por lado');
    var modProf = makeMod('profundidade', '+ Profundidade', 'Moldura caixa, mais encorpada');
    var modFino = makeMod('fino', '+ Fino', 'Moldura slim, mais discreta');

    (function () {
      var b = document.createElement('span');
      b.className = 'jun26-mod-badge';
      b.textContent = 'Acabamento de galeria';
      modPasp.label.querySelector('.jun26-mod-label').appendChild(b);
    })();

    var opGroup = document.createElement('div');
    opGroup.className = 'jun26-opcionais';
    var opHeader = document.createElement('div');
    opHeader.className = 'jun26-acabamento-header';
    var opPrefix = document.createElement('span');
    opPrefix.className = 'jun26-label-prefix';
    opPrefix.textContent = 'Opcionais';
    opHeader.appendChild(opPrefix);

    var opInfo = document.createElement('div');
    opInfo.className = 'jun26-op-info';
    opInfo.innerHTML = ''
      + '<svg class="jun26-info-ico" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">'
      + '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>'
      + '</svg>'
      + '<span>Quadros neste tamanho já vêm com profundidade maior (moldura caixa).</span>';
    opInfo.style.display = 'none';
    opGroup.append(opHeader, opInfo, modsRow);

    if (isRDmod) {
      opGroup.classList.add('jun26-extras-flat');
      opPrefix.textContent = 'Extras';
      var opTag = document.createElement('span');
      opTag.className = 'jun26-op-tag';
      opTag.textContent = '· opcional';
      opHeader.appendChild(opTag);
      modsRow.classList.add('jun26-extras-panel');

      /* 28/jul — A CAIXA DE EXTRAS É RECOLHÍVEL E COMEÇA FECHADA.
         Extras são opcionais de verdade: a maior parte das pessoas compra sem
         eles, e dois cards abertos no meio do caminho competem com a decisão
         principal (tamanho e moldura). Fechada, a caixa vira uma linha só que
         ANUNCIA que existe opção — quem quer, abre.
         O estado é setado UMA vez, na criação. Depois disso ele é do usuário:
         quem abriu pra escolher um extra continua vendo o que escolheu, mesmo
         quando o bloco some e volta ao trocar de tipo de moldura. */
      opHeader.setAttribute('role', 'button');
      opHeader.setAttribute('tabindex', '0');
      opHeader.setAttribute('aria-expanded', 'false');
      var opSeta = document.createElement('span');
      opSeta.className = 'jun26-op-seta';
      opSeta.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      opHeader.appendChild(opSeta);
      var opToggle = function () {
        var aberto = opGroup.classList.toggle('rd-op-aberto');
        opHeader.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      };
      opHeader.addEventListener('click', opToggle);
      opHeader.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); opToggle(); }
      });

      [modProf, modPasp, modFino].forEach(function (mod) {
        mod.label.addEventListener('click', function (ev) {
          var cb = mod.checkbox;
          if (!cb.disabled || cb.checked) return;
          ev.preventDefault();
          [modProf, modPasp, modFino].forEach(function (other) {
            if (other !== mod && other.checkbox.checked) {
              other.checkbox.checked = false;
              other.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          cb.disabled = false;
          cb.checked = true;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      /* ═══════════════════════════════════════════════════════════════════════
         28/jul — EXTRAS: COMPONENTE PRÓPRIO (desktop)
         Os cartões antigos eram do tema, e vestir eles por CSS só produzia
         briga de regra. Aqui a fileira original vira MODELO — ela continua no
         DOM, invisível, guardando o estado e recebendo tudo que o
         resolveAndSync escreve — e esta view nova é o que aparece.
         Duas decisões de desenho:
         · CARTÃO, não linha. Moldura, cor e tamanho logo acima já são cartões;
           linha aqui seria um terceiro padrão na mesma coluna. Com o slim fora,
           sobram dois extras, que preenchem a largura sem sobra.
         · O QUE NÃO DÁ PRA ESCOLHER SAI DA ÁREA DE ESCOLHA. Extra indisponível
           ou já incluso não é opção apagada, é informação — desce pro bloco
           "neste tamanho", com o motivo por extenso. Os cartões passam a
           mostrar só o que de fato dá pra decidir.
         ═══════════════════════════════════════════════════════════════════════ */
      /* a fileira antiga vira modelo invisível — o display sai pelo CSS
         (.jun26-extras-panel tem `display: grid !important`, então inline não
         venceria) */
      modsRow.classList.add('rd-extras-modelo');

      var X_DEF = [
        { key: 'paspatur', mod: modPasp, nome: 'Paspatur 5 cm',
          /* 28/jul: UMA linha, no tom da ficha da moldura logo acima. Duas
             frases viravam dois períodos pra explicar uma margem — e o número
             do tamanho final já é dito pela nota do bloco de preço, então
             repetir aqui dava dois lugares falando a mesma coisa. */
          /* 28/jul: encurtada de novo pra caber com o link NA MESMA LINHA — a
             frase e o "Ver como fica" formam uma frase só, como na moldura. */
          sub: function () { return 'Adiciona 5 cm por lado · estética de galeria.'; },
          motivoOff: 'A partir de 70 × 100 cm, por limite de manuseio',
          motivoOn: 'Margem branca entre a arte e a moldura, 5 cm por lado.' },
        /* 28/jul: a PROFUNDIDADE existe como extra nos tamanhos em que ela é
           escolha — e some de 70 × 100 pra cima, onde a caixa deixou de ser
           oferecida junto com a revogação da trava estrutural. Lá o bloco fica
           só com o paspatur. */
        { key: 'profundidade', mod: modProf, nome: 'Profundidade 3 cm',
          sub: function () { return 'Mais corpo e presença na parede.'; },
          soAte: 7000,   /* área da arte em cm²: 70×100 já não oferece */
          motivoOff: 'Não existe nesta combinação de moldura e tamanho',
          motivoOn: '' }
      ];

      var xBloco = document.createElement('div');
      xBloco.className = 'rd-extras';
      var xCards = document.createElement('div');
      xCards.className = 'rd-extras__cards';
      var xDesc = document.createElement('p');
      xDesc.className = 'rd-extras__desc';
      var xDescTxt = document.createElement('span');
      xDescTxt.className = 'rd-extras__desc-txt';
      /* 28/jul: o link mora no FIM da linha de descrição, igual ao "Ver ficha
         técnica" da moldura — mas ele é FIXO, e só o texto antes dele é que vai
         e vem conforme o cursor. Se ele dependesse do hover, a única porta pra
         entender o produto sumiria no celular e apareceria por acaso no
         desktop. */
      var xLink = document.createElement('button');
      xLink.type = 'button';
      xLink.className = 'rd-extras__link';
      xDesc.append(xDescTxt, xLink);
      var xNotas = document.createElement('div');
      xNotas.className = 'rd-extras__notas';
      var xNotasTit = document.createElement('div');
      xNotasTit.className = 'rd-extras__notas-tit';
      xNotasTit.textContent = 'Neste tamanho';
      xNotas.appendChild(xNotasTit);
      xBloco.append(xCards, xDesc, xNotas);
      opGroup.appendChild(xBloco);

      var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4.5 4.5L19 7"/></svg>';
      var TRACO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';

      X_DEF.forEach(function (x) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'rd-xcard rd-xcard--' + x.key;
        /* 28/jul: o cartão adota a MESMA anatomia dos chips de moldura — duas
           linhas curtas (nome e o que ele custa) e altura de chip. A descrição
           não cabe aqui e não precisa: ela desce pra linha embaixo da fileira,
           igual à ficha da moldura selecionada. Ícone sai: os chips vizinhos
           não têm, e a 42px aquele desenho de linha não lia mesmo. */
        card.innerHTML = '<span class="rd-xcard__nome"></span>'
          + '<span class="rd-xcard__preco"></span>'
          + '<span class="rd-xcard__marca">' + CHECK + '</span>';
        card.addEventListener('click', function () {
          var cb = x.mod.checkbox;
          /* 28/jul: ESCOLHER UM SOLTA O OUTRO. Quando a combinação não existe,
             a versão anterior deixava o vizinho inerte dizendo "não combina" —
             e isso transforma uma troca simples num aviso de erro. Aqui o
             clique sempre funciona: se o extra estava bloqueado pelo que já
             estava escolhido, o que estava escolhido sai e ele entra. A regra
             deixa de ser texto e vira comportamento. */
          if (cb.disabled && !cb.checked) {
            X_DEF.forEach(function (o) {
              if (o !== x && o.mod.checkbox.checked) {
                o.mod.checkbox.checked = false;
                o.mod.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
            cb.disabled = false;
          }
          cb.checked = !cb.checked;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
        xCards.appendChild(card);

        var nota = document.createElement('div');
        nota.className = 'rd-xnota rd-xnota--' + x.key;
        nota.innerHTML = '<span class="rd-xnota__ico"></span>'
          + '<span class="rd-xnota__col"><span class="rd-xnota__t"></span><span class="rd-xnota__d"></span></span>';
        xNotas.appendChild(nota);

        x.card = card; x.nota = nota;
      });

      /* 28/jul: a descrição segue o CLIQUE, não o cursor. Chegou a seguir o
         hover — e texto que muda ao passar o mouse é informação que aparece por
         acidente: a pessoa lê metade, tira o mouse, e ela some. Aqui vale a
         mesma regra da moldura: o texto descreve o que está ESCOLHIDO. Sem
         escolha, fica só o link, que é a porta pra entender antes de decidir. */
      var pintaDesc = function () {
        var alvo = X_DEF.filter(function (x) { return !x.card.hidden && x.mod.checkbox.checked; })[0];
        /* 28/jul: sem cursor e sem escolha, a linha fica VAZIA. Explicar o
           primeiro extra por padrão seria descrever uma coisa que a pessoa não
           pediu — e ela leria aquilo como se já estivesse valendo. A altura
           continua reservada no CSS pra nada pular quando o texto entra. */
        /* 28/jul: sem escolha, a linha INTEIRA some — inclusive o link. Ele não
           é um botão solto embaixo da fileira: é o fim da frase que descreve o
           que você escolheu, do mesmo jeito que o "Saiba mais" da moldura é o
           fim da frase que descreve a moldura escolhida. Sem frase, não há fim
           de frase. */
        /* 28/jul: no JÁ INCLUSO a linha também não existe — nem texto, nem
           link. Ali não há decisão pendente: a peça vem assim. Oferecer "saiba
           mais" sobre algo que a pessoa não pode mudar é convidá-la a
           questionar o que já está resolvido. */
        var mudo = !alvo || alvo.card.classList.contains('rd-xcard--incluso');
        xDesc.hidden = mudo;
        if (mudo) { xDescTxt.textContent = ''; return; }
        var txt = alvo.sub();
        xDescTxt.textContent = txt ? txt + ' ' : '';
      };

      /* ── A GAVETA DO EXTRA ─────────────────────────────────────────────────
         Reusa o componente que já existe (.rd-tamsheet, do "Tamanho final"):
         mesma gaveta, mesmo scrim, mesmo arrastar-pra-fechar, mesmo Esc. Só o
         conteúdo é outro. Criar uma segunda gaveta com a mesma cara seria
         manter dois códigos pro mesmo gesto.
         Os desenhos usam a MESMA receita das minis: cor de madeira do produto,
         face proporcional ao tamanho, paspatur como respiro interno. Retângulo
         dourado genérico mostraria uma moldura que a loja não vende. */
      var xDrawer = null, xScrim = null;
      function fechaXDrawer() {
        if (!xDrawer) return;
        xDrawer.classList.remove('is-open');
        if (xScrim) xScrim.classList.remove('is-open');
      }
      function molduraCSS(arte, opts) {
        /* 28/jul: a ARTE tem tamanho fixo em cm nos dois desenhos — é esse o
           fato que o paspatur ensina ("a arte continua do mesmo tamanho"). Se o
           desenho esticar a imagem pra preencher o vão, ele diz o contrário do
           texto. Então: a arte é desenhada em arte.w × arte.h, e o paspatur é o
           branco em volta dela; a peça inteira cresce por fora.
           Cores e proporção da face saem da medida real (2 cm de perfil na
           moldura padrão), escaladas junto — como no mini do carrinho, onde a
           face engrossa conforme o quadro diminui. */
        var refQ = document.querySelector('.rd-buymini__q');
        var refCS = refQ ? getComputedStyle(refQ) : null;
        var cor = refCS ? refCS.borderTopColor : '#C9A876';
        var corR = refCS ? refCS.borderRightColor : cor;
        var corB = refCS ? refCS.borderBottomColor : cor;
        var esc = opts.esc;
        /* 28/jul: SEM o piso de 2px que eu tinha copiado das minis. A face real
           é constante em centímetros (2 cm de perfil em qualquer tamanho) — o
           que muda é a proporção: num quadro pequeno esses 2 cm são uma fatia
           bem maior da peça. É isso que o desenho tem que mostrar.
           O piso achatava justamente os tamanhos grandes (1,6px virava 2px) e
           comia a diferença. Sem ele, 30×42 dá ~3,3px e 70×100 dá ~1,6px: o
           dobro, que é a verdade da peça.
           Nas minis o piso existe porque lá o desenho tem 60px e a face sumiria;
           aqui a figura é três vezes maior. */
        var face = Math.max(1, (opts.faceCm || 2) * esc);
        var mat = opts.pasp ? 5 * esc : 0;
        var img = document.querySelector('.rd-buymini__art') || document.querySelector('.pp26__art');
        var src = img ? (img.currentSrc || img.src || '') : '';
        /* 28/jul: SEM COTA. Ela foi tentada de três jeitos — dentro da margem,
           com o número fora, com o rótulo generalizando os quatro lados — e
           nenhum funciona nesta escala: a margem tem ~8px e a anotação técnica
           acaba maior que a coisa medida. As fichas das molduras aguentam cota
           porque o desenho é grande; aqui a peça inteira tem 90px.
           O crescimento já está dito três vezes: as duas figuras na mesma
           escala mostram, a legenda nomeia e o parágrafo dá o número. */
        /* 28/jul: as cotas aqui são as MESMAS da gaveta do tamanho final —
           colchete no paspatur (que é largo) e linha-guia na face (que tem
           3px), as duas em cima e na horizontal. As quatro setas atravessando a
           margem nos quatro lados diziam a mesma medida quatro vezes e
           brigavam com a arte. A da face passa a existir aqui também: ela é
           parte do que faz a peça crescer. */
        /* 28/jul (revisão) — AS COTAS VÃO PRA DENTRO, NOS QUATRO LADOS.
           A versão anterior media por fora, em cima, e dizia duas coisas
           diferentes lado a lado (5 cm de paspatur, 2 cm de face) — o olho lia
           as duas como se fossem a mesma medida em lugares diferentes da peça.
           Aqui a pergunta é uma só: quanto de respiro a arte ganha. Então cada
           lado carrega a sua própria cota, dentro da margem que ela mede, como
           em desenho técnico. A face sai da conta: ela não muda com o paspatur.
           Isso só funciona porque a figura cresceu — com margem de ~15px não
           cabia rótulo nenhum, que foi o motivo de elas terem ido pra fora. */
        var cota = '';
        if (opts.cotas) {
          var m = mat.toFixed(1);
          cota = '<i class="rd-pcota rd-pcota--top" style="height:' + m + 'px"><em>5 cm</em></i>'
            + '<i class="rd-pcota rd-pcota--bot" style="height:' + m + 'px"><em>5 cm</em></i>'
            + '<i class="rd-pcota rd-pcota--esq" style="width:' + m + 'px"><em>5 cm</em></i>'
            + '<i class="rd-pcota rd-pcota--dir" style="width:' + m + 'px"><em>5 cm</em></i>';
        }
        return '<span class="rd-xfig__quadro" style="padding:' + mat.toFixed(1) + 'px;'
          + 'border:' + face.toFixed(1) + 'px solid ' + cor + ';'
          + 'border-right-color:' + corR + ';border-bottom-color:' + corB + ';">'
          + cota
          + '<i class="rd-xfig__art" style="width:' + (arte.w * esc).toFixed(1) + 'px;height:' + (arte.h * esc).toFixed(1) + 'px;'
          + 'background-image:url(&quot;' + src + '&quot;)"></i>'
          + '</span>';
      }
      function conteudoDrawer(x) {
        var d = parseTamanho(getCurrentSize() || '') || { w: 30, h: 40 };
        /* 28/jul: RESPEITAR A ORIENTAÇÃO. O valor da variante vem sempre em
           retrato ("50x70"), e quem diz se a peça é deitada é a obra. Sem esta
           troca, uma arte horizontal aparecia em pé na gaveta — o desenho
           mostrava um quadro que não é o que ela está comprando.
           A orientação sai do DOM (o slide da galeria a publica), com a
           proporção da mini como segunda fonte. */
        /* 28/jul: mesma correção da gaveta do tamanho final — a orientação sai
           da proporção da arte renderizada, não de um [data-orientation] solto. */
        /* 28/jul (correção): a orientação vem do TAMANHO NATURAL da imagem, não
           do retângulo renderizado. A mini do preço saiu do desktop na dieta da
           coluna, e elemento oculto mede 0×0 — a conta caía sempre em
           "vertical" e a gaveta desenhava em pé uma obra deitada. O arquivo
           tem a proporção verdadeira esteja ele visível ou não. */
        var refA = document.querySelector('.rd-buymini__art') || document.querySelector('.pp26__art') || document.querySelector('.jun26-amb-photo');
        var rr = refA && (refA.naturalWidth ? { width: refA.naturalWidth, height: refA.naturalHeight } : refA.getBoundingClientRect());
        var orient = (rr && rr.width > rr.height + 1) ? 'horizontal' : 'vertical';
        if (orient === 'horizontal' && d.h > d.w) { var t0 = d.w; d.w = d.h; d.h = t0; }
        var preco = (x.mod.price.textContent || '').replace(/^\+\s*/, '').trim();
        var ligado = x.mod.checkbox.checked;
        /* 28/jul: ligado, a linha de custo fica MUDA. "Incluído no preço" não
           diz nada que a pessoa não veja no total — e ao lado de um botão
           REMOVER soa como se ela estivesse pagando duas vezes. O botão sozinho
           já diz o estado. */
        var acao = '<div class="rd-xdrawer__acao">'
          + '<span class="rd-xdrawer__custo">' + (ligado ? '' : (preco ? 'Acrescenta <b>' + preco + '</b>' : '')) + '</span>'
          /* 28/jul: REMOVER é o botão ao contrário — vazado, com fio de tinta.
             Preto pleno é o peso de quem convida a agir; tirar um extra não é
             a ação que a página quer promover, então ela existe sem gritar. */
          + '<button type="button" class="rd-xdrawer__btn' + (ligado ? ' rd-xdrawer__btn--out' : '') + '" data-key="' + x.key + '">' + (ligado ? 'Remover' : 'Incluir') + '</button>'
          + '</div>';
        if (x.key === 'paspatur') {
          /* 28/jul — UMA figura só, grande, com as quatro cotas. A comparação
             lado a lado ("sem" e "com") ensinava que a peça cresce; esta ensina
             ONDE ela cresce, que é a pergunta seguinte e a que importa na hora
             de medir a parede. O crescimento total continua dito no parágrafo.
             As setas atravessam a margem e os rótulos ficam FORA da peça: na
             largura da gaveta o paspatur desenhado tem ~18px, e nenhum texto
             cabe ali dentro. */
          var notaTxt = (root.querySelector('.rd-size-note__txt') || {}).textContent || '';
          var mm = notaTxt.replace(/\u00a0/g, ' ').match(/(\d+)\s*×\s*(\d+)/);
          var pw = mm ? +mm[1] : d.w, ph = mm ? +mm[2] : d.h;
          if (ligado) { pw -= 10; ph -= 10; }
          var faceLida = (pw - d.w) / 2;
          var faceCm = (faceLida > 0.5 && faceLida < 12) ? faceLida : 2;
          /* 28/jul (revisão): a altura ganha o mesmo fôlego da largura. O teto
             de 150px espremia a peça a menos da metade do que a gaveta oferece
             (o desenho saía com 150 de largura numa caixa de 356) e, com a
             margem em ~15px, nenhuma cota cabia dentro dela. Com 344×300 a
             margem passa dos 28px e o desenho volta a ser o assunto da gaveta.
             O texto de sobrancelha sai: a figura cotada já diz que a arte
             mantém o tamanho, e o parágrafo abaixo dá o número. */
          var escS = Math.min(344 / (pw + 10), 300 / (ph + 10));
          return '<div class="rd-xdrawer__solo"><div class="rd-tffig">'
            /* 28/jul (revisão): a moldura desenhada afina. Nas outras figuras a
               face é medida — aqui ela é só o limite da peça, e na escala nova
               (a figura dobrou de tamanho) os 2 cm cheios viravam uma barra
               grossa que disputava com o paspatur, que é o assunto. Fica em 2/3
               da medida: continua lendo como madeira, sem roubar a margem. */
            + molduraCSS(d, { esc: escS, pasp: true, faceCm: faceCm * 0.66, cotas: true })
            + '</div></div>'
            + '<p class="rd-xdrawer__texto">O paspatur cria uma margem branca de 5 cm em cada lado. A arte permanece no tamanho escolhido, e o quadro fica 10 cm maior na largura e na altura.</p>'
            + '<p class="rd-xdrawer__dica"><svg class="rd-xdrawer__i" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg><span>Ao medir a parede, considere o tamanho final do quadro.</span></p>' + acao;
        }
        /* 28/jul — PERFIL: o quadro visto de lado, na altura real da peça.
           Saiu a prateleira (a barra de sombra no pé lia como móvel, não como
           sombra) e a cota saiu de cima do desenho — número dentro da madeira
           disputa com ela. Agora a medida vai na legenda, junto do nome. */
        /* 28/jul: MESMA ESCALA NOS DOIS EIXOS. Antes a largura ia a 9px/cm e a
           altura a ~1,7px/cm pra peça inteira caber — e aí 3 cm de profundidade
           liam como uns 16. Agora vale uma escala só (9px/cm) e a peça SANGRA
           em altura: vira detalhe ampliado, com a proporção verdadeira dentro
           do recorte. É como se aproximasse a lente, não como se esticasse. */
        var escP = 9;
        var altura = d.h * escP;
        /* 28/jul: a peça é DESENHADA EM DOIS PEDAÇOS com uma quebra no meio.
           Sangrando embaixo ela pousava no chão — e quadro não pousa, pendura.
           Mostrando inteira, a escala mentiria (uma peça de 50 cm a 9px/cm teria
           450px). A quebra resolve: as duas bordas aparecem, a peça flutua, e o
           recorte fica declarado, como em desenho técnico.
           A quebra é um VÃO LIMPO: a versão com zigue-zague lia como parafuso
           ou serrilha na madeira, que é o oposto do acabamento que a peça tem. */
        /* 28/jul: UMA peça só, flutuando. A versão em dois pedaços (com o vão
           declarando o corte) lia como moldura atravessada — desenho técnico
           dentro de um desenho ilustrativo. Aqui vale o oposto: bloco limpo,
           sem tocar o topo nem o chão, e a parede atrás dando o contexto. */
        var perfil = function (cm) {
          var w = (cm * escP).toFixed(1);
          return '<span class="rd-xfig__perfil">'
            + '<i class="rd-xfig__parede"></i>'
            + '<i class="rd-xfig__face" style="width:' + w + 'px"></i>'
            + '</span>';
        };
        return '<p class="rd-xdrawer__eyebrow">Mais profundidade. Mesmo tamanho de frente.</p>'
          + '<div class="rd-xdrawer__par">'
          + '<figure class="rd-xfig">' + perfil(1) + '<figcaption>Padrão · 1 cm</figcaption></figure>'
          + '<figure class="rd-xfig rd-xfig--on">' + perfil(3) + '<figcaption>Com profundidade · 3 cm</figcaption></figure>'
          + '</div>'
          + '<p class="rd-xdrawer__texto">A altura e a largura permanecem iguais. A moldura passa de 1 cm para 3 cm de profundidade, criando mais volume e presença quando vista de lado.</p>'
          + '<p class="rd-xdrawer__texto">A peça avança 2 cm a mais da parede.</p>'
          + '<p class="rd-xdrawer__dica"><svg class="rd-xdrawer__i" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg><span>A profundidade não altera a área ocupada na parede.</span></p>' + acao;
      }
      function abreXDrawer(x) {
        if (!xDrawer) {
          /* 28/jul: sem o helper el() aqui — ele não existe neste escopo, e a
             primeira versão quebrava com ReferenceError no clique. */
          xScrim = document.createElement('div');
          xScrim.className = 'rd-tamsheet__scrim rd-xdrawer__scrim';
          xScrim.addEventListener('click', fechaXDrawer);
          xDrawer = document.createElement('div');
          xDrawer.className = 'rd-tamsheet rd-xdrawer';
          xDrawer.setAttribute('role', 'dialog');
          xDrawer.innerHTML = '<div class="rd-tamsheet__grip" aria-hidden="true"></div>'
            + '<button class="rd-tamsheet__x" type="button" aria-label="Fechar">'
            + '<svg viewBox="0 0 15.22 15.22" width="15.22" height="15.22" fill="none" stroke="currentColor" stroke-width="1.22" stroke-linecap="butt" aria-hidden="true">'
            + '<path d="M0.61 0.61 L14.61 14.61 M14.61 0.61 L0.61 14.61"/></svg></button>'
            + '<p class="rd-tamsheet__tit" data-no-relabel></p>'
            + '<div class="rd-tamsheet__corpo"></div>';
          xDrawer.querySelector('.rd-tamsheet__x').addEventListener('click', fechaXDrawer);
          document.body.appendChild(xScrim);
          document.body.appendChild(xDrawer);
          var y0 = null;
          xDrawer.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
          xDrawer.addEventListener('touchend', function (e) {
            if (y0 == null) return;
            var t = e.changedTouches && e.changedTouches[0];
            if (t && t.clientY - y0 > 60) fechaXDrawer();
            y0 = null;
          }, { passive: true });
          document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechaXDrawer(); });
        }
        xDrawer.querySelector('.rd-tamsheet__tit').textContent = x.nome;
        var corpo = xDrawer.querySelector('.rd-tamsheet__corpo');
        corpo.innerHTML = conteudoDrawer(x);
        var b = corpo.querySelector('.rd-xdrawer__btn');
        if (b) b.addEventListener('click', function () { x.card.click(); fechaXDrawer(); });
        xScrim.classList.add('is-open');
        xDrawer.classList.add('is-open');
      }
      xLink.addEventListener('click', function () {
        var alvo = X_DEF.filter(function (x) { return !x.card.hidden && x.mod.checkbox.checked; })[0]
          || X_DEF.filter(function (x) { return !x.card.hidden; })[0];
        if (alvo) abreXDrawer(alvo);
      });

      var syncX = function () {
        var comNota = 0, comCard = 0, nomesX = [];
        /* 28/jul: um extra pode ficar impossível por DOIS motivos, e eles não
           merecem o mesmo tratamento.
           · Nunca existiu nesta peça (tamanho/moldura não comportam): não
             aparece. Listar porta fechada que a pessoa nem sabia que existia só
             empobrece a configuração.
           · Deixou de existir por causa do que ela ACABOU de escolher: aparece
             INATIVO, dizendo o porquê. Aqui a informação vale ouro — é o que
             explica que é um ou outro, em vez de deixar o cartão sumir na cara
             da pessoa e ela se perguntar o que aconteceu. */
        var algumLigado = X_DEF.some(function (x) { return x.mod.checkbox.checked; });
        /* 28/jul: a trava de faixa do PASPATUR foi removida (o 70 × 100 tem
           paspatur sim). Ficou uma trava por tamanho genérica, hoje usada só
           pela profundidade: ela não é oferecida de 70 × 100 pra cima. */
        var szX = parseTamanho(getCurrentSize() || '');
        var areaArte = szX ? szX.w * szX.h : 0;
        /* 28/jul: extra é coisa de moldura PADRÃO. Canvas e sem-moldura não têm
           o que acrescentar — a tela é esticada no chassi e a impressão vai
           sozinha —, então o bloco inteiro sai da folha em vez de aparecer
           anunciando o que não existe. */
        var ehPadrao = !!(typeof state !== 'undefined' && state && /padr/i.test(String(state.primario || '')));
        if (!ehPadrao) {
          X_DEF.forEach(function (x) { x.card.hidden = true; x.nota.hidden = true; });
          xCards.hidden = true; xNotas.hidden = true; xDesc.hidden = true; xBloco.hidden = true;
          opGroup.classList.add('rd-extras-vazio');
          return;
        }
        X_DEF.forEach(function (x) {
          var cb = x.mod.checkbox;
          var travado = x.mod.label.classList.contains('jun26-mod--locked');
          var indisponivel = cb.disabled && !cb.checked && !travado;
          /* a trava de FAIXA some com o cartão antes de qualquer outra regra:
             não é "bloqueado pela sua escolha" (que ficaria à vista pra você
             trocar), é "não existe nesta medida". Precisa vir antes porque a
             profundidade travada conta como escolhida, e a regra de troca
             mantinha o paspatur à vista achando que era um caso de swap. */
          if (x.soAte && areaArte >= x.soAte && !cb.checked) {
            x.card.hidden = true;
            x.nota.hidden = true;
            return;
          }
          /* 28/jul: o INDISPONÍVEL não aparece. Extra que não existe pra esta
             peça não é informação útil — é uma porta fechada que a pessoa nem
             sabia que existia, e listar portas fechadas só faz a configuração
             parecer mais pobre do que é. Some inteiro.
             O INCLUSO fica: ali não há o que escolher, mas há o que saber —
             é uma característica do que ela está levando. */
          /* 28/jul: o INCLUSO deixou de ser uma linha à parte com check verde —
             aquilo lia como recado de sistema no meio da configuração. Agora é
             um terceiro ESTADO do mesmo cartão: mesma caixa, mesma marca de
             tinta, e no lugar do preço a palavra que interessa. Assim o bloco
             tem um objeto só, em três situações: dá pra escolher, você
             escolheu, ou já vem na peça. */
          /* o extra bloqueado POR OUTRA ESCOLHA continua clicável: o clique
             troca um pelo outro (ver o handler acima). Só some quem não existe
             pra esta peça nem sozinho. */
          x.card.hidden = indisponivel && !algumLigado;
          x.nota.hidden = true;
          if (x.card.hidden) return;
          comCard++;
          nomesX.push(x.nome.split(' ')[0].toLowerCase());
          x.card.disabled = false;
          x.card.classList.toggle('rd-xcard--incluso', travado);
          x.card.disabled = travado;
          if (travado) {
            x.card.classList.add('rd-xcard--on');
            x.card.setAttribute('aria-pressed', 'true');
            x.card.querySelector('.rd-xcard__nome').textContent = x.nome;
            x.card.querySelector('.rd-xcard__preco').textContent = 'Já incluso';
            return;
          }
          x.card.classList.toggle('rd-xcard--on', cb.checked);
          x.card.setAttribute('aria-pressed', cb.checked ? 'true' : 'false');
          x.card.querySelector('.rd-xcard__nome').textContent = x.nome;
          var preco = (x.mod.price.textContent || '').trim();
          x.card.querySelector('.rd-xcard__preco').textContent = cb.checked ? 'Incluído' : preco;
        });
        /* 28/jul — O RÓTULO DIZ O QUE TEM DENTRO.
           Fechada, a caixa era "Extras · opcional": dizia a natureza da coisa
           (é opcional) e escondia o conteúdo (o quê?). Quem lê precisa decidir
           se vale abrir, e pra isso o nome dos extras vale mais do que a
           palavra "opcional" — que, aliás, a caixa fechada já insinua.
           A lista é montada do que está À VISTA: em tamanhos onde só o paspatur
           existe, o rótulo diz só paspatur. Rótulo que promete o que não tem é
           pior que rótulo genérico. */
        if (typeof opTag !== 'undefined' && opTag) {
          opTag.textContent = nomesX.length ? '· ' + nomesX.join(' e ') : '· opcional';
        }
        xNotas.hidden = comNota === 0;
        xCards.hidden = comCard === 0;
        /* sem cartão e sem nota não há bloco: o título "Extras" sozinho seria
           uma seção vazia anunciando que não tem nada */
        xLink.textContent = 'Saiba mais';
        xLink.hidden = comCard === 0;
        pintaDesc();
        var vazio = comCard === 0 && comNota === 0;
        xBloco.hidden = vazio;
        opGroup.classList.toggle('rd-extras-vazio', vazio);
      };
      document.addEventListener('change', function () { setTimeout(syncX, 0); }, true);
      setTimeout(syncX, 0);
      setTimeout(syncX, 600);
    }
    var sizeFsForOp = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
    if (sizeFsForOp && sizeFsForOp.parentElement) {
      sizeFsForOp.parentElement.insertBefore(opGroup, sizeFsForOp.nextSibling);
    } else {
      container.appendChild(opGroup);
    }

    var corBlock = null;
    var corValueEl = null;
    var corSwatches = [];
    if (corFs) {
      corBlock = document.createElement('div');
      corBlock.className = 'jun26-cor-block';

      var corHeader = document.createElement('div');
      corHeader.className = 'jun26-acabamento-header';
      var corPrefix = document.createElement('span');
      corPrefix.className = 'jun26-label-prefix';
      corPrefix.textContent = 'Cor da moldura';
      var corSep = document.createElement('span');
      corSep.className = 'jun26-label-sep';
      corSep.textContent = '·';
      corValueEl = document.createElement('span');
      corValueEl.className = 'jun26-label-value';
      corHeader.append(corPrefix, corSep, corValueEl);
      corBlock.appendChild(corHeader);

      var swatchesRow = document.createElement('div');
      swatchesRow.className = 'jun26-swatches-row';

      var corInputs = corFs.querySelectorAll('input[type="radio"]:not([value="sem moldura"])');
      corInputs.forEach(function (input) {
        var origLabel = input.nextElementSibling;
        if (!origLabel) return;
        var sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'jun26-swatch';
        sw.dataset.value = input.value;
        sw.style.setProperty('--option-color', origLabel.style.getPropertyValue('--option-color') || '#ccc');
        sw.style.setProperty('--option-color-image', origLabel.style.getPropertyValue('--option-color-image') || '');

        sw.setAttribute('data-tooltip', input.value);
        sw.setAttribute('aria-label', input.value);
        sw.addEventListener('click', function () {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          updateCorUI();
        });
        swatchesRow.appendChild(sw);
        corSwatches.push({ el: sw, input: input });
      });

      corBlock.appendChild(swatchesRow);
      container.appendChild(corBlock);
    }

    function titleCase(s) {
      return (s || '').replace(/\S+/g, function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      });
    }

    function priceOfMold(moldura) {
      var sz = getCurrentSize();
      var per = PRICE_BY_SIZE && sz && PRICE_BY_SIZE[sz];
      var c = per && moldura ? per[moldura] : null;
      if (c == null || c >= 999900) return null;
      return c;
    }

    function fmtBRL(cents) {
      var r = cents / 100;
      var dec = r % 1 === 0 ? 0 : 2;
      return 'R$ ' + r.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: 2 });
    }

    function modAddCost(modKey) {
      var on = Object.assign({}, state), off = Object.assign({}, state);
      on[modKey] = true; off[modKey] = false;
      if (modKey === 'profundidade') on.fino = false;
      if (modKey === 'fino') on.profundidade = false;
      var kOn = on.primario + '|' + (on.profundidade ? 1 : 0) + '|' + (on.fino ? 1 : 0) + '|' + (on.paspatur ? 1 : 0);
      var kOff = off.primario + '|' + (off.profundidade ? 1 : 0) + '|' + (off.fino ? 1 : 0) + '|' + (off.paspatur ? 1 : 0);
      var pOn = priceOfMold(VARIANT_MAP[kOn]), pOff = priceOfMold(VARIANT_MAP[kOff]);
      if (pOn == null || pOff == null) return null;
      return pOn - pOff;
    }

    function modSwapCost(modKey) {
      var on = Object.assign({}, state, { profundidade: false, fino: false, paspatur: false });
      var off = Object.assign({}, on);
      on[modKey] = true;
      var kOn = on.primario + '|' + (on.profundidade ? 1 : 0) + '|' + (on.fino ? 1 : 0) + '|' + (on.paspatur ? 1 : 0);
      var kOff = off.primario + '|' + (off.profundidade ? 1 : 0) + '|' + (off.fino ? 1 : 0) + '|' + (off.paspatur ? 1 : 0);
      var pOn = priceOfMold(VARIANT_MAP[kOn]), pOff = priceOfMold(VARIANT_MAP[kOff]);
      if (pOn == null || pOff == null) return null;
      return pOn - pOff;
    }

    function updateCorUI() {
      if (!corFs) return;
      var checked = corFs.querySelector('input:checked');
      var val = checked ? checked.value : '';
      corSwatches.forEach(function (item) {
        item.el.classList.toggle('jun26-swatch--active', item.input.value === val);
      });
      if (corValueEl) corValueEl.textContent = titleCase(val);
    }


    molduraFs.parentElement.insertBefore(container, molduraFs);

    var cardConfig = document.createElement('div');
    cardConfig.className = 'jun26-card-config';
    container.parentElement.insertBefore(cardConfig, container);
    cardConfig.appendChild(container);
    if (corBlock) cardConfig.appendChild(corBlock);
    var tamGroup = document.createElement('div');
    tamGroup.className = 'jun26-tam-group';
    var tamRowEl = root.querySelector('.jun26-tamanho-row');
    var sizeFsEl = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');

    tamGroup.appendChild(molduraFs);
    if (corFs) tamGroup.appendChild(corFs);
    if (tamRowEl) tamGroup.appendChild(tamRowEl);
    if (sizeFsEl) tamGroup.appendChild(sizeFsEl);

    var cmpBelowEl = root.querySelector('.jun26-compare-link--below');
    if (cmpBelowEl) tamGroup.appendChild(cmpBelowEl);
    cardConfig.appendChild(tamGroup);
    cardConfig.appendChild(opGroup);

    var inner = root.querySelector('.product-information--inner') || root;
    var extras = document.createElement('div');
    extras.className = 'jun26-extras';
    extras.innerHTML = ''
      + '<div class="jun26-trust">'
      + '<span class="jun26-trust-item"><span class="jun26-lock" aria-hidden="true"><span class="jun26-lock-shackle"></span><span class="jun26-lock-body"></span></span>Compra 100% segura</span>'
      + '<span class="jun26-trust-item jun26-trust-devolucao">'
      + '<svg class="jun26-return-ico" aria-hidden="true" width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<path d="M4.5 1.5L2 4l2.5 2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>'
      + '<path d="M2 4h6.5a3.75 3.75 0 0 1 0 7.5H4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
      + '</svg>'
      + 'Devolução grátis</span>'
      + '<span class="jun26-trust-dot jun26-trust-dot-b">·</span>'
      + '<a class="jun26-trust-link" href="/pages/trocas-e-devolucoes">Ver política</a>'
      + '</div>'
      + '<div class="jun26-specs">'
      + '<div class="jun26-spec-row" data-spec="papel"><div class="jun26-spec-label">Papel</div><div class="jun26-spec-value">Canson® Satin 240g/m², impressão giclée</div></div>'
      + '<div class="jun26-spec-row" data-spec="moldura"><div class="jun26-spec-label">Moldura</div><div class="jun26-spec-value"></div></div>'
      + '<div class="jun26-spec-row" data-spec="envio"><div class="jun26-spec-label">Envio</div><div class="jun26-spec-value"></div></div>'
      + '<div class="jun26-spec-row"><div class="jun26-spec-label">Arte</div><div class="jun26-spec-value">Reprodução oficial autorizada · artista comissionado em cada venda</div></div>'
      + '</div>'
      + '<div class="jun26-curadoria">'
      + '<div class="jun26-curadoria-col">'
      + '<span class="jun26-curadoria-title">Dúvidas sobre o quadro?</span>'
      + '<span class="jun26-curadoria-sub">Fale com a curadoria no WhatsApp.</span>'
      + '<span class="jun26-curadoria-status"></span>'
      + '</div>'
      + '<a class="jun26-curadoria-btn" target="_blank" rel="noopener noreferrer">'
      + '<svg class="jun26-wa-ico" width="14" height="14" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/></svg>'
      + '<span class="jun26-curadoria-btn-txt"></span>'
      + '</a>'
      + '</div>';

    var gridEl = root.querySelector('.pp26-product-grid') ||
      (inner.closest && inner.closest('.pp26-product-grid'));

    var mqDesk = window.matchMedia('(min-width: 1068px)');

    var isRedesignPDP = root.classList.contains('thb-product-detail--redesign');
    function placeExtras() {
      if (isRedesignPDP) { if (extras.parentElement) extras.remove(); return; }
      if (mqDesk.matches && gridEl && gridEl.parentElement) {
        if (gridEl.nextElementSibling !== extras) {
          gridEl.parentElement.insertBefore(extras, gridEl.nextSibling);
        }
        extras.classList.add('jun26-extras--below');
      } else {
        if (extras.parentElement !== inner) inner.appendChild(extras);
        extras.classList.remove('jun26-extras--below');
      }
    }
    placeExtras();
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', placeExtras);
    else if (mqDesk.addListener) mqDesk.addListener(placeExtras);
    var specMolduraRow = extras.querySelector('[data-spec="moldura"]');
    var specMolduraVal = specMolduraRow.querySelector('.jun26-spec-value');
    var specPapelRow = extras.querySelector('[data-spec="papel"]');
    var specPapelLabel = specPapelRow.querySelector('.jun26-spec-label');
    var specPapelVal = specPapelRow.querySelector('.jun26-spec-value');

    var SPEC_PAPEL = {
      'canvas': { label: 'Tela', value: 'Canvas 100% algodão · impressão UV em alta definição' },
      'padrão': { label: 'Papel', value: 'Canson® Satin 240g/m², impressão giclée' },
      'sem moldura': { label: 'Papel', value: 'Canson® Satin 240g/m², impressão giclée' }
    };
    var SPEC_MOLDURA = {
      'canvas': 'Flutuante, em madeira revestida · pendurador e kit de instalação inclusos',
      'padrão': 'Madeira revestida, com vidro de proteção · pendurador e kit de instalação inclusos',
      'sem moldura': null
    };
    var SPEC_ENVIO = {
      'canvas': 'Caixa reforçada · cantoneiras de proteção',
      'padrão': 'Caixa reforçada · cantoneiras de proteção',
      'sem moldura': 'Tubo postal rígido · arte cuidadosamente enrolada'
    };
    var specEnvioVal = extras.querySelector('[data-spec="envio"] .jun26-spec-value');

    var waBtn = document.querySelector('#support-widget a[data-sw-action="whatsapp"]');
    var curaBtn = extras.querySelector('.jun26-curadoria-btn');
    var curaStatus = extras.querySelector('.jun26-curadoria-status');
    var curaBtnTxt = extras.querySelector('.jun26-curadoria-btn-txt');
    function curadoriaOnline() {
      var now = new Date();
      var br = new Date(now.getTime() - 3 * 3600 * 1000);
      var day = br.getUTCDay();
      var h = br.getUTCHours() + br.getUTCMinutes() / 60;
      return day >= 1 && day <= 5 && h >= 10 && h < 18;
    }
    var WA_FALLBACK = 'https://api.whatsapp.com/send/?phone=5511911292673&text=Ol%C3%A1%21+Gostaria+de+uma+Consultoria+de+Quadros.&type=phone_number&app_absent=0';
    curaBtn.href = (waBtn && waBtn.href) ? waBtn.href : WA_FALLBACK;
    var online = curadoriaOnline();

    curaStatus.textContent = online ? 'Online agora' : '';
    curaStatus.style.display = online ? '' : 'none';
    curaStatus.classList.toggle('jun26-curadoria-status--on', online);
    curaBtnTxt.textContent = online ? 'Enviar mensagem' : 'Deixar mensagem';

    var pixPct = 10;
    var pixLbl = document.querySelector('.obrah-pix-discount-label');
    var pixM = pixLbl && pixLbl.textContent.match(/(\d+)\s*%/);
    if (pixM) pixPct = parseInt(pixM[1], 10);
    var buybar = document.createElement('div');
    buybar.className = 'jun26-buybar';

    buybar.innerHTML = ''
      + '<div class="jun26-buybar-row">'
      + '<div class="jun26-buybar-price">'
      + '<span class="jun26-buybar-amount-line"><span class="jun26-buybar-amount"></span><span class="jun26-buybar-installments">em até 12x</span></span>'
      + '<span class="jun26-buybar-pix"><span class="jun26-buybar-pix-val"></span><span class="jun26-buybar-badge">−' + pixPct + '%</span></span>'
      + '</div>'
      + '<button type="button" class="jun26-buybar-cta">Comprar</button>'
      + '<span class="jun26-heart-slot jun26-buybar-heart" aria-label="Adicionar aos favoritos"></span>'
      + '</div>';
    document.body.appendChild(buybar);
    var barPixLine = buybar.querySelector('.jun26-buybar-price');
    var barPriceLockW = 0;
    var barAmount = buybar.querySelector('.jun26-buybar-amount');
    var barPixVal = buybar.querySelector('.jun26-buybar-pix-val');
    var barCta = buybar.querySelector('.jun26-buybar-cta');
    barCta.addEventListener('click', function () {
      var real = root.querySelector('button[name="add"]');
      if (real && !real.disabled) real.click();
    });

    var cardBuy = document.createElement('div');
    cardBuy.className = 'jun26-card-buy';
    cardBuy.innerHTML = ''

      + '<div class="jun26-buy-price"><span class="jun26-buy-amount"></span><span class="jun26-buy-installments">em até 12x</span></div>'
      + '<div class="jun26-buy-pix"><span class="jun26-buy-pix-val"></span><span class="jun26-buy-badge">−' + pixPct + '%</span></div>'
      + '<div class="jun26-buy-cta-row">'
      + '<button type="button" class="jun26-buy-cta">Adicionar ao carrinho</button>'
      + '<span class="jun26-heart-slot jun26-buy-heart" aria-label="Adicionar aos favoritos"></span>'
      + '</div>'
      + '<div class="jun26-buy-trust">'
      + '<span class="jun26-trust-item"><span class="jun26-lock" aria-hidden="true"><span class="jun26-lock-shackle"></span><span class="jun26-lock-body"></span></span>Compra 100% segura</span>'
      + '<span class="jun26-trust-item jun26-buy-devolucao-item">'
      + '<svg class="jun26-return-ico" aria-hidden="true" width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<path d="M4.5 1.5L2 4l2.5 2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>'
      + '<path d="M2 4h6.5a3.75 3.75 0 0 1 0 7.5H4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
      + '</svg>'
      + 'Devolução grátis</span>'
      + '<span class="jun26-trust-dot">·</span>'
      + '<a class="jun26-buy-trust-link" href="/pages/trocas-e-devolucoes">Ver política</a>'
      + '</div>';
    cardConfig.parentElement.insertBefore(cardBuy, cardConfig.nextSibling);
    var buyAmount = cardBuy.querySelector('.jun26-buy-amount');
    var buyPixLine = cardBuy.querySelector('.jun26-buy-pix');
    var buyPixVal = cardBuy.querySelector('.jun26-buy-pix-val');
    var buyCta = cardBuy.querySelector('.jun26-buy-cta');
    /* 27/jul: grudada no pé da tela a barra é uma LINHA — e numa linha o rótulo
       longo empurra o preço pra fora. "ADICIONAR" basta: o contexto (preço ao
       lado, sacola do header) já diz do que se trata. Solta, volta ao rótulo
       inteiro, que é o que se espera de um botão de largura cheia. */
    /* 28/jul: o rótulo volta a ser INTEIRO também na barra grudada. O encurtamento
       existia porque o bookmark dividia a linha com o botão; com ele no cabeçalho,
       sobra largura pra frase toda — e "Adicionar", sozinho, é ambíguo em
       português: lido rápido, sugere adicionar MAIS UM. O verbo precisa do
       destino, e é a mesma frase do desktop: mesmo produto, mesmas palavras. */
    (function ctaCurto() {
      var LONGO = 'Adicionar ao carrinho', CURTO = 'Adicionar ao carrinho';
      /* 28/jul: na barra grudada o parcelamento encolhe pra "até 12x". A
         informação importa (é ela que responde "cabe no meu mês?"), mas o "em"
         não carrega nada — e a coluna do preço é a que cede espaço, já que o
         botão passou a ter largura fixa. Solta, a frase volta inteira. */
      /* 28/jul: o parcelamento sai de cima do preço e vira linha própria — e
         diz o que é argumento. "em até 12x" não informa se tem juros; quem
         decide compra em 3x sem juros e quem quer prazo lê o 12x na mesma
         frase. No sticky do mobile a versão curta continua valendo. */
      /* 28/jul (revisão): sem "3× sem juros". A frase virava duas informações
         concorrendo na mesma linha, e a que importa aqui é o teto do
         parcelamento. Onde os juros começam é conversa do checkout. */
      /* 28/jul: "12x" com xis, não com o sinal de multiplicação. O × é o glifo
         certo em "70 × 100 cm", onde ele multiplica de verdade; em parcela ele
         desenha uma cruz alta que destoa do texto ao redor. */
      var PARC_LONGO = 'até 12x no cartão', PARC_CURTO = 'até 12x';
      var parc = cardBuy.querySelector('.jun26-buy-installments');
      var sync = function () {
        var curto = cardBuy.classList.contains('is-stuck') && window.matchMedia('(max-width: 959px)').matches;
        var alvo = curto ? CURTO : LONGO;
        if (buyCta.textContent.trim() !== alvo) buyCta.textContent = alvo;
        if (parc) {
          var alvoP = curto ? PARC_CURTO : PARC_LONGO;
          if (parc.textContent.trim() !== alvoP) parc.textContent = alvoP;
        }
      };
      new MutationObserver(sync).observe(cardBuy, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', sync);
      sync();
    })();
    buyCta.addEventListener('click', function () {
      var real = root.querySelector('button[name="add"]');
      if (real && !real.disabled) real.click();
    });

    function fmtBRLcents(cents) {
      var r = cents / 100;
      var dec = Math.round(cents) % 100 === 0 ? 0 : 2;
      return 'R$ ' + r.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: 2 });
    }

    var NO_RETURN_SIZES = { '70x100': 1, '100x140': 1, '100x100': 1 };
    var trustDevolucaoEl = extras.querySelector('.jun26-trust-devolucao');
    var trustLinkEl = extras.querySelector('.jun26-trust-link');
    var buyDevolucaoEl = cardBuy.querySelector('.jun26-buy-devolucao-item');
    var buyTrustLinkEl = cardBuy.querySelector('.jun26-buy-trust-link');

    var policyDrawer = document.createElement('div');
    policyDrawer.id = 'Jun26-Policy-Drawer';
    policyDrawer.className = 'side-panel jun26-policy-drawer';
    policyDrawer.innerHTML = ''
      + '<div class="side-panel-inner">'
      + '<div class="side-panel-header"><div>'
      + '<h4 class="body-font">Trocas e devoluções</h4>'
      + '<side-panel-close class="side-panel-close">'
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
      + '</side-panel-close>'
      + '</div></div>'
      + '<div class="side-panel-content"><div class="jun26-policy-body rte"></div></div>'
      + '</div>';
    document.body.appendChild(policyDrawer);
    var policyLoaded = false;
    function loadPolicy() {
      if (policyLoaded) return;
      policyLoaded = true;
      fetch('/pages/trocas-e-devolucoes')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.rte') || doc.querySelector('.page-content') || doc.querySelector('main');
          var body = policyDrawer.querySelector('.jun26-policy-body');
          body.innerHTML = content
            ? content.innerHTML
            : '<p>Veja a política completa em <a href="/pages/trocas-e-devolucoes">trocas e devoluções</a>.</p>';
        })
        .catch(function () { policyLoaded = false; });
    }
    function openPolicyDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.add('open-cc');
      policyDrawer.classList.add('active');
      loadPolicy();
    }

    if ('requestIdleCallback' in window) requestIdleCallback(loadPolicy, { timeout: 4000 });
    else setTimeout(loadPolicy, 1500);
    if (trustLinkEl) trustLinkEl.addEventListener('click', openPolicyDrawer);
    if (buyTrustLinkEl) buyTrustLinkEl.addEventListener('click', openPolicyDrawer);

    root._openPolicyDrawer = openPolicyDrawer;
    root._noReturnSizes = NO_RETURN_SIZES;

    function updateBuyBar() {
      var sz = getCurrentSize();
      var noReturn = !!(sz && NO_RETURN_SIZES[sz]);
      if (trustDevolucaoEl) trustDevolucaoEl.style.display = noReturn ? 'none' : '';
      if (trustLinkEl) {
        trustLinkEl.textContent = noReturn ? 'Política de trocas e devoluções' : 'Ver política';
      }
      if (buyDevolucaoEl) buyDevolucaoEl.style.display = noReturn ? 'none' : '';
      if (buyTrustLinkEl) {
        buyTrustLinkEl.textContent = noReturn ? 'Política de trocas e devoluções' : 'Ver política';
      }
      var p = priceOfMold(resolveVariant());
      var real = root.querySelector('button[name="add"]');
      var dis = !!(real && real.disabled);
      barCta.disabled = dis;
      buyCta.disabled = dis;
      if (p == null) {
        barPixLine.style.visibility = 'hidden';
        buyPixLine.style.visibility = 'hidden';
        barAmount.textContent = '';
        buyAmount.textContent = '';
        return;
      }
      barPixLine.style.visibility = '';
      buyPixLine.style.visibility = '';
      var pixNum = fmtBRLcents(Math.round(p * (100 - pixPct) / 100));
      barAmount.textContent = fmtBRLcents(p);
      barPixVal.textContent = pixNum + ' no PIX';
      buyPixVal.innerHTML = pixNum + ' <span class="rd-pix-suf">no PIX</span>';
      buyAmount.textContent = fmtBRLcents(p);

      var live = Math.ceil(barPixLine.scrollWidth);
      if (live > barPriceLockW) {
        barPriceLockW = live;
        barPixLine.style.width = live + 'px';
        barPixLine.style.minWidth = live + 'px';
      }
    }

    (function watchRealAddButton() {
      var realBtn = root.querySelector('button[name="add"]');
      if (!realBtn) return;
      new MutationObserver(function () { updateBuyBar(); })
        .observe(realBtn, { attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
    })();

    var state = inferStateFromSelection(molduraFs);
    var lastCor = null;
    if (corFs) {
      var checkedCor = corFs.querySelector('input:checked');
      if (checkedCor && checkedCor.value !== 'sem moldura') {
        lastCor = checkedCor.value;
      }
      corFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        i.addEventListener('change', function () {
          if (i.checked && i.value !== 'sem moldura') {
            lastCor = i.value;
          }
        });
      });
    }

    function resolveVariant() {
      var key = state.primario + '|' +
        (state.profundidade ? 1 : 0) + '|' +
        (state.fino ? 1 : 0) + '|' +
        (state.paspatur ? 1 : 0);
      return VARIANT_MAP[key] || null;
    }

    function syncToShopify() {
      var target = resolveVariant();
      if (!target) return;
      var input = molduraInputs[target];
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function getAvailableMoldVariants() {
      var set = {};
      molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        set[i.value] = true;
      });
      return set;
    }

    function getCurrentSize() {
      var s = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
      return s ? s.value : null;
    }

    function getSizeMoldVariants(availAll) {
      if (!MOLD_BY_SIZE) return availAll;
      var sz = getCurrentSize();
      var per = sz && MOLD_BY_SIZE[sz];
      if (!per) return availAll;
      var out = {};
      Object.keys(availAll).forEach(function (k) { if (per[k]) out[k] = true; });
      return out;
    }

    function isPrimarioAvailable(p, avail) {
      if (p === 'canvas') return !!avail['canvas'];
      if (p === 'sem moldura') return !!avail['sem moldura'];

      return !!(avail['padrão'] || avail['padrão com paspatur'] ||
                avail['caixa'] || avail['caixa com paspatur'] ||
                avail['slim'] || avail['slim com paspatur']);
    }

    function isModAvailable(mod, avail) {
      if (mod === 'profundidade') return !!(avail['caixa'] || avail['caixa com paspatur']);
      if (mod === 'fino')         return !!(avail['slim'] || avail['slim com paspatur']);
      if (mod === 'paspatur')     return !!(avail['padrão com paspatur'] ||
                                            avail['caixa com paspatur'] ||
                                            avail['slim com paspatur']);
      return false;
    }

    function render() {

      var availAll = getAvailableMoldVariants();
      var avail = getSizeMoldVariants(availAll);

      if (Object.keys(avail).length && !isPrimarioAvailable(state.primario, avail)) {
        var firstOk = Object.keys(pills).filter(function (k) {
          return isPrimarioAvailable(k, avail);
        })[0];
        if (firstOk) {
          state.primario = firstOk;
          state.profundidade = false; state.fino = false; state.paspatur = false;
        }
      }

      // 13/jul: GG pra cima (70×100+) o padrão simples NÃO era vendido — questão
      // ESTRUTURAL, quadro grande precisa de mais profundidade (caixa). A trava
      // valia mesmo com a variante padrão existindo no cadastro.
      //
      // 28/jul — TRAVA REVOGADA por decisão do negócio. Motivo: a variante
      // Padrão 70×100 é vendida e cobrada normalmente pelo carrinho (R$ 2.554),
      // enquanto a PDP mostrava o preço da caixa (R$ 2.805) — dois preços pra
      // mesma peça, dependendo do caminho. Além disso a caixa forçada derrubava
      // o PASPATUR nesses tamanhos, porque "caixa com paspatur" não existe pra
      // todos os produtos.
      // Consequência a registrar: 70×100, 100×100 e 100×140 voltam a ser
      // vendidos em perfil de 1 cm. Se o ateliê não entregar essa medida sem
      // empenar, o conserto NÃO é reativar esta linha — é apagar a variante
      // padrão desses tamanhos no cadastro, senão ela continua vendável pelo
      // carrinho, por link de variante e por app.
      var RD_FORCE_DEPTH = {};
      var _szKey = (getCurrentSize() || '').replace(/\s/g, '').toLowerCase();
      var _forceDepth = !!RD_FORCE_DEPTH[_szKey];
      if (state.primario === 'padrão' && (_forceDepth || !avail['padrão']) &&
          (avail['caixa'] || avail['caixa com paspatur'])) {
        if (!state.profundidade) { state.profundidade = true; state.fino = false; }
        state._profForced = true;
      } else if (state._profForced && avail['padrão'] && !_forceDepth) {
        state.profundidade = false;
        state._profForced = false;
      }

      var comboKey = function (s) { return s.primario + '|' + (s.profundidade ? 1 : 0) + '|' + (s.fino ? 1 : 0) + '|' + (s.paspatur ? 1 : 0); };
      var comboValid = function (s) { var v = VARIANT_MAP[comboKey(s)]; return !!v && !!avail[v]; };
      if (Object.keys(avail).length && !comboValid(state)) {
        var tryDrop = ['paspatur', 'fino'];
        if (!state._profForced) tryDrop.push('profundidade');
        for (var di = 0; di < tryDrop.length && !comboValid(state); di++) {
          if (state[tryDrop[di]]) {
            var t = Object.assign({}, state); t[tryDrop[di]] = false;
            if (comboValid(t)) state[tryDrop[di]] = false;
          }
        }
      }

      Object.keys(pills).forEach(function (k) {
        pills[k].style.display = isPrimarioAvailable(k, availAll) ? '' : 'none';
        var okSize = isPrimarioAvailable(k, avail);
        pills[k].disabled = !okSize;
        pills[k].classList.toggle('jun26-pill--disabled', !okSize);
        pills[k].classList.toggle('jun26-pill--active', state.primario === k);
      });
      var isPadrao = state.primario === 'padrão';
      modsRow.classList.toggle('jun26-modificadores--visible', isPadrao);

      var anyMod = isModAvailable('profundidade', availAll) ||
                   isModAvailable('fino', availAll) ||
                   isModAvailable('paspatur', availAll);
      opGroup.style.display = (isPadrao && anyMod) ? '' : 'none';

      modProf.label.style.display = isModAvailable('profundidade', availAll) ? '' : 'none';
      modFino.label.style.display = isModAvailable('fino', availAll) ? '' : 'none';
      modPasp.label.style.display = isModAvailable('paspatur', availAll) ? '' : 'none';
      modProf.checkbox.checked = state.profundidade;
      modFino.checkbox.checked = state.fino;
      modPasp.checkbox.checked = state.paspatur;

      function wouldYieldValid(modKey) {
        var s = Object.assign({}, state);
        s[modKey] = !s[modKey];

        if (modKey === 'profundidade' && s.profundidade) s.fino = false;
        if (modKey === 'fino' && s.fino) s.profundidade = false;
        var key = s.primario + '|' + (s.profundidade ? 1 : 0) + '|' + (s.fino ? 1 : 0) + '|' + (s.paspatur ? 1 : 0);
        var variant = VARIANT_MAP[key];
        return !!variant && !!avail[variant];
      }

      modProf.checkbox.disabled = state.fino || _forceDepth || !wouldYieldValid('profundidade');
      modFino.checkbox.disabled = state.profundidade || !wouldYieldValid('fino');
      modPasp.checkbox.disabled = !wouldYieldValid('paspatur');

      var profLocked = state._profForced && state.profundidade && modProf.checkbox.disabled;

      // card TRAVADO fica VISÍVEL com o selo "incluído" (13/jul: o selo
      // "tava, mas sumiu") — a linha ⓘ saiu: redundante com selo + hint do card
      opInfo.style.display = 'none';
      if (profLocked) modProf.label.style.display = '';
      modProf.label.classList.toggle('jun26-mod--locked', profLocked);
      // travado = hint explica o PORQUÊ (estrutural), sem falar em preço
      var profHintEl = modProf.label.querySelector('.jun26-mod-hint');
      if (profHintEl) {
        if (!profHintEl.dataset.rdHintOrig) profHintEl.dataset.rdHintOrig = profHintEl.textContent;
        profHintEl.textContent = profLocked
          ? 'Já incluída neste tamanho para garantir maior estrutura e estabilidade ao quadro.'
          : profHintEl.dataset.rdHintOrig;
      }
      modProf.label.classList.toggle('jun26-mod--disabled', modProf.checkbox.disabled && !profLocked);
      modFino.label.classList.toggle('jun26-mod--disabled', modFino.checkbox.disabled);
      modPasp.label.classList.toggle('jun26-mod--disabled', modPasp.checkbox.disabled);

      if (modPasp.checkbox.disabled && !modPasp.checkbox.checked) modPasp.label.style.display = 'none';
      if (modFino.checkbox.disabled && !modFino.checkbox.checked) modFino.label.style.display = 'none';
      if (!profLocked && modProf.checkbox.disabled && !modProf.checkbox.checked) modProf.label.style.display = 'none';

      var anyActionable = (modProf.label.style.display !== 'none' && !profLocked) ||
        modFino.label.style.display !== 'none' ||
        modPasp.label.style.display !== 'none';
      var anyVisible = profLocked || anyActionable;
      opGroup.style.display = (isPadrao && anyVisible) ? '' : 'none';
      opHeader.style.display = anyVisible ? '' : 'none';
      // só o card travado à vista = nada é opcional; o "· opcional" sai
      var opTagEl = opHeader.querySelector('.jun26-op-tag');
      if (opTagEl) opTagEl.style.display = anyActionable ? '' : 'none';

      modsRow.classList.toggle('jun26-modificadores--visible', isPadrao && anyVisible);

      if (corBlock) {
        corBlock.classList.toggle('jun26-cor-block--hidden', state.primario === 'sem moldura');
      }
      updateCorUI();

      [['profundidade', modProf], ['fino', modFino], ['paspatur', modPasp]].forEach(function (pair) {
        var d = modAddCost(pair[0]);

        if (d == null && isRDmod) d = modSwapCost(pair[0]);
        pair[1].price.textContent = (d != null && d > 0) ? '+ ' + fmtBRL(d) : '';

        if (isRDmod) pair[1].label.classList.toggle('jun26-mod--deadend', d == null);
      });

      var szPasp = parseTamanho(getCurrentSize() || '');
      if (szPasp && !root.classList.contains('thb-product-detail--redesign')) {
        modPasp.label.querySelector('.jun26-mod-hint').textContent =
          'Acréscimo de 5 cm de margem branca por lado · tamanho final do quadro é ' + (szPasp.w + 10) + ' × ' + (szPasp.h + 10) + ' cm';
      }

      var headerName = PILL_NAMES[state.primario] || titleCase(state.primario);
      /* 28/jul: com a profundidade inclusa a moldura CONTINUA sendo Padrão. Ela
         trocava de nome pra "Caixa", e aí a pessoa que escolheu Padrão via outro
         produto no cabeçalho — como se tivesse sido trocada sem avisar. A
         profundidade é um atributo da peça, não outra moldura. */
      if (state.primario === 'padrão' && state.fino) headerName = 'Slim';
      headerValue.textContent = headerName;

      microEl.textContent = MICROCOPY[state.primario] || '';
      var specTxt = SPEC_MOLDURA[state.primario];
      specMolduraRow.style.display = specTxt ? '' : 'none';
      if (specTxt) specMolduraVal.textContent = specTxt;
      var papelSpec = SPEC_PAPEL[state.primario];
      if (papelSpec) {
        specPapelLabel.textContent = papelSpec.label;
        specPapelVal.textContent = papelSpec.value;
      }

      if (state.primario === 'padrão') {
        specPapelRow.parentElement.insertBefore(specMolduraRow, specPapelRow);
      } else {
        specMolduraRow.parentElement.insertBefore(specPapelRow, specMolduraRow);
      }
      if (specEnvioVal) specEnvioVal.textContent = SPEC_ENVIO[state.primario] || '';

      updateBuyBar();
    }

    function resolveAndSync() {
      render();
      syncToShopify();
    }

    molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (i.checked && i.value !== resolveVariant()) {
          state = inferStateFromVariant(i.value);
          render();
        }
      });
    });

    var sizeFs = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
    if (sizeFs) {
      sizeFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        i.addEventListener('change', function () { updateTamanhoHeader(); resolveAndSync(); });
      });
    }

    function normalizeInitialSelection() {
      var real = root.querySelector('button[name="add"]');
      if (!real || !real.disabled) return;
      if (corFs && state.primario !== 'sem moldura') {
        var c = corFs.querySelector('input:checked');
        if (!c || c.value === 'sem moldura') {
          var fallback = corFs.querySelector('input[type="radio"][value="' + (lastCor || 'madeira escura') + '"]') ||
                         corFs.querySelector('input[type="radio"]:not([value="sem moldura"])');
          if (fallback) { fallback.checked = true; c = fallback; }
        }
        if (c) c.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var m = molduraFs.querySelector('input:checked');
      if (m) m.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function lockBarPriceWidth() {
      if (!PRICE_BY_SIZE) return;
      var max = 0;
      Object.keys(PRICE_BY_SIZE).forEach(function (sz) {
        var per = PRICE_BY_SIZE[sz];
        Object.keys(per).forEach(function (m) {
          var c = per[m];
          if (c && c < 999900 && c > max) max = c;
        });
      });
      if (!max) return;
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;';
      probe.innerHTML = '<div class="jun26-buybar-price">'
        + '<span class="jun26-buybar-amount-line"><span class="jun26-buybar-amount">' + fmtBRLcents(max) + '</span><span class="jun26-buybar-installments">em até 12x</span></span>'
        + '<span class="jun26-buybar-pix"><span class="jun26-buybar-pix-val">' + fmtBRLcents(Math.round(max * (100 - pixPct) / 100)) + ' no PIX</span><span class="jun26-buybar-badge">−' + pixPct + '%</span></span>'
        + '</div>';
      buybar.appendChild(probe);
      var w = Math.ceil(probe.firstChild.getBoundingClientRect().width);
      probe.remove();

      if (w && w > barPriceLockW) {
        barPriceLockW = w;
        barPixLine.style.width = w + 'px';
        barPixLine.style.minWidth = w + 'px';
      }
    }

    loadMoldBySize(function () {
      resolveAndSync();
      lockBarPriceWidth();
      setTimeout(normalizeInitialSelection, 300);
      setTimeout(normalizeInitialSelection, 1200);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { lockBarPriceWidth(); });
    }

    render();
  }

  var AMB_ENVS = [
    {
      id: 'hall', label: 'HALL', asset: 'jun26-amb-hall.webp',
      img: { w: 1600, h: 1993 },

      cal: { pxPerCm: 9, anchorX: 0.62, anchorY: 0.689 },
      furnitureY: 0.63, ceilY: 0.03,

      fx: { brilho: 88, contraste: 103, saturacao: 106, calor: 14 },

      noTouch: [{ x0: 0.24, y0: 0.609, x1: 1, y1: 0.756 }, { x0: 0, y0: 0.534, x1: 0.28, y1: 0.684 }]
    },
    {
      id: 'sala', label: 'SALA', asset: 'jun26-amb-sala-estar-2.webp',
      img: { w: 1600, h: 1993 },

      cal: { pxPerCm: 6.355, anchorX: 0.494, anchorY: 0.55 },
      furnitureY: 0.434, ceilY: 0.051
    },
    {
      id: 'quarto', label: 'QUARTO', asset: 'jun26-amb-quarto.webp',
      img: { w: 1600, h: 1993 },

      cal: { pxPerCm: 7.5, anchorX: 0.42, anchorY: 0.55 },
      furnitureY: 0.58, ceilY: 0.07
    },
    {
      id: 'jantar', label: 'JANTAR', asset: 'jun26-amb-sala.jpg',
      img: { w: 1600, h: 1993 },

      cal: { pxPerCm: 7.8, anchorX: 0.436, anchorY: 0.675 },
      furnitureY: 0.588, ceilY: 0.08,
      noTouch: [{ x0: 0.729, y0: 0.056, x1: 0.879, y1: 0.689 }]
    }
  ];

  var AMB_WOOD = {
    marrom: [101, 74, 49],
    preta: [46, 46, 46],
    clara: [202, 160, 110],
    branca: [183, 183, 183]
  };
  var AMB_COR_SLUG = { 'mel': 'marrom', 'preta': 'preta', 'pinus': 'clara', 'branca': 'branca' };

  var AMB_GEO = {
    canvas: { profile: 0.7, gap: 1.0, depth: 4.0, glass: false, gapDark: true, innerR: 0.15 },
    padrao: { profile: 2.0, gap: 0.0, depth: 1.0, glass: true, gapDark: false, innerR: 0 },
    caixa: { profile: 2.0, gap: 0.0, depth: 3.0, glass: true, gapDark: false, innerR: 0 }
  };
  var AMB_PASPATUR_CM = 5;

  var AMB_FX_DEF = { brilho: 100, contraste: 100, saturacao: 100, calor: 4 };

  var AMB_TEX_OP = 0.6;
  function ambPhotoFilter(fx) {
    var f = fx || AMB_FX_DEF;
    return 'brightness(' + (f.brilho / 100) + ') contrast(' + (f.contraste / 100) +
      ') saturate(' + (f.saturacao / 100) + ') sepia(' + (f.calor / 100) + ')';
  }
  function ambShade(c, d) {
    return 'rgb(' + Math.max(0, Math.min(255, c[0] + d)) + ',' +
      Math.max(0, Math.min(255, c[1] + d)) + ',' + Math.max(0, Math.min(255, c[2] + d)) + ')';
  }

  function setupRedesignTabs(root) {
    var mediaCol = root.querySelector('.pp26-product-grid__media');
    var grid = root.querySelector('.pp26-product-grid');
    if (!mediaCol || !grid || root.querySelector('.rd-tabs')) return;

    var REVIEW_PAGE = 6;

    var TABS = [
      { id: 'ficha', label: 'Ficha técnica' },
      { id: 'avaliacoes', label: 'Avaliações' },
      { id: 'producao', label: 'Produção e entrega' },
      { id: 'cuidados', label: 'Instalação e cuidados' }
    ];

    function frameType() {
      var f = root.querySelector('.pp26__frame');
      var t = (f && f.dataset.frameType) || 'padrao';
      if (/sem.?moldura/.test(t)) return 'sem-moldura';
      if (/paspatur/.test(t)) return 'paspatur';
      if (/canvas/.test(t)) return 'canvas';
      if (/caixa/.test(t)) return 'caixa';
      if (/slim/.test(t)) return 'slim';
      return 'padrao';
    }

    var FRAME_SPEC = {
      padrao: {
        rotulo: 'Moldura Padrão',
        medidas: [['Face da moldura', '2 cm'], ['Profundidade', '1 cm'], ['Vidro', '2 mm'], ['Fundo', 'MDF']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Papel', 'Canson® Satin 240 g/m²'], ['Vidro', 'Incluso · 2 mm'], ['Madeira', 'Pinus · revestimento texturizado'], ['Fixação', 'Kit incluso · parafuso + bucha']]
      },
      caixa: {
        rotulo: 'Moldura Caixa',
        medidas: [['Face da moldura', '2 cm'], ['Profundidade', '3 cm'], ['Vidro', '2 mm'], ['Base na parede', '1,5 cm'], ['Fundo', 'MDF']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Papel', 'Canson® Satin 240 g/m²'], ['Vidro', 'Incluso · 2 mm'], ['Madeira', 'Pinus · revestimento texturizado'], ['Fixação', 'Kit incluso · parafuso + bucha']]
      },
      slim: {
        rotulo: 'Moldura Slim',
        medidas: [['Face da moldura', '0,7 cm'], ['Profundidade', '2 cm'], ['Degrau', '0,8 cm'], ['Vidro', '2 mm'], ['Base na parede', '3 cm'], ['Fundo', 'MDF']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Papel', 'Canson® Satin 240 g/m²'], ['Vidro', 'Incluso · 2 mm'], ['Madeira', 'Pinus · revestimento texturizado'], ['Fixação', 'Kit incluso · parafuso + bucha']]
      },
      paspatur: {
        rotulo: 'Moldura com paspatur',
        medidas: [['Face da moldura', '2 cm'], ['Profundidade', '1 cm'], ['Paspatur', '5 cm por lado'], ['Vidro', '2 mm'], ['Fundo', 'MDF']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Papel', 'Canson® Satin 240 g/m²'], ['Paspatur', 'Margem de 5 cm por lado'], ['Vidro', 'Incluso · 2 mm'], ['Madeira', 'Pinus · revestimento texturizado'], ['Fixação', 'Kit incluso · parafuso + bucha']]
      },
      canvas: {
        rotulo: 'Moldura Canvas',
        medidas: [['Face da moldura', '0,7 cm'], ['Vão ao redor da tela', '0,6 cm'], ['Profundidade', '4,5 cm'], ['Base na parede', '2 cm']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Tela', '100% algodão · sem vidro'], ['Moldura', 'Madeira flutuante · pinus'], ['Fixação', 'Kit incluso · parafuso + bucha']]
      },
      'sem-moldura': {
        rotulo: 'Sem moldura',
        medidas: [['Acabamento', 'Apenas a impressão, sem moldura'], ['Envio', 'Enrolada em tubo rígido']],
        materiais: [['Impressão', 'Giclée · tintas pigmentadas'], ['Papel', 'Canson® Satin 240 g/m²']]
      }
    };

    function el(tag, cls, txt) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (txt != null) e.textContent = txt;
      return e;
    }

    function stars(n) {
      var pct = Math.max(0, Math.min(100, (n / 5) * 100));
      var s = el('span', 'rd-stars rd-stars--grad', '★★★★★');
      s.style.setProperty('--fill', pct + '%');
      s.setAttribute('aria-label', String(n).replace('.', ',') + ' de 5');
      return s;
    }
    var MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
    function relDate(iso) {
      var d = new Date(iso + 'T00:00:00');
      if (isNaN(d)) return '';
      var days = Math.floor((Date.now() - d.getTime()) / 86400000);
      if (days < 7) return 'esta semana';
      if (days < 30) { var w = Math.floor(days / 7); return 'há ' + w + (w > 1 ? ' semanas' : ' semana'); }
      if (days < 365) { var m = Math.floor(days / 30); return 'há ' + m + (m > 1 ? ' meses' : ' mês'); }
      return MESES[d.getMonth()] + ' ' + d.getFullYear();
    }

    function specRows(rows) {
      var p = el('div', 'rd-spec');
      rows.forEach(function (r) {
        var line = el('div', 'rd-spec__row');
        line.appendChild(el('span', 'rd-spec__k', r[0]));
        line.appendChild(el('span', 'rd-spec__v', r[1]));
        p.appendChild(line);
      });
      return p;
    }
    function specPanel(rows, note) {
      var wrap = el('div');
      wrap.appendChild(specRows(rows));
      if (note) wrap.appendChild(el('p', 'rd-spec__note', note));
      return wrap;
    }

    var FICHA_NOTA = {
      canvas: 'Tela impressa com proteção UV, esticada sobre chassi e envolvida por moldura flutuante de madeira revestida. Sem vidro. O vão entre a tela e o perfil cria o efeito suspenso, deixando a peça ligeiramente maior que a arte e com acabamento de galeria. Acompanha penduradores e kit de instalação.',
      padrao: 'Impressão em papel profissional Canson® Satin 240 g/m², protegida por vidro e emoldurada em madeira revestida. O perfil mantém a obra protegida e pronta para pendurar, com acabamento clássico e definido. Acompanha penduradores e kit de instalação.',
      paspatur: 'Moldura de madeira revestida com vidro de proteção e paspatur (passe-partout) branco ao redor da obra. A margem de 5 cm amplia o respiro visual e dá mais presença ao quadro na parede — ideal para destacar uma peça ou compor conjuntos. Acompanha penduradores e kit de instalação.',
      caixa: 'Moldura de madeira revestida com vidro de proteção e perfil mais profundo. A projeção em relação à parede cria sombra e dá mais volume ao quadro. Acompanha penduradores e kit de instalação.',
      'sem-moldura': 'Impressão giclée em papel profissional Canson® Satin 240 g/m² — acabamento acetinado, com ampla gama de cores, pretos profundos e brancos naturais. Sem moldura e sem suporte: o tamanho corresponde exatamente à medida da arte. Enviada enrolada em tubo rígido para você escolher o acabamento depois.'
    };
    var FICHA_NOTA_PADRAO = 'O tamanho final inclui a moldura — a arte fica num quadro um pouco maior. Veja o tamanho exato no seletor de tamanho.';

    function fichaSVGpadrao(F) {
      return '<svg class="rd-ficha-svg" viewBox="100 92 470 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Desenho técnico — moldura padrão com vidro">'
        + '<g class="rd-fx-base">'
        + '<rect x="110" y="100" width="150" height="212" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="119" y="109" width="132" height="194" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="100" x2="119" y2="109" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="100" x2="251" y2="109" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="312" x2="251" y2="303" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="312" x2="119" y2="303" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="152" y1="109" x2="152" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="185" y1="109" x2="185" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="218" y1="109" x2="218" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="142" x2="251" y2="142" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="175" x2="251" y2="175" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="208" x2="251" y2="208" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="241" x2="251" y2="241" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="274" x2="251" y2="274" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="490" y1="155" x2="524" y2="155" stroke="#C7C2B8" stroke-width="1.2" stroke-dasharray="2 2"/>'
        + '<line x1="490" y1="163" x2="524" y2="163" stroke="#B3AEA3" stroke-width="0.9"/>'
        + '<line x1="490" y1="175" x2="524" y2="175" stroke="#9A968C" stroke-width="1.4"/>'
        + '<path d="M410,128 L510,128 L510,148 L490,148 L490,178 L410,178 Z" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '</g>'
        + '<g class="rd-fx-dimline">'
        + '<line x1="410" y1="114" x2="510" y2="114" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="111" x2="410" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="510" y1="111" x2="510" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="524" y1="128" x2="524" y2="148" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="128" x2="527" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="148" x2="527" y2="148" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="398" y1="128" x2="398" y2="178" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="395" y1="128" x2="401" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="395" y1="178" x2="401" y2="178" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '</g>'
        + '<g class="rd-fx-dimtext">'
        + '<text x="460" y="108" ' + F + ' text-anchor="middle">2 cm</text>'
        + '<text x="530" y="141" ' + F + '>0,4 cm</text>'
        + '<text x="390" y="156" ' + F + ' text-anchor="end">1 cm</text>'
        + '</g>'
        + '</svg>';
    }

    function fichaSVGcaixa(F) {
      return '<svg class="rd-ficha-svg" viewBox="100 92 470 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Desenho técnico — moldura caixa com vidro">'
        + '<g class="rd-fx-base">'
        + '<rect x="110" y="100" width="150" height="212" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="119" y="109" width="132" height="194" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="100" x2="119" y2="109" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="100" x2="251" y2="109" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="312" x2="251" y2="303" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="312" x2="119" y2="303" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="152" y1="109" x2="152" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="185" y1="109" x2="185" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="218" y1="109" x2="218" y2="303" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="142" x2="251" y2="142" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="175" x2="251" y2="175" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="208" x2="251" y2="208" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="241" x2="251" y2="241" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="274" x2="251" y2="274" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="485" y1="156" x2="546" y2="156" stroke="#C7C2B8" stroke-width="1.2" stroke-dasharray="2 2"/>'
        + '<line x1="485" y1="164" x2="546" y2="164" stroke="#B3AEA3" stroke-width="0.9"/>'
        + '<line x1="485" y1="171" x2="546" y2="171" stroke="#9A968C" stroke-width="1.4"/>'
        + '<path d="M410,128 L510,128 L510,153 L485,153 L485,278 L410,278 Z" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '</g>'
        + '<g class="rd-fx-dimline">'
        + '<line x1="410" y1="114" x2="510" y2="114" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="111" x2="410" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="510" y1="111" x2="510" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="524" y1="128" x2="524" y2="153" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="128" x2="527" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="153" x2="527" y2="153" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="502" y1="176" x2="502" y2="276" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="499" y1="176" x2="505" y2="176" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="499" y1="276" x2="505" y2="276" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="392" y1="128" x2="392" y2="278" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="389" y1="128" x2="395" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="389" y1="278" x2="395" y2="278" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="296" x2="485" y2="296" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="293" x2="410" y2="299" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="485" y1="293" x2="485" y2="299" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '</g>'
        + '<g class="rd-fx-dimtext">'
        + '<text x="460" y="106" ' + F + ' text-anchor="middle">2 cm</text>'
        + '<text x="532" y="144" ' + F + '>0,5 cm</text>'
        + '<text x="508" y="230" ' + F + '>2 cm</text>'
        + '<text x="382" y="206" ' + F + ' text-anchor="end">3 cm</text>'
        + '<text x="447" y="314" ' + F + ' text-anchor="middle">1,5 cm</text>'
        + '</g>'
        + '</svg>';
    }

    function fichaSVGslim(F) {
      return '<svg class="rd-ficha-svg" viewBox="100 92 500 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Desenho técnico — moldura slim com vidro">'
        + '<g class="rd-fx-base">'
        + '<rect x="110" y="100" width="150" height="212" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="115" y="105" width="140" height="202" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="100" x2="115" y2="105" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="100" x2="255" y2="105" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="312" x2="255" y2="307" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="312" x2="115" y2="307" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="150" y1="105" x2="150" y2="307" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="185" y1="105" x2="185" y2="307" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="220" y1="105" x2="220" y2="307" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="115" y1="139" x2="255" y2="139" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="115" y1="173" x2="255" y2="173" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="115" y1="207" x2="255" y2="207" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="115" y1="241" x2="255" y2="241" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="115" y1="275" x2="255" y2="275" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="432" y1="150" x2="492" y2="150" stroke="#C7C2B8" stroke-width="1.2" stroke-dasharray="2 2"/>'
        + '<line x1="432" y1="161" x2="492" y2="161" stroke="#B3AEA3" stroke-width="0.9"/>'
        + '<line x1="432" y1="174" x2="492" y2="174" stroke="#9A968C" stroke-width="1.4"/>'
        + '<path d="M410 128L445 128 445 143 432 143 432 188 560 188 560 228 410 228Z" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '</g>'
        + '<g class="rd-fx-dimline">'
        + '<line x1="410" y1="114" x2="445" y2="114" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="111" x2="410" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="445" y1="111" x2="445" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="455" y1="128" x2="455" y2="143" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="452" y1="128" x2="458" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="452" y1="143" x2="458" y2="143" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="574" y1="188" x2="574" y2="228" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="571" y1="188" x2="577" y2="188" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="571" y1="228" x2="577" y2="228" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="392" y1="128" x2="392" y2="228" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="389" y1="128" x2="395" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="389" y1="228" x2="395" y2="228" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="246" x2="560" y2="246" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="243" x2="410" y2="249" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="560" y1="243" x2="560" y2="249" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '</g>'
        + '<g class="rd-fx-dimtext">'
        + '<text x="427" y="109" ' + F + ' text-anchor="middle">0,7 cm</text>'
        + '<text x="462" y="139" ' + F + '>0,3 cm</text>'
        + '<text x="580" y="212" ' + F + '>0,8 cm</text>'
        + '<text x="384" y="180" ' + F + ' text-anchor="end">2 cm</text>'
        + '<text x="485" y="264" ' + F + ' text-anchor="middle">3 cm</text>'
        + '</g>'
        + '</svg>';
    }

    function fichaSVGpaspatur(F) {
      return '<svg class="rd-ficha-svg" viewBox="80 88 505 272" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Desenho técnico — moldura padrão com paspatur">'
        + '<g class="rd-fx-base">'
        + '<rect x="97" y="104" width="176" height="238" fill="#ECE9E2"/>'
        + '<rect x="119" y="126" width="132" height="194" fill="#F5F3EF"/>'
        + '<line x1="152" y1="126" x2="152" y2="320" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="185" y1="126" x2="185" y2="320" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="218" y1="126" x2="218" y2="320" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="159" x2="251" y2="159" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="192" x2="251" y2="192" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="225" x2="251" y2="225" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="258" x2="251" y2="258" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<line x1="119" y1="291" x2="251" y2="291" stroke="#DDD9D0" stroke-width="0.4"/>'
        + '<rect x="88" y="95" width="194" height="256" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="97" y="104" width="176" height="238" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="88" y1="95" x2="97" y2="104" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="282" y1="95" x2="273" y2="104" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="282" y1="351" x2="273" y2="342" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="88" y1="351" x2="97" y2="342" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="119" y="126" width="132" height="194" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="490" y1="152" x2="524" y2="152" stroke="#C7C2B8" stroke-width="1.2" stroke-dasharray="2 2"/>'
        + '<line x1="490" y1="157" x2="524" y2="157" stroke="#BCB6AA" stroke-width="1.1"/>'
        + '<line x1="490" y1="163" x2="524" y2="163" stroke="#B3AEA3" stroke-width="0.9"/>'
        + '<line x1="490" y1="175" x2="524" y2="175" stroke="#9A968C" stroke-width="1.4"/>'
        + '<path d="M410,128 L510,128 L510,148 L490,148 L490,178 L410,178 Z" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '</g>'
        + '<g class="rd-fx-dimline">'
        + '<line x1="185" y1="107" x2="185" y2="123" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="182" y1="107" x2="188" y2="107" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="182" y1="123" x2="188" y2="123" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="114" x2="510" y2="114" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="111" x2="410" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="510" y1="111" x2="510" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="524" y1="128" x2="524" y2="148" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="128" x2="527" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="521" y1="148" x2="527" y2="148" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="398" y1="128" x2="398" y2="178" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="395" y1="128" x2="401" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="395" y1="178" x2="401" y2="178" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '</g>'
        + '<g class="rd-fx-dimtext">'
        + '<text x="192" y="119" ' + F + '>5 cm</text>'
        + '<text x="460" y="108" ' + F + ' text-anchor="middle">2 cm</text>'
        + '<text x="530" y="141" ' + F + '>0,4 cm</text>'
        + '<text x="390" y="156" ' + F + ' text-anchor="end">1 cm</text>'
        + '</g>'
        + '</svg>';
    }
    function fichaSVG(ft) {
      var Fp = 'font-family="Archivo Narrow, Archivo, sans-serif" font-weight="600" font-size="11" fill="#161310"';
      if (ft === 'padrao') return fichaSVGpadrao(Fp);
      if (ft === 'caixa') return fichaSVGcaixa(Fp);
      if (ft === 'slim') return fichaSVGslim(Fp);
      if (ft === 'paspatur') return fichaSVGpaspatur(Fp);
      if (ft !== 'canvas') return null;
      var vg = '', hg = '', i;
      for (i = 130; i <= 240; i += 11) vg += '<line x1="' + i + '" y1="109" x2="' + i + '" y2="303" stroke="#BCB6AA" stroke-width="0.7" stroke-linecap="round" stroke-dasharray="0.5 3"/>';
      for (i = 120; i <= 296; i += 11) hg += '<line x1="119" y1="' + i + '" x2="251" y2="' + i + '" stroke="#CFC9BE" stroke-width="0.7" stroke-linecap="round" stroke-dasharray="0.5 3"/>';
      var F = 'font-family="Archivo Narrow, Archivo, sans-serif" font-weight="600" font-size="11" fill="#161310"';
      return '<svg class="rd-ficha-svg" viewBox="100 80 470 312" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Desenho técnico — moldura canvas flutuante">'

        + '<g class="rd-fx-base">'
        + '<rect x="115" y="105" width="140" height="202" fill="#BCB6AA"/>'
        + '<rect x="119" y="109" width="132" height="194" rx="4" fill="#F5F3EF"/>'
        + '<rect x="119" y="109" width="132" height="194" rx="4" fill="none" stroke="#9A968C" stroke-width="0.5" stroke-linecap="round" stroke-dasharray="0.5 3"/>'
        + '<g>' + vg + '</g><g>' + hg + '</g>'
        + '<path d="M548,128 L481,128 C476,128 473,130 473,135 L473,321" fill="none" stroke="#151515" stroke-width="1.1" stroke-linecap="round" stroke-dasharray="0.5 3"/>'
        + '<rect x="110" y="100" width="150" height="212" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<rect x="115" y="105" width="140" height="202" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="100" x2="115" y2="105" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="100" x2="255" y2="105" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="260" y1="312" x2="255" y2="307" stroke="#161310" stroke-width="0.5"/>'
        + '<line x1="110" y1="312" x2="115" y2="307" stroke="#161310" stroke-width="0.5"/>'
        + '<path d="M410,128 L445,128 L445,251 L466,251 L466,325 L510,325 L510,353 L410,353 Z" fill="none" stroke="#161310" stroke-width="0.5"/>'
        + '</g>'

        + '<g class="rd-fx-dimline">'
        + '<line x1="410" y1="114" x2="445" y2="114" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="111" x2="410" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="445" y1="111" x2="445" y2="117" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="455" y1="128" x2="455" y2="82" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="455" y1="82" x2="503" y2="82" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="388" y1="128" x2="388" y2="353" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="385" y1="128" x2="391" y2="128" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="385" y1="353" x2="391" y2="353" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="373" x2="510" y2="373" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="410" y1="370" x2="410" y2="376" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '<line x1="510" y1="370" x2="510" y2="376" pathLength="1" stroke="#161310" stroke-width="0.4"/>'
        + '</g>'

        + '<g class="rd-fx-dimtext">'
        + '<text x="427" y="108" ' + F + ' text-anchor="middle">0,7 cm</text>'
        + '<text x="507" y="86" ' + F + '>0,6 cm</text>'
        + '<text x="380" y="244" ' + F + ' text-anchor="end">4,5 cm</text>'
        + '<text x="460" y="391" ' + F + ' text-anchor="middle">2 cm</text>'
        + '</g>'
        + '</svg>';
    }

    var FICHA_VIEW = {
      canvas:   { front: '98 92 182 232', section: '346 74 224 322' },
      padrao:   { front: '98 92 182 232', section: '366 96 206 104' },
      caixa:    { front: '98 92 182 232', section: '372 94 206 232' },
      slim:     { front: '98 92 182 232', section: '376 80 236 200' },
      paspatur: { front: '74 86 222 276', section: '366 96 206 104' }
    };
    function buildFicha() {
      var ft = frameType();
      var spec = FRAME_SPEC[ft] || FRAME_SPEC.padrao;
      var wrap = el('div', 'rd-ficha');

      /* 28/jul: a ficha continua dizendo MOLDURA PADRÃO quando a caixa veio da
         profundidade inclusa. Nos tamanhos grandes a peça é produzida em caixa
         por estrutura — mas quem escolheu Padrão não trocou de moldura, e ver
         "Moldura Caixa" na ficha faz parecer que a loja entregou outra coisa.
         O desenho e as medidas seguem os da peça real; só o nome respeita a
         escolha. */
      var rotuloFicha = spec.rotulo;
      /* a escolha da pessoa é o CHIP marcado na tela, não o tipo da variante:
         `state.primario` acompanha a variante e já chega como caixa nos tamanhos
         grandes, então ele não serve pra saber o que ela escolheu */
      var pillOn = document.querySelector('.jun26-pill--active');
      if (ft === 'caixa' && pillOn && /^padr/i.test(pillOn.textContent.trim())) {
        rotuloFicha = (FRAME_SPEC.padrao || spec).rotulo;
      }
      wrap.appendChild(el('div', 'rd-ficha__title', rotuloFicha));
      wrap.appendChild(el('p', 'rd-ficha__intro', FICHA_NOTA[ft] || FICHA_NOTA_PADRAO));

      var full = fichaSVG(ft);
      var inner = full ? full.replace(/^<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '') : '';
      var view = FICHA_VIEW[ft] || FICHA_VIEW.padrao;
      function svgPart(vb, label) {
        if (!inner) return '';
        return '<svg class="rd-ficha-svg rd-ficha-svg--part" viewBox="' + vb + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + label + '">' + inner + '</svg>';
      }
      function cell(html) { var c = el('div', 'rd-ficha__cell'); if (html != null) c.innerHTML = html; return c; }
      function secCell(title, rows) {
        var c = el('div', 'rd-ficha__cell');
        var sec = el('div', 'rd-ficha__sec');
        sec.appendChild(el('h4', 'rd-ficha__h', title));
        sec.appendChild(specRows(rows));
        c.appendChild(sec);
        return c;
      }

      if (!inner) {
        var matSec = el('div', 'rd-ficha__sec');
        matSec.appendChild(el('h4', 'rd-ficha__h', 'Materiais'));
        matSec.appendChild(specRows(spec.materiais));
        wrap.appendChild(matSec);
        var medSec = el('div', 'rd-ficha__sec');
        medSec.appendChild(el('h4', 'rd-ficha__h', 'Medidas'));
        medSec.appendChild(specRows(spec.medidas));
        wrap.appendChild(medSec);
        return wrap;
      }
      var grid = el('div', 'rd-ficha__grid');

      var cF = cell(svgPart(view.front, 'Desenho técnico — moldura frontal'));
      cF.classList.add('rd-ficha__cell--draw');
      grid.appendChild(cF);
      grid.appendChild(secCell('Materiais', spec.materiais));

      var cS = cell(svgPart(view.section, 'Desenho técnico — medidas'));
      cS.classList.add('rd-ficha__cell--draw');
      grid.appendChild(cS);
      grid.appendChild(secCell('Medidas', spec.medidas));
      wrap.appendChild(grid);
      return wrap;
    }
    function buildStatic(id) {
      if (id === 'producao') {
        return specPanel([
          ['Produção', 'Sob medida · pronto em até 7 dias úteis'],
          ['Envio', 'Transportadora · Brasil todo, com rastreio'],
          ['Devolução', 'Até 14 dias após o recebimento']
        ]);
      }
      if (id === 'cuidados') {
        return specPanel([
          ['Instalação', 'Kit incluso (parafuso + bucha). Medir, furar e nivelar.'],
          ['Limpeza', 'Moldura: pano seco. Com vidro: limpa-vidros no pano. Canvas: espanador.'],
          ['Conservação', 'Longe de sol direto e umidade. Segure pelas laterais.']
        ]);
      }
      return el('div');
    }

    function buildReviewsPanel(data) {
      var wrap = el('div', 'rd-reviews');
      var s = data.summary || {};
      var revs = data.reviews || [];

      /* 28/jul — AVALIAÇÕES REFEITAS (mock do Paper).
         Três coisas novas, todas vindas do mesmo diagnóstico: a prova estava
         escrita, e neste negócio ela é VISUAL. Quem hesita quer ver a moldura
         na parede de outra pessoa, não ler que ficou boa.
         · MURAL primeiro: as fotos de quem comprou, antes de qualquer texto.
         · FILTROS: "com foto" e "5 estrelas" são as duas perguntas reais de
           quem chega aqui — e o número em cada um já é informação (28 pessoas
           mandaram foto).
         · CADA AVALIAÇÃO DIZ A CONFIGURAÇÃO. "Canvas · Madeira escura · 40 × 40"
           transforma um elogio genérico em prova do que a pessoa está
           configurando agora. */
      var COR_LEGIVEL = { mel: 'Madeira escura', pinus: 'Madeira clara', preta: 'Preta', branca: 'Branca' };
      function variantePt(v) {
        if (!v) return '';
        return String(v).split('/').map(function (parte, i) {
          var t = parte.trim();
          if (!t) return '';
          if (i === 1 && COR_LEGIVEL[t.toLowerCase()]) return COR_LEGIVEL[t.toLowerCase()];
          if (/^\d+\s*x\s*\d+$/i.test(t)) return t.replace(/\s*x\s*/i, ' × ');
          return t.charAt(0).toUpperCase() + t.slice(1);
        }).filter(Boolean).join(' · ');
      }

      var comFoto = revs.filter(function (r) { return r.photos && r.photos.length; });
      var cinco = revs.filter(function (r) { return (r.rating || 0) >= 5; });

      var head = el('div', 'rd-rev-head');
      var big = el('div', 'rd-rev-score');
      /* 26/jul: nota com PONTO (4.8), igual ao resto da PDP */
      /* 27/jul: a nota grande volta pra VÍRGULA — é como se escreve número em pt-BR,
         e o ponto ali lia como se fosse outra escala. */
      big.appendChild(el('div', 'rd-rev-avg', String(s.avg != null ? s.avg : '').replace('.', ',')));
      var meta = el('div', 'rd-rev-meta');
      meta.appendChild(stars(s.avg || 5));
      /* 28/jul: fica só a porcentagem. O total de avaliações foi testado e
         recusado — ele convida a comparar volume com outras lojas, que é uma
         conversa que a OBRAH não quer ter; a proporção de 5 estrelas fala da
         experiência, que é o que importa aqui. */
      meta.appendChild(el('div', 'rd-rev-count', (s.pct5 || 0) + '% deram 5 estrelas'));
      big.appendChild(meta);
      head.appendChild(big);

      var filtros = el('div', 'rd-rev-filtros');
      var FILTROS = [
        { id: 'todas', rot: 'Todas', lista: revs },
        { id: 'foto', rot: 'Com foto · ' + comFoto.length, lista: comFoto },
        { id: 'cinco', rot: '5 estrelas · ' + cinco.length, lista: cinco }
      ];
      head.appendChild(filtros);

      /* 1/ago — AS FOTOS ABREM A SEÇÃO. O cabeçalho (nota, % de 5 estrelas,
         filtros) vinha primeiro e as fotos apareciam depois, como anexo. Mas
         quem chega nesta seção quer ver a obra na parede de outra pessoa — a
         foto É a prova, o número é o resumo dela. Invertido: o mural abre, e a
         nota e os filtros entram logo abaixo, já como ferramenta de leitura do
         que vem em seguida.
         O `wrap.appendChild(head)` desceu para depois do bloco do mural. */

      /* o mural: as fotos de todas as avaliações, na ordem em que chegaram */
      var todasFotos = [];
      revs.forEach(function (r, idx) {
        (r.photos || []).forEach(function (u) { todasFotos.push({ url: u, i: idx, nome: r.name }); });
      });
      if (todasFotos.length) {
        var mural = el('div', 'rd-rev-mural');
        /* 28/jul (revisão) — o mural é UMA FILEIRA que corre pro lado.
           A versão com "+N" abrindo em grade virava quatro fileiras e engolia
           a seção; a versão com corte em 7 escondia 25 fotos atrás de um botão
           que, sem os filtros, não fazia nada visível. Trilho horizontal
           resolve os dois: a fileira nunca quebra, e todas as fotos continuam
           alcançáveis com um gesto que já é natural no toque. */
        todasFotos.forEach(function (f) {
          var b = el('button', 'rd-rev-mural__f');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ver a avaliação de ' + f.nome);
          var im = el('img');
          im.src = f.url; im.loading = 'lazy'; im.alt = '';
          b.appendChild(im);
          b.addEventListener('click', function () {
            var alvo = list.children[Math.max(0, comFoto.indexOf(revs[f.i]))];
            if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          mural.appendChild(b);
        });
        wrap.appendChild(mural);
        /* 1/ago — "Toque para ler a avaliação" saiu: com o mural abrindo a
           seção, o texto da avaliação está logo abaixo, à vista. A instrução
           narrava um gesto que a própria proximidade já entrega — e o clique
           continua funcionando pra quem quiser pular direto. */
        wrap.appendChild(el('p', 'rd-rev-mural__leg', 'Fotos enviadas por quem comprou.'));
      }

      wrap.appendChild(head);

      var list = el('div', 'rd-rev-list');
      wrap.appendChild(list);
      var pager = el('div', 'rd-rev-pager');
      wrap.appendChild(pager);

      function card(r) {
        var c = el('article', 'rd-rev-card');
        var av = el('div', 'rd-rev-av', (r.name || '?').trim().charAt(0).toUpperCase());
        c.appendChild(av);
        var body = el('div', 'rd-rev-body');
        var top = el('div', 'rd-rev-top');
        top.appendChild(el('span', 'rd-rev-name', r.name));
        top.appendChild(stars(r.rating || 5));
        if (r.verified) {
          var vrf = el('span', 'rd-rev-vrf');

          vrf.innerHTML = '<svg class="rd-vrf-ico" viewBox="0 0 1200 1200" width="13" height="13" aria-hidden="true"><circle cx="600" cy="600" r="600" fill="#161310"/><g transform="translate(300 371) scale(0.5)"><path d="m1076.5 344.76-107.04-106.92-510.48 510.48-228.48-228.48-107.04 106.92 335.52 335.4z" fill="#fff"/></g></svg>';
          vrf.appendChild(document.createTextNode('Compra verificada'));
          top.appendChild(vrf);
        }
        top.appendChild(el('span', 'rd-rev-date', relDate(r.date)));
        body.appendChild(top);
        body.appendChild(el('p', 'rd-rev-text', r.body));
        /* 28/jul: a configuração comprada SAI do card. As avaliações são da
           loja, não desta obra (o dado traz `handle` de outro produto), então
           "Canvas · Madeira escura · 40 × 40" dava a entender que era a
           configuração DESTA peça. Informação verdadeira no lugar errado é
           informação falsa. */
        if (r.photos && r.photos.length) {
          var ph = el('div', 'rd-rev-photos');
          r.photos.slice(0, 3).forEach(function (u) {
            var img = el('img', 'rd-rev-photo');
            img.src = u; img.loading = 'lazy'; img.alt = 'Foto de ' + r.name;
            ph.appendChild(img);
          });
          body.appendChild(ph);
        }
        c.appendChild(body);
        return c;
      }

      var atual = revs, shown = 0;
      function renderMore() {
        atual.slice(shown, shown + REVIEW_PAGE).forEach(function (r) {
          list.appendChild(card(r));
        });
        shown += REVIEW_PAGE;
        pager.innerHTML = '';
        if (shown < atual.length) {
          var btn = el('button', 'rd-rev-morebtn', 'Ver mais avaliações');
          btn.type = 'button';
          btn.onclick = renderMore;
          pager.appendChild(btn);
        }
      }
      function filtra(id) {
        var f = FILTROS.filter(function (x) { return x.id === id; })[0] || FILTROS[0];
        atual = f.lista; shown = 0; list.innerHTML = '';
        [].slice.call(filtros.children).forEach(function (b) { b.classList.toggle('is-on', b.dataset.f === id); });
        renderMore();
      }
      FILTROS.forEach(function (f) {
        var b = el('button', 'rd-rev-filtro' + (f.id === 'todas' ? ' is-on' : ''), f.rot);
        b.type = 'button'; b.dataset.f = f.id;
        b.addEventListener('click', function () { filtra(f.id); });
        filtros.appendChild(b);
      });
      renderMore();
      return wrap;
    }

    var block = el('section', 'rd-tabs');
    var bar = el('div', 'rd-tabbar');
    var body = el('div', 'rd-tabbody');

    var barScroll = el('div', 'rd-tabscroll');
    barScroll.appendChild(bar);
    block.appendChild(barScroll);
    block.appendChild(body);

    function scrollTabTop() {
      var y = block.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
    }

    var panels = {};
    var reviewsData = null;
    function showPanel(id) {
      /* 28/jul: no desktop a faixa é SÓ a ficha (a barra de abas está oculta e
         as outras três viraram seção de largura inteira). Sem esta trava,
         qualquer código antigo que peça outra aba — e existe mais de um, vindo
         de quando a nota abria as avaliações — deixava a faixa mostrando um
         painel duplicado e a ficha simplesmente sumia da página. */
      if (block.classList.contains('rd-tabs--ficha') && id !== 'ficha') id = 'ficha';
      body.innerHTML = '';
      [].slice.call(bar.children).forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.tab === id);
      });
      if (id === 'avaliacoes') {
        if (reviewsData) body.appendChild(buildReviewsPanel(reviewsData));
        else body.appendChild(el('div', 'rd-rev-loading', 'Carregando avaliações…'));
      } else if (id === 'ficha') {
        body.appendChild(buildFicha());
      } else {
        body.appendChild(buildStatic(id));
      }
    }
    function activeTab() {
      var on = bar.querySelector('.is-on');
      return on && on.dataset.tab;
    }

    TABS.forEach(function (t) {
      var b = el('button', 'rd-tab', t.label);
      b.type = 'button';
      b.dataset.tab = t.id;
      b.onclick = function () { showPanel(t.id); };
      bar.appendChild(b);
    });

    var leftWrap = document.createElement('div');
    leftWrap.className = 'rd-left';
    mediaCol.parentNode.insertBefore(leftWrap, mediaCol);
    leftWrap.appendChild(mediaCol);
    leftWrap.appendChild(block);

    /* 28/jul — AS ABAS SAEM DA COLUNA DA ESQUERDA (só desktop).
       Com o palco fixo, tudo que vem DEPOIS dele na mesma coluna rola por trás
       dele — as abas passavam por baixo do quadro. E não é só defeito visual:
       a ficha precisa de ~700px pra manter a grade de dois lados (desenhos à
       esquerda, tabelas à direita), e numa coluna de 1360 dividida com o palco
       ela nunca teria isso.
       Então o bloco de abas vira faixa própria, largura inteira, DEPOIS da
       grade. Aí a coluna da esquerda fica só com o palco e o trilho do sticky
       passa a ser a altura da coluna da direita — que é o comportamento que a
       gente quer: a obra parada enquanto o texto rola ao lado.
       No mobile nada muda: lá as abas seguem logo abaixo do palco, na ordem
       natural de leitura. */
    /* 28/jul — SALVAR MORA JUNTO DA NOTA, não ao lado do botão (desktop).
       Ele dividia a quina com o "Adicionar ao carrinho": ação de ADIAR com o
       mesmo peso visual da de comprar, e roubando 56px de um botão que deveria
       ser inteiro. Junto do título e da nota ele fica onde a pessoa ainda está
       decidindo se aquilo interessa — e ganha rótulo, porque o glifo sozinho
       não diz o que faz. */
    (function salvarNoTopo() {
      var mqS = window.matchMedia('(min-width: 960px)');
      var eyebrow = root.querySelector('.jun26-wh-eyebrow');
      if (!eyebrow || !eyebrow.parentElement) return;
      var caixa = null;
      function coloca() {
        var heart = root.querySelector('.jun26-buy-heart');
        if (!heart || !mqS.matches) return;
        if (!caixa) {
          caixa = document.createElement('div');
          caixa.className = 'rd-salvar';
          var rot = document.createElement('span');
          rot.className = 'rd-salvar__rot';
          /* 28/jul: só "Salvar". Na linha do título, "Salvar na lista" quebrava
             em duas e o par com o título se desmontava; e o destino ("a lista")
             é o que a pessoa descobre depois de salvar, não antes. */
          rot.textContent = 'Salvar';
          caixa.append(heart, rot);
          caixa.addEventListener('click', function (ev) {
            if (heart.contains(ev.target)) return;
            var b = heart.querySelector('button, a');
            if (b) b.click();
          });
        } else if (heart.parentElement !== caixa) {
          caixa.insertBefore(heart, caixa.firstChild);
        }
        /* 28/jul: o salvar entra na LINHA DO TÍTULO, não numa terceira linha
           solta. À esquerda o cabeçalho tem duas linhas (artista, título); à
           direita ele tinha uma pilha com ritmo próprio, e por isso nada
           alinhava. Agora cada linha é um par que divide a mesma linha de
           base: artista ↔ nota, título ↔ salvar. */
        var linhaTit = root.querySelector('.jun26-wh-row');
        var destino = linhaTit || eyebrow.parentElement;
        if (caixa.parentElement !== destino) destino.appendChild(caixa);
      }
      coloca();
      setTimeout(coloca, 900);
      setTimeout(coloca, 2500);
      if (mqS.addEventListener) mqS.addEventListener('change', coloca);
    })();

    /* 28/jul (revisão) — AS TRÊS SEÇÕES DESCEM PRA LARGURA INTEIRA.
       A sanfona na coluna durou algumas horas e foi revogada por um princípio
       mais forte: a coluna da direita só carrega o que é necessário pra
       CLICAR. Prova (avaliações) e detalhe (produção, instalação) viram seção
       de largura inteira, onde cabem imagem e respiro.
       Sanfona mata review em especial — quem está em dúvida é justamente quem
       não abre. Aqui elas ficam à vista, e a nota lá em cima leva até elas.
       Efeito colateral aceito: sem esse conteúdo, a coluna encurta e o palco
       fixo tem menos trilho. Segurar prova social na coluna só pra alimentar
       um efeito de rolagem seria o rabo abanando o cachorro. */
    function faixaSecao(id, titulo, monta) {
      var sec = el('section', 'rd-secao rd-secao--' + id);
      sec.id = 'rd-sec-' + id;
      var h = el('h2', 'rd-secao__tit', titulo);
      var corpo = el('div', 'rd-secao__corpo');
      sec.append(h, corpo);
      monta(corpo);
      return sec;
    }

    (function abasFaixa() {
      var mqAbas = window.matchMedia('(min-width: 960px)');
      var depois = grid && grid.parentElement ? grid.parentElement : null;
      function coloca() {
        if (!depois) return;
        if (mqAbas.matches) {
          if (block.parentElement !== depois) depois.insertBefore(block, grid.nextSibling);
          /* com as três de texto na direita, sobra uma aba só: barra de abas
             com um item é um botão fingindo ser escolha. Vira título. */
          block.classList.add('rd-tabs--ficha');
          if (activeTab() !== 'ficha') showPanel('ficha');
        } else {
          block.classList.remove('rd-tabs--ficha');
          if (block.parentElement !== leftWrap) leftWrap.appendChild(block);
        }
      }
      coloca();
      if (mqAbas.addEventListener) mqAbas.addEventListener('change', coloca);
      else if (mqAbas.addListener) mqAbas.addListener(coloca);

      /* as faixas nascem depois da ficha, na ordem em que a dúvida aparece:
         prova primeiro, depois processo, depois cuidado */
      if (mqAbas.matches && depois && !document.getElementById('rd-sec-avaliacoes')) {
        var secAval = faixaSecao('avaliacoes', 'Avaliações', function (c) {
          c.appendChild(reviewsData ? buildReviewsPanel(reviewsData) : el('div', 'rd-rev-loading', 'Carregando avaliações…'));
        });
        var secProd = faixaSecao('producao', 'Produção e entrega', function (c) { c.appendChild(buildStatic('producao')); });
        var secCuid = faixaSecao('cuidados', 'Instalação e cuidados', function (c) { c.appendChild(buildStatic('cuidados')); });
        depois.insertBefore(secAval, block.nextSibling);
        depois.insertBefore(secProd, secAval.nextSibling);
        depois.insertBefore(secCuid, secProd.nextSibling);
      }
    })();

    /* 26/jul: no MOBILE o header só fica branco quando VOLTA subindo. O gatilho de
       distância (>40) servia pro desktop, mas no mobile ele pintava o header de
       branco no meio do recolhimento — dava um flash branco antes de sumir. Aqui
       vale a DIREÇÃO: desceu = segue transparente (e o tema recolhe); subiu longe
       do topo = sólido; chegou no início = transparente de novo. */
    var hdrLastY = window.pageYOffset;
    /* 26/jul — PALCO RENTE À TELA (desktop): a coluna é sticky, então a distância dela
       até o topo muda entre o repouso (abaixo do anúncio) e o estado pinado. Com altura
       fixa sobrava uma faixa branca embaixo num dos dois. Aqui a altura acompanha a
       posição real, e só quando ela MUDA de patamar (dois valores, não a cada frame). */
    (function palcoRente() {
      var mq = window.matchMedia('(min-width: 960px)');
      var ultimo = -1, tick = false;
      function aplica() {
        tick = false;
        var media = root.querySelector('.pp26-product-grid__media');
        if (!media) return;
        if (!mq.matches) { media.style.removeProperty('--rd-palco-top'); return; }
        var t = Math.max(0, Math.round(media.getBoundingClientRect().top));
        if (Math.abs(t - ultimo) < 2) return;
        ultimo = t;
        media.style.setProperty('--rd-palco-top', t + 'px');
        /* o ambientado recalcula a moldura quando o palco muda de tamanho */
        if (root.classList.contains('jun26-amb-active')) {
          requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
        }
      }
      window.addEventListener('scroll', function () {
        if (!tick) { tick = true; requestAnimationFrame(aplica); }
      }, { passive: true });
      window.addEventListener('resize', function () { ultimo = -1; setTimeout(aplica, 120); });
      /* trocar quadro ⇄ ambiente muda a posição do palco: sem isto a altura ficava com
         o valor do estado anterior e sobrava fio embaixo numa das vistas (26/jul) */
      if (window.MutationObserver) {
        var mc = root.querySelector('.pp26-product-grid__media');
        if (mc) new MutationObserver(function () { ultimo = -1; setTimeout(aplica, 60); })
          .observe(mc, { attributes: true, attributeFilter: ['class'] });
      }
      aplica();
      setTimeout(aplica, 500);
    })();

    var onHdrScroll = function () {
      var y = window.pageYOffset;
      document.body.classList.toggle('jun26-header-solid', y > 40);
      if (Math.abs(y - hdrLastY) >= 4) {
        var subindo = y < hdrLastY;
        hdrLastY = y;
        document.body.classList.toggle('jun26-hd-solid-m', subindo && y > 40);
      }
      if (y <= 40) document.body.classList.remove('jun26-hd-solid-m');
    };
    window.addEventListener('scroll', onHdrScroll, { passive: true });
    onHdrScroll();

    var frameEl = root.querySelector('.pp26__frame');
    if (frameEl && window.MutationObserver) {
      new MutationObserver(function () {
        if (activeTab() === 'ficha') showPanel('ficha');
      }).observe(frameEl, { attributes: true, attributeFilter: ['data-frame-type'] });
    }

    /* 28/jul: a PDP abre na FICHA TÉCNICA, não nas avaliações. A primeira aba é
       sobre a peça — material, moldura, medidas —, que é o que continua a
       conversa que o palco começou. Avaliações são prova social: importam na
       dúvida, não na apresentação, e quem quer chega nelas em um toque. */
    showPanel('ficha');
    var url = root.dataset.reviewsUrl;
    if (url) {
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        reviewsData = d;
        if (bar.querySelector('.is-on') && bar.querySelector('.is-on').dataset.tab === 'avaliacoes') showPanel('avaliacoes');
        var alvoFaixa = document.querySelector('#rd-sec-avaliacoes .rd-secao__corpo');
        if (alvoFaixa) { alvoFaixa.innerHTML = ''; alvoFaixa.appendChild(buildReviewsPanel(d)); }
        /* 28/jul (revisão): a nota fica só "4,8". O número de avaliações foi
           testado e recusado — ele transforma um selo curto numa frase, e ao
           lado do nome da obra isso disputa com o próprio título. A quantidade
           continua dita onde ela pesa: no cabeçalho da seção de avaliações. */
      }).catch(function () {  });
    }
  }

  function setupLayoutEdit(root) {
    if (!/[?&]layoutedit/.test(location.search)) return;
    if (document.getElementById('__layoutedit-panel')) return;
    var S = { col: 500, fscale: 100, secpad: 12, cardh: 56, gap: 16 };
    var BASE = { title: 18, artist: 14.5, price: 28, pill: 13.5, small: 12 };
    var style = document.createElement('style'); style.id = '__layoutedit-style'; document.head.appendChild(style);
    function px(n, m) { return (n * m).toFixed(1) + 'px'; }
    function css() {
      var f = S.fscale / 100, R = '.thb-product-detail--redesign ';
      return '@media(min-width:960px){'
        + R + '.pp26-product-grid{grid-template-columns:minmax(0,1fr) ' + S.col + 'px!important}'
        + R + '.jun26-acabamento-row,' + R + '.jun26-tam-group,' + R + '.jun26-cor-block{padding-top:' + S.secpad + 'px!important;padding-bottom:' + S.secpad + 'px!important}'
        + R + '.jun26-pill,' + R + '.jun26-size-chip{min-height:' + S.cardh + 'px!important}'
        + R + '.rd-madeline,' + R + '.jun26-extras-acc{margin-top:' + S.gap + 'px!important}'
        + R + '.jun26-wh-title{font-size:' + px(BASE.title, f) + '!important}'
        + R + '.jun26-wh-artist{font-size:' + px(BASE.artist, f) + '!important}'
        + R + '.jun26-buy-amount{font-size:' + px(BASE.price, f) + '!important}'
        + R + '.jun26-pill-name{font-size:' + px(BASE.pill, f) + '!important}'
        + R + '.jun26-label-prefix,' + R + '.jun26-label-value,' + R + '.jun26-wh-count,' + R + '.jun26-acabamento-micro,' + R + '.jun26-ficha-link,' + R + '.rd-madeline{font-size:' + px(BASE.small, f) + '!important}'
        + '}';
    }
    function apply() { style.textContent = css(); }
    var p = document.createElement('div'); p.id = '__layoutedit-panel'; p.className = '__layoutedit-panel';
    var h = document.createElement('div'); h.className = 'le-h'; h.textContent = 'LAYOUT EDIT'; p.appendChild(h);
    [['Coluna buy box', 'col', 360, 620, 2, 'px'], ['Fonte (escala)', 'fscale', 75, 110, 1, '%'], ['Padding seções', 'secpad', 4, 24, 1, 'px'], ['Altura cards', 'cardh', 42, 74, 1, 'px'], ['Gaps', 'gap', 6, 34, 1, 'px']].forEach(function (r) {
      var lab = r[0], key = r[1], row = document.createElement('label'); row.className = 'le-row';
      row.innerHTML = '<span>' + lab + '</span><input type="range" min="' + r[2] + '" max="' + r[3] + '" step="' + r[4] + '" value="' + S[key] + '"><b>' + S[key] + r[5] + '</b>';
      var inp = row.querySelector('input'), out = row.querySelector('b');
      inp.addEventListener('input', function () { S[key] = parseFloat(inp.value); out.textContent = inp.value + r[5]; apply(); });
      p.appendChild(row);
    });
    var copy = document.createElement('button'); copy.className = 'le-copy'; copy.textContent = 'Copiar CSS';
    copy.addEventListener('click', function () {
      var out = css();
      if (navigator.clipboard) navigator.clipboard.writeText(out);
      copy.textContent = 'Copiado ✓'; setTimeout(function () { copy.textContent = 'Copiar CSS'; }, 1200);
      console.log(out);
    });
    p.appendChild(copy);
    document.body.appendChild(p);
    apply();
  }

  function setupRedesignBuyBox(root) {
    var info = root.querySelector('.product-information--inner') || root.querySelector('.pp26-product-grid__info');
    var cardConfig = root.querySelector('.jun26-card-config');
    if (!info || !cardConfig || root.querySelector('.rd-finalsize')) return;

    function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
    function frameType() {
      var f = root.querySelector('.pp26__frame');
      var t = (f && f.dataset.frameType) || 'padrao';
      if (/sem.?moldura/.test(t)) return 'sem-moldura';
      if (/paspatur/.test(t)) return 'paspatur';
      if (/canvas/.test(t)) return 'canvas';
      if (/caixa/.test(t)) return 'caixa';
      if (/slim/.test(t)) return 'slim';
      return 'padrao';
    }
    var BORDER_CM = { canvas: 1.5, padrao: 2, caixa: 2, paspatur: 7, slim: 0.7, 'sem-moldura': 0 };
    var FRAME_LABEL = { canvas: 'Canvas', padrao: 'Padrão', caixa: 'Caixa', paspatur: 'Padrão Paspatur', slim: 'Slim', 'sem-moldura': 'Sem moldura' };
    function curSizeCm() {
      var s = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
      if (!s) return null;
      var p = String(s.value).replace(/\s/g, '').toLowerCase().split('x');
      var w = parseFloat(p[0]), h = parseFloat(p[1]);
      return (isNaN(w) || isNaN(h)) ? null : { w: w, h: h };
    }

    var tf = el('div', 'rd-finalsize');
    tf.innerHTML = '<svg class="rd-finalsize__ico" width="34" height="34" viewBox="0 0 1200 1200" fill="#8A8A86" aria-hidden="true"><path d="m976.78 349.22h-753.56v501.61h753.61zm-44.391 457.18h-664.78v-412.78h664.78z"/><path d="m164.39 285.61h126v-43.219h-170.39v162h44.391z"/><path d="m290.39 914.39h-126v-118.78h-44.391v162h170.39z"/><path d="m909.61 285.61h126v118.78h44.391v-162h-170.39z"/><path d="m1035.6 914.39h-126v43.219h170.39v-162h-44.391z"/></svg>'
      + '<div class="rd-finalsize__txt"><div class="rd-finalsize__main">'
      + '<button class="rd-finalsize__info" type="button" aria-label="O que é o tamanho final?">'
      + '<span class="rd-finalsize__i" aria-hidden="true">i</span>'
      + '<span class="rd-finalsize__tip" role="tooltip">É o tamanho já <b>com a moldura</b> — como a peça fica na parede. A arte é a medida menor; a moldura acrescenta a borda em volta.</span>'
      + '</button>'
      + '</div><div class="rd-finalsize__sub"></div></div>';

    var feito = el('div', 'rd-madeline');

    var madeIcons = el('span', 'rd-made-icons');
    madeIcons.innerHTML = '<span class="rd-made-ic is-active"><span class="rd-madedot" aria-hidden="true"></span></span>';
    var madeCycle = el('span', 'rd-made-cycle');
    var madeRow1 = el('span', 'rd-made-row is-active');
    madeRow1.textContent = 'Produzido em 7 dias úteis';
    madeCycle.appendChild(madeRow1);
    feito.appendChild(madeIcons);
    feito.appendChild(madeCycle);

    cardConfig.parentNode.insertBefore(feito, cardConfig.nextSibling);

    var szNote = el('div', 'rd-size-note');
    szNote.innerHTML = '<svg class="rd-size-note__ico" width="15" height="15" viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true"><path d="m751.22 255.37-495.84 495.84 193.45 193.45 495.84-495.84zm-444.98 495.84 444.98-444.98 142.55 142.55-84 84-71.297-71.297-25.453 25.453 71.297 71.297-100.31 100.31-71.297-71.297-25.453 25.453 71.297 71.297-100.31 100.31-71.297-71.297-25.453 25.453 71.297 71.297-84 84z"/></svg>'
      + '<span class="rd-size-note__txt"></span>'

      + '<button class="rd-size-note__info" type="button" aria-label="Como o tamanho final é calculado?">'

      + '<svg class="rd-size-note__i" viewBox="0 0 1200 1200" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="m600 60c-143.22 0-280.57 56.895-381.84 158.16-101.27 101.27-158.16 238.62-158.16 381.84s56.895 280.57 158.16 381.84c101.27 101.27 238.62 158.16 381.84 158.16s280.57-56.895 381.84-158.16c101.27-101.27 158.16-238.62 158.16-381.84-0.16016-143.17-57.105-280.43-158.34-381.66s-238.49-158.18-381.66-158.34zm0 1020c-127.3 0-249.39-50.57-339.41-140.59-90.02-90.016-140.59-212.11-140.59-339.41s50.57-249.39 140.59-339.41c90.016-90.02 212.11-140.59 339.41-140.59s249.39 50.57 339.41 140.59c90.02 90.016 140.59 212.11 140.59 339.41-0.14453 127.26-50.762 249.27-140.75 339.25-89.984 89.988-211.99 140.61-339.25 140.75zm-48-600h96v432h-96zm96-144c0 12.73-5.0586 24.938-14.059 33.941-9.0039 9-21.211 14.059-33.941 14.059s-24.938-5.0586-33.941-14.059c-9-9.0039-14.059-21.211-14.059-33.941s5.0586-24.938 14.059-33.941c9.0039-9 21.211-14.059 33.941-14.059s24.938 5.0586 33.941 14.059c9 9.0039 14.059 21.211 14.059 33.941z"/></svg>'
      + '<span class="rd-size-note__tip" role="tooltip"></span>'
      + '</button>';
    var szInfo = szNote.querySelector('.rd-size-note__info');

    /* ═══ FICHA DO TAMANHO COMO FOLHA (26/jul) ═══
       No mobile o (i) deixa de abrir tooltip e abre uma folha de baixo pra cima, na
       MESMA linguagem do card "Nesta parede" da home: alça no topo, scrim escuro
       atrás, eyebrow maiúsculo com fio embaixo e linhas separadas por fio. No desktop
       o tooltip continua igual. */
    /* ═══════════════════════════════════════════════════════════════════════
       28/jul — O MIOLO DA GAVETA DO TAMANHO FINAL
       Antes eram três linhas secas copiadas de um tooltip, e o paspatur — que
       é justamente o que mais muda a conta — nem aparecia.
       Agora: a peça DESENHADA (mesma receita das minis: cor da madeira
       escolhida, face proporcional, respiro do paspatur) e a soma item a item,
       terminando no número que se leva pra parede. A frase do fim diz o erro
       que a gente quer evitar — medir pela arte em vez de medir pela peça.
       ═══════════════════════════════════════════════════════════════════════ */
    function corpoTamanhoFinal() {
      /* 28/jul: leitura direta do DOM — getCurrentSize()/parseTamanho vivem em
         outra closure e quebravam aqui com ReferenceError, engolindo a abertura
         inteira da gaveta (o is-open só entra no fim da função). */
      var selTam = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
      var mTam = String(selTam ? selTam.value : '').match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      var d = mTam ? { w: parseFloat(mTam[1]), h: parseFloat(mTam[2]) } : null;
      if (!d) return '';
      /* 28/jul: a orientação vem da PROPORÇÃO DA ARTE já renderizada na mini,
         não de um [data-orientation] qualquer da página — o primeiro elemento
         com esse atributo podia ser outra coisa (uma cena do ambientado), e aí
         uma obra em pé aparecia deitada: "42 × 30" embaixo de uma peça 30 × 42. */
      /* 28/jul (correção): mesma história da gaveta de extras — proporção pelo
         arquivo, não pelo retângulo, porque a mini está oculta no desktop. */
      var refArtO = document.querySelector('.rd-buymini__art') || document.querySelector('.pp26__art');
      var rO = refArtO ? (refArtO.naturalWidth ? { width: refArtO.naturalWidth, height: refArtO.naturalHeight } : refArtO.getBoundingClientRect()) : null;
      var orient = (rO && rO.width > rO.height + 1) ? 'horizontal' : 'vertical';
      /* 28/jul: os NÚMEROS ficam na ordem do catálogo (a mesma dos chips e da
         nota: "30 × 42"), e só o DESENHO gira pra orientação real da obra.
         Trocar os números fazia a gaveta contradizer a página — a pessoa lia
         "42 × 30" logo abaixo de um chip escrito "30 × 42" e não tinha como
         saber qual dos dois acreditar. */
      var dDes = { w: d.w, h: d.h };
      if (orient === 'horizontal' && dDes.h > dDes.w) { var t0 = dDes.w; dDes.w = dDes.h; dDes.h = t0; }

      var cbP = document.querySelector('.jun26-mod--paspatur input[type="checkbox"]');
      var temPasp = !!(cbP && cbP.checked);
      var notaEl = szNote.querySelector('.rd-size-note__txt');
      var mm = (notaEl ? notaEl.textContent : '').replace(/\u00a0/g, ' ').match(/(\d+)\s*×\s*(\d+)/);
      if (!mm) return '';
      var fw = +mm[1], fh = +mm[2];

      var addP = temPasp ? 10 : 0;
      var faceCm = Math.round(((fw - d.w - addP) / 2) * 10) / 10;
      if (!(faceCm > 0)) faceCm = 2;

      /* desenho: mesma fonte de cor das minis, pra moldura nunca divergir */
      var refQ = document.querySelector('.rd-buymini__q');
      var refCS = refQ ? getComputedStyle(refQ) : null;
      var cor = refCS ? refCS.borderTopColor : '#C9A876';
      var corR = refCS ? refCS.borderRightColor : cor;
      var corB = refCS ? refCS.borderBottomColor : cor;
      /* 28/jul: o CANVAS não é uma padrão mais fina — ele tem o vão escuro entre
         a arte e o perfil (efeito flutuante). Sem isso o desenho mostrava um
         quadro que a pessoa não está comprando. O fundo vem da própria mini,
         que já resolve isso, e o vão é 1 cm real escalado. */
      var ftDesenho = (document.querySelector('.pp26__frame') || { dataset: {} }).dataset.frameType || '';
      var ehCanvas = /canvas/i.test(ftDesenho);
      var fundoQ = refCS ? refCS.backgroundColor : '#FFFFFF';
      var img = document.querySelector('.rd-buymini__art') || document.querySelector('.pp26__art');
      var src = img ? (img.currentSrc || img.src || '') : '';
      /* 28/jul (correção): a figura VOLTA a caber. Eu tinha subido pra 300px de
         lado maior pra cota de 1,5 cm ficar legível — e não conferi o
         resultado: com as cotas por fora, 300 estoura os 420px da gaveta e o
         desenho vaza. O teto é a largura útil menos o espaço das cotas
         (rótulo à esquerda + colchete à direita), ~110px no total. */
      var esc = Math.min(232 / Math.max(fw, fh), 168 / Math.min(fw, fh));
      if (orient !== 'horizontal') esc = Math.min(196 / fw, 132 / fh);
      /* 28/jul: o MESMO teto das minis (5,5px). Sem ele a face escala junto com
         o desenho — 1,5 cm × escala 4,7 dá 7px — e a moldura fica gorda perto
         do mini do carrinho e do checkout, que usam esse limite. A finura é
         parte do vocabulário: a mesma peça tem que parecer a mesma em todos os
         lugares onde é desenhada. */
      var face = Math.max(2, Math.min(5.5, faceCm * esc));
      var mat = temPasp ? 5 * esc : 0;
      var outerW = dDes.w * esc + 2 * mat + 2 * face;
      var outerH = dDes.h * esc + 2 * mat + 2 * face;
      /* as reguinhas: face e paspatur em cima (cada uma sobre a faixa que mede)
         e a altura total à esquerda. Bracket com tique nas duas pontas, no traço
         das fichas técnicas das molduras. */
      /* 28/jul: a cota da moldura vai pro canto DIREITO. As duas em cima à
         esquerda se atropelavam — a face tem 3px e o rótulo 26, então "2 cm" e
         "5 cm" ficavam um por cima do outro. Separadas pelos cantos, cada uma
         mede a sua faixa sem disputar espaço. */
      /* 28/jul: a face usa LINHA-GUIA (tique em cima e traço descendo até a
         peça), não colchete. Colchete precisa de largura pra existir, e a face
         tem 3px — ele virava um ⊓ espremido. O paspatur, que é largo, mantém o
         colchete. */
      /* 28/jul (correção): a cota da face usa a MESMA construção das do
         paspatur — fio com tique nas duas pontas e o rótulo AO LADO, não em
         cima. Em cima, num vão de 7px, o rótulo ficava boiando sobre um
         colchete que lia como "Π". Ao lado, o desenho é idêntico ao das cotas
         de topo do paspatur, que é o que você já aprovou. */
      var cotas = '<i class="rd-tfcota rd-tfcota--face" style="height:' + face.toFixed(1) + 'px"><em>' + String(faceCm).replace('.', ',') + ' cm</em></i>'
        + (mat ? '<i class="rd-tfcota rd-tfcota--h" style="left:' + face.toFixed(1) + 'px;width:' + mat.toFixed(1) + 'px"><em>5 cm</em></i>' : '')
        + '<i class="rd-tfcota rd-tfcota--v" style="height:' + outerH.toFixed(1) + 'px"><em>' + (orient === 'horizontal' ? Math.min(fw, fh) : fh) + ' cm</em></i>';
      var desenho = '<div class="rd-xdrawer__solo"><div class="rd-tffig">' + cotas
        + '<span class="rd-xfig__quadro" style="padding:' + (mat + (ehCanvas ? 1 * esc : 0)).toFixed(1) + 'px;'
        + 'background:' + (ehCanvas ? fundoQ : '#FFFFFF') + ';'
        + 'border:' + face.toFixed(1) + 'px solid ' + cor + ';'
        + 'border-right-color:' + corR + ';border-bottom-color:' + corB + ';">'
        + '<i class="rd-xfig__art" style="width:' + (dDes.w * esc).toFixed(1) + 'px;height:' + (dDes.h * esc).toFixed(1) + 'px;'
        + 'background-image:url(&quot;' + src + '&quot;)"></i>'
        + '</span></div></div>';

      /* cada linha leva a amostra da cor que ela representa no desenho — é o que
         liga a tabela à figura sem precisar de legenda (28/jul) */
      var linha = function (nome, det, val, forte, amostra) {
        return '<div class="rd-tfsoma__l' + (forte ? ' rd-tfsoma__l--tot' : '') + '">'
          + '<span class="rd-tfsoma__n">'
          + (amostra ? '<i class="rd-tfsoma__cor" style="' + amostra + '"></i>' : '')
          + nome + (det ? ' <em>' + det + '</em>' : '') + '</span>'
          + '<span class="rd-tfsoma__v">' + val + '</span></div>';
      };
      /* 28/jul: as amostras são as COISAS, não aproximações. A da arte é a
         própria imagem; a da moldura é o swatch de madeira que a pessoa
         escolheu, lido do seletor de cor (a mesma textura, não um bege
         parecido). Cor chapada ali dizia "mais ou menos assim", e o painel
         inteiro existe pra tirar o "mais ou menos". */
      var swEl = document.querySelector('.jun26-swatch--active');
      var swCS = swEl ? getComputedStyle(swEl) : null;
      var swImg = swCS ? (swCS.getPropertyValue('--option-color-image') || '').trim() : '';
      if (!swImg && swCS) {
        var todas = (swCS.backgroundImage || '').match(/url\((?:[^)]+)\)/g);
        if (todas && todas.length) swImg = todas[todas.length - 1];   /* o check vem antes */
      }
      var amostraArte = src ? 'background-image:url(&quot;' + src + '&quot;);background-size:cover;background-position:center' : 'background:#D6D1C7';
      var amostraMold = swImg ? 'background-image:' + swImg + ';background-size:cover;background-position:center' : 'background:' + cor;

      var soma = '<div class="rd-tfsoma">'
        + linha('Arte', '', d.w + ' × ' + d.h + ' cm', false, amostraArte)
        + (temPasp ? linha('Paspatur', '5 cm por lado', '+ 10 cm', false, 'background:#FFFFFF;box-shadow:inset 0 0 0 1px #D6D1C7') : '')
        + linha('Moldura', String(faceCm).replace('.', ',') + ' cm por lado', '+ ' + String(Math.round(faceCm * 2 * 10) / 10).replace('.', ',') + ' cm', false, amostraMold)
        + linha('Na parede', '', '<b>' + fw + ' × ' + fh + ' cm</b>', true)
        + '</div>';

      return desenho + soma
        + '<p class="rd-xdrawer__dica"><svg class="rd-xdrawer__i" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>'
        + '<span>Meça a parede por este número, não pelo tamanho da arte.</span></p>';
    }

    var tamSheet = null, tamScrim = null;
    function fechaTamSheet() {
      if (!tamSheet) return;
      tamSheet.classList.remove('is-open');
      if (tamScrim) tamScrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    function abreTamSheet() {
      if (!tamSheet) {
        tamScrim = el('div', 'rd-tamsheet__scrim');
        tamScrim.addEventListener('click', fechaTamSheet);
        tamSheet = el('div', 'rd-tamsheet');
        tamSheet.setAttribute('role', 'dialog');
        tamSheet.setAttribute('aria-label', 'Como o tamanho final é calculado');
        tamSheet.innerHTML = '<div class="rd-tamsheet__grip" aria-hidden="true"></div>'
          + '<button class="rd-tamsheet__x" type="button" aria-label="Fechar">'
          + '<svg viewBox="0 0 15.22 15.22" width="15.22" height="15.22" fill="none" stroke="currentColor" stroke-width="1.22" stroke-linecap="butt" aria-hidden="true">'
          + '<path d="M0.61 0.61 L14.61 14.61 M14.61 0.61 L0.61 14.61"/></svg></button>'
          + '<p class="rd-tamsheet__tit" data-no-relabel>Tamanho final <span>· na parede</span></p>'
          + '<div class="rd-tamsheet__corpo"></div>';
        tamSheet.querySelector('.rd-tamsheet__x').addEventListener('click', fechaTamSheet);
        document.body.appendChild(tamScrim);
        document.body.appendChild(tamSheet);
        /* arrastar a folha pra baixo fecha, como no card da home */
        var y0 = null;
        tamSheet.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
        tamSheet.addEventListener('touchend', function (e) {
          if (y0 == null) return;
          var t = e.changedTouches && e.changedTouches[0];
          if (t && t.clientY - y0 > 60) fechaTamSheet();
          y0 = null;
        }, { passive: true });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechaTamSheet(); });
      }
      var corpo = tamSheet.querySelector('.rd-tamsheet__corpo');
      corpo.innerHTML = corpoTamanhoFinal() || (function () {
        var origem = szNote.querySelector('.rd-size-note__tip');
        return origem ? origem.innerHTML : '';
      })();
      tamScrim.classList.add('is-open');
      tamSheet.classList.add('is-open');
    }

    szNote.addEventListener('click', function (e) {
      if (!e.target.closest('.rd-size-note__info')) return;
      e.preventDefault();
      e.stopPropagation();
      /* 26/jul: a ficha é o caminho nas duas larguras — folha embaixo no mobile,
         gaveta lateral no desktop (o balão flutuante caía por cima da configuração) */
      abreTamSheet();
    });
    document.addEventListener('click', function (e) {
      if (!szNote.contains(e.target)) szNote.classList.remove('rd-size-note--tipopen');
    });
    var sizeFsForNote = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
    // nota do tamanho final NO FIM da configuração, antes do preço — como no
    // quick add (6/jul); fallback: logo após o seletor de tamanho
    var buyParaNota = root.querySelector('.jun26-card-buy');
    if (buyParaNota && buyParaNota.parentElement) buyParaNota.parentElement.insertBefore(szNote, buyParaNota);
    else if (sizeFsForNote && sizeFsForNote.parentElement) sizeFsForNote.parentElement.insertBefore(szNote, sizeFsForNote.nextSibling);

    var whEl = root.querySelector('.jun26-workhead');
    if (whEl && whEl.parentNode) {
      whEl.parentNode.insertBefore(feito, whEl.nextSibling);

      var back = el('button', 'rd-back');
      back.type = 'button';
      back.setAttribute('aria-label', 'Voltar');

      back.innerHTML = '<svg width="17" height="17" viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true"><path d="m574.21 270.36-294.54 294.55h774.98v70.18h-774.98l294.54 294.55-49.605 49.621-379.26-379.26 379.26-379.26z"/></svg>';
      back.addEventListener('click', function () {
        var sameOrigin = false;
        try { sameOrigin = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (x) { }
        if (sameOrigin && window.history.length > 1) history.back();
        else location.href = '/collections/all';
      });

      var backRow = el('div', 'rd-backrow');
      backRow.appendChild(back);
      whEl.insertBefore(backRow, whEl.firstChild);
      var galEye = whEl.querySelector('.jun26-wh-eyebrow');
      var galRow = whEl.querySelector('.jun26-wh-row');
      if (galEye && galRow) {
        var gal = el('div', 'rd-galabel');
        whEl.insertBefore(gal, galEye);
        gal.appendChild(galEye);
        gal.appendChild(galRow);
        var artEl = galEye.querySelector('.jun26-wh-artist');
        if (artEl) {
          var full = artEl.textContent.trim();
          var partes = full.split(/\s+/);
          if (partes.length > 3) {
            var curto = partes[0] + ' ' + partes[partes.length - 1];
            artEl.textContent = '';
            var sf = el('span', 'rd-art-full', full);
            var sc = el('span', 'rd-art-short', curto);
            artEl.appendChild(sf);
            artEl.appendChild(sc);
          }
        }
      }
    }
    var cardBuy = root.querySelector('.jun26-card-buy');
    if (cardBuy) cardBuy.classList.add('rd-buy-sticky');

    if (cardBuy) {
      var mini = el('div', 'rd-ministrust');

      root._miniTrustUpdate = function (noReturn) {
        var itens = ['Pagamento seguro'];
        if (!noReturn) itens.push('Devolução grátis');
        itens.push('Garantia de 2 anos');
        mini.textContent = itens.join(' · ');
      };
      root._miniTrustUpdate(false);
      cardBuy.appendChild(mini);
      var stickSentinel = document.createElement('div');
      stickSentinel.className = 'rd-stick-sentinel';
      if (cardBuy.parentNode) cardBuy.parentNode.insertBefore(stickSentinel, cardBuy.nextSibling);

      // a nota do tamanho final passa a viajar com o bloco de compra: os dois entram
      // num dock que é o sticky nas DUAS larguras (10/jul) — linha, nota, preço,
      // um bloco só, igual no desktop. O sentinel fica FORA do dock, senão ele subiria
      // junto e o is-stuck nunca dispararia.
      var buyDock = null;
      if (szNote && szNote.nextElementSibling === cardBuy && cardBuy.parentNode) {
        buyDock = el('div', 'rd-buydock');
        cardBuy.parentNode.insertBefore(buyDock, szNote);
        buyDock.appendChild(szNote);
        buyDock.appendChild(cardBuy);
      }

      var stickTick = false;
      var stickBox = buyDock || cardBuy;   /* quem de fato gruda */
      var stickPrev = stickBox.previousElementSibling;
      var stickState = false, stickFlipY = null;
      function updateStuck() {
        stickTick = false;
        /* verdade do sticky: o bloco está DESLOCADO do próprio slot?
           (slot = fim do irmão anterior + margem; rendered < slot ⇒ pinado) */
        /* 27/jul — O CRITÉRIO NÃO PODE DEPENDER DA ALTURA DA PRÓPRIA DOCA.
           Era essa a piscada. O sentinela fica DEPOIS da doca, então a altura dela
           empurrava o sentinela: compactou → a doca encolheu (a nota do tamanho
           some, a régua entra) → o sentinela subiu → o critério dizia "solta" →
           a doca cresceu → o sentinela desceu → "compacta" de novo. O estado
           mexia na altura e a altura mexia no estado: laço.
           Agora a medida é o TOPO NATURAL da doca — o pé do irmão anterior —, que
           não muda quando ela troca de forma. RESERVA é o espaço que a barra
           compacta ocupa no pé da tela. */
        var RESERVA = 150;
        var raw;
        if (stickPrev) {
          var topoNatural = stickPrev.getBoundingClientRect().bottom;
          raw = topoNatural > window.innerHeight - RESERVA;
        } else {
          raw = stickSentinel.getBoundingClientRect().top > window.innerHeight;
        }
        /* 27/jul — TRAVA ASSIMÉTRICA.
           A trava existe porque a troca compacta↔cheia anima a altura, e no limite
           o critério cru flipa de volta no mesmo ponto (treme). Mas ela só pode
           valer numa direção: segurar a SAÍDA da forma compacta é o que produzia o
           estado impossível — barra compacta com o conteúdo da página aparecendo
           embaixo dela, porque ela já tinha deixado de estar presa no rodapé e a
           classe ainda não sabia.
           Compactar: espera 44px (mata o tremor).
           Descompactar: NA HORA. A forma compacta só existe enquanto ela está de
           fato presa no pé da tela. */
        if (raw !== stickState && (raw === false || stickFlipY === null || Math.abs(window.scrollY - stickFlipY) >= 44)) {
          stickState = raw;
          stickFlipY = window.scrollY;
        }
        /* 27/jul — A DOCA NÃO ENCOLHE.
           Sticky não tira do fluxo: quando o card compactava, a doca encolhia
           junto, o documento inteiro subia e a pessoa tinha que rolar de novo pra
           chegar no mesmo lugar — além do tranco visível na troca. Aqui a doca
           guarda a altura do formato CHEIO (medida enquanto ele está solto) e a
           mantém como piso. A barra compacta passa a flutuar dentro de um espaço
           que não muda: sem pulo, sem piscada. */
        /* 27/jul: o gesto da troca é o COLAPSO original do tema (cada peça fecha o
           próprio eixo em .45s) — não precisa de classe transitória nenhuma. */
        cardBuy.classList.toggle('is-stuck', stickState);
        if (buyDock) buyDock.classList.toggle('is-stuck', stickState);
      }
      window.addEventListener('scroll', function () {
        if (!stickTick) { stickTick = true; requestAnimationFrame(updateStuck); }
      }, { passive: true });
      updateStuck();
    }

    if (cardBuy) {
      var freeShip = el('span', 'rd-freeship');
      freeShip.textContent = 'Frete grátis';
      var pixLine = cardBuy.querySelector('.jun26-buy-pix');
      if (pixLine) pixLine.appendChild(freeShip);
      var amtEl = cardBuy.querySelector('.jun26-buy-amount');
      var updateFreeShip = function () {
        if (!amtEl) return;
        var v = parseInt(String(amtEl.textContent).split(',')[0].replace(/\D/g, ''), 10) || 0;
        /* 30/jul — `style.display = 'none'` NÃO escondia o selo. Alguma folha de
           CSS de app (11 das 57 da página são cross-origin) força
           `display: flex !important` neste elemento, e !important de autor vence
           estilo inline sem prioridade. Resultado: "FRETE GRÁTIS" aparecia em
           TODO produto — inclusive num quadro de R$ 965, quando o grátis real só
           começa em R$ 2.500 e ainda por cima só vale no Econômico.
           Medido: com `display:none` a largura era 86px; com prioridade
           `important`, 0px. Por isso o setProperty com o terceiro argumento. */
        if (v >= 2500) freeShip.style.setProperty('display', 'flex', 'important');
        else freeShip.style.setProperty('display', 'none', 'important');
      };
      updateFreeShip();
      if (amtEl && 'MutationObserver' in window) {
        new MutationObserver(updateFreeShip).observe(amtEl, { childList: true, characterData: true, subtree: true });
      }
    }

    var tcMobile = document.createElement('meta');
    tcMobile.name = 'theme-color';
    tcMobile.media = '(max-width: 959px)';
    tcMobile.content = '#F4F2EE';
    document.head.appendChild(tcMobile);

    /* 31/jul — RATING E SALVAR TROCAM DE LINHA (ref. Kave Home).
       Estava: "Tyng ★4,8" na primeira linha, "Lemon [♡ SALVAR]" na segunda.
       Fica:   "Tyng                    ♡"   — só o ícone, sem rótulo
               "Lemon ★4,8"
       Por quê: o rating qualifica a OBRA, não o artista, então pertence à linha
       do título. E o botão de salvar é ação, não informação — ícone sozinho no
       canto é o padrão que a pessoa já conhece de qualquer catálogo, e o rótulo
       "SALVAR" gastava peso de texto numa linha que deveria ser só o nome.
       Reposiciono em vez de reconstruir: os dois elementos mantêm seus
       listeners e estados (favorito salvo, link da nota). */
    (function trocaRatingSalvar() {
      /* o `.rd-salvar` é montado depois deste ponto, então a troca espera o
         tick — sem isso o rating muda de linha e o botão fica onde estava,
         que foi exatamente o que aconteceu na primeira tentativa. */
      /* o bloco do título é re-renderizado depois deste ponto, então uma
         aplicação única não pega: a primeira tentativa move e o re-render
         desfaz. Reaplico por ~4s, e a cada passada só mexo no que ainda estiver
         fora do lugar — depois disso o DOM está estável. */
      var passadas = 0;
      (function aplica() {
        var eyebrow = document.querySelector('.jun26-wh-eyebrow');
        var row = document.querySelector('.jun26-wh-row');
        if (eyebrow && row) {
          var rating = row.parentNode ? eyebrow.querySelector('.jun26-wh-rating') : null;
          var grupo = row.querySelector('.jun26-wh-titlegroup');
          if (rating && grupo) grupo.appendChild(rating);
          var salvar = row.querySelector('.rd-salvar');
          if (salvar) eyebrow.appendChild(salvar);
          var rot = eyebrow.querySelector('.rd-salvar__rot');
          if (rot) rot.hidden = true;
        }
        if (++passadas < 20) setTimeout(aplica, 200);
      })();
    })();

    if (cardBuy) {
      var proof = el('div', 'rd-proof');
      proof.textContent = '+20.000 paredes transformadas';
      var ctaRowEl = cardBuy.querySelector('.jun26-buy-cta-row');
      if (ctaRowEl && ctaRowEl.parentNode) ctaRowEl.parentNode.insertBefore(proof, ctaRowEl.nextSibling);
      else cardBuy.appendChild(proof);
    }

    function updateFinal() {
      var d = curSizeCm(), ft = frameType();
      var main = tf.querySelector('.rd-finalsize__main'), sub = tf.querySelector('.rd-finalsize__sub');
      var fmt = function (w, h) { return w + ' × ' + h + ' cm'; };

      if (!d || ft === 'sem-moldura') {
        tf.classList.add('rd-finalsize--off');
        szNote.style.display = 'none';
        /* 26/jul: sem a nota, o fio de baixo dela sumia junto e o bloco de preço
           ficava solto — a classe deixa o CSS devolver a linha e apertar o vão */
        root.classList.add('rd-sem-nota');
        return;
      }
      root.classList.remove('rd-sem-nota');
      tf.classList.remove('rd-finalsize--off');
      var b = BORDER_CM[ft] != null ? BORDER_CM[ft] : 2;
      main.setAttribute('data-txt', 'Tamanho final: ' + fmt(Math.round(d.w + 2 * b), Math.round(d.h + 2 * b)));
      sub.textContent = 'Arte ' + fmt(d.w, d.h) + ' + Moldura ' + FRAME_LABEL[ft];

      szNote.style.display = '';
      var NB = String.fromCharCode(160);

      var medida = (fmt(Math.round(d.w + 2 * b), Math.round(d.h + 2 * b)) + '.').split(' ').join(NB);
      var txtEl = szNote.querySelector('.rd-size-note__txt');

      /* 26/jul: sem o prefixo da moldura — "O tamanho final do quadro será de ..." */
      txtEl.innerHTML = 'O tamanho final do quadro será de ';
      var tail = document.createElement('span');
      tail.className = 'rd-size-note__tail';
      tail.innerHTML = '<b>' + medida + '</b>';
      tail.appendChild(szInfo);
      txtEl.appendChild(tail);

      // tooltip: a conta na cara, em vez de descrever a conta (10/jul)
      var vlr = function (s) { return String(s).split(' ').join(NB); };
      var faceCm = String(b).replace('.', ',');
      // data-no-relabel: sem isso o reescritor global do theme.liquid troca
      // "Tamanho da arte" e "Tamanho final" por "Tamanho:"
      var linhaTip = function (rot, val, tot) {
        return '<span class="rd-tipsum__l' + (tot ? ' rd-tipsum__l--tot' : '') + '">'
          + '<span data-no-relabel>' + rot + '</span><b>' + vlr(val) + '</b></span>';
      };
      /* 28/jul — O PASPATUR APARECE NA CONTA DO TOOLTIP.
         A gaveta grande já discriminava (Arte / Paspatur / Moldura / Na
         parede), mas este resumo somava os dois numa linha só chamada "Face da
         moldura": com paspatur ligado ele dizia "+ 7 cm" de moldura, quando
         são 5 de paspatur e 2 de moldura. Número certo, rótulo mentindo. */
      var pspOn = !!(root.querySelector('.rd-xcard--paspatur[aria-pressed="true"]')
        || (function () { var c = root.querySelector('input[value*="paspatur" i]'); return c && c.checked; })());
      var faceSo = pspOn ? Math.max(0, b - 5) : b;
      var tipHTML = '<span class="rd-tipsum">'
        + '<span class="rd-tipsum__head">O tamanho final é o que a peça ocupa na parede.</span>'
        + linhaTip('Tamanho da arte', fmt(d.w, d.h))
        + (pspOn ? linhaTip('Paspatur (cada lado)', '+ 5 cm') : '')
        + linhaTip('Face da moldura (cada lado)', '+ ' + String(faceSo).replace('.', ',') + ' cm')
        + linhaTip('Tamanho final', fmt(Math.round(d.w + 2 * b), Math.round(d.h + 2 * b)), true)
        + '</span>';
      var tip = tf.querySelector('.rd-finalsize__tip');
      if (tip) tip.innerHTML = tipHTML;

      var noteTip = szNote.querySelector('.rd-size-note__tip');
      if (noteTip) noteTip.innerHTML = tipHTML;
      fitNote();
    }

    function fitNote() {

      var inner = szNote.querySelector('.rd-size-note__txt');
      szNote.style.whiteSpace = 'nowrap';
      if (inner) inner.style.whiteSpace = 'nowrap';

      szNote.style.fontSize = '';
      var fs0 = parseFloat(getComputedStyle(szNote).fontSize) || 12;
      for (var fs = fs0; fs >= fs0 - 2; fs -= 0.5) {
        szNote.style.fontSize = fs + 'px';
        if (szNote.scrollWidth <= szNote.clientWidth) return;
      }
      szNote.style.whiteSpace = '';
      if (inner) inner.style.whiteSpace = '';
      szNote.style.fontSize = '';
    }
    window.addEventListener('resize', fitNote);
    updateFinal();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) updateFinal();
    });
    var frameEl = root.querySelector('.pp26__frame');
    if (frameEl && window.MutationObserver) {
      new MutationObserver(updateFinal).observe(frameEl, { attributes: true, attributeFilter: ['data-frame-type'] });
    }

    var trust = el('div', 'rd-trust');
    trust.innerHTML =

      '<div class="rd-trust__row"><svg class="rd-trust__ico" width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C8.8 4 8 6.66667 8 8V12M16 12H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div class="rd-trust__t">Pagamento seguro</div><div class="rd-trust__badges" aria-label="Pix, Visa, Mastercard, Elo e American Express"></div></div>'
      + '<div class="rd-trust__row rd-trust__row--devolucao"><svg class="rd-trust__ico" width="17" height="17" viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true"><path d="m1051.3 519.84c0 75.234-29.719 146.39-83.625 200.29s-125.06 83.625-200.29 83.625h-458.81l101.25 101.25-59.016 59.016-202.03-202.03 202.03-202.03 59.016 59.016-101.3 101.25h458.81c108.66 0 200.44-91.781 200.44-200.44s-91.781-200.44-200.44-200.44h-363.89v-83.438h363.89c75.234 0 146.39 29.719 200.29 83.625s83.625 125.06 83.625 200.29z"/></svg><div class="rd-trust__t">Devolução grátis</div><a class="rd-trust__side" href="/pages/trocas-e-devolucoes">Até 14 dias após o recebimento</a></div>'

      + '<div class="rd-trust__row"><svg class="rd-trust__ico" width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10.5213 2.62368C11.3147 1.75255 12.6853 1.75255 13.4787 2.62368L14.4989 3.74391C14.8998 4.18418 15.4761 4.42288 16.071 4.39508L17.5845 4.32435C18.7614 4.26934 19.7307 5.23857 19.6757 6.41554L19.6049 7.92905C19.5771 8.52388 19.8158 9.10016 20.2561 9.50111L21.3763 10.5213C22.2475 11.3147 22.2475 12.6853 21.3763 13.4787L20.2561 14.4989C19.8158 14.8998 19.5771 15.4761 19.6049 16.071L19.6757 17.5845C19.7307 18.7614 18.7614 19.7307 17.5845 19.6757L16.071 19.6049C15.4761 19.5771 14.8998 19.8158 14.4989 20.2561L13.4787 21.3763C12.6853 22.2475 11.3147 22.2475 10.5213 21.3763L9.50111 20.2561C9.10016 19.8158 8.52388 19.5771 7.92905 19.6049L6.41553 19.6757C5.23857 19.7307 4.26934 18.7614 4.32435 17.5845L4.39508 16.071C4.42288 15.4761 4.18418 14.8998 3.74391 14.4989L2.62368 13.4787C1.75255 12.6853 1.75255 11.3147 2.62368 10.5213L3.74391 9.50111C4.18418 9.10016 4.42288 8.52388 4.39508 7.92905L4.32435 6.41553C4.26934 5.23857 5.23857 4.26934 6.41554 4.32435L7.92905 4.39508C8.52388 4.42288 9.10016 4.18418 9.50111 3.74391L10.5213 2.62368Z" stroke="currentColor" stroke-width="1.5"/><path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div class="rd-trust__t">Garantia de 2 anos</div><div class="rd-trust__side">Contra defeitos de fabricação</div></div>';

    root.querySelectorAll('.jun26-extras, .jun26-buy-trust').forEach(function (e) { e.remove(); });
    info.appendChild(trust);

    /* 28/jul — DIETA DA COLUNA: as garantias viram uma linha, não três.
       "Devolução grátis / Até 7 dias após o recebimento" gastava uma linha
       inteira pra dizer o que cabe em quatro palavras. O texto encurta aqui (e
       não no CSS) porque ele também é o rótulo do link — encurtar por fora
       deixaria o link com um nome e a tela com outro. */
    var devSide = trust.querySelector('.rd-trust__row--devolucao .rd-trust__side');
    if (devSide) devSide.textContent = 'em 14 dias';

    /* 28/jul — PROPOSTA B DO PAPER, no desktop.
       Três blocos com papéis distintos, na gramática da casa (fio + rótulo em
       caixa alta + valor), e não mais três linhas iguais dentro de uma lista:
       · PAGAMENTO vira rodapé do botão — fecha o gesto da compra ("clicou
         aqui, paga assim") em vez de disputar espaço com garantias;
       · ENTREGA ganha bloco próprio entre dois fios: é a única informação que
         a pessoa ainda não tem quando decide;
       · DEVOLUÇÃO e GARANTIA viram uma linha só — são o que se espera
         encontrar, e ausência incomodaria mais que presença convence.
       O bloco de entrega NÃO inventa prazo: sem a tabela de transporte por
       região, ele confirma a cidade pelo ViaCEP (público) e diz que o cálculo
       fecha no checkout. Data estimada aqui vira reclamação depois. */
    (function fechamentoB() {
      var mqB = window.matchMedia('(min-width: 960px)');
      if (!mqB.matches) return;
      var ctaRow = root.querySelector('.jun26-buy-cta-row');
      if (!ctaRow) return;

      /* 28/jul (revisão) — TRIO DE ÍCONES ABAIXO DO BOTÃO (proposta A do Paper).
         Pagamento, devolução e garantia são da mesma natureza: formalidades que
         a pessoa espera encontrar. Em três linhas separadas elas ocupavam a
         coluna inteira dizendo pouco; como trio, ocupam uma faixa e leem de
         uma vez — é a mesma estrutura da faixa de benefícios do rodapé, que é
         como a casa já diz esse tipo de coisa.
         A entrega fica FORA do trio, embaixo: ela não é formalidade, é a única
         informação nova ali. */
      /* 31/jul — MÍNIMO (decisão do dono, Paper: variação "D · mínimo").
         O bloco de confiança volta a ser UMA linha.

         O argumento não é estético: a coluna já pede seis decisões antes desta
         região — tipo de moldura, cor, tamanho, extras, forma de pagamento e
         agora o CEP. O bloco de garantias não é uma sétima decisão, mas com
         ícone de 28px, peso e linha própria ele PARECE uma, e some com a
         estimativa de frete abaixo da dobra.
         Aqui as garantias assumem o que são: rodapé fino do botão. Foram de
         cinco linhas e nove objetos para uma linha e três textos.

         O que se perde, conscientemente: as bandeiras saem da vista. "Pagamento
         seguro" vira o link que abre a mesma gaveta do antigo "+7" — quem
         precisa saber se aceita Pix passa a precisar de um clique.
         "Desde 2016 · Mais de 20 mil paredes" sai da coluna; é credencial da
         casa e o lugar dela é a faixa de largura inteira, fora da zona de
         decisão. */
      var pag = document.createElement('div');
      pag.className = 'rd-fech__conf';
      /* 31/jul — A LINHA VIRA CICLADOR, como a barra de anúncio do topo.
         Três mensagens não cabiam lado a lado numa coluna de 360px sem
         mutilar todas — "Devolução gratuita em 14 dias · Garantia de 2 anos ·
         Pagamento 100% seguro" mede 400px. Uma de cada vez cabe inteira, e
         ainda sobra espaço para as bandeiras voltarem à vista, à direita.
         Reuso o `rd-made-cycle` que já existe no tema (a mesma transição
         vertical da linha de produção), em vez de escrever um segundo
         ciclador — se alguém ajustar o tempo ou a curva lá, isto acompanha. */
      var pag = document.createElement('div');
      pag.className = 'rd-fech__conf';
      pag.innerHTML = ''
        + '<span class="rd-made-cycle rd-fech__cyc">'
        + '  <span class="rd-made-row rd-fech__cycrow is-active" data-dev></span>'
        + '  <span class="rd-made-row rd-fech__cycrow">Garantia de 2 anos</span>'
        + '  <span class="rd-made-row rd-fech__cycrow">Pagamento 100% seguro</span>'
        + '</span>'
        + '<span class="rd-fech__bandeiras"></span>';

      /* as bandeiras voltam para cá — elas dizem "aceita Pix" mais rápido que
         qualquer frase, e o "+7" continua sendo a porta para a gaveta. */
      setTimeout(function () {
        var alvo = pag.querySelector('.rd-fech__bandeiras');
        var caixa = root.querySelector('.rd-trust__badges');
        if (alvo && caixa) alvo.appendChild(caixa);
      }, 0);

      /* 31/jul — A DEVOLUÇÃO NÃO É GRÁTIS NO GG. Peça de 70x100 (e maior) tem
         custo de frete reverso que inviabiliza a gratuidade, e prometer o que a
         operação não cumpre vira disputa no cartão, não só reclamação.
         PENDENTE: alinhar a redação com a página de políticas. */
      var TAMANHOS_SEM_DEVOLUCAO_GRATIS = ['70x100', '100x140'];
      function tamanhoSelecionado() {
        var i = document.querySelector('input[name="Escolha o tamanho (cm)"]:checked');
        return i ? String(i.value).toLowerCase().replace(/\s/g, '') : '';
      }
      function pintaDevolucao() {
        var el = pag.querySelector('[data-dev]');
        if (!el) return;
        var grande = TAMANHOS_SEM_DEVOLUCAO_GRATIS.indexOf(tamanhoSelecionado()) >= 0;
        el.textContent = grande ? 'Devoluções em 14 dias' : 'Devoluções gratuitas em 14 dias';
      }
      pintaDevolucao();
      Array.prototype.forEach.call(
        document.querySelectorAll('input[name="Escolha o tamanho (cm)"]'),
        function (i) { i.addEventListener('change', pintaDevolucao); }
      );

      /* o ciclo pausa quando a aba está oculta: animação rodando em segundo
         plano só gasta bateria. */
      (function ciclaConf() {
        var linhas = pag.querySelectorAll('.rd-fech__cycrow');
        if (linhas.length < 2) return;
        var atual = 0;
        setInterval(function () {
          if (document.hidden) return;
          var sai = linhas[atual];
          atual = (atual + 1) % linhas.length;
          var entra = linhas[atual];
          sai.classList.remove('is-active');
          sai.classList.add('is-leaving');
          entra.classList.add('is-active');
          setTimeout(function () { sai.classList.remove('is-leaving'); }, 600);
        }, 3800);
      })();
      ctaRow.parentNode.insertBefore(pag, ctaRow.nextSibling);
      /* as bandeiras são criadas DEPOIS deste ponto (o código que as monta
         procura por `.rd-trust__badges` dentro do bloco antigo). Movendo agora,
         eu levaria a caixa vazia e o buscador não a acharia mais — nenhuma
         bandeira seria criada. Por isso a mudança de lugar espera o tick. */
      /* as bandeiras não cabem numa coluna de ~120px sem virar manchinha; elas
         seguem vivas na gaveta de pagamento, que abre pelo "+7" de lá. Aqui a
         coluna diz em texto o que elas diriam em logo. */

      /* 31/jul — MARCAÇÃO v2 (Paper: "Estimativa v2 — resultado primeiro").
         A virada em relação à v1: a MANCHETE é a resposta, não o campo. Antes do
         CEP ela diz o que já se sabe sem endereço nenhum ("Produzido em 7 dias
         úteis"); depois do CEP ela vira a soma. O campo desce para segundo
         plano e some quando não é mais necessário — o CEP fica como link no
         cabeçalho, acumulando "qual endereço usei" e "trocar".
         Quatro estados, todos desenhados no Paper: inicial · carregando ·
         cotado · editando. O esqueleto do carregando tem a MESMA forma do
         resultado, então nada pula de lugar quando os dados chegam. */
      var ent = document.createElement('div');
      ent.className = 'rd-fech__ent';
      ent.innerHTML = ''
        + '<div class="rd-fech__col">'
        + '  <div class="rd-fech__head">'
        + '    <span class="rd-fech__icobox"><svg width="19" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v9H2z"/><path d="M13 9h4.2l2.8 3v3h-7z"/><circle cx="6" cy="17.5" r="1.7"/><circle cx="16.5" cy="17.5" r="1.7"/></svg></span>'
        /* 31/jul — "FRETE E PRAZO", não "ESTIMATIVA DE ENTREGA". Três razões:
           é o termo que o brasileiro procura numa PDP (a frase padrão do setor
           é "calcular frete e prazo"); nomeia as DUAS saídas do bloco em vez de
           uma; e cabe em 13 caracteres contra 21, o que devolve espaço para o
           "Não sei meu CEP" na mesma linha.
           A ressalva "estimativa" não se perde — ela vive na nota do rodapé,
           que é onde ela é de fato lida antes da compra. */
        + '    <span class="rd-fech__rot">FRETE E PRAZO</span>'
        /* o CEP cotado vira botão: mostra o endereço usado E reabre a edição */
        /* 31/jul — "Não sei meu CEP" mora AQUI, na mesma vaga que o CEP cotado
           ocupa depois. Os dois nunca coexistem, então o cabeçalho não muda de
           altura e nada pula quando a cotação chega.
           Embaixo do campo ele disputava atenção com a linha do frete grátis —
           dois textos miúdos empilhados, nenhum com prioridade. E ali em cima
           ele aparece ANTES de a pessoa tentar digitar, que é quando a dúvida
           "não sei meu CEP" realmente acontece. */
        + '    <a class="rd-fech__nsei" href="https://buscacepinter.correios.com.br/app/endereco/index.php"'
        + '       target="_blank" rel="noopener noreferrer">Não sei meu CEP</a>'
        + '    <button type="button" class="rd-fech__cepchip" hidden></button>'
        + '  </div>'
        + '  <div class="rd-fech__campo">'
        + '    <input class="rd-fech__cep" type="text" inputmode="numeric" maxlength="9" placeholder="Digite seu CEP" aria-label="Seu CEP">'
        + '    <button type="button" class="rd-fech__ok" aria-label="Calcular frete"><svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true"><path d="M1 6h15M12 1.5L16.5 6 12 10.5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button>'
        + '  </div>'
        + '  <div class="rd-fech__sub" role="status"></div>'
        /* 31/jul — a manchete vem DEPOIS do campo. Enquanto há ação a fazer, o
           campo ocupa o topo logo abaixo do rótulo, que é a posição de maior
           prioridade do bloco; a produção fica como contexto que segue.
           Quando a cotação chega o campo some, e a manchete sobe sozinha para o
           lugar dele — o resultado assume o topo sem precisar de regra especial
           nem de reordenação por JS. */
        /* 1/ago — O VISTO VERDE VOLTA, AGORA NA MANCHETE.
           Em 31/jul a bolinha pulsante saiu daqui porque disputava o verde com
           o visto da faixa de frete grátis, a 60px de distância. Com a faixa
           fora (abaixo), o verde fica livre — e o visto é o glifo certo para
           esta frase: "produzido em 7 dias" é um compromisso confirmado, não um
           status que pulsa. Reusa a calha de ícone de 22px (`.rd-made-icons`),
           então o texto continua no mesmo eixo do subtítulo, e some sozinho
           quando a manchete vira a resposta de entrega.
           O texto ganha span próprio: `estado()` escreve por textContent, que
           apagaria o ícone se ele fosse irmão direto. */
        + '  <div class="rd-fech__manchete">'
        + '    <div class="rd-fech__manchete-t">'
        + '      <span class="rd-made-icons rd-fech__mck" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>'
        + '      <span class="rd-fech__manchete-tx"></span>'
        + '    </div>'
        + '    <div class="rd-fech__manchete-s"></div>'
        + '  </div>'
        /* 1/ago — A FAIXA DE FRETE GRÁTIS SAIU. Ela era upsell ("a partir de
           R$ 2.500") num bloco cuja pergunta é outra — quando chega e quanto
           custa PARA ESTE endereço. Antes da cotação ela ocupava o lugar da
           resposta com uma condição que a maioria dos pedidos não alcança, e
           depois da cotação sumia de qualquer forma. O "Grátis" real continua
           aparecendo na linha do Econômico quando o carrinho de fato passa do
           valor — que é onde a informação vale. */
        /* esqueleto com a forma exata do resultado: duas linhas, texto à
           esquerda em dois níveis, valor à direita. */
        + '  <div class="rd-fech__esq" hidden>'
        + '    <div class="rd-fech__esq-l"><span class="rd-fech__esq-b" style="width:84px;height:9px"></span><span class="rd-fech__esq-b rd-fech__esq-b--fraca" style="width:148px;height:8px"></span><span class="rd-fech__esq-v"></span></div>'
        + '    <div class="rd-fech__esq-l"><span class="rd-fech__esq-b" style="width:62px;height:9px"></span><span class="rd-fech__esq-b rd-fech__esq-b--fraca" style="width:148px;height:8px"></span><span class="rd-fech__esq-v"></span></div>'
        + '  </div>'
        + '  <div class="rd-fech__envio" hidden></div>'
        + '</div>';
      pag.parentNode.insertBefore(ent, pag.nextSibling);

      /* 28/jul: a linha inteira é área de clique do campo. Antes só os 63px do
         número respondiam — o resto da faixa parecia clicável e não era. */
      ent.addEventListener('click', function (ev) {
        /* o link do CEP também escapa do "clicou na faixa, foca no campo" —
           senão ele abre a aba nova E rouba o foco pro campo atrás. */
        if (ev.target.closest('.rd-fech__ok') || ev.target.closest('.rd-fech__nsei')) return;
        var alvo = ent.querySelector('.rd-fech__cep');
        if (alvo && ev.target !== alvo) alvo.focus();
      });
      var campo = ent.querySelector('.rd-fech__cep');
      var subEl = ent.querySelector('.rd-fech__sub');
      var nseiEl = ent.querySelector('.rd-fech__nsei');
      var okEl = ent.querySelector('.rd-fech__ok');
      var envioEl = ent.querySelector('.rd-fech__envio');
      var campoEl = ent.querySelector('.rd-fech__campo');
      var esqEl = ent.querySelector('.rd-fech__esq');
      var chipEl = ent.querySelector('.rd-fech__cepchip');
      var mTitEl = ent.querySelector('.rd-fech__manchete-t');
      var mTxEl = ent.querySelector('.rd-fech__manchete-tx');
      var mSubEl = ent.querySelector('.rd-fech__manchete-s');

      /* 31/jul — ESTADOS. Cada um liga/desliga o mesmo conjunto de peças; ter a
         troca num lugar só evita o clássico "escondi A mas esqueci B" que já
         apareceu duas vezes neste bloco. */
      function estado(nome, dados) {
        var d = dados || {};
        var editando = nome === 'editando';
        var cotado = nome === 'cotado';
        var carregando_ = nome === 'carregando';
        /* 31/jul — EDITAR NÃO APAGA. Quem clica no CEP quer comparar outro
           endereço, não zerar o que já viu: o resultado anterior fica na tela
           enquanto o campo está aberto. Com nada perdido, não existe o que
           cancelar — por isso o botão "cancelar" saiu. Sair do modo edição é
           simplesmente cotar de novo. */
        var temResultado = cotado || editando;
        campoEl.hidden = cotado;
        campoEl.classList.toggle('is-loading', carregando_);
        campoEl.classList.toggle('is-editing', editando);
        /* 31/jul — o "Não sei meu CEP" depende do CAMPO estar vazio, não do
           estado. Ele é saída de emergência para quem não sabe o número; assim
           que qualquer dígito entra, deixou de ser útil e vira ruído ao lado do
           CEP. Some ao digitar e volta se a pessoa apagar tudo. */
        var temTexto = String(campo.value).trim() !== '';
        if (nseiEl) nseiEl.hidden = carregando_ || temTexto;
        esqEl.hidden = !carregando_;
        envioEl.hidden = !temResultado;
        notaEl.hidden = !temResultado;
        chipEl.hidden = !cotado;
        okEl.disabled = carregando_;
        if (cotado && d.cep) chipEl.textContent = d.cep;
        if (d.titulo != null) mTxEl.textContent = d.titulo;
        if (d.sub != null) mSubEl.textContent = d.sub;
        /* 31/jul — o TAMANHO da manchete é função do estado, não do conteúdo.
           Enquanto ela informa contexto (produção), fica em corpo de texto;
           quando vira a resposta que a pessoa pediu, cresce. Assim o corpo
           grande significa sempre a mesma coisa — "aqui está o que você
           perguntou" — e crescer vira recompensa pela ação. */
        mTitEl.parentNode.classList.toggle('rd-fech__manchete--resposta', cotado);
      }

      /* a manchete ociosa é a única resposta que não depende de endereço: a
         produção. Ela precisa acompanhar a troca de quadro para poster. */
      function mancheteInicial() {
        var poster = ehPoster();
        return {
          titulo: 'Produzido em ' + DIAS_PRODUCAO + ' dias úteis',
          sub: (poster ? 'Impressão e acabamento.' : 'Impressão, emolduramento e acabamento.') + ' O envio inicia após essa etapa.'
        };
      }
      /* a linha de produção não espera CEP: ela vale para qualquer endereço e
         já responde metade da pergunta antes de a pessoa digitar. Só o texto
         muda quando ela troca quadro por poster. */
      /* 31/jul — a chamada inicial NÃO fica aqui. `estado()` mexe em listaEl,
         notaEl e envioEl, e os dois primeiros só nascem umas 200 linhas abaixo.
         Com `var` eles existem por hoisting mas valem `undefined`, então a
         primeira pintura estourava em `notaEl.hidden` e a manchete nascia
         vazia. A chamada foi para depois da criação de todos eles. */
      function pintaProducao() { estado('inicial', mancheteInicial()); }
      /* 30/jul — "calculando frete…" com reticências fazia a espera parecer
         travamento: o texto fica idêntico por dois segundos e nada na tela se
         mexe. Uma roda girando resolve com menos palavras — e libera a linha
         para dizer o que já se sabe (a cidade), em vez de gastá-la narrando o
         que o próprio spinner mostra.
         O `aria-live` no texto continua anunciando o estado para leitor de tela;
         a roda é decorativa e fica fora da árvore de acessibilidade. */
      function carregando(on, texto) {
        if (texto != null) subEl.textContent = texto;
        /* 30/jul — a roda mudou de lugar: sai da linha de apoio e entra NO
           botão, no lugar da seta. É lá que a pessoa acabou de clicar, é lá que
           ela olha esperando resposta — e o botão vira sua própria confirmação
           de que o clique pegou, sem precisar de uma segunda pista a três
           linhas de distância. */
        if (okEl) {
          okEl.classList.toggle('is-loading', !!on);
          okEl.disabled = !!on;
        }
      }
      /* 31/jul — CEP no padrão dos Correios: NNNNN-NNN. A máscara virou função
         porque só o listener de `input` não bastava: valor posto por código
         (restaurar depois do "cancelar", autofill do navegador, colar em alguns
         casos) não dispara `input`, e o campo ficava com os oito dígitos
         grudados. Agora todo caminho passa por aqui. */
      function mascaraCep(valor) {
        var v = String(valor == null ? '' : valor).replace(/\D/g, '').slice(0, 8);
        return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      }
      function setCep(valor) { campo.value = mascaraCep(valor); }
      campo.addEventListener('input', function () {
        campo.value = mascaraCep(campo.value);
        if (nseiEl) nseiEl.hidden = String(campo.value).trim() !== '';
        /* 31/jul — MEXEU NO CEP, A COTAÇÃO MORRE. O resultado só vale para o
           CEP que o gerou; mantê-lo na tela enquanto a pessoa digita outro
           número é mostrar um preço que não corresponde ao endereço escrito
           logo acima dele. O bloco recolhe ao estado original e espera um novo
           clique na seta — sem botão de limpar, sem passo extra.
           A senha é queimada junto para que uma consulta em voo não pinte
           resultado por cima do estado recolhido. */
        if (!envioEl.hidden || ultimoCotado) {
          senha++;
          ultimoCotado = null;
          listaEl.hidden = true;
          campoEl.classList.remove('is-loading', 'is-editing');
          carregando(false, '');
          estado('inicial', mancheteInicial());
          subEl.textContent = '';
          if (nseiEl) nseiEl.hidden = String(campo.value).trim() !== '';
        }
      });
      campo.addEventListener('change', function () { campo.value = mascaraCep(campo.value); });

      /* 30/jul — O CICLO FECHA: preço e data de verdade, não mais "no checkout".
         A Mandaê já está registrada como carrier service da loja (as cotações
         voltam com `source: "Mandae Production"`), então o próprio Shopify
         responde preço E data por CEP no nosso domínio, sem token e sem proxy:
         /cart/shipping_rates.json. O número que sai daqui não é uma estimativa
         parecida com o checkout — é o checkout respondendo.

         Bater na API da Mandaê direto foi testado e DESCARTADO por dois motivos,
         nessa ordem: (1) api.mandae.com.br não responde preflight de CORS, então
         o navegador nem sairia do lugar; (2) mesmo via proxy a conta erra, porque
         o app usa uma caixa por produto que não dá pra ler de fora — a variante
         35x50 sai 21,62 no checkout e 18,55 na API crua com peso equivalente.
         Errar pra menos no PDP e corrigir pra mais no checkout é o tipo de coisa
         que vira abandono de carrinho. Aqui não tem como divergir: é a mesma
         fonte. */
      var listaEl = document.createElement('div');
      listaEl.className = 'rd-fech__taxas';
      listaEl.hidden = true;
      ent.querySelector('.rd-fech__envio').appendChild(listaEl);

      /* 30/jul — SEM DATA DE CHEGADA (decisão do dono). A faixa mostra as duas
         pernas em dias úteis — produção e envio — e deixa a soma com a pessoa.
         O que motivou: a data cheia batia em meados do mês seguinte e pesava
         mais do que informava.
         Continua honesto porque as duas pernas aparecem inteiras e nenhuma some;
         o que sai é a conversão de dias em calendário. Se um dia voltar a fazer
         sentido cravar a data, o `delivery_date` do Shopify vem em toda cotação
         e só precisa de produção somada por cima — ele é SÓ transporte, a Mandaê
         devolve 2 dias para SP e o Shopify 3, ou seja, +1 de manuseio, nunca os
         7 de produção.
         ATENÇÃO: o site tem DOIS prazos de produção — 7 dias úteis no PDP e 9
         no FAQ do widget de suporte. Uso o do PDP, que é o que a pessoa acabou
         de ler na mesma tela. Se o certo for 9, muda só esta constante. */
      var DIAS_PRODUCAO = 7;
      function moeda(v) {
        var n = parseFloat(v);
        /* frete grátis acima de R$ 2.500 vem como price "0.00" e vale só no
           Econômico — o Rápido continua cobrando. Não invento a palavra: se o
           Shopify mandou zero, é grátis mesmo. */
        if (!(n > 0)) return 'Grátis';
        return 'R$ ' + n.toFixed(2).replace('.', ',');
      }
      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }

      /* 30/jul — "PRODUÇÃO DO QUADRO" mente quando a pessoa escolheu só a
         impressão: ali não há emolduramento nenhum, e prometer uma etapa que não
         existe é o mesmo erro da data sem produção, em escala menor.
         A fonte da verdade é o chip de moldura marcado — quando ele é "sem
         moldura", o que sai da produção é um pôster. Leio do DOM em vez do
         VARIANT_MAP porque este bloco vive noutro closure, e o chip é
         justamente o que a pessoa acabou de clicar. */
      function ehPoster() {
        var m = document.querySelector('input[name="Escolha o tipo de moldura"]:checked')
             || document.querySelector('input[name="Escolha a cor da moldura"]:checked');
        return !!m && String(m.value).toLowerCase().indexOf('sem moldura') >= 0;
      }

      /* 30/jul — os caminhõezinhos das linhas de opção saíram: com duas linhas
         só, o ícone não distinguia nada que o nome já não dissesse, e roubava a
         margem esquerda que agora alinha tudo em um eixo só. */

      function variantAtual() {
        var i = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
        return i && i.value ? i.value : null;
      }

      function taxas(cep, uf) {
        var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(cep)
              + '&shipping_address%5Bcountry%5D=Brazil'
              + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);
        return fetch('/cart/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('rates ' + r.status)); })
          .then(function (d) { return (d && d.shipping_rates) || []; });
      }

      /* o endpoint cota o CARRINHO, não a página — com carrinho vazio ele volta
         lista vazia. Então a cotação do PDP empresta o item por um instante e
         devolve o carrinho exatamente como estava. Se o item JÁ está no carrinho,
         não mexe em nada: cota como está.
         A marca em sessionStorage cobre a aba que morre no meio do empréstimo;
         o próximo carregamento devolve. */
      /* 30/jul — A TRAVA QUE VOCÊ PRECISA DECIDIR ANTES DE SUBIR.
         Para cotar um carrinho vazio eu adiciono o item, cotO e removo. Funciona
         e o preço é exato — mas `/cart/add.js` dispara o evento
         `product_added_to_cart` dos Web Pixels do Shopify. Ou seja: todo mundo
         que digitar um CEP com carrinho vazio vira um "adicionou ao carrinho"
         nos relatórios, no pixel da Meta e nos gatilhos de carrinho abandonado.
         Isso suja taxa de conversão e pode gerar e-mail de abandono para quem só
         consultou frete — o tipo de estrago que aparece semanas depois e ninguém
         liga à causa.
         Com `false`, a faixa segue exata onde já existe carrinho e apenas pede o
         CEP quando ele está vazio. O jeito certo de ter as duas coisas é um
         carrinho descartável pela Storefront API, que não toca no carrinho da
         sessão nem dispara pixel — precisa de um token público de Storefront
         que só você pode gerar no admin. */
      var EMPRESTAR_CARRINHO = true;
      var MARCA = 'rd-frete-emprestado';
      function devolver(vid) {
        try { sessionStorage.removeItem(MARCA); } catch (e) {}
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(vid), quantity: 0 })
        }).catch(function () {});
      }
      /* o que a última cotação realmente mediu — a nota do rodapé depende disso.
         Com carrinho vazio a conta é de UMA unidade deste quadro; com carrinho
         cheio é do carrinho inteiro, e prometer "1 unidade" ali seria mentira
         na direção mais cara. */
      var ultimoEscopo = 'item';
      function comItemEmprestado(fn) {
        var vid = variantAtual();
        if (!vid) return Promise.reject(new Error('sem variante selecionada'));
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var jaTem = (cart.items || []).some(function (it) { return String(it.id) === String(vid); });
            if (jaTem || cart.item_count > 0) {
              ultimoEscopo = cart.item_count > 1 || !jaTem ? 'carrinho' : 'item';
              return fn();
            }
            ultimoEscopo = 'item';
            if (!EMPRESTAR_CARRINHO) return [];
            try { sessionStorage.setItem(MARCA, vid); } catch (e) {}
            return fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            }).then(fn).then(
              function (out) { return devolver(vid).then(function () { return out; }); },
              function (err) { return devolver(vid).then(function () { throw err; }); }
            );
          });
      }
      /* devolução atrasada: só apaga se a linha ainda estiver do jeito que o
         empréstimo deixou (quantidade 1). Se a pessoa mexeu no carrinho depois,
         o carrinho é dela — não encosto. */
      (function devolucaoPendente() {
        var vid;
        try { vid = sessionStorage.getItem(MARCA); } catch (e) { return; }
        if (!vid) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var linha = (cart.items || []).filter(function (it) { return String(it.id) === String(vid); })[0];
            if (linha && linha.quantity === 1) return devolver(vid);
            try { sessionStorage.removeItem(MARCA); } catch (e) {}
          })
          .catch(function () {});
      })();

      /* 30/jul — LINHA DO TEMPO REMOVIDA (decisão do dono). A faixa mostra só
         o que a pessoa escolhe: Econômico e Rápido. A produção não sumiu — ela
         virou informação da linha de apoio, logo acima das opções, porque ali
         ela é contexto de uma vez só e não uma etapa competindo por espaço com
         as duas que realmente têm preço e prazo diferentes. */
      function textoProducao() {
        return 'Produção do ' + (ehPoster() ? 'poster' : 'quadro') + ' em ' + DIAS_PRODUCAO + ' dias úteis';
      }
      /* 31/jul — a linha de apoio (`subEl`) é SÓ canal de erro na v2. O texto de
         produção que vivia aqui virou manchete, e mantê-lo nos dois lugares
         imprimia a mesma frase duas vezes seguidas na tela. */
      function textoIdle() { return ''; }
      subEl.textContent = '';

      var notaEl = document.createElement('div');
      notaEl.className = 'rd-fech__nota';
      notaEl.hidden = true;
      ent.querySelector('.rd-fech__col').appendChild(notaEl);

      /* 31/jul — A BOLINHA PULSANDO MUDA DE CASA. "Produzido em 7 dias úteis"
         aparecia em dois lugares da coluna: na linha própria com o ponto verde,
         e agora na manchete da estimativa. Dizer duas vezes a mesma frase a
         poucos centímetros uma da outra não reforça, confunde — parece que são
         prazos diferentes.
         Em vez de recriar o ponto, movo o elemento original: ele já carrega a
         animação e as regras de cor do tema, e assim não existem duas fontes de
         verdade para o mesmo indicador. A linha antiga some.
         O tick de espera é porque `.rd-madeline` é montada por outro bloco, que
         pode rodar depois deste. */
      /* 31/jul — a prova social volta, com texto novo, e agora mora SOB o trio
         de garantias. Ela foi escondida em 28/jul por ser credencial da casa em
         vez de informação de compra — o que continua verdade, mas o lugar certo
         era logo depois de pagamento/devolução/garantia, que são exatamente as
         outras três credenciais. Ali ela fecha o grupo em vez de interromper a
         decisão. */
      /* 31/jul — a `.rd-proof` solta não é mais movida para cá: a prova social
         virou uma linha do próprio bloco de confiança, com "Desde 2016" junto.
         A antiga continua escondida pela regra de 28/jul. */

      /* 31/jul — A BOLINHA VERDE SAIU. Ela e o visto do frete grátis são verdes
         a 60px um do outro, mas significam coisas diferentes: o ponto é
         indicador de status ("em produção"), o visto é confirmação de benefício
         ("isto é grátis"). Mesma cor, gramáticas distintas — o olho aprende
         "verde = coisa boa" e para de distinguir qual.
         O visto fica porque ganha o verde por mérito: é o mesmo papel do verde
         no preço PIX, dinheiro que não se paga. O ponto sinalizava um estado que
         nunca muda (são sempre 7 dias, para todo produto), e indicador que pulsa
         sempre a mesma coisa decora em vez de informar.
         Bônus: sem ele, a manchete alinha com a descrição logo abaixo — some o
         desalinho de eixo que a gente perseguiu mais cedo.
         A linha original continua oculta; só não movemos mais o ponto para cá. */
      setTimeout(function () {
        var madeline = document.querySelector('.rd-madeline');
        if (madeline) madeline.hidden = true;
      }, 0);

      /* agora sim: todas as peças existem, o estado inicial pode ser pintado */
      pintaProducao();

      /* 30/jul — LIMPAR vai para o FIM do bloco, depois do rodapé. Como link na
         linha de apoio ele disputava a ponta com o "Não sei meu CEP" e, do lado
         de "São Paulo, SP", parecia legenda em vez de ação. No pé, depois de
         tudo que a cotação tinha a dizer, ele fecha o bloco na ordem em que a
         pessoa realmente usa: lê o resultado e só então decide trocar o CEP.
         Ganha caixa e caixa alta porque agora é botão isolado — sublinhado solto
         no meio do branco não lê como coisa clicável. */
      /* 31/jul — o botão LIMPAR saiu junto com o "cancelar", pela mesma razão:
         ninguém abre uma estimativa de frete querendo apagá-la. Trocar de CEP
         é clicar no CEP e digitar outro. */

      function pinta(cidade, uf, rates, estimado) {
        carregando(false);
        if (!rates.length) {
          estado('inicial', mancheteInicial());
          subEl.textContent = cidade + ', ' + uf + ' · frete e prazo no checkout';
          return;
        }
        subEl.textContent = '';
        /* 31/jul — a manchete vira FAIXA: do envio mais rápido ao mais lento.
           Um número só obrigava a escolher entre prometer o melhor caso (que a
           maioria não pega) ou o pior (que faz a loja parecer mais lenta do que
           é). A faixa diz a verdade inteira e ainda deixa visível que existe uma
           opção mais rápida — o que a linha do Rápido vai confirmar logo abaixo.
           Quando as duas opções têm o mesmo trânsito, cai para um número só:
           "Chega em 11–11" seria ridículo. */
        var menor = Infinity, maior = 0;
        rates.forEach(function (r) {
          var dd = r.delivery_days || [];
          var t = dd.length ? dd[dd.length - 1] : 0;
          if (t > maior) maior = t;
          if (t < menor) menor = t;
        });
        if (!isFinite(menor)) menor = maior;
        var tMin = DIAS_PRODUCAO + menor, tMax = DIAS_PRODUCAO + maior;
        ultimoCotado = {
          cep: campo.value,
          titulo: 'Entrega em ' + (tMin === tMax ? tMax : tMin + '–' + tMax) + ' dias úteis',
          sub: DIAS_PRODUCAO + ' de produção + '
             + (menor === maior ? menor : menor + ' a ' + maior) + ' de envio, para '
             + (estimado ? 'a região de ' : '') + cidade + ', ' + uf
        };
        estado('cotado', {
          cep: campo.value,
          titulo: 'Entrega em ' + (tMin === tMax ? tMax : tMin + '–' + tMax) + ' dias úteis',
          sub: DIAS_PRODUCAO + ' de produção + '
             + (menor === maior ? menor : menor + ' a ' + maior) + ' de envio, para '
             + (estimado ? 'a região de ' : '') + cidade + ', ' + uf
        });

        listaEl.innerHTML = rates.map(function (r) {
          var gratis = !(parseFloat(r.price) > 0);
          var dd = r.delivery_days || [];
          var transito = dd.length ? dd[dd.length - 1] : null;
          /* "após a produção" em cada linha: sem isso, "4 dias úteis" solto ao
             lado de um preço é lido como prazo total. */
          var prazo = transito
            ? transito + (transito > 1 ? ' dias úteis' : ' dia útil') + ' após a produção'
            : '';
          var nome = r.presentment_name || r.name;
          return '<div class="rd-fech__taxa' + (gratis ? ' rd-fech__taxa--gratis' : '') + '">'
               + '<span class="rd-fech__taxa-txt">'
               + '<span class="rd-fech__taxa-nome">' + esc(nome) + '</span>'
               + '<span class="rd-fech__taxa-prazo">' + esc(prazo) + '</span>'
               + '</span>'
               + '<span class="rd-fech__taxa-preco">' + esc(moeda(r.price)) + '</span>'
               + '</div>';
        }).join('');
        listaEl.hidden = false;

        notaEl.textContent = ultimoEscopo === 'carrinho'
          ? 'Estimativa para o seu carrinho atual. O prazo e o frete podem variar conforme a quantidade. Para o cálculo final, siga até o checkout.'
          : 'Estimativa para 1 item. O prazo e o frete podem variar conforme a quantidade. Para o cálculo final, siga até o checkout.';
        notaEl.hidden = false;
      }

      /* 31/jul — SENHA DE CHAMADA (restaurada). Cada consulta tira um número;
         quando volta, só escreve na tela se ainda for a vez dela. Sem isso, uma
         consulta antiga terminando depois de um reset escrevia o erro dela numa
         faixa já limpa — era a origem do "Não deu para consultar agora" que
         aparecia do nada ao trocar de tamanho.
         A declaração caiu junto numa reescrita do `pinta()`, e o bloco inteiro
         passou a estourar `ReferenceError: senha is not defined` no primeiro
         clique — a cotação não saía do lugar. */
      var senha = 0;
      /* 31/jul — SAÍDA DE ERRO ÚNICA. `carregando(false)` só tirava a classe do
         BOTÃO, mas a roda é acionada por `is-loading` no CAMPO — quem põe é
         `estado('carregando')`, e ninguém tirava. Com CEP inválido a mensagem
         aparecia e a roda continuava girando para sempre, ao lado de uma
         manchete com o resultado da consulta anterior e um subtítulo dizendo
         "Calculando o envio para…".
         Aqui o carregamento é desligado de fato e a manchete volta ao que era
         antes da tentativa: a última cotação boa, se houver, ou o texto de
         produção. A mensagem de erro fica na linha de apoio, que é o lugar dela. */
      function erroConsulta(msg) {
        /* 31/jul — a roda tem DUAS origens: `is-loading` no campo (regra da v2)
           e no botão (regra da v1, que ficou no arquivo). Tirar só uma deixava
           o spinner girando para sempre ao lado de "CEP não encontrado".
           `carregando(false)` cobre o botão; a linha abaixo, o campo. */
        carregando(false);
        campoEl.classList.remove('is-loading');
        esqEl.hidden = true;
        okEl.disabled = false;
        if (ultimoCotado) {
          mTxEl.textContent = ultimoCotado.titulo;
          mSubEl.textContent = ultimoCotado.sub;
        } else {
          var m = mancheteInicial();
          mTxEl.textContent = m.titulo;
          mSubEl.textContent = m.sub;
        }
        /* 31/jul — o erro carrega a saída junto. "CEP não encontrado" sozinho é
           um beco: a pessoa não sabe se digitou errado ou se o CEP não existe,
           e o link do cabeçalho está escondido justamente porque o campo tem
           texto. Aqui ele reaparece colado na mensagem, que é onde o olho está.
           Só no caso de CEP inválido — em falha de rede o buscador dos Correios
           não ajuda em nada. */
        if (/não encontrado/.test(msg)) {
          subEl.innerHTML = esc(msg) + ' · <a class="rd-fech__sublink" '
            + 'href="https://buscacepinter.correios.com.br/app/endereco/index.php" '
            + 'target="_blank" rel="noopener noreferrer">consulte seu CEP</a>';
        } else {
          subEl.textContent = msg;
        }
      }
      function consulta() {
        var minhaSenha = ++senha;
        function minhaVez() { return minhaSenha === senha; }
        var v = campo.value.replace(/\D/g, '');
        if (v.length !== 8) {
          listaEl.hidden = true;
          carregando(false, 'CEP incompleto — faltam ' + (8 - v.length) + ' dígito' + (8 - v.length > 1 ? 's' : ''));
          return;
        }
        listaEl.hidden = true;
        notaEl.hidden = true;
        /* 30/jul — sem "Consultando"/"Calculando frete" na linha de apoio. A roda
           no botão já diz que algo está acontecendo, e trocar o texto por um
           aviso de espera apagava a informação de produção para colocar no lugar
           uma frase que não acrescenta nada. A linha fica como está e o resultado
           entra por cima quando chega. */
        carregando(true);
        estado('carregando', {sub: 'Calculando o envio para ' + campo.value});
        /* o ViaCEP continua no fluxo por dois motivos: valida o CEP (o endpoint
           do Shopify cota CEP inexistente sem reclamar) e dá a UF, que a cotação
           exige — sem `province` a resposta é 422. */
        fetch('https://viacep.com.br/ws/' + v + '/json/').then(function (r) { return r.json(); }).then(function (d) {
          if (!minhaVez()) return;
          if (d.erro) { erroConsulta('CEP não encontrado'); return; }
          carregando(true);
          return comItemEmprestado(function () { return taxas(v, d.uf); })
            .then(function (rates) { if (minhaVez()) pinta(d.localidade, d.uf, rates, false); });
        }).catch(function () {
          if (minhaVez()) erroConsulta('Não deu para consultar agora');
        });
      }

      /* 30/jul — PALPITE PELA CONEXÃO, para a faixa não nascer muda.
         ipwho.is devolve `region_code` (a UF que a cotação exige) e um CEP
         representativo da região, com CORS liberado. Acerta o estado com folga
         no Brasil; a cidade erra em rede móvel e VPN, e por isso o texto diz
         "estimativa" e pede o CEP.
         REGRA DURA: o palpite NUNCA empresta o carrinho. Ele só cota se já
         houver item lá — ver o comentário do `EMPRESTAR_CARRINHO` abaixo sobre
         por que um add.js automático seria caro. Com carrinho vazio ele apenas
         reconhece a região, que já é melhor que uma faixa vazia. */
      function palpiteRegional() {
        if (campo.value) return;
        fetch('https://ipwho.is/')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || d.country_code !== 'BR' || !d.region_code) return;
            var cidade = d.city || d.region, uf = d.region_code;
            var cep = String(d.postal || '').replace(/\D/g, '');
            if (campo.value) return;
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (!cart.item_count || cep.length !== 8) {
                  /* 30/jul — a cidade NÃO aparece mais aqui. Dizer "Sao Paulo,
                     SP" para quem não digitou nada é constrangedor (a pessoa não
                     contou onde mora) e não adiantava nada: sem CEP não há
                     cotação, e o palpite pelo IP erra cidade em rede móvel e VPN.
                     Sobra o pedido do CEP, que é o que ela precisa fazer. */
                  subEl.textContent = textoIdle();
                  return;
                }
                return taxas(cep, uf).then(function (rates) {
                  if (campo.value) return;
                  pinta(cidade, uf, rates, true);
                });
              });
          })
          .catch(function () {});
      }
      if (window.requestIdleCallback) requestIdleCallback(palpiteRegional, { timeout: 2500 });
      else setTimeout(palpiteRegional, 1200);
      /* 31/jul — LIMPAR RECOLHE TUDO. Não é apagar o texto do campo: é devolver
         o bloco ao estado original — sem cotação, sem manchete de entrega, com
         o link de volta no cabeçalho. Limpar só o input deixava o resultado
         antigo na tela ao lado de um campo vazio, o que é pior que não limpar:
         o número na tela deixa de corresponder a qualquer CEP. */
      function limpar() {
        /* queima a senha: qualquer consulta no ar deixa de ter direito à tela */
        senha++;
        ultimoCotado = null;
        campo.value = '';
        listaEl.hidden = true;
        carregando(false, '');
        campoEl.classList.remove('is-loading', 'is-editing');
        estado('inicial', mancheteInicial());
        subEl.textContent = '';
        if (nseiEl) nseiEl.hidden = false;
        campo.focus();
      }

      /* 31/jul — clicar no CEP reabre o campo já preenchido: é troca de
         endereço, não digitação do zero. O "cancelar" existe para quem clicou
         sem querer — sem ele a pessoa fica presa no modo edição, com o
         resultado anterior fora da tela. */
      /* limpar esvazia o CAMPO, não o resultado: quem apaga o CEP quer digitar
         outro, e o número anterior continua útil como referência até o novo
         chegar. */

      var ultimoCotado = null;
      chipEl.addEventListener('click', function () {
        ultimoCotado = {cep: chipEl.textContent, titulo: mTxEl.textContent, sub: mSubEl.textContent};
        estado('editando');
        campo.focus();
        campo.setSelectionRange(campo.value.length, campo.value.length);
      });

      /* 30/jul — TROCOU DE MOLDURA, A COTAÇÃO MORREU. Peso e dimensão mudam com
         a variante, então o preço na tela vira ficção assim que a pessoa troca
         canvas por sem-moldura ou PP por GG — e o rótulo "PRODUÇÃO DO QUADRO"
         ainda por cima passa a mentir se ela escolheu só a impressão.
         Recotar sozinho seria pior: dispararia empréstimo de carrinho a cada
         clique em chip, e chips são clicados muito. Então o resultado se apaga e
         devolve a faixa ao estado inicial, com o CEP preservado — um clique na
         seta traz o número novo. */
      var chipsMoldura = document.querySelectorAll(
        'input[name="Escolha o tipo de moldura"], input[name="Escolha a cor da moldura"], input[name="Escolha o tamanho (cm)"]');
      Array.prototype.forEach.call(chipsMoldura, function (i) {
        i.addEventListener('change', function () {
          pintaProducao();
          if (listaEl.hidden) return;
          var cepAtual = campo.value;
          limpar();
          setCep(cepAtual);
          carregando(false, 'Recalcule o frete para esta opção');
          envioEl.hidden = true;
        });
      });

      ent.querySelector('.rd-fech__ok').addEventListener('click', consulta);
      campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); consulta(); } });

      /* as duas garantias agora moram no trio; a linha separada sai */
      var selos = document.createElement('div');
      selos.hidden = true;
      selos.className = 'rd-fech__selos';
      selos.innerHTML = ''
        + '<svg class="rd-fech__ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 8.5L2 6l2.5-2.5"/><path d="M2 6h9.5a5.5 5.5 0 0 1 0 11H5"/></svg>'
        + '<span>Devolução grátis em 14 dias</span>'
        + '<span class="rd-fech__pt">·</span>'
        + '<svg class="rd-fech__ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.6l2.1 2.3 3.1-.15-.15 3.1L19.4 12l-2.35 2.1.15 3.1-3.1-.15L12 19.4l-2.1-2.35-3.1.15.15-3.1L4.6 12l2.35-2.1-.15-3.1 3.1.15z"/><path d="M9.2 12.1l1.9 1.9 3.7-3.9"/></svg>'
        + '<span>Garantia de 2 anos</span>';
      ent.parentNode.insertBefore(selos, ent.nextSibling);

      trust.hidden = true;
    })();

    var flagsBox = trust.querySelector('.rd-trust__badges');
    var cssLink = document.querySelector('link[href*="redesign-pdp"]') || document.querySelector('link[href*="jun26"]');
    if (flagsBox && cssLink) {
      var assetBase = cssLink.href.replace(/[^\/]+\.css.*$/, '');

      ['pix-pb', 'visa', 'master', 'elo'].forEach(function (m) {
        var im = document.createElement('img');
        im.className = 'rd-trust__flag';
        im.src = assetBase + 'obrah-pagamento-' + m + '.svg';
        im.alt = '';
        im.loading = 'lazy';
        flagsBox.appendChild(im);
      });

      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'rd-trust__flag rd-trust__flag--more';
      plusBtn.setAttribute('aria-label', 'Ver todas as formas de pagamento');
      plusBtn.textContent = '+\u20097';
      flagsBox.appendChild(plusBtn);
      var payDrawer = document.createElement('div');
      payDrawer.id = 'RD-Pay-Drawer';
      payDrawer.className = 'side-panel rd-pay-drawer';
      function payFlags(list) {
        return '<div class="rd-pay__flags">' + list.map(function (m) {
          return '<img class="rd-trust__flag" src="' + assetBase + 'obrah-pagamento-' + m + '.svg" alt="" loading="lazy">';
        }).join('') + '</div>';
      }
      payDrawer.innerHTML = ''
        + '<div class="side-panel-inner">'
        + '<div class="side-panel-header"><div>'
        + '<h4 class="body-font">Formas de pagamento</h4>'
        + '<side-panel-close class="side-panel-close">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
        + '</side-panel-close>'
        + '</div></div>'
        + '<div class="side-panel-content"><div class="rd-pay">'
        + '<div class="rd-pay__sec"><div class="rd-pay__t">Cartão de crédito</div>' + payFlags(['visa', 'master', 'elo', 'amex', 'hipercard', 'diners', 'discover', 'jcb'])
        + '<p class="rd-pay__s">Em até 3x sem juros — ou em até 12x. Aceitamos Visa, Mastercard, Elo, American Express, Hipercard, Diners, Discover e JCB.</p></div>'
        + '<div class="rd-pay__sec"><div class="rd-pay__t">PIX</div>' + payFlags(['pix'])
        + '<p class="rd-pay__s">10% de desconto e aprovação na hora.</p></div>'
        + '<div class="rd-pay__sec"><div class="rd-pay__t">Boleto</div>' + payFlags(['boleto'])
        + '<p class="rd-pay__s">À vista, com compensação em até 3 dias úteis.</p></div>'
        + '<div class="rd-pay__sec"><div class="rd-pay__t">Faturado para empresas</div>'
        + '<p class="rd-pay__s">Compras com CNPJ podem ser faturadas — fale com a nossa equipe pelo WhatsApp.</p></div>'
        + '</div></div>'
        + '</div>';
      document.body.appendChild(payDrawer);
      plusBtn.addEventListener('click', function () {
        document.body.classList.add('open-cc');
        payDrawer.classList.add('active');
      });
    }

    var devLink = trust.querySelector('.rd-trust__row--devolucao .rd-trust__side');
    if (devLink) devLink.addEventListener('click', function (e) {
      if (root._openPolicyDrawer) root._openPolicyDrawer(e);
    });

    function updateTrustReturn() {
      var row = trust.querySelector('.rd-trust__row--devolucao');
      if (!row || !root._noReturnSizes) return;
      var s = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
      var key = s ? String(s.value).replace(/\s/g, '').toLowerCase() : '';
      var noRet = !!root._noReturnSizes[key];
      row.style.display = noRet ? 'none' : '';
      if (root._miniTrustUpdate) root._miniTrustUpdate(noRet);
    }
    updateTrustReturn();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) updateTrustReturn();
    });

    function updateQuinaThumbs() {
      var link = document.querySelector('link[href*="redesign-pdp"]') || document.querySelector('link[href*="jun26"]');
      if (!link) return;
      var base = link.href.replace(/[^\/]+\.css.*$/, '');
      var sw = root.querySelector('.jun26-swatch--active');
      var slug = sw ? String(sw.dataset.value || '').toLowerCase().trim().replace(/\s+/g, '-') : 'preta';
      if (!/^(branca|preta|madeira-clara|madeira-escura)$/.test(slug)) slug = 'preta';
      [
        { mod: 'paspatur', file: 'obrah-paspatur-quina-' },
        { mod: 'profundidade', file: 'obrah-moldura-caixa-quina-' }
      ].forEach(function (q) {
        var ico = root.querySelector('.jun26-extras-flat .jun26-mod--' + q.mod + ' .jun26-mod-ico');
        if (!ico) return;
        var src = base + q.file + slug + '.png?v=4';
        var img = ico.querySelector('img.rd-mod-quina');
        if (!img) {
          ico.innerHTML = '';
          img = document.createElement('img');
          img.className = 'rd-mod-quina';
          img.alt = '';
          img.loading = 'lazy';
          ico.appendChild(img);
        }
        if (img.getAttribute('src') !== src) img.src = src;
      });
    }
    updateQuinaThumbs();

    document.addEventListener('change', function () { setTimeout(updateQuinaThumbs, 400); });

    var buyCardMini = root.querySelector('.jun26-card-buy');
    var buyPriceMini = buyCardMini && buyCardMini.querySelector('.jun26-buy-price');
    var buyPixMini = buyCardMini && buyCardMini.querySelector('.jun26-buy-pix');
    if (buyCardMini && buyPriceMini) {
      var buyTop = el('div', 'rd-buytop');
      var miniStage = el('div', 'rd-buymini');
      var buyRight = el('div', 'rd-buytop__col');
      buyCardMini.insertBefore(buyTop, buyPriceMini);
      buyTop.appendChild(miniStage);
      buyTop.appendChild(buyRight);

      /* ═══ LINHA DA OBRA no sticky de preço (26/jul, mobile) — artista · título ·
         nota entram no bloco de compra SÓ com a página em repouso (no topo). Assim
         que desce, a linha recolhe e sobra a seta de voltar ao início; subiu até o
         começo, ela volta. Mesma linguagem da linha do header (.rd-hd-obra). */
      if (root.classList.contains('thb-product-detail--redesign')) {
        (function buildBuyObra() {
          if (buyCardMini.querySelector('.rd-buyobra')) return;
          var wArtist = root.querySelector('.jun26-wh-artist');
          var wTitle = root.querySelector('.jun26-wh-title');
          var wStars = root.querySelector('.jun26-wh-rating .jun26-wh-stars');
          var wCount = root.querySelector('.jun26-wh-rating .jun26-wh-count');

          var row = el('div', 'rd-buyobra');
          var txt = el('div', 'rd-buyobra__txt');
          var href = wArtist && wArtist.getAttribute ? wArtist.getAttribute('href') : null;
          var nome = href ? document.createElement('a') : document.createElement('b');
          if (href) nome.setAttribute('href', href);
          nome.className = 'rd-buyobra__a';
          nome.textContent = wArtist ? wArtist.textContent.trim() : '';
          var tit = el('span', 'rd-buyobra__t');
          tit.textContent = wTitle ? wTitle.textContent.trim() : '';
          /* 26/jul: empilhado — artista em cima (miúdo), obra embaixo (maior) */
          txt.append(nome, tit);
          var nota = el('span', 'rd-buyobra__r');
          /* 26/jul: a nota vem com a escala — "4,8/5" — e ANCORA nos reviews */
          /* 26/jul: nota com PONTO e escala — "4.8/5" */
          var notaTxt = (wCount ? wCount.textContent.trim() : '').replace(',', '.');
          /* a fonte (workhead) já vem como "4.8/5" — não concatenar de novo */
          if (notaTxt && notaTxt.indexOf('/') < 0) notaTxt += '/5';
          nota.innerHTML = '<span class="jun26-wh-stars">' + (wStars ? wStars.textContent : '★') + '</span>'
            + '<span class="jun26-wh-count">' + notaTxt + '</span>';
          nota.setAttribute('role', 'link');
          nota.setAttribute('tabindex', '0');
          nota.classList.add('rd-buyobra__r--link');
          nota.addEventListener('click', function () {
            var tab = null;
            root.querySelectorAll('.rd-tab').forEach(function (b) { if (/Avalia/.test(b.textContent)) tab = b; });
            if (tab) { tab.click(); tab.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          });

          row.append(txt, nota);
          buyCardMini.insertBefore(row, buyCardMini.firstChild);

          /* SÓ SCROLL (26/jul): sem seta, sem puxador. No topo a gaveta está aberta;
             desceu, ela recolhe; voltou ao início, ela sobe de novo. */
          var obraTick = false;
          function obraUpd() {
            obraTick = false;
            /* "em repouso" = a página está no início (12px de folga pro bounce do iOS) */
            buyCardMini.classList.toggle('rd-obra-on', window.scrollY <= 12);
          }
          window.addEventListener('scroll', function () {
            if (!obraTick) { obraTick = true; requestAnimationFrame(obraUpd); }
          }, { passive: true });
          obraUpd();
        })();
      }
      buyRight.appendChild(buyPriceMini);
      if (buyPixMini) buyRight.appendChild(buyPixMini);
      // SPEC LINE: completa o que a miniatura não mostra (tamanho) —
      // "Canvas · Madeira Clara · 25 × 35 cm". Desktop sempre; mobile só stuck.
      var buySpec = el('div', 'rd-buyspec');
      buyRight.appendChild(buySpec);
      // MESMA técnica do ambientado: border 4 lados com ambShade (quinas em
      // 45° via miter) + cores calibradas AMB_WOOD; canvas = fundo escuro (vão),
      // paspatur = fundo papel. Sem vidro/grão — imperceptíveis nesta escala.
      var MINI_WOOD_SLUG = { 'madeira-escura': 'marrom', 'preta': 'preta', 'madeira-clara': 'clara', 'branca': 'branca' };
      var updateBuyMini = function () {
        var artImg = root.querySelector('.pp26__art');
        var artSrc = artImg && artImg.currentSrc ? artImg.currentSrc : (artImg ? artImg.src : '');
        if (!artSrc) { miniStage.innerHTML = ''; return; }
        var f = root.querySelector('.pp26__frame');
        var t = (f && f.dataset.frameType) || 'padrao';
        var tipo = /sem.?moldura/.test(t) ? 'sem' : (/canvas/.test(t) ? 'canvas' : (/paspatur/.test(t) ? 'paspatur' : 'padrao'));
        var tipo2 = /caixa/.test(t) ? 'caixa' : (/slim/.test(t) ? 'slim' : tipo);
        var sw = root.querySelector('.jun26-swatch--active');
        var slug = sw ? String(sw.dataset.value || '').toLowerCase().trim().replace(/\s+/g, '-') : 'preta';
        var wood = AMB_WOOD[MINI_WOOD_SLUG[slug] || 'marrom'];
        /* 28/jul: a mini deixa de ser reescrita por innerHTML a cada troca.
           Nó novo não anima — ele aparece pronto, e era isso que dava o salto
           seco ao mudar de moldura ou de tamanho. Reaproveitando os mesmos
           elementos, tudo que muda (espessura e cor da face, fundo, respiro da
           arte) vira propriedade transicionável, e a moldura se transforma à
           vista, na mesma curva do palco. O src só é reescrito quando a arte
           realmente muda, senão a imagem recarrega e pisca. */
        var q = miniStage.querySelector('.rd-buymini__q');
        var mi = miniStage.querySelector('.rd-buymini__art');
        if (!q || !mi) {
          miniStage.innerHTML = '<div class="rd-buymini__q"><img class="rd-buymini__art" alt="" loading="lazy" draggable="false"></div>';
          q = miniStage.querySelector('.rd-buymini__q');
          mi = miniStage.querySelector('.rd-buymini__art');
        }
        if (mi.getAttribute('src') !== artSrc) mi.setAttribute('src', artSrc);
        if (tipo === 'sem') {
          q.classList.add('rd-buymini__q--sem');
          q.removeAttribute('style');
          mi.removeAttribute('style');
          atualizaSpec('sem', slug);
          return;
        }
        q.classList.remove('rd-buymini__q--sem');
        // ESCALA FÍSICA — MESMA régua do mini do carrinho (cart-drawer.liquid):
        // ppc = 58/largura-cm, face 2/0.85cm, clamps idênticos → minis iguais.
        var rSel = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
        var dims = rSel ? String(rSel.value).toLowerCase().split('x') : ['25', '35'];
        var wcm = parseFloat(dims[0]) || 25, hcm = parseFloat(dims[1]) || 35;
        var ppc = 58 / wcm;
        function pxc(cm, mn, mx) { return Math.max(mn, Math.min(mx, cm * ppc)).toFixed(1); }
        var fw = pxc(tipo === 'canvas' ? 0.85 : 2, 2, 5.5);   // piso 2px: a face não some no mini (6/jul)
        var bordas = 'border-style:solid;border-width:' + fw + 'px;'
          + 'border-top-color:' + ambShade(wood, 0) + ';'
          + 'border-left-color:' + ambShade(wood, -3) + ';'
          + 'border-right-color:' + ambShade(wood, -11) + ';'
          + 'border-bottom-color:' + ambShade(wood, -16) + ';';
        var fundo = tipo === 'canvas' ? 'background:#0c0b0a;' : (tipo === 'paspatur' ? 'background:#F9F8F4;' : '');
        /* 28/jul: o respiro (vão do canvas, paspatur) somava POR FORA — a arte
           mantinha o tamanho e a moldura crescia. Com paspatur em peça pequena
           isso dava 85,8×109 dentro de uma caixa de 60×86: a mini atravessava o
           preço em cima e o botão embaixo.
           Agora quem cede é a ARTE: o teto dela desconta o respiro e a face, de
           modo que o conjunto SEMPRE caiba na mesma caixa. Assim a mini com
           paspatur tem o mesmo tamanho externo das outras — muda a proporção
           entre arte e moldura, que é justamente o que o paspatur faz na peça
           real. */
        var mm = tipo === 'canvas' ? parseFloat(pxc(1, 0.75, 4)) : (tipo === 'paspatur' ? parseFloat(pxc(5, 2, 11)) : 0);
        var mArt = mm ? 'margin:' + mm.toFixed(1) + 'px;' : '';
        var boxW = miniStage.clientWidth || 60, boxH = miniStage.clientHeight || 86;
        var faceN = parseFloat(fw);
        mArt += 'max-width:' + Math.max(10, boxW - 2 * mm - 2 * faceN).toFixed(1) + 'px;'
             +  'max-height:' + Math.max(10, boxH - 2 * mm - 2 * faceN).toFixed(1) + 'px;';
        q.style.cssText = bordas + fundo;
        mi.style.cssText = mArt;
        atualizaSpec(tipo2, slug);
      };
      var MINI_TIPO_LABEL = { canvas: 'Canvas', padrao: 'Padrão', paspatur: 'Padrão Paspatur', caixa: 'Caixa', slim: 'Slim', sem: 'Sem moldura' };
      function atualizaSpec(tipoLbl, slug) {
        var cor = slug.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        // tamanho da ARTE (= SKU): é o que aparece no carrinho/checkout —
        // usar o final aqui confundiria na conferência (decisão)
        var r = root.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
        var tam = r ? String(r.value).replace(/\s*x\s*/i, ' \u00D7 ') + ' cm' : '';
        var partes = [MINI_TIPO_LABEL[tipoLbl] || ''];
        if (tipoLbl !== 'sem') partes.push(cor);
        if (tam) partes.push(tam);
        buySpec.textContent = partes.filter(Boolean).join(' \u00B7 ');
      }
      updateBuyMini();
      document.addEventListener('change', function () { setTimeout(updateBuyMini, 450); });
    }

    var _now = new Date();
    var _dia = _now.getDay();
    var _online = (_dia >= 1 && _dia <= 5 && _now.getHours() >= 10 && _now.getHours() < 18);

    /* 25/jul: SÓ "online" + bolinha verde depois, sem pulso — dias/horários saíram de vez */
    var _statusTxt = 'online<span class="rd-cons__on" aria-hidden="true"></span>';
    var cons = el('div', 'rd-consultor');
    if (!_online) cons.classList.add('rd-consultor--offline');
    cons.innerHTML =
      '<div class="rd-cons__avatars"><span class="rd-cons__av rd-cons__av--a">RF</span><span class="rd-cons__av rd-cons__av--b">NX</span><span class="rd-cons__dot" aria-hidden="true"></span></div>'
      + '<div class="rd-cons__txt"><div class="rd-cons__t">Fale com um\u00A0consultor</div><div class="rd-cons__s">' + _statusTxt + '</div></div>'
      + '<a class="rd-cons__btn" target="_blank" rel="noopener noreferrer" aria-label="Falar no WhatsApp" href="https://api.whatsapp.com/send/?phone=5511911292673&text=Consultoria+de+quadros"><svg class="rd-cons__wa" width="24" height="24" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/></svg><span class="rd-cons__btlbl">Enviar WhatsApp</span></a>';

    try {
      var mqTabs = window.matchMedia('(max-width: 959px)');
      var rdTabsEl = document.querySelector('.rd-tabs');
      var infoEl = document.querySelector('.pp26-product-grid__info');
      var tabsHome = rdTabsEl ? rdTabsEl.parentElement : null;

      var madEl = document.querySelector('.rd-madeline');
      var madHome = madEl ? { parent: madEl.parentElement, next: madEl.nextSibling } : null;
      var cfgEl = document.querySelector('.jun26-card-config');

      var ratingEl = document.querySelector('.jun26-wh-rating');
      var ratingHome = ratingEl ? { parent: ratingEl.parentElement, next: ratingEl.nextSibling } : null;
      var backRowEl = document.querySelector('.rd-backrow');
      function placeTabs() {
        if (mqTabs.matches) {
          if (rdTabsEl && infoEl) infoEl.appendChild(rdTabsEl);
          if (madEl && cfgEl && cfgEl.parentElement) cfgEl.parentElement.insertBefore(madEl, cfgEl);
          if (ratingEl && backRowEl && ratingEl.parentElement !== backRowEl) backRowEl.appendChild(ratingEl);
        } else {
          if (rdTabsEl && tabsHome && rdTabsEl.parentElement !== tabsHome) tabsHome.appendChild(rdTabsEl);
          if (madEl) {
            var whDesk = document.querySelector('.jun26-workhead');
            if (whDesk && whDesk.parentNode) whDesk.parentNode.insertBefore(madEl, whDesk.nextSibling);
          }
          if (ratingEl && ratingHome && ratingEl.parentElement !== ratingHome.parent) ratingHome.parent.insertBefore(ratingEl, ratingHome.next);
        }
      }
      placeTabs();
      if (mqTabs.addEventListener) mqTabs.addEventListener('change', placeTabs);
    } catch (e) {}

    var consLink = cons.querySelector('.rd-cons__btn');
    cons.style.cursor = 'pointer';
    cons.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      if (consLink) window.open(consLink.href, '_blank', 'noopener');
    });
    info.appendChild(cons);
  }

  function setupAmbientado(root) {
    var slide = root.querySelector('.pp26__slide--perspective');
    if (!slide || root.querySelector('.jun26-amb')) return;

    var mediaCol = root.querySelector('.pp26-product-grid__media') || slide;

    try {
      var envEl = document.querySelector('.jun26-amb-envs');
      if (envEl) {
        var fromTheme = JSON.parse(envEl.textContent);
        if (fromTheme && fromTheme.length) AMB_ENVS = fromTheme;
      }
    } catch (e) {  }

    var ambeditOn = /[?&]ambedit/.test(location.search) && root.dataset.ambedit !== 'false';
    AMB_ENVS.forEach(function (env) {
      if (ambeditOn) {
        try {
          var sv = JSON.parse(localStorage.getItem('jun26_amb_cal_' + env.id) || 'null');
          if (sv && sv.pxPerCm) env.cal = sv;
        } catch (e) {  }
        try {
          var sf = JSON.parse(localStorage.getItem('jun26_amb_fx_' + env.id) || 'null');
          if (sf && sf.brilho != null) env.fx = sf;
        } catch (e) {  }
        try {
          var snt = JSON.parse(localStorage.getItem('jun26_amb_nt_' + env.id) || 'null');
          if (snt && snt.length != null) env.noTouch = snt;
        } catch (e) {  }
        try {
          var sl = JSON.parse(localStorage.getItem('jun26_amb_lines_' + env.id) || 'null');
          if (sl) { if (sl.furnitureY != null) env.furnitureY = sl.furnitureY; if (sl.ceilY != null) env.ceilY = sl.ceilY; }
        } catch (e) {  }
      }
      if (!env.fx) env.fx = Object.assign({}, AMB_FX_DEF);
      if (!env.noTouch) env.noTouch = [];
    });

    if (ambeditOn) {
      try {
        var sw = JSON.parse(localStorage.getItem('jun26_amb_wood') || 'null');
        if (sw) Object.keys(sw).forEach(function (k) { if (AMB_WOOD[k]) AMB_WOOD[k] = sw[k]; });
      } catch (e) {  }
      try {
        var sto = parseFloat(localStorage.getItem('jun26_amb_tex'));
        if (!isNaN(sto)) AMB_TEX_OP = sto;
      } catch (e) {  }
    }
    var curEnv = AMB_ENVS[0];

    var cssLink = document.querySelector('link[href*="jun26"]');
    var base = cssLink ? cssLink.href.replace(/jun26[^\/]*\.css.*$/, '') : '';

    var ver = '';
    if (cssLink) { var vm = cssLink.href.match(/[?&]v=([^&]+)/); if (vm) ver = '?v=' + vm[1]; }

    function envSrc(env) { return env.assetUrl || (base + env.asset + ver); }

    var amb = document.createElement('div');
    amb.className = 'jun26-amb';
    var photo = document.createElement('img');
    photo.className = 'jun26-amb-photo';
    photo.src = envSrc(curEnv);

    function applyPhotoFilter() { photo.style.filter = ambPhotoFilter(curEnv.fx); }
    applyPhotoFilter();

    var navSampler = new Image();
    navSampler.crossOrigin = 'anonymous';
    function setNavContrast(which) {
      root.classList.toggle('jun26-nav-dark', which === 'dark');
      root.classList.toggle('jun26-nav-light', which === 'light');
    }
    function sampleNavBrightness() {
      try {
        var img = navSampler;
        if (!img.naturalWidth) { setNavContrast('light'); return; }
        var iw = img.naturalWidth, ih = img.naturalHeight;
        var cw = mediaCol.clientWidth || 1, ch = mediaCol.clientHeight || 1;
        var cal = curEnv.cal || {};
        var fx = cal.focalX != null ? cal.focalX : 0.5;
        var fy = cal.focalY != null ? cal.focalY : 0.5;

        var s = Math.max(cw / iw, ch / ih);
        var ox = (cw - iw * s) * fx, oy = (ch - ih * s) * fy;
        var navH = 100, navW = cw * 0.6;
        var sx = Math.max(0, (0 - ox) / s);
        var sy = Math.max(0, (0 - oy) / s);
        var sw = Math.min(iw - sx, (navW - ox) / s - sx);
        var sh = Math.min(ih - sy, (navH - oy) / s - sy);
        if (sw < 1 || sh < 1) { setNavContrast('light'); return; }
        var c = document.createElement('canvas'), W = 32, H = 10;
        c.width = W; c.height = H;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);
        var d = ctx.getImageData(0, 0, W, H).data, sum = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; n++; }
        var lum = sum / n;

        if (curEnv.fx && curEnv.fx.brilho) lum *= curEnv.fx.brilho / 100;
        setNavContrast(lum > 150 ? 'dark' : 'light');
      } catch (e) { setNavContrast('light'); }
    }
    /* 26/jul: no AMBIENTADO a faixa do topo (Dynamic Island) pega a cor da própria
       foto — amostra a média do alto da imagem e escreve em data-topcolor no <html>;
       o script global do obrah-foundation respeita esse valor. No quadro o atributo
       sai e o global volta a ler a superfície do palco (o bege). */
    var amostrador = new Image();
    amostrador.crossOrigin = 'anonymous';
    function corDoTopoDaFoto() {
      try {
        var img = amostrador;
        if (!img.naturalWidth) return null;
        var c = document.createElement('canvas'), W = 24, H = 6;
        c.width = W; c.height = H;
        var ctx = c.getContext('2d');
        /* faixa do alto da foto, na largura toda */
        ctx.drawImage(img, 0, 0, img.naturalWidth, Math.max(1, Math.round(img.naturalHeight * 0.06)), 0, 0, W, H);
        var d = ctx.getImageData(0, 0, W, H).data, r = 0, g = 0, b = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
        return 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
      } catch (e) { return null; }
    }
    function aplicaCorDoTopo() {
      if (!mediaCol.classList.contains('jun26-amb-on')) {
        document.documentElement.removeAttribute('data-topcolor');
        return;
      }
      var src = envSrc(curEnv);
      if (amostrador.getAttribute('src') !== src) {
        amostrador.onload = function () {
          var cor = corDoTopoDaFoto();
          if (cor && mediaCol.classList.contains('jun26-amb-on')) document.documentElement.setAttribute('data-topcolor', cor);
        };
        amostrador.src = src;
        return;
      }
      var cor = corDoTopoDaFoto();
      if (cor) document.documentElement.setAttribute('data-topcolor', cor);
    }

    function updateNavContrast() {

      setNavContrast(mediaCol.classList.contains('jun26-amb-on') ? 'light' : 'dark');
      aplicaCorDoTopo();
    }
    void sampleNavBrightness;
    setNavContrast('dark');
    photo.alt = '';
    photo.draggable = false;

    var quadro = document.createElement('div');
    quadro.className = 'jun26-amb-quadro';
    var wood = document.createElement('div');
    wood.className = 'jun26-amb-wood';
    var artwin = document.createElement('div');
    artwin.className = 'jun26-amb-artwin';
    var art = document.createElement('img');
    art.className = 'jun26-amb-art';
    art.alt = '';
    art.draggable = false;

    var glass = document.createElement('div');
    glass.className = 'jun26-amb-glass';

    var grain = document.createElement('div');
    grain.className = 'jun26-amb-grain';

    var tex = document.createElement('div');
    tex.className = 'jun26-amb-tex';

    var vao = document.createElement('div');
    vao.className = 'jun26-amb-vao';

    var cast = document.createElement('div');
    cast.className = 'jun26-amb-cast';
    artwin.appendChild(art);
    artwin.appendChild(tex);
    artwin.appendChild(vao);
    quadro.appendChild(cast);
    quadro.appendChild(wood);
    quadro.appendChild(grain);
    quadro.appendChild(artwin);
    quadro.appendChild(glass);
    amb.appendChild(photo);
    amb.appendChild(quadro);
    mediaCol.appendChild(amb);

    /* ═══ SEGUNDA CAMADA (26/jul) — a que ENTRA deslizando no slider do palco.
       É um clone do DOM da camada principal, então herda todo o CSS da moldura
       de graça. Pra desenhá-la, renderInto() aponta os ponteiros do motor
       (amb/photo/quadro/...) e o curEnv pro clone, chama o MESMO layout() e
       devolve tudo no lugar — assim o cômodo que entra sai idêntico ao que
       sairia se ele fosse o principal, com a espessura de moldura certa
       (cada ambiente tem sua própria escala em pxPerCm). */
    var peek = null;
    var peeking = false;
    function ensurePeek() {
      if (peek) return peek;
      var node = amb.cloneNode(true);
      node.classList.add('jun26-amb--peek');
      peek = {
        amb: node,
        photo: node.querySelector('.jun26-amb-photo'),
        quadro: node.querySelector('.jun26-amb-quadro'),
        wood: node.querySelector('.jun26-amb-wood'),
        grain: node.querySelector('.jun26-amb-grain'),
        artwin: node.querySelector('.jun26-amb-artwin'),
        art: node.querySelector('.jun26-amb-art'),
        glass: node.querySelector('.jun26-amb-glass'),
        tex: node.querySelector('.jun26-amb-tex'),
        vao: node.querySelector('.jun26-amb-vao'),
        cast: node.querySelector('.jun26-amb-cast')
      };
      mediaCol.appendChild(node);
      return peek;
    }
    function renderInto(env, L) {
      var s0 = amb, s1 = photo, s2 = quadro, s3 = wood, s4 = grain, s5 = artwin,
          s6 = art, s7 = glass, s8 = tex, s9 = vao, s10 = cast, s11 = curEnv;
      amb = L.amb; photo = L.photo; quadro = L.quadro; wood = L.wood; grain = L.grain;
      artwin = L.artwin; art = L.art; glass = L.glass; tex = L.tex; vao = L.vao; cast = L.cast;
      curEnv = env;
      peeking = true;
      try {
        var src = envSrc(env);
        if (photo.getAttribute('src') !== src) photo.src = src;
        photo.style.filter = ambPhotoFilter(env.fx);
        var asrc = getArtSrc();
        if (asrc && art.getAttribute('src') !== asrc) art.src = asrc;
        layout();
      } finally {
        peeking = false;
        amb = s0; photo = s1; quadro = s2; wood = s3; grain = s4; artwin = s5;
        art = s6; glass = s7; tex = s8; vao = s9; cast = s10; curEnv = s11;
      }
    }

    var tg = document.createElement('div');
    tg.className = 'jun26-stage-toggle';

    var isRedesign = root.classList.contains('thb-product-detail--redesign');

    /* 26/jul: no mobile, ao entrar no ambiente o palco sobe pro topo da tela */
    function ambScrollMobile() {
      /* 1/ago — NA PDP 2026 O AMBIENTE ENTRA SEM PUXAR A PÁGINA.
         Lá o ambiente também é chamado por CLICAR NUM TAMANHO, no meio da
         coluna: subir o palco pro topo nesse momento tira da tela justamente o
         controle que a pessoa acabou de tocar, e ela perde o lugar da leitura.
         O ambiente entra atrás, e quem decide olhar rola até ele. */
      if (root.dataset.pdp2026 === 'true') return;
      if (!isRedesign || !window.matchMedia('(max-width: 959px)').matches) return;
      var wh = root.querySelector('.jun26-workhead');
      var y = wh ? (wh.getBoundingClientRect().top + window.scrollY + wh.offsetHeight)
                 : (mediaCol.getBoundingClientRect().top + window.scrollY);
      var target = Math.max(0, Math.round(y));
      if (Math.abs(window.scrollY - target) <= 4) return;
      document.body.classList.add('jun26-progscroll');
      var settled = 0, guard = 0;
      (function waitSettle() {
        var d = Math.abs(window.scrollY - target);
        if (d < 2) settled++; else settled = 0;
        if (settled >= 3 || guard++ > 120) {
          var hdr = document.querySelector('.header.mobile-product-show');
          if (hdr) hdr.classList.remove('mobile-product-show');
          document.body.classList.remove('jun26-progscroll');
          return;
        }
        requestAnimationFrame(waitSettle);
      })();
      window.scrollTo({ top: target, behavior: 'smooth' });
    }

    /* alterna a vista: quadro ⇄ ambiente (o ambiente volta pro cômodo atual).
       No mobile a troca é um SLIDE no trilho (26/jul), não um swap de imagem. */
    function toggleVista(toAmb) {
      if (toAmb) ambScrollMobile();
      /* 26/jul: o botão desliza nas DUAS direções. O crossfade da volta (ambiente →
         quadro) ficou bonito no papel mas engasgava no celular — revelar a vista do
         quadro custa decodificar a arte grande, e o atraso aparecia como abertura
         seca. O slide não paga esse pedágio: as duas camadas já estão pintadas.
         Pra voltar ao crossfade, troque a constante abaixo por 'fade'. */
      if (!toAmb && slVoltaQuadro()) return;
      var alvo = toAmb ? Math.max(1, slTrack().indexOf(curEnv.id)) : 0;
      if (slGo(alvo, SL_MODO_BOTAO)) return;

      /* ═══ EFEITO DE RESERVA (26/jul) ═══
         Se a máquina de duas camadas recusar por qualquer motivo (estado ocupado,
         camada faltando, largura fora da faixa), a troca NÃO pode acontecer seca.
         Aqui a vista que entra desliza sozinha pra dentro do palco — um terço da
         largura, com a mesma curva. Não depende de clone, de decode nem de peek:
         é a própria camada que já está na tela entrando no lugar. */
      setMode(toAmb ? curEnv.id : 'quadro');
      var alvoEl = toAmb ? amb : [ensurePainelQuadro(), (galEl || slide)];
      if (!alvoEl || !SL_MQ.matches) return;
      var desloc = (toAmb ? 1 : -1) * Math.round((mediaCol.clientWidth || 300) * 0.34);
      mediaCol.classList.add('jun26-sl-drag');
      slCada(alvoEl, function (e) {
        e.style.transition = 'none';
        e.style.transform = 'translate3d(' + desloc + 'px, 0, 0)';
        e.style.opacity = '0.02';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slCada(alvoEl, function (e) {
            e.style.transition = 'transform 0.44s ' + SL_CURVA + ', opacity 0.3s ease';
            e.style.transform = 'none';
            e.style.opacity = '1';
          });
          setTimeout(function () {
            slClear(alvoEl);
            mediaCol.classList.remove('jun26-sl-drag');
          }, 480);
        });
      });
    }

    /* 26/jul: REDESIGN — um botão só, no desenho do ADICIONAR (pill em tinta,
       hover invertido). Ele nomeia a AÇÃO, não o estado: "VER AMBIENTE" e, dentro
       do ambiente, "VER QUADRO" pra voltar. Nada de ícones nem de célula ativa.
       Variante clara pra comparar: ?vertog=branco na URL. */
    var verTog = null;
    if (isRedesign) {
      verTog = document.createElement('button');
      verTog.type = 'button';
      verTog.className = 'rd-vertog';
      verTog.dataset.mode = 'vertog';
      /* 26/jul: sem ícone. Em corpo pequeno o desenho virava um bloco ao lado das
         letras e engordava o botão; o rótulo sozinho é mais limpo nas duas vistas. */
      verTog.innerHTML = '<span class="rd-vertog__txt">Ver no ambiente</span>';
      if (/[?&]vertog=branco/.test(location.search)) verTog.classList.add('rd-vertog--branco');
      /* 26/jul: o botão precisa RESPONDER ao dedo. Sem hover (é preto pleno nas duas
         vistas) e sem :active confiável no iOS, o estado de pressão vem por classe:
         encosta = afunda um pouco e a sombra recolhe, como se ele entrasse na tela. */
      var solta = function () { verTog.classList.remove('is-press'); };
      verTog.addEventListener('pointerdown', function () { verTog.classList.add('is-press'); });
      ['pointerup', 'pointercancel', 'pointerleave', 'blur'].forEach(function (ev) {
        verTog.addEventListener(ev, solta);
      });
      verTog.addEventListener('click', function () {
        toggleVista(!mediaCol.classList.contains('jun26-amb-on'));
      });
      tg.appendChild(verTog);
      /* a trava de largura é medida com a fonte real e no padding da largura atual —
         refaz quando a Neuzeit chega e quando muda o breakpoint */
      var reTrava = function () {
        if (!verTog || verTog.classList.contains('is-amb')) return;
        verTog.style.minWidth = '';
        var lw = verTog.getBoundingClientRect().width;
        if (lw > 8) verTog.style.minWidth = Math.ceil(lw) + 'px';
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(reTrava);
      window.addEventListener('resize', reTrava);
    } else {
      [['quadro', 'QUADRO'], ['ambiente', 'AMBIENTE']].forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.mode = m[0];
        b.textContent = m[1];
        if (m[0] === 'quadro') b.classList.add('is-on');
        b.addEventListener('click', function () { toggleVista(m[0] === 'ambiente'); });
        tg.appendChild(b);
      });
    }

    /* ═══════════════════════════════════════════════════════════════════════
       SLIDER DO PALCO (26/jul, mobile) — UM trilho só: o quadro é o slide 0 e
       cada cômodo é um slide na sequência. O dedo arrasta as duas camadas
       (a que sai e a que entra) e solta na mais perto; nada de troca seca de
       imagem. A miniatura ativa é a sinalização de onde você está.
       Desktop (≥960) não entra aqui: lá o palco é um card centralizado com
       transform próprio e a escolha de cômodo segue no dropdown.
       ═══════════════════════════════════════════════════════════════════════ */
    var SL_MQ = window.matchMedia('(max-width: 959px)');
    var slBusy = false;
    /* (4/ago) FILA DE UM LUGAR SÓ, mobile: toque durante um fade não
       interrompe — interrupção era o samba real ("vou indo de um pra outro"):
       cada corte teleportava o quadro principal (medido: 136→207→168, com
       dois quadros visíveis juntos). O toque só atualiza o DESTINO; quando o
       fade conclui, um único fade novo vai direto pro último pedido. */
    var slFila = null;
    var slEmVoo = null;   /* destino da transição em curso — a referência
                             certa pra "vizinho" durante um fade */
    window.__slEsvaziaFila = function () { slFila = null; };
    var galEl = null;
    function slOn() { return isRedesign && SL_MQ.matches; }
    function slTrack() {
      return ['quadro'].concat(AMB_ENVS.map(function (e) { return e.id; }));
    }
    /* 26/jul: a VERDADE é o DOM, não a variável `mode`. Se as duas dessincronizassem
       (transições sobrepostas, setMode vindo de outro caminho), o botão calculava
       from === to, slBegin devolvia null e a volta caía no swap SEM animação — o
       sintoma "dá um segundo e abre seco". Assim ele se auto-corrige. */
    function slIdx() {
      var alvo = mediaCol.classList.contains('jun26-amb-on') ? (curEnv && curEnv.id) : 'quadro';
      var i = slTrack().indexOf(alvo);
      if (i < 0) i = slTrack().indexOf(mode);
      return i < 0 ? 0 : i;
    }
    function slW() { return mediaCol.clientWidth || 1; }
    /* as camadas podem ser um elemento OU uma lista (a vista do quadro viaja como
       painel + galeria, pra ter uma superfície com borda, igual à foto do ambiente) */
    function slCada(el, fn) {
      if (!el) return;
      if (el.length !== undefined && !el.style) { [].forEach.call(el, function (e) { if (e) fn(e); }); }
      else fn(el);
    }
    function slSetX(el, x, tr) {
      slCada(el, function (e) {
        e.style.transition = tr ? 'transform 0.28s cubic-bezier(0.22, 0.61, 0.36, 1)' : 'none';
        e.style.transform = 'translate3d(' + Math.round(x) + 'px, 0, 0)';
      });
    }
    /* CROSSFADE (26/jul): as duas camadas ficam SOBREPOSTAS e trocam por opacidade +
       escala. Nunca passa pelo branco — a que entra já está pintando quando a que sai
       desaparece (regra da casa: crossfade não apaga a tela).
       A que ENTRA usa a receita da entrada dos cards da coleção (rdCardIn): do MAIOR
       pro MENOR, scale 1.05 → 1, 0.8s cubic-bezier(0.22,0.61,0.24,1). A que SAI só
       esvanece, mais rápido, sem escala — ela não deve disputar o movimento. */
    /* 26/jul (v2, "a volta tava dura"): as duas camadas se CRUZAM no mesmo tempo e na
       mesma curva — antes o ambiente apagava em 0,26s e sumia pro bege liso antes de a
       arte chegar, o que lia como corte. Agora o ambiente RECUA (escala pra 1,03 +
       desfoque leve, como quem sai de foco) enquanto a obra vem do maior pro menor e
       assenta. Nenhum instante com a tela vazia. */
    /* modo do BOTÃO ver ambiente/ver quadro: 'slide' (atual) ou 'fade' (crossfade) */
    /* 27/jul — PADRÃO: o quadro PERCORRE até a âncora nova enquanto a parede entra,
       em vez de surgir já posicionado. É o gesto do desktop trazido pro mobile.
       ?troca=off volta ao comportamento anterior (útil pra comparar).
       Pendência conhecida: onde a trava de móvel morde forte (sofá, mesa, cabeceira)
       o percurso ainda hesita, porque layout() reescreve o alvo no meio do caminho.
       A correção é guardar o alvo uma vez — ver o comentário em layout(). */
    /* alvo do percurso em curso: enquanto ele existe, layout() escreve NELE em vez
       de recalcular. É o que tira a hesitação — sem isso cada chamada de layout
       durante a transição (load da foto, assentamento, palcoRente) recalculava as
       travas de teto/móvel e reiniciava a animação rumo a um destino um pouco
       diferente. Travar a escrita não serve: congela a moldura na medida antiga. */
    var alvoPercurso = null;
    var trocaC = !/[?&]troca=off/.test(location.search)
      /* (4/ago) só no desktop: o percurso anima left/top/width/height — 
         re-layout a cada frame por 450ms, em cima do deslize da parede. No
         desktop é o gesto bonito; no celular é o orçamento de um quadro
         inteiro queimado em layout. No mobile o quadro chega já posicionado
         na cena, e a parede segue deslizando na composição. */
      && !window.matchMedia('(max-width: 767px)').matches;
    /* (4/ago) o FLIP mobile foi construído e desligado NO MESMO DIA: o
       Rafael pediu o oposto — cada cena chegando JÁ PRONTA, quadro
       renderizado no lugar dela, sem nada se reposicionando na abertura
       ("se eles fossem renderizados antes nas posições respectivas?"). A
       continuidade fica sendo efeito só do desktop; no celular o remédio é
       pré-aquecer as cenas (pdp2026.js) pra chegada ser inteira. */
    var trocaMovel = false;
    if (trocaC) root.classList.add('rd-troca-c');
    /* 27/jul — BANCADA DE FORMATO: ?forma=vertical | horizontal | quadrado
       Força a proporção da obra no palco pra dar pra comparar as três alturas no
       MESMO produto, sem caçar três produtos diferentes. Só muda a GEOMETRIA da
       moldura (que é o que define a altura ocupada) — a arte dentro continua a
       mesma, então não sirva pra julgar a imagem, só a caixa. */
    var formaForcada = (/[?&]forma=(vertical|horizontal|quadrado)/.exec(location.search) || [])[1] || null;
    if (formaForcada) root.classList.add('rd-forma-' + formaForcada);
    var SL_MODO_BOTAO = 'slide';
    /* carimbo pra conferir no aparelho se o JS que rodou é o novo (cache do celular
       segurava a versão com crossfade+blur): no console, window.__obrahSlider */
    window.__obrahSlider = 'slide-v4 26/jul';
    var SL_CURVA = 'cubic-bezier(0.22, 0.61, 0.24, 1)';
    /* SEM BLUR (26/jul, v4): animar `filter: blur()` numa camada com foto em tela
       cheia obriga o navegador a re-rasterizar todo frame — no celular isso trava 1-2s
       e a troca "estoura" no fim, lendo como seca. Só opacidade e transform, que o
       compositor resolve na GPU; o afastamento do ambiente ficou por conta da escala. */
    var SL_FADE_OUT = 'opacity 0.42s ' + SL_CURVA + ', transform 0.52s ' + SL_CURVA;
    /* (4/ago) no celular o dissolve respira mais devagar (0,8s): a troca de
       cena é contemplação, não navegação — pedido do Rafael */
    var SL_FADE_OUT_M = 'opacity 0.28s ' + SL_CURVA;
    var SL_FADE_IN_M = 'opacity 0.42s ' + SL_CURVA;
    /* ABERTURA: a obra não chega junto com a superfície — a parede clara aparece
       primeiro e, um respiro depois (60ms), a peça assenta nela, vindo de cima e de
       fora. É esse compasso que faz ler como abertura, e não como troca de camada. */
    var SL_FADE_IN = 'opacity 0.4s ' + SL_CURVA + ' 0.06s, transform 0.56s ' + SL_CURVA + ' 0.06s';
    var SL_FADE_MS = 640;
    var SL_IN_TF = 'scale(1.06) translateY(12px)';
    var SL_OUT_TF = 'scale(1.06)';   /* o ambiente se afasta — sem desfoque */
    /* (4/ago) no celular o fade é DISSOLVE PURO: os empurrões de escala e
       translateY que dão vida ao fade do desktop, aplicados à cena inteira,
       viravam a moldura "sambando de um lado pro outro" — cada camada
       deslizava um pouco enquanto trocava. Opacidade e mais nada. */
    function slFadePuro() {
      return window.matchMedia('(max-width: 767px)').matches &&
        !!document.querySelector('.thb-product-detail--pdp2026');
    }
    function slSetFade(el, op, tf, tr) {
      slCada(el, function (e) {
        var puro = slFadePuro();
        e.style.transition = tr === 'in' ? (puro ? SL_FADE_IN_M : SL_FADE_IN)
          : (tr === 'out' ? (puro ? SL_FADE_OUT_M : SL_FADE_OUT) : 'none');
        e.style.opacity = String(op);
        e.style.transform = tf || 'none';
      });
    }
    /* 26/jul: a vista do quadro não entra como bloco rígido — o PAINEL (a parede)
       desliza inteiro e a ARTE aparece nele: chega 18% atrasada no eixo X (parallax)
       e materializa por opacidade, como uma moldura nova surgindo na parede. */
    var SL_ARTE_ATRASO = 0.82;
    function slArte(el) {
      if (!el || el.length === undefined || el.style) return null;
      return [].filter.call(el, function (e) { return e && e !== painelQuadro; })[0] || null;
    }
    function slArteEntra(inEl, x, animando) {
      var arte = slArte(inEl);
      if (!arte) return;
      arte.style.transition = animando
        ? 'transform 0.34s cubic-bezier(0.22, 0.61, 0.36, 1), opacity 0.44s cubic-bezier(0.22, 0.61, 0.24, 1) 0.06s'
        : 'none';
      /* (22/ago, 2ª volta) a arte viaja 1:1 COM a parede — o atraso de
         parallax (SL_ARTE_ATRASO) fazia o quadro escorregar dentro da
         superfície e assentar no fim ("ele muda de posicao"). Parede e
         quadro agora são um objeto só. */
      arte.style.transform = 'translate3d(' + Math.round(x) + 'px, 0, 0)';
      /* (22/ago, decisão do dono) a volta entra OPACA, como as trocas entre
         ambientes: o fade de 0,12→1 que acompanhava o dedo (26/jul) lia como
         "camada semitransparente" — o quadro sumia e sobrava um degradê
         ("nao pode"). */
      arte.style.opacity = '1';
    }
    function slClear(el) {
      slCada(el, function (e) {
        e.style.transition = ''; e.style.transform = ''; e.style.opacity = '';
        e.style.filter = ''; e.style.willChange = ''; e.style.zIndex = '';
      });
    }
    function slLayer(idx, incoming) {
      if (idx === 0) {
        var pq = ensurePainelQuadro();
        pq.style.zIndex = '5'; if (galEl) galEl.style.zIndex = '6';
        return [pq, galEl];
      }
      if (!incoming) return amb;
      var p = ensurePeek();
      /* (4/ago) o display liga ANTES de pintar: o layout() mede a foto
         renderizada, e com a camada display:none os rects dão zero — o
         quadro nascia 0×0 e o crossfade ficava só na foto. Ligar aqui é
         síncrono com a preparação de opacidade 0 do fade (mesmo frame),
         então nada pisca. Um repinte tardio no meio da transição foi
         tentado e recuado: reposicionava com a cena já em cena — samba. */
      p.amb.style.display = 'block';
      renderInto(AMB_ENVS[idx - 1], p);
      /* (22/ago) o repinte-um-frame do fade (4/ago) vale TAMBÉM pro arrasto:
         sem ele, quando a foto ainda não tinha reportado dimensões, o quadro
         do clone nascia 0×0 e ficava invisível o gesto inteiro — "o quadro
         some" até o assentamento. E se a foto só carregar no meio do gesto,
         o load repinta uma vez. A geometria entra seca (transition:none sob
         jun26-sl-drag): sem samba. */
      (function (envIn, L) {
        requestAnimationFrame(function () { try { renderInto(envIn, L); } catch (e) {} });
        var ph = L.photo;
        if (ph && !ph.complete) ph.addEventListener('load', function () {
          try { if (mediaCol.classList.contains('jun26-sl-drag')) renderInto(envIn, L); } catch (e) {}
        }, { once: true });
      })(AMB_ENVS[idx - 1], p);
      return p.amb;
    }
    /* prepara o par de camadas; devolve null se não há pra onde ir (ponta do trilho).
       modo 'slide' = arrasto (manipulação direta); 'fade' = toque no botão, que é
       troca de REGISTRO (sair do quarto real / voltar pra parede da galeria) */
    function slBegin(to, modo, dirForce) {
      var from = slIdx();
      var t = slTrack();
      if (to === from || to < 0 || to >= t.length) return null;
      /* 27/jul: normalmente a direção vem da ordem dos índices. No LAÇO ela é
         imposta: quem aperta a seta pra frente no último cômodo tem que ver a
         cena entrar pela direita, não voltar correndo até o começo — senão o
         movimento contradiz o dedo. */
      var dir = dirForce ? (dirForce > 0 ? 1 : -1) : (to > from ? 1 : -1);
      var st = {
        from: from, to: to, dir: dir, modo: modo === 'fade' ? 'fade' : 'slide',
        outEl: slLayer(from, false),
        inEl: slLayer(to, true)
      };
      if (!st.outEl || !st.inEl) return null;
      mediaCol.classList.add('jun26-sl-drag');
      /* 27/jul — ?troca=c: O QUADRO DESLIZA DENTRO DA PAREDE QUE CHEGA.
         Hoje a camada nova entra com o quadro já no lugar final, então ele
         "surge posicionado". No desktop ele PERCORRE de uma região à outra, e é
         isso que dá o gesto bonito. Aqui a camada nova entra com o quadro na
         âncora ANTIGA e, enquanto ela desliza, ele caminha até a nova — o
         movimento é relativo à parede que o carrega, não à tela. */
      st.trocaC = null;
      if (trocaMovel && st.modo !== 'fade') {
        var qiM = st.inEl.querySelector ? st.inEl.querySelector('.jun26-amb-quadro') : null;
        var qoM = st.outEl.querySelector ? st.outEl.querySelector('.jun26-amb-quadro') : null;
        if (qiM && qoM) {
          var rqo = qoM.getBoundingClientRect(), rqi = qiM.getBoundingClientRect();
          if (rqo.width > 2 && rqi.width > 2) {
            /* o quadro compacto carrega um translateY(-8vh) de CSS; o inline
               substitui o CSS, então o C entra na conta e volta no alvo */
            var cpx = document.querySelector('.thb-product-detail--pdp2026.pdp26-compacto')
              ? -(window.innerHeight * 0.08) : 0;
            qiM.style.transition = 'none';
            qiM.style.transformOrigin = '0 0';
            qiM.style.transform = 'translate(' + (rqo.left - rqi.left).toFixed(1) + 'px,' +
              (rqo.top - rqi.top + cpx).toFixed(1) + 'px) scale(' +
              (rqo.width / rqi.width).toFixed(4) + ',' + (rqo.height / rqi.height).toFixed(4) + ')';
            st.trocaC = { el: qiM, porTransform: true,
              alvoT: cpx ? 'translateY(' + cpx.toFixed(1) + 'px)' : 'none' };
          }
        }
      } else if (trocaC && st.modo !== 'fade') {
        var qi = st.inEl.querySelector ? st.inEl.querySelector('.jun26-amb-quadro') : null;
        var qo = st.outEl.querySelector ? st.outEl.querySelector('.jun26-amb-quadro') : null;
        if (qi && qo) {
          st.trocaC = {
            el: qi,
            alvo: { left: qi.style.left, top: qi.style.top, width: qi.style.width, height: qi.style.height }
          };
          qi.style.transition = 'none';
          qi.style.left = qo.style.left; qi.style.top = qo.style.top;
          qi.style.width = qo.style.width; qi.style.height = qo.style.height;
        }
      }
      /* 26/jul — A CAMADA QUE ENTRA FICA POR CIMA. Era esse o buraco: na ida o
         ambiente entra com z-index 4 e passa por cima do quadro, então você vê a
         superfície chegando; na volta o quadro entrava POR BAIXO (z 2/3) e o
         ambiente cobria tudo até terminar de sair — o olho lia "descobriu o que
         estava embaixo", nunca "chegou". Agora o papel de cima é de quem chega. */
      slCada(st.outEl, function (e) { e.style.zIndex = '3'; });
      slCada(st.inEl, function (e, i) { e.style.zIndex = '5'; });
      if (st.modo === 'fade') {
        /* promove as duas camadas antes de animar: sem isso o primeiro frame paga
           a criação da camada de composição e a troca começa atrasada */
        /* slCada: a camada do QUADRO é um PAR [painel, galeria] — acesso
           direto a .style explodia quando o fade envolvia essa vista (só
           aconteceu quando o mobile passou a usar fade nela, 4/ago) */
        slCada(st.outEl, function (e) { e.style.willChange = 'opacity, transform'; });
        slCada(st.inEl, function (e) { e.style.willChange = 'opacity, transform'; });
        slSetFade(st.outEl, 1, '', false);
        slSetFade(st.inEl, 0, slFadePuro() ? '' : SL_IN_TF, false);
      } else {
        slSetX(st.outEl, 0, false);
        slSetX(st.inEl, dir * slW(), false);
        slArteEntra(st.inEl, dir * slW(), false);
      }
      return st;
    }
    function slDrag(st, dx) {
      /* (22/ago, 2ª volta) a volta pro quadro DESLIZA como as outras trocas
         ("tinha que arrastar ela como nos outros"). A cobertura com o
         ambiente parado viveu uma tarde: era band-aid pro clone 0×0 — com o
         repinte da largada, cada camada carrega o seu quadro e o deslize
         duplo volta a contar certo. */
      slSetX(st.outEl, dx, false);
      slSetX(st.inEl, dx + st.dir * slW(), false);
      slArteEntra(st.inEl, dx + st.dir * slW(), false);
    }
    function slEnd(st, commit) {
      slBusy = true;
      var dur = 290;
      /* o percurso do quadro começa junto com o da parede, com a curva do desktop */
      if (st.trocaC && commit && st.trocaC.porTransform) {
        var tcm = st.trocaC;
        /* dois rAF: o primeiro quadro precisa pintar VESTIDO da geometria
           antiga antes da transição começar, senão o percurso vira salto */
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          tcm.el.style.transition = 'transform 0.45s cubic-bezier(0.22,0.61,0.36,1)';
          tcm.el.style.transform = tcm.alvoT;
          setTimeout(function () {
            tcm.el.style.transition = '';
            tcm.el.style.transform = '';
            tcm.el.style.transformOrigin = '';
          }, 520);
        }); });
      } else if (st.trocaC && commit) {
        var tc = st.trocaC;
        alvoPercurso = { el: tc.el, geo: tc.alvo };
        setTimeout(function () { alvoPercurso = null; }, 560);
        tc.el.style.transition = 'left 0.45s cubic-bezier(0.22,0.61,0.36,1), top 0.45s cubic-bezier(0.22,0.61,0.36,1), width 0.45s cubic-bezier(0.22,0.61,0.36,1), height 0.45s cubic-bezier(0.22,0.61,0.36,1)';
        tc.el.style.left = tc.alvo.left; tc.el.style.top = tc.alvo.top;
        tc.el.style.width = tc.alvo.width; tc.el.style.height = tc.alvo.height;
      } else if (st.trocaC && st.trocaC.porTransform) {
        /* troca cancelada: a camada volta pra fora — o quadro dela larga a
           roupa emprestada na hora, sem animar */
        st.trocaC.el.style.transition = 'none';
        st.trocaC.el.style.transform = '';
        st.trocaC.el.style.transformOrigin = '';
      }
      if (st.modo === 'fade') {
        dur = slFadePuro() ? 850 : SL_FADE_MS;
        if (slFadePuro() && commit) {
          /* (4/ago, o diagnóstico final do samba) FADE-THROUGH, não crossfade:
             no cruzado, duas cenas — e dois quadros em PONTOS DIFERENTES —
             ficam meio-visíveis juntas: dupla exposição, o fantasma que o
             Rafael caçou o dia inteiro ("sambou de novo"; filmado: main a
             136/op .58 SOBRE peek a 207/op .29). Aqui a cena sai POR INTEIRO
             (0,28s), a parede do palco respira um instante, e só então a
             nova entra (0,42s). Duas cenas nunca dividem a tela: dupla
             exposição impossível por construção. */
          slSetFade(st.outEl, 0, '', 'out');
          slSetFade(st.inEl, 0, '', false);
          /* no VÃO (as duas cenas a zero) quem aparecia por baixo era a
             GALERIA da perspectiva — cada clique na barrinha piscava o
             quadro antes do ambiente chegar (4/ago). Entre ambientes ela se
             esconde e o vão respira na parede neutra do palco; volta na
             limpeza. Nas travessias que envolvem o quadro ela é parte, fica. */
          if (st.from !== 0 && st.to !== 0) {
            if (galEl) galEl.style.visibility = 'hidden';
            if (painelQuadro) painelQuadro.style.visibility = 'hidden';
          }
          setTimeout(function () { slSetFade(st.inEl, 1, '', 'in'); }, 310);
        } else {
          slSetFade(st.outEl, commit ? 0 : 1, (commit && !slFadePuro()) ? SL_OUT_TF : '', 'out');
          slSetFade(st.inEl, commit ? 1 : 0, (commit || slFadePuro()) ? '' : SL_IN_TF, 'in');
        }
      } else {
        slSetX(st.outEl, commit ? -st.dir * slW() : 0, true);
        slSetX(st.inEl, commit ? 0 : st.dir * slW(), true);
        slArteEntra(st.inEl, commit ? 0 : st.dir * slW(), true);
      }
      setTimeout(function () {
        /* a camada que entrou fica no lugar cobrindo o palco enquanto a principal
           assume o destino — só então limpamos, pra não piscar no meio da troca */
        if (commit) setMode(st.to === 0 ? 'quadro' : slTrack()[st.to]);
        var feito = false;
        var limpa = function () {
          if (feito) return;
          feito = true;
          /* 26/jul: posiciona a moldura AGORA, com as transições ainda desligadas pela
             classe de arraste — senão o layout final chegava depois e a moldura
             "dançava" da posição do cômodo anterior até a nova. Em seguida a classe de
             acomodação segura a transição por mais uns frames, cobrindo o layout que o
             `load` da foto dispara. */
          try { if (mode !== 'quadro') layout(); } catch (e) {}
          slClear(st.outEl); slClear(st.inEl);
          mediaCol.classList.remove('jun26-sl-drag');
          mediaCol.classList.add('jun26-sl-settle');
          setTimeout(function () { mediaCol.classList.remove('jun26-sl-settle'); }, 320);
          if (galEl) galEl.style.visibility = '';
          if (painelQuadro) painelQuadro.style.visibility = '';
          slBusy = false;
          slEmVoo = null;
          /* fila: o último destino pedido durante o fade parte agora, num
             fade inteiro — nunca um corte */
          if (slFila !== null) {
            var fAlvo = slFila;
            slFila = null;
            if (fAlvo !== slIdx()) setTimeout(function () { slGo(fAlvo); }, 40);
          }
        };
        if (commit && st.to !== 0 && photo.decode) photo.decode().then(limpa, limpa);
        else requestAnimationFrame(function () { requestAnimationFrame(limpa); });
        /* REDE DE SEGURANÇA (26/jul): o decode da foto podia demorar (ou nunca
           resolver, se o src trocasse no meio) e o slBusy ficava preso — aí o toque
           seguinte no VER QUADRO caía no caminho SEM animação, depois de um segundo
           parado. Era exatamente o "dá um segundo e abre seco". */
        setTimeout(limpa, 420);
      }, dur);
    }
    /* ═══════════════════════════════════════════════════════════════════════════
       VOLTA PRO QUADRO — 4 abordagens pra comparar (26/jul). Troque pela URL:
       ?volta=sombra   superfície com sombra na borda de ataque (padrão)
       ?volta=recuo    o ambiente recua e se afasta enquanto a parede entra
       ?volta=cortina  a parede desce de cima; o ambiente fica parado e apaga
       ?volta=zoom     sem deslize: o ambiente se afasta e a moldura assenta
       Todas mantêm o parallax + fade da moldura. Só a VOLTA muda; a ida e o
       arrasto com o dedo seguem iguais.
       ═══════════════════════════════════════════════════════════════════════════ */
    function slVariante() {
      var m = /[?&]volta=(fade|sombra|recuo|cortina|zoom)/.exec(location.search);
      return m ? m[1] : 'fade';
    }
    function slVoltaQuadro() {
      if (!slOn() || !mediaCol.classList.contains('jun26-amb-on')) return false;
      if (slBusy) { slBusy = false; mediaCol.classList.remove('jun26-sl-drag'); slClear(amb); slClear(galEl); }
      var painel = ensurePainelQuadro();
      var arte = galEl;
      var saindo = amb;
      var W = slW();
      var v = slVariante();
      var CURVA = 'cubic-bezier(0.22, 0.61, 0.24, 1)';
      var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
      var ms = 480;
      slBusy = true;
      mediaCol.classList.add('jun26-sl-drag');
      /* quem chega fica por cima (ver nota no slBegin) */
      saindo.style.zIndex = '3';
      painel.style.zIndex = '5';
      arte.style.zIndex = '6';
      painel.style.willChange = 'transform, opacity';
      arte.style.willChange = 'transform, opacity';
      saindo.style.willChange = 'transform, opacity';

      /* ── posição inicial ── */
      var i = { painel: '', arte: '', saindo: '' }, f = { painel: '', arte: '', saindo: '' };
      var opI = { painel: 1, arte: 0.12, saindo: 1 }, opF = { painel: 1, arte: 1, saindo: 0 };
      var trans = {};
      if (v === 'cortina') {
        ms = 520;
        i.painel = 'translate3d(0,-100%,0)'; i.arte = 'translate3d(0,-88%,0)';
        f.painel = 'none'; f.arte = 'none';
        i.saindo = 'none'; f.saindo = 'none';
        opI.saindo = 1; opF.saindo = 0.35;
        trans.painel = 'transform 0.52s ' + EXPO;
        trans.arte = 'transform 0.6s ' + EXPO + ', opacity 0.5s ' + CURVA + ' 0.06s';
        trans.saindo = 'opacity 0.4s ' + CURVA + ' 0.12s';
      } else if (v === 'zoom') {
        ms = 520;
        i.painel = 'none'; i.arte = 'scale(1.04)';
        f.painel = 'none'; f.arte = 'none';
        i.saindo = 'none'; f.saindo = 'scale(1.06)';
        opI.painel = 0; opF.painel = 1;
        trans.painel = 'opacity 0.34s ' + CURVA;
        trans.arte = 'transform 0.5s ' + EXPO + ' 0.06s, opacity 0.42s ' + CURVA + ' 0.06s';
        trans.saindo = 'transform 0.5s ' + CURVA + ', opacity 0.42s ' + CURVA;
      } else if (v === 'recuo') {
        ms = 540;
        i.painel = 'translate3d(' + (-W) + 'px,0,0)'; i.arte = 'translate3d(' + Math.round(-W * 0.82) + 'px,0,0)';
        f.painel = 'none'; f.arte = 'none';
        i.saindo = 'none'; f.saindo = 'translate3d(' + Math.round(W * 0.34) + 'px,0,0) scale(0.92)';
        trans.painel = 'transform 0.5s ' + CURVA;
        trans.arte = 'transform 0.56s ' + CURVA + ', opacity 0.5s ' + CURVA + ' 0.06s';
        trans.saindo = 'transform 0.52s ' + CURVA + ', opacity 0.44s ' + CURVA + ' 0.06s';
      } else if (v === 'fade') {
        /* 26/jul (padrão): NADA corre. Primeiro a superfície aparece por cima do
           ambiente (a parede tomando a cena), e só depois a obra se materializa
           nela. Correr a parede junto com o quadro ficava estranho — dois objetos
           diferentes viajando colados. */
        ms = 620;
        i.painel = 'none'; f.painel = 'none';
        i.arte = 'scale(1.02)'; f.arte = 'none';
        i.saindo = 'none'; f.saindo = 'none';
        opI.painel = 0; opF.painel = 1;
        opI.arte = 0; opF.arte = 1;
        opI.saindo = 1; opF.saindo = 1;   /* o ambiente nem se mexe: é coberto */
        trans.painel = 'opacity 0.34s ' + CURVA;
        trans.arte = 'opacity 0.34s ' + CURVA + ' 0.24s, transform 0.5s ' + EXPO + ' 0.24s';
        trans.saindo = 'none';
      } else {   /* sombra */
        ms = 460;
        i.painel = 'translate3d(' + (-W) + 'px,0,0)'; i.arte = 'translate3d(' + Math.round(-W * 0.82) + 'px,0,0)';
        f.painel = 'none'; f.arte = 'none';
        i.saindo = 'none'; f.saindo = 'translate3d(' + W + 'px,0,0)';
        trans.painel = 'transform 0.42s ' + CURVA + ', box-shadow 0.3s ease 0.14s';
        trans.arte = 'transform 0.46s ' + CURVA + ', opacity 0.44s ' + CURVA + ' 0.04s';
        trans.saindo = 'transform 0.42s ' + CURVA;
        painel.style.boxShadow = '18px 0 44px rgba(20, 18, 14, 0.34)';
      }

      painel.style.transition = 'none'; painel.style.transform = i.painel; painel.style.opacity = String(opI.painel);
      arte.style.transition = 'none'; arte.style.transform = i.arte; arte.style.opacity = String(opI.arte);
      saindo.style.transition = 'none'; saindo.style.transform = i.saindo; saindo.style.opacity = String(opI.saindo);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          painel.style.transition = trans.painel; painel.style.transform = f.painel; painel.style.opacity = String(opF.painel);
          arte.style.transition = trans.arte; arte.style.transform = f.arte; arte.style.opacity = String(opF.arte);
          saindo.style.transition = trans.saindo; saindo.style.transform = f.saindo; saindo.style.opacity = String(opF.saindo);
          if (v === 'sombra') painel.style.boxShadow = '0 0 0 rgba(20, 18, 14, 0)';
          setTimeout(function () {
            setMode('quadro');
            requestAnimationFrame(function () {
              slClear(painel); slClear(arte); slClear(saindo);
              painel.style.boxShadow = '';
              mediaCol.classList.remove('jun26-sl-drag');
              slBusy = false;
            });
          }, ms);
        });
      });
      window.__slDiag = { resultado: 'VOLTA (' + v + ')', largura: window.innerWidth, js: window.__obrahSlider };
      return true;
    }

    /* salto programático. Toque no botão = crossfade; miniatura = slide (elas são
       vizinhas no mesmo trilho, o deslize mantém o trilho legível) */
    function slGo(to, modo, dirForce) {
      window.__slDiag = {
        pedido: to, modo: modo, slOn: slOn(), largura: window.innerWidth,
        ocupado: slBusy, mode: mode, idx: slIdx(),
        temGaleria: !!galEl, emAmb: mediaCol.classList.contains('jun26-amb-on'),
        css: getComputedStyle(root).getPropertyValue('--rd-css-ver').trim() || '(css antigo)',
        js: window.__obrahSlider || '(js antigo)'
      };
      if (!slOn()) { window.__slDiag.resultado = 'SEM SLIDER (largura > 959?)'; return false; }
      /* ocupado? encerra a limpeza pendente na hora em vez de cair no swap seco */
      if (slBusy) {
        if (window.matchMedia('(max-width: 767px)').matches &&
            document.querySelector('.thb-product-detail--pdp2026')) {
          slFila = to;
          window.__slDiag.resultado = 'NA FILA: ' + to + ' (fade em curso, sem interromper)';
          return true;
        }
        slBusy = false;
        mediaCol.classList.remove('jun26-sl-drag');
        slClear(amb); slClear(galEl);
        if (peek) slClear(peek.amb);
      }
      /* (4/ago) ENTRE AMBIENTES, NO CELULAR, A TROCA É CROSSFADE. O deslize
         carrega o quadro junto com a parede e o olho lê o conjunto se
         mexendo ("tem como aparecer sem ficar mexendo a arte?"); o fade
         troca a cena inteira por opacidade — a arte não sai do lugar, e
         opacidade é o que o compositor do iPhone anima de graça, mais
         barato que qualquer deslocamento. Só nas trocas por botão/traço:
         o arrasto com dedo não passa por aqui e continua deslizando, que é
         o que o gesto pede. Quadro↔ambiente também segue no deslize — lá a
         fresta e a seta contam a história da vizinhança. */
      /* vale pra TODAS as trocas por botão — abrir o ambiente a partir do
         quadro também sambava com o deslize ("quando abre o ambiente").
         Só o arrasto com dedo segue deslizando, e ele não passa por aqui. */
      if (window.matchMedia('(max-width: 767px)').matches &&
          document.querySelector('.thb-product-detail--pdp2026')) modo = 'fade';
      var st = slBegin(to, modo, dirForce);
      if (!st) { window.__slDiag.resultado = 'slBegin devolveu null (from===to ou camada faltando)'; return false; }
      slEmVoo = to;
      window.__slDiag.resultado = 'ANIMOU: ' + st.from + ' -> ' + st.to + ' (' + st.modo + ', dir ' + st.dir + ')';
      /* dois frames antes de disparar: o primeiro pinta a camada que entra (ela estava
         com visibility:hidden e sem camada de composição) e o segundo começa a
         transição já com tudo pronto — senão o começo engasga (26/jul) */
      requestAnimationFrame(function () {
        /* (4/ago) repinte da cena que entra, um frame após a montagem: mesmo
           pré-aquecida, a foto só reporta dimensões um tick depois do src —
           o layout() da largada pintava o quadro 0×0 e o crossfade ficava só
           na foto. Aqui a imagem já respondeu e a camada ainda está a 0 de
           opacidade: o quadro ganha geometria ANTES de qualquer pixel subir,
           então não há reposicionamento visível. */
        if (st.modo === 'fade' && st.to > 0 && peek) {
          try { renderInto(AMB_ENVS[st.to - 1], peek); } catch (e) {}
          /* (4/ago) REGRA ABSOLUTA, fechada depois de um dia inteiro:
             NADA ANIMA NO QUADRO. NUNCA. Foram construídos e removidos no
             mesmo dia: o percurso por layout (lento), o FLIP por transform
             (sambava), o morph quadro-objeto (sambava bonito, mas sambava) e
             por fim o assentamento de escala no próprio lugar — que também
             leu como samba: o quadro que entra "respirando" sobre o quadro
             fixo que sai cria dupla imagem pulsante. O que resta é o único
             movimento que o olho aceita aqui: NENHUM. A cena atravessa o
             dissolve com o quadro parado no lugar dele, e pronto. */
        }
        requestAnimationFrame(function () { slEnd(st, true); });
      });
      return true;
    }

    /* PAINEL DA VISTA DO QUADRO (26/jul): a arte mora numa galeria de 345px sobre o
       fundo do CONTÊINER — então, no slide de volta, só o quadrinho viajava e o bege
       ficava parado: sem borda atravessando a tela, ninguém lê como deslize ("parece
       que só descobriu o que estava por baixo"). Este painel dá à vista do quadro uma
       superfície própria, do tamanho do palco, que viaja junto com a arte. */
    var painelQuadro = null;
    function ensurePainelQuadro() {
      if (painelQuadro) return painelQuadro;
      painelQuadro = document.createElement('div');
      painelQuadro.className = 'jun26-quadro-bg';
      painelQuadro.setAttribute('aria-hidden', 'true');
      mediaCol.insertBefore(painelQuadro, mediaCol.firstChild);
      return painelQuadro;
    }

    (function setupPalcoSlider() {
      galEl = mediaCol.querySelector('.pp26-gallery') || slide;
      var x0 = null, y0 = null, ax = null, st = null, edge = null, t0 = 0, last = 0, lastT = 0, vel = 0;
      function reset() { x0 = null; ax = null; st = null; edge = null; }

      /* (4/ago) no mobile pdp26 o gesto NÃO morre com a máquina ocupada: o
         swipe é comando e comando durante fade vai pra FILA — descartá-lo
         deixava o palco surdo por ~1s a cada troca ("não tô conseguindo
         deslizar": swipes em ritmo normal caíam todos no vão). */
      function swipeComanda() {
        return window.matchMedia('(max-width: 767px)').matches &&
          !!document.querySelector('.thb-product-detail--pdp2026');
      }
      /* dedup toque/mouse: em emulação (e em alguns aparelhos) o navegador
         sintetiza eventos de mouse DEPOIS do toque — o mesmo gesto virava
         dois comandos e pulava cenas ("vai vários slides de uma vez") */
      var swUltimoComando = 0;
      mediaCol.addEventListener('touchstart', function (e) {
        /* (4/ago, noite) guarda ESTRITO de volta: o afrouxo era do tempo do
           swipe-comando (que enfileirava); com o arrasto contínuo restaurado,
           começar um drag DURANTE um fade sobrepõe duas transições — "ih
           sambou". Ocupada = gesto espera. */
        if (!slOn() || slBusy || e.touches.length > 1) { reset(); return; }
        if (e.target.closest && e.target.closest('.jun26-stage-toolbar, .jun26-zoom-btn, .jun26-sheet-grip')) { reset(); return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        ax = null; st = null; edge = null;
        t0 = lastT = e.timeStamp; last = 0; vel = 0;
      }, { passive: true });

      mediaCol.addEventListener('touchmove', function (e) {
        if (x0 == null || slBusy || e.touches.length > 1) return;
        var t = e.touches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (ax === null) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          /* trava o eixo no começo: horizontal claro vira slide, o resto devolve
             o gesto pra página (scroll) e pro pinch do zoom */
          ax = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          if (ax === 'x') {
            /* (4/ago, noite) o "swipe = comando" viveu uma tarde: o Rafael
               pediu de volta o slider de produtos de verdade — dedo puxando
               a cena continuamente, snap ao soltar ("tal qual um slider de
               produtos, vê na home"). O arrasto direto é manipulação, não
               transição autônoma: a regra do samba nunca foi sobre ele. */
            st = slBegin(slIdx() + (dx < 0 ? 1 : -1));
            if (!st) {
              /* (4/ago) no celular a ponta do trilho é PAREDE: sem elástico,
                 sem deslocamento nenhum — o balanço lia como "a imagem sai
                 do lugar" ("tem que travar e não fazer nada"). Desktop segue
                 com o elástico. */
              if (window.matchMedia('(max-width: 767px)').matches &&
                  document.querySelector('.thb-product-detail--pdp2026')) { reset(); return; }
              edge = slIdx() === 0 ? galEl : amb;
              mediaCol.classList.add('jun26-sl-drag');
            }
          }
        }
        if (ax !== 'x') return;
        e.preventDefault();
        var dt = e.timeStamp - lastT;
        if (dt > 0) { vel = (dx - last) / dt; lastT = e.timeStamp; last = dx; }
        if (st) slDrag(st, dx);
        else if (edge) slSetX(edge, dx * 0.28, false);   /* ponta do trilho: elástico */
      }, { passive: false });

      mediaCol.addEventListener('touchend', function (e) {
        if (x0 == null) { reset(); return; }
        var arrastou = ax === 'x';
        if (arrastou) {
          var t = e.changedTouches && e.changedTouches[0];
          var dx = t ? t.clientX - x0 : 0;
          /* trava o tap-to-zoom logo depois de um arrasto (o clique vem junto) */
          window.__jun26SlideGuard = Date.now();
          if (st) {
            var rapido = Math.abs(vel) > 0.35 && (vel < 0) === (st.dir > 0);
            slEnd(st, Math.abs(dx) > slW() * 0.2 || rapido);
          } else if (edge) {
            slSetX(edge, 0, true);
            var el = edge;
            setTimeout(function () { slClear(el); mediaCol.classList.remove('jun26-sl-drag'); }, 290);
          }
        }
        reset();
      }, { passive: true });

      mediaCol.addEventListener('touchcancel', function () {
        if (st) slEnd(st, false); else if (edge) { slClear(edge); mediaCol.classList.remove('jun26-sl-drag'); }
        reset();
      }, { passive: true });

      /* ═══ TRACKPAD LATERAL = SLIDER NATIVO (4/ago) ═══
         Na home o carrossel de artistas rola nativo, então dois dedos no
         trackpad passeiam por ele — e o palco ficava surdo a isso ("porque
         eu não consigo scrollar com o trackpad que nem lá?"). Aqui o wheel
         horizontal dirige a MESMA máquina do arrasto: revela contínuo,
         solta com snap (>20% fecha, senão devolve). Vertical segue sendo
         da página. Só no mobile pdp26; desktop intocado. */
      (function rodaLateral() {
        var wSt = null, wDir = 0, wAcc = 0, wTimer = null;
        function encerra() {
          if (!wSt) return;
          var frac = Math.max(0, Math.min(1, (wDir > 0 ? wAcc : -wAcc) / slW()));
          slEnd(wSt, frac > 0.2);
          wSt = null; wAcc = 0;
        }
        mediaCol.addEventListener('wheel', function (e) {
          if (!swipeComanda()) return;
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          clearTimeout(wTimer);
          wTimer = setTimeout(encerra, 150);
          if (!wSt) {
            if (slBusy) return;
            var dir = e.deltaX > 0 ? 1 : -1;
            var alvo = slIdx() + dir;
            if (alvo < 0 || alvo >= slTrack().length) return;   /* parede */
            wSt = slBegin(alvo, dir);
            if (!wSt) return;
            wDir = dir; wAcc = 0;
          }
          wAcc += e.deltaX;
          var frac = Math.max(0, Math.min(1, (wDir > 0 ? wAcc : -wAcc) / slW()));
          if (frac >= 1) {
            slEnd(wSt, true); wSt = null; wAcc = 0;
            return;
          }
          if (frac <= 0) { slEnd(wSt, false); wSt = null; wAcc = 0; return; }
          slDrag(wSt, -wDir * frac * slW());
        }, { passive: false });
      })();

      /* ═══ O MESMO ARRASTO, COM O MOUSE (4/ago) ═══════════════════════════
         Toda a mecânica acima — trava de eixo, elástico nas pontas, decisão
         por distância ou por velocidade — só existia para o dedo. Quem está
         no computador tinha as setas e nada mais: agarrar a cena e puxar,
         que é o gesto natural diante de uma imagem, não respondia.

         Isto não é um segundo sistema de arrasto; é a mesma máquina
         (slBegin/slDrag/slEnd) ouvindo outro dispositivo. O que muda é o
         mínimo necessário: o limiar cai de 10px para 6px (o mouse é preciso,
         o dedo é grosso) e o movimento é ouvido na JANELA, não no palco —
         sem isso, soltar o botão fora da imagem deixava a cena presa no meio
         do caminho. Diferente do dedo, aqui não existe rolagem concorrente,
         então o eixo vertical apenas cancela o gesto. */
      (function arrastaComMouse() {
        var mx0 = null, my0 = null, max = null, mst = null, medge = null;
        var mlast = 0, mlastT = 0, mvel = 0;
        function mreset() { mx0 = null; max = null; mst = null; medge = null; }

        mediaCol.addEventListener('mousedown', function (e) {
          if (!slOn() || slBusy || e.button !== 0) { mreset(); return; }
          if (e.target.closest && e.target.closest('.jun26-stage-toolbar, .jun26-zoom-btn, .jun26-sheet-grip, .pdp26-topo, .pdp26-fita, .pdp26-fresta, a, button')) { mreset(); return; }
          mx0 = e.clientX; my0 = e.clientY;
          mlastT = e.timeStamp; mlast = 0; mvel = 0;
        });

        window.addEventListener('mousemove', function (e) {
          if (mx0 == null || slBusy) return;
          var dx = e.clientX - mx0, dy = e.clientY - my0;
          if (max === null) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            max = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
            if (max === 'x') {
              /* espelho do toque: arrasto contínuo também no mouse */
              mst = slBegin(slIdx() + (dx < 0 ? 1 : -1));
              if (!mst) {
                /* mesma parede da ponta do trilho do toque (4/ago) */
                if (window.matchMedia('(max-width: 767px)').matches &&
                    document.querySelector('.thb-product-detail--pdp2026')) { mreset(); return; }
                medge = slIdx() === 0 ? galEl : amb;
                mediaCol.classList.add('jun26-sl-drag');
              }
              mediaCol.classList.add('jun26-sl-grab');
            }
          }
          if (max !== 'x') return;
          /* sem isto o navegador entende o gesto como seleção de texto e
             pinta a imagem de azul enquanto ela desliza */
          e.preventDefault();
          var dt = e.timeStamp - mlastT;
          if (dt > 0) { mvel = (dx - mlast) / dt; mlastT = e.timeStamp; mlast = dx; }
          if (mst) slDrag(mst, dx);
          else if (medge) slSetX(medge, dx * 0.28, false);
        });

        window.addEventListener('mouseup', function (e) {
          if (mx0 == null) { mreset(); return; }
          if (max === 'x') {
            var dx = e.clientX - mx0;
            window.__jun26SlideGuard = Date.now();
            if (mst) {
              var rapido = Math.abs(mvel) > 0.35 && (mvel < 0) === (mst.dir > 0);
              slEnd(mst, Math.abs(dx) > slW() * 0.2 || rapido);
            } else if (medge) {
              slSetX(medge, 0, true);
              var el = medge;
              setTimeout(function () { slClear(el); mediaCol.classList.remove('jun26-sl-drag'); }, 290);
            }
          }
          mediaCol.classList.remove('jun26-sl-grab');
          mreset();
        });
      })();
    })();

    var envRow = document.createElement('div');
    envRow.className = 'jun26-stage-envs';
    function titleCase(s) { return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
    if (isRedesign) {

      envRow.classList.add('jun26-env-dd');
      var ddTrig = document.createElement('div');
      ddTrig.className = 'jun26-env-dd__trigger';
      ddTrig.innerHTML = '<span class="jun26-env-dd__eyebrow">Ambiente</span>'
        + '<span class="jun26-env-dd__name">' + titleCase(curEnv.label) + '</span>'
        + '<svg class="jun26-env-dd__chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      ddTrig.addEventListener('click', function (ev) {
        ev.stopPropagation(); envRow.classList.toggle('is-open');

        if (envRow.classList.contains('is-open') && stageBar) {
          var q = tg.querySelector('button');
          if (q) ddMenu.style.setProperty('left', Math.round(q.getBoundingClientRect().right - stageBar.getBoundingClientRect().left) + 'px', 'important');
        }
      });
      envRow.appendChild(ddTrig);
      var ddMenu = document.createElement('div');
      ddMenu.className = 'jun26-env-dd__menu';
      /* 27/jul: a VISTA DO QUADRO entra como a primeira miniatura da fileira. A
         barra passa a ser o único navegador do palco — 1 de 5 — e voltar pra obra
         é tocar na primeira, não caçar um botão. O rótulo aparece só na ativa:
         nomeia onde você está sem transformar a fileira num menu de texto. */
      var optQuadro = document.createElement('button');
      optQuadro.type = 'button';
      optQuadro.className = 'jun26-env-dd__opt rd-envth--quadro';
      optQuadro.dataset.mode = 'quadro';
      optQuadro.setAttribute('aria-label', 'Ver o quadro');
      optQuadro.innerHTML = '<span class="rd-envth__cena"><i class="rd-envth__art"></i></span>'
        + '<span class="rd-envth__cap">Quadro</span>';
      optQuadro.addEventListener('click', function () { setMode('quadro'); });
      ddMenu.appendChild(optQuadro);
      AMB_ENVS.forEach(function (e) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jun26-env-dd__opt';
        b.dataset.mode = e.id;
        b.innerHTML = '<span>' + titleCase(e.label) + '</span>'
          + '<svg class="jun26-env-dd__check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4.5 4.5L19 7"/></svg>';
        /* 26/jul: no MOBILE a opção vira MINIATURA da foto do cômodo (sem nome e
           sem o quadro dentro) — o CSS usa esta var e esconde o texto. No desktop
           segue sendo o item de texto do dropdown. */
        b.style.setProperty('--rd-envthumb', 'url("' + envSrc(e) + '")');
        b.setAttribute('aria-label', titleCase(e.label));
        /* 27/jul: a OBRA entra composta na miniatura. Cômodo vazio convida a
           escolher cenário; com a peça dentro, a fileira vira comparação de
           resultado — é a mesma pergunta do palco, em quatro respostas. */
        /* 27/jul: a foto e o recorte da obra passam pra uma CENA interna. O botão
           fica sem overflow, e é isso que deixa o fio da seleção viver fora da
           imagem — e poder crescer da esquerda, como o sublinhado do menu. */
        var cena = document.createElement('span');
        cena.className = 'rd-envth__cena';
        var mini = document.createElement('i');
        mini.className = 'rd-envth__art';
        cena.appendChild(mini);
        b.appendChild(cena);
        var cap = document.createElement('span');
        cap.className = 'rd-envth__cap';
        cap.textContent = titleCase(e.label);
        b.appendChild(cap);
        b.addEventListener('click', function () { setMode(e.id); envRow.classList.remove('is-open'); });
        ddMenu.appendChild(b);
      });
      envRow.appendChild(ddMenu);

      /* 27/jul: contagem + seta. Com quatro miniaturas na faixa, nada diz que há
         mais cômodos; o "n/N" dá o tamanho do conjunto e a seta anda pro próximo,
         arrastando a fileira junto quando ela não cabe. */
      var envNav = document.createElement('div');
      envNav.className = 'rd-envnav';
      var envCount = document.createElement('span');
      envCount.className = 'rd-envnav__count';
      /* seta oficial da casa (arrow-obrah.svg) — a de trás é a mesma, espelhada */
      var SETA_OBRAH = '<svg viewBox="0 0 1200 1200" fill="currentColor" aria-hidden="true">'
        + '<path d="m489.49 861.97-24.984-25.945 242.14-233.18-242.28-239.03 25.273-25.633 268.58 264.97z"/>'
        + '</svg>';
      /* a seta é INFINITA: do último cômodo ela fecha o círculo no primeiro, e a
         cena entra pelo lado pra onde a seta aponta. Seta que morre no fim de uma
         fileira de quatro é mais frustrante do que o laço — e o laço só engana se
         o movimento andar pro lado errado, o que o dirForce impede. (27/jul) */
      function andaEnv(passo) {
        var ids = AMB_ENVS.map(function (e) { return e.id; });
        var i = ids.indexOf(curEnv.id);
        var alvoId = ids[(i + passo + ids.length) % ids.length];
        if (slOn() && !slBusy) {
          var alvo = slTrack().indexOf(alvoId);
          if (alvo > 0 && slGo(alvo, SL_MODO_BOTAO, passo)) return;
        }
        setMode(alvoId);
      }
      var envPrev = document.createElement('button');
      envPrev.type = 'button';
      envPrev.className = 'rd-envnav__arrow rd-envnav__prev';
      envPrev.setAttribute('aria-label', 'Ambiente anterior');
      envPrev.innerHTML = SETA_OBRAH;
      envPrev.addEventListener('click', function (ev) { ev.stopPropagation(); andaEnv(-1); });
      var envNext = document.createElement('button');
      envNext.type = 'button';
      envNext.className = 'rd-envnav__arrow rd-envnav__next';
      envNext.setAttribute('aria-label', 'Próximo ambiente');
      envNext.innerHTML = SETA_OBRAH;
      envNext.addEventListener('click', function (ev) { ev.stopPropagation(); andaEnv(1); });
      envNav.appendChild(envCount);
      envNav.appendChild(envPrev);
      envNav.appendChild(envNext);
      envRow.appendChild(envNav);

      var syncEnvNav = function () {
        var ids = AMB_ENVS.map(function (e) { return e.id; });
        var i = ids.indexOf(curEnv.id);
        /* 27/jul: com as quatro miniaturas à vista, contador de posição é ruído —
           você já VÊ onde está (a de fio branco). O que falta dizer é o TAMANHO do
           conjunto. Vira rótulo, e só no desktop: no mobile a quarta espiando na
           borda já conta a mesma história sem gastar largura. */
        var faixa = ['quadro'].concat(ids);
        var pos = faixa.indexOf(mediaCol.classList.contains('jun26-amb-on') ? curEnv.id : 'quadro');
        envCount.textContent = (pos < 0 ? 1 : pos + 1) + ' de ' + faixa.length;
        var at = ddMenu.querySelector('.jun26-env-dd__opt.is-on');
        if (at && ddMenu.scrollWidth > ddMenu.clientWidth + 2) {
          var l = at.offsetLeft, r = l + at.offsetWidth;
          if (l < ddMenu.scrollLeft) ddMenu.scrollTo({ left: Math.max(0, l - 12), behavior: 'smooth' });
          else if (r > ddMenu.scrollLeft + ddMenu.clientWidth) ddMenu.scrollTo({ left: r - ddMenu.clientWidth + 12, behavior: 'smooth' });
        }
      };
      /* no mobile o toque na miniatura DESLIZA até o cômodo (captura antes do
         handler de cima, que trocaria a imagem na hora) — 26/jul */
      ddMenu.addEventListener('click', function (ev) {
        if (!slOn() || slBusy) return;
        var b = ev.target.closest && ev.target.closest('.jun26-env-dd__opt');
        if (!b || b.classList.contains('is-on')) return;
        var alvo = slTrack().indexOf(b.dataset.mode);
        if (alvo >= 0 && slGo(alvo)) { ev.preventDefault(); ev.stopPropagation(); }
      }, true);
      document.addEventListener('click', function (ev) { if (!envRow.contains(ev.target)) envRow.classList.remove('is-open'); });
    } else {
      AMB_ENVS.forEach(function (e) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.mode = e.id;
        b.textContent = e.label;
        b.addEventListener('click', function () { setMode(e.id); });
        envRow.appendChild(b);
      });
    }

    var stageBar = null;
    if (root.classList.contains('thb-product-detail--redesign')) {
      stageBar = document.createElement('div');
      stageBar.className = 'jun26-stage-toolbar';
      stageBar.appendChild(tg);
      stageBar.appendChild(envRow);
      mediaCol.appendChild(stageBar);
      /* 27/jul — BANCADA DE TESTE da fileira (desktop). Sem parâmetro fica o que
         está no código; ?fila=c prova a FITA CORRIDA (cenas coladas, ativa marcada
         por fio embaixo) e ?fila=g prova a COLUNA (barra vertical na margem
         esquerda, cenas de 140, passe-partout na ativa). */
      var fila = /[?&]fila=(c|g)/.exec(location.search);
      if (fila) root.classList.add('rd-fila-' + fila[1]);

      /* 27/jul — NO MOBILE A FITA SAI DE DENTRO DO PALCO.
         Enquanto ela morava na coluna de mídia (que é sticky, de altura cheia, com
         a foto do ambiente ocupando tudo), não existia "abaixo do palco": qualquer
         posição estática caía atrás da foto ou atrás da folha branca. Aqui ela vira
         IRMÃ do palco, logo depois dele — aí o ambiente sobe, a fita ganha chão
         próprio e a seleção pode ser um fio embaixo da cena, como as abas do menu.
         No desktop ela volta pra dentro do palco, flutuando sobre a cena. */
      /* 27/jul — NO MOBILE A FITA SAI DE DENTRO DO PALCO e vira irmã dele: é o que
         permite ela morar ABAIXO da foto, com chão próprio, em vez de flutuar por
         cima. Como o palco é sticky (fica pinado enquanto o resto rola), a fita
         precisa de duas coisas pra não atravessar a foto:
           1. ficar GRUDADA logo abaixo do palco (sticky no pé dele);
           2. RECOLHER como gaveta assim que o scroll começa — e voltar quando a
              página volta ao topo, igual aos stickies de baixo.
         No desktop ela volta pra dentro do palco, flutuando sobre a cena. */
      var fitaCompara = { on: false };
      var mqFita = window.matchMedia('(max-width: 959px)');
      var posicionaFita = function () {
        if (!stageBar || !mediaCol.parentNode) return;
        if (mqFita.matches) {
          if (stageBar.parentNode !== mediaCol.parentNode) {
            mediaCol.parentNode.insertBefore(stageBar, mediaCol.nextSibling);
          }
        } else if (stageBar.parentNode !== mediaCol) {
          mediaCol.appendChild(stageBar);
        }
        if (typeof pintaMini === 'function') requestAnimationFrame(pintaMini);
      };
      posicionaFita();
      if (mqFita.addEventListener) mqFita.addEventListener('change', posicionaFita);
      else mqFita.addListener(posicionaFita);

      /* 27/jul — A RÉGUA DE TAMANHO ENTRA NA GAVETA.
         Escolher tamanho e escolher cômodo são dois eixos da MESMA pergunta — que
         tamanho funciona na minha parede —, e o cômodo é só a régua. Separá-los por
         400px de scroll é que era estranho.
         A fileira só nasce no PRIMEIRO toque num chip de tamanho: tocar num cômodo
         diz "quero ver de outro jeito"; tocar num tamanho diz "estou decidindo o
         tamanho", e é isso que justifica trazer a régua pra junto da foto. Quem
         nunca compara tamanho não paga altura nenhuma por ela. */
      var tamFita = null;
      function montaTamFita() {
        /* o conjunto de tamanhos muda com o acabamento — se mudou, refaz */
        if (tamFita) {
          var vis = document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) label.jun26-size-chip');
          var n = 0;
          [].forEach.call(vis, function (l) { if (l.getClientRects().length) n++; });
          if (n === tamFita.children.length) return;
          tamFita.parentNode && tamFita.parentNode.removeChild(tamFita);
          tamFita = null;
        }
        if (!stageBar) return;
        var radios = [].slice.call(document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]'));
        if (radios.length < 2) return;
        tamFita = document.createElement('div');
        tamFita.className = 'rd-tamfita';
        radios.forEach(function (r) {
          /* a sigla (PP · P · M · G · XG) vive no chip que o tema desenha, não no
             input — o `label` irmão com .jun26-size-chip. Sem ele a fileira ficava
             repetindo o número ("2020 × 20"). */
          var lab = r.parentElement && r.parentElement.querySelector('label.jun26-size-chip');
          if (!lab) return;
          /* 27/jul: quem esconde um tamanho que a loja não vende (o 20×20, por
             exemplo) é o WRAPPER do input, não o label — testar só o display do
             label deixava o PP entrar na régua. Um tamanho inexistente na régua
             não é só ruído: escolhido, ele zera o preço, porque não há variante.
             getClientRects() vazio pega qualquer ancestral oculto. */
          if (!lab.getClientRects().length) return;
          if (r.disabled) return;
          var medida = r.value || '';
          var sg = lab.querySelector('.jun26-size-sigla');
          var nm = lab.querySelector('.jun26-size-num');
          var sigla = sg ? sg.textContent.trim() : '';
          if (nm) medida = nm.textContent.trim();
          if (!sigla) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rd-tamfita__chip';
          b.dataset.val = r.value || '';   /* valor CRU: é por ele que a sincronia compara */
          b.innerHTML = '<span class="rd-tamfita__s">' + sigla + '</span>'
            + '<span class="rd-tamfita__m">' + medida + '</span>';
          b.addEventListener('click', function () {
            if (r.checked) return;
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          });
          tamFita.appendChild(b);
        });
        /* 27/jul: a régua NÃO mora na gaveta — ela empilha em cima do STICKY.
           Lá embaixo ela ganha três coisas: fica na zona do polegar (é o controle
           que mais recebe toques repetidos), não cobra altura da foto, e compõe a
           tela inteira de uma vez — palco em cima, cenas logo abaixo dele, e no
           pé a régua sobre o preço. As quatro informações da decisão numa tela só. */
        var doca = document.querySelector('.rd-buydock');
        var cardCompra = doca && doca.querySelector('.jun26-card-buy');
        if (doca && cardCompra) doca.insertBefore(tamFita, cardCompra);
        else stageBar.appendChild(tamFita);
        sincTamFita();
      }
      function sincTamFita() {
        if (!tamFita) return;
        var m = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
        var v = m ? m.value : '';
        [].slice.call(tamFita.children).forEach(function (c) {
          c.classList.toggle('is-on', c.dataset.val === v);
        });
      }
      document.addEventListener('change', function (ev) {
        if (!ev.target.closest) return;
        if (!ev.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) return;
        if (!window.matchMedia('(max-width: 959px)').matches) return;
        montaTamFita();
        root.classList.add('rd-tamfita-on');
        sincTamFita();
      }, true);

      /* 27/jul — IDENTIDADE EM CIMA, TRANSAÇÃO EMBAIXO.
         O bloco artista · título · estrelas sai do sticky de compra e sobe pro
         alto da folha, logo abaixo do grip. Assim a primeira tela apresenta a
         obra antes de cobrar por ela, e o sticky fica só com preço, PIX e botão —
         cada coisa num lugar, sem eco. Ele recolhe junto com a fita no scroll:
         é isso que faz Moldura e Cor da moldura subirem mais rápido. */
      (function obraNoTopo() {
        var mqO = window.matchMedia('(max-width: 959px)');
        var obra = null, docaOriginal = null, ondeNaDoca = null;
        var move = function () {
          obra = obra || document.querySelector('.rd-buyobra');
          if (!obra) return;
          if (!docaOriginal) { docaOriginal = obra.parentNode; ondeNaDoca = obra.nextSibling; }
          var folha = document.querySelector('.pp26-product-grid__info');
          var grip = folha && folha.querySelector('.jun26-sheet-grip');
          if (mqO.matches) {
            if (grip && obra.previousElementSibling !== grip) {
              grip.parentNode.insertBefore(obra, grip.nextSibling);
              obra.classList.add('rd-buyobra--topo');
            }
          } else if (docaOriginal && obra.parentNode !== docaOriginal) {
            docaOriginal.insertBefore(obra, ondeNaDoca);
            obra.classList.remove('rd-buyobra--topo');
          }
        };
        /* 27/jul: no alto da folha a nota é um SELO, não uma régua — uma estrela
           preta e o número em vírgula. Cinco estrelas ali repetiam a informação
           que o próprio número já dá, e roubavam a atenção do título. */
        var notaOrig = null;
        var enxugaNota = function () {
          if (!obra) return;
          var st = obra.querySelector('.jun26-wh-stars');
          var ct = obra.querySelector('.jun26-wh-count');
          if (!st || !ct) return;
          if (notaOrig === null) notaOrig = { st: st.textContent, ct: ct.textContent };
          /* 28/jul: UMA estrela cheia (revoga as cinco de 27/jul, que repetiam
             em desenho o que o número já diz). O "/5" continua fora: sem régua
             à vista o denominador voltaria a fazer falta, mas aqui a nota é
             selo, não medição. */
          st.textContent = '★';
          st.setAttribute('data-nota', '4.8');
          ct.textContent = notaOrig.ct.replace('/5', '').replace('.', ',').trim();
        };
        /* 27/jul: a nota é clicável (leva pras avaliações) — precisa dizer isso */
        var luva = function () {
          if (!obra) return;
          var r = obra.querySelector('.rd-buyobra__r');
          if (r) r.classList.add('rd-buyobra__r--link');
        };
        move();
        enxugaNota();
        luva();
        if (mqO.addEventListener) mqO.addEventListener('change', function () { move(); enxugaNota(); });
        else mqO.addListener(function () { move(); enxugaNota(); });
        setTimeout(function () { move(); enxugaNota(); }, 400);
      })();

      /* 28/jul — O BOOKMARK SOBE PRO CABEÇALHO (mobile).
         Salvar não é ação comercial: você salva a OBRA, não a configuração que
         montou. Dentro da barra ele disputava largura e atenção com o CTA, e
         obrigava a linha da compra a carregar duas ações de pesos diferentes.
         No alto, alinhado à direita logo abaixo da nota, ele entra no bloco de
         identidade — artista · título · nota · salvar. A avaliação diz o que os
         outros acharam; o bookmark é o que VOCÊ achou. A barra fica com preço e
         um gesto só, e o CTA herda a largura que sobrou.
         A nota e o bookmark passam a morar num lado direito próprio
         (.rd-buyobra__side) pra empilhar um sob o outro sem depender de
         posicionamento absoluto. */
      (function bookmarkNoTopo() {
        var mqB = window.matchMedia('(max-width: 959px)');
        var heart = null, casaOriginal = null, ondeNaCasa = null;
        var move = function () {
          heart = heart || document.querySelector('.jun26-buy-heart');
          var obra = document.querySelector('.rd-buyobra');
          if (!heart || !obra) return;
          if (!casaOriginal) { casaOriginal = heart.parentNode; ondeNaCasa = heart.nextSibling; }
          if (mqB.matches) {
            var lado = obra.querySelector('.rd-buyobra__side');
            if (!lado) {
              lado = document.createElement('span');
              lado.className = 'rd-buyobra__side';
              obra.appendChild(lado);
            }
            var nota = obra.querySelector('.rd-buyobra__r');
            if (nota && nota.parentNode !== lado) lado.appendChild(nota);
            if (heart.parentNode !== lado) lado.appendChild(heart);
            heart.classList.add('rd-buyheart--topo');
          } else if (casaOriginal && heart.parentNode !== casaOriginal) {
            casaOriginal.insertBefore(heart, ondeNaCasa);
            heart.classList.remove('rd-buyheart--topo');
          }
        };
        move();
        if (mqB.addEventListener) mqB.addEventListener('change', move);
        else mqB.addListener(move);
        /* o slot do bookmark é montado pelo app de favoritos e pode chegar
           depois da primeira pintura — mesmo compasso do obraNoTopo */
        setTimeout(move, 400);
        setTimeout(move, 1200);
      })();

      (function fitaGaveta() {
        var tick = false, aberta = null;
        /* 27/jul — MODO COMPARAÇÃO.
           A gaveta seguia o SCROLL: passou de 48px, recolhe. Só que o enquadramento
           do tamanho rola a página pra ~300 — então tocar num tamanho fechava,
           no mesmo gesto, a régua que a pessoa acabou de usar. Absurdo.
           Agora ela segue a INTENÇÃO: enquanto a pessoa está comparando (acabou de
           tocar num tamanho ou numa cena), fica aberta em qualquer posição. Um
           gesto de rolagem DELA — dedo ou roda — encerra a comparação e a gaveta
           volta a obedecer o scroll. */
        var encerra = function () { if (fitaCompara.on) { fitaCompara.on = false; passo(); } };
        ['touchstart', 'wheel'].forEach(function (ev) {
          window.addEventListener(ev, encerra, { passive: true });
        });

        /* 28/jul — A RÉGUA É TRANSIENTE, COMO TODO CONTROLE INVOCADO.
           Ela nascia no primeiro toque num tamanho e ficava pra sempre: um
           segundo degrau permanente empilhado na barra, comendo altura de tela
           num aparelho que não tem altura sobrando. Agora ela obedece a mesma
           regra da gaveta — INTENÇÃO, não posição: seguiu em frente (um gesto de
           rolagem que não começou nela nem nos chips de tamanho), ela se recolhe.
           Volta só quando você toca em outro tamanho, que é quando ela serve.
           O teste tem que ser por intenção porque tocar num tamanho ROLA a página
           sozinho (o enquadramento) — dismiss por posição fecharia a régua no
           mesmo gesto que a abriu. */
        var guardaRegua = function (ev) {
          if (!root.classList.contains('rd-tamfita-on')) return;
          var t = ev && ev.target;
          if (t && t.closest && (t.closest('.rd-tamfita') || t.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])'))) return;
          root.classList.remove('rd-tamfita-on');
        };
        ['touchstart', 'wheel'].forEach(function (ev) {
          window.addEventListener(ev, guardaRegua, { passive: true });
        });
        var medeTopo = function () {
          /* 27/jul: a ALTURA REAL da fita vira variável — no desktop a foto do
             ambiente termina exatamente onde ela começa, e chumbar 87px deixava
             uma sobra (a fita tem padding próprio e a conta mudava com a cena). */
          if (stageBar) {
            var hf = Math.round(stageBar.getBoundingClientRect().height);
            if (hf > 0) root.style.setProperty('--rd-fita-h', hf + 'px');
          }
          if (!mqFita.matches) return;
          var h = Math.round(mediaCol.getBoundingClientRect().height);
          if (h > 0) root.style.setProperty('--rd-fita-top', h + 'px');
        };
        var passo = function () {
          tick = false;
          if (!mqFita.matches) { root.classList.remove('rd-fita-off'); aberta = null; return; }
          /* histerese: abre rente ao topo, fecha depois de um passo de verdade —
             sem isso a gaveta treme no rubber-band do iOS */
          if (fitaCompara.on) {
            if (aberta !== true) { aberta = true; root.classList.remove('rd-fita-off'); }
            return;
          }
          var y = window.scrollY;
          var quer = y <= 10 ? true : (y > 48 ? false : aberta);
          if (quer !== aberta) {
            aberta = quer;
            root.classList.toggle('rd-fita-off', !quer);
          }
        };
        window.addEventListener('scroll', function () {
          if (!tick) { tick = true; requestAnimationFrame(passo); }
        }, { passive: true });
        window.addEventListener('resize', function () { medeTopo(); passo(); });
        if (window.ResizeObserver) {
          new ResizeObserver(medeTopo).observe(mediaCol);
          if (stageBar) new ResizeObserver(medeTopo).observe(stageBar);
        }
        medeTopo(); passo();
      })();
      /* a PDP abre na vista do quadro: a fileira já tem que dizer isso — primeira
         miniatura marcada, rótulo aceso e "1 de 5" no lugar (27/jul) */
      if (isRedesign && typeof syncEnvNav === 'function') {
        var marcaInicial = function () {
          var emAmb = mediaCol.classList.contains('jun26-amb-on');
          [].slice.call(ddMenu.querySelectorAll('.jun26-env-dd__opt')).forEach(function (o) {
            o.classList.toggle('is-on', emAmb ? (o.dataset.mode === curEnv.id) : (o.dataset.mode === 'quadro'));
          });
          syncEnvNav();
          pintaMini();
        };
        requestAnimationFrame(function () { requestAnimationFrame(marcaInicial); });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(marcaInicial);
      }
    } else {
      mediaCol.appendChild(tg);
      mediaCol.appendChild(envRow);
    }

    if (root.classList.contains('thb-product-detail--redesign')) {
      var stageToggleFollow = function () {
        var mh = mediaCol.clientHeight;

        var maxT = Math.max(0, Math.round(mh * 0.25) - 110);
        var ty = Math.max(0, Math.min(window.pageYOffset, maxT));
        (stageBar || tg).style.transform = 'translateY(' + ty + 'px)';
      };
      window.addEventListener('scroll', stageToggleFollow, { passive: true });
      stageToggleFollow();
    }

    var mode = 'quadro';
    var lastGeo = null;
    var ambeditSync = function () {  };
    var zonesRender = function () {  };
    var guidesRender = function () {  };
    function setMode(m) {
      mode = m;
      var on = m !== 'quadro';
      if (on) {
        var env = AMB_ENVS.filter(function (e) { return e.id === m; })[0];
        if (env) {
          curEnv = env;
          var newSrc = envSrc(env);

          if (photo.getAttribute('src') !== newSrc) photo.src = newSrc;

          mediaCol.style.setProperty('--amb-aspect', env.aspect ? String(env.aspect) : (env.img.w + ' / ' + env.img.h));
          applyPhotoFilter();
        }
      }
      mediaCol.classList.toggle('jun26-amb-on', on);
      slide.classList.toggle('jun26-amb-on', on);

      root.classList.toggle('jun26-amb-active', on);

      var allBtns = [].slice.call(tg.querySelectorAll('button'))
        .concat([].slice.call(envRow.querySelectorAll('button')));
      allBtns.forEach(function (b) {
        var dm = b.dataset.mode;
        if (dm === 'vertog') return;
        b.classList.toggle('is-on', dm === 'ambiente' ? on : dm === m);
      });

      /* botão único: o rótulo é a ação — quem está no quadro vê "VER AMBIENTE" (26/jul) */
      if (verTog) {
        var rot = verTog.querySelector('.rd-vertog__txt');
        var alvoRot = on ? 'Ver quadro' : 'Ver no ambiente';
        /* 26/jul: o botão NÃO encolhe ao virar "Ver quadro" — ele é o mesmo objeto
           trocando de rótulo, então trava na largura do rótulo longo (medida com a
           fonte já carregada) e o texto curto fica centrado. */
        var travaLargura = function () {
          if (verTog.classList.contains('is-amb')) return;
          verTog.style.minWidth = '';
          var lw = verTog.getBoundingClientRect().width;
          if (lw > 8) verTog.style.minWidth = Math.ceil(lw) + 'px';
        };
        var poeRot = function () {
          if (rot) rot.textContent = alvoRot; else verTog.textContent = alvoRot;
          travaLargura();
        };
        var atual = rot ? rot.textContent : verTog.textContent;
        verTog.classList.toggle('is-amb', on);
        if (atual === alvoRot) {
          travaLargura();
        } else {
          /* a troca não é um corte seco: o rótulo antigo sai e o novo entra — a
             caixa é a mesma, só o texto respira */
          verTog.classList.add('is-troca');
          setTimeout(function () {
            poeRot();
            verTog.classList.remove('is-troca');
          }, 130);
        }
      }

      if (on && isRedesign) {
        var ddName = envRow.querySelector('.jun26-env-dd__name');
        if (ddName) ddName.textContent = curEnv.label.charAt(0).toUpperCase() + curEnv.label.slice(1).toLowerCase();
      }
      if (isRedesign && typeof syncEnvNav === 'function') syncEnvNav();
      if (isRedesign && typeof pintaMini === 'function') pintaMini();
      ambeditSync();
      if (on) layout();
      updateNavContrast();
    }

    /* 27/jul — CENTRAR A OBRA NO PALCO (mobile, vista do quadro).
       Centrar a GALERIA não resolve: a moldura não fica no meio dela (a galeria
       reserva espaço pra sombra e perspectiva), então centrar a caixa jogava a
       obra pra baixo. Aqui a conta é feita na moldura de verdade — mede as duas
       folgas e desloca o slide pela metade da diferença. Serve pra qualquer
       proporção: vertical, horizontal ou quadrado acham o próprio meio. */
    function centraObra() {
      if (mediaCol.classList.contains('jun26-amb-on')) return;
      /* 27/jul — A ÂNCORA MUDA POR LARGURA, e isso não é inconsistência:
         no DESKTOP a moldura é desenhada em perspectiva e o PNG tem transparência
         em volta, então a caixa dela é bem maior que o objeto visível — centrar
         por ali deixa a obra visualmente baixa. Lá a âncora é a ARTE.
         No MOBILE a moldura é frontal e a caixa dela É o objeto; centrar pela arte
         (que é o pano interno, deslocado dentro do palco de perspectiva) joga a
         obra pra cima. Lá a âncora é a MOLDURA.
         Em ambos os casos a regra é a mesma: ancorar no que se VÊ. */
      /* (4/ago) NA PDP 2026 MOBILE A CORREÇÃO É INCREMENTAL E ANIMADA.
         O truque padrão deste centrador — zerar o transform, medir, aplicar —
         pressupõe aplicação instantânea: com transição no slide, medir após
         zerar lê o rect interpolado e a conta sai lixo. E escrever seco era o
         tranco que o Rafael sentia. Aqui: mede o ERRO com o transform atual
         mesmo (sem zerar), soma ao deslocamento vigente e escreve — o CSS
         anima a chegada. O erro é medido no espaço VISUAL, mas o slide vive
         dentro do trilho escalado do modo compacto, então se divide pela
         escala pra convergir numa passada só. Necessário porque o
         pp26-gallery reconstrói o trilho nas voltas de cena e a obra renasce
         deslocada — este é o único corretor que sobrou no mobile. */
      if (window.matchMedia('(max-width: 767px)').matches &&
          document.querySelector('.thb-product-detail--pdp2026.pdp26-palco-fixo')) {
        /* NUNCA durante uma troca de cena: escrever no slide com a máquina
           de duas camadas no ar interrompia a coreografia dela — a cena
           ficava congelada no meio, fantasma (4/ago, "CONTINUA"). A máquina
           avisa quando está em cena; o corretor espera a vez. */
        if (mediaCol.classList.contains('jun26-sl-drag')) return;
        var frM = slide.querySelector('.pp26__art') || slide.querySelector('.pp26__frame');
        if (!frM) return;
        var alvoM = slide.querySelector('.pp26__slide') || slide;
        var rmM = mediaCol.getBoundingClientRect(), rfM = frM.getBoundingClientRect();
        if (!rmM.height || !rfM.height) return;
        var erroM = (rmM.top + rmM.height / 2) - (rfM.top + rfM.height / 2);
        if (Math.abs(erroM) < 1.5) return;
        var escM = 1;
        var trilhoM = mediaCol.querySelector('.pp26-gallery__slider');
        if (trilhoM) {
          var mxM = /matrix\(([-\d.]+),/.exec(getComputedStyle(trilhoM).transform || '');
          if (mxM && parseFloat(mxM[1]) > 0.05) escM = parseFloat(mxM[1]);
        }
        var atualM = parseFloat((/translateY\((-?[\d.]+)px\)/.exec(alvoM.style.transform || '') || [])[1]) || 0;
        alvoM.style.setProperty('transform', 'translateY(' + Math.round(atualM + erroM / escM) + 'px)', 'important');
        return;
      }
      var mob = window.matchMedia('(max-width: 959px)').matches;
      /* (6/ago) NA PDP 2026 DESKTOP O ENQUADRADOR DA COLUNA É O DONO.
         O aproveitaMolduraDesktop (pdp2026.js) já centra a cena nos dois
         eixos, no trilho. Com este centrador TAMBÉM escrevendo translateY no
         slide, eram duas verticais somadas — e como cada um mede no instante
         que calha, a obra pousava numa altura diferente a cada load (medido:
         y=97 num load, 132 no outro, mesmo variant). Cede a vez, como o
         branch do palco-fixo acima já faz no mobile. */
      if (!mob && document.querySelector('.thb-product-detail--pdp2026')) return;
      var fr = mob
        ? (slide.querySelector('.pp26__frame') || slide.querySelector('.pp26__art'))
        : (slide.querySelector('.pp26__art') || slide.querySelector('.pp26__frame'));
      if (!fr) return;
      var alvo = slide.querySelector('.pp26__slide') || slide;
      /* o deslocamento entra INLINE com !important: há regra de tema mexendo no
         transform deste nó (um translateY(-12) antigo), e var() em folha perdia
         a disputa. Zera, mede, aplica — assim a conta parte sempre do mesmo lugar. */
      alvo.style.setProperty('transform', 'none', 'important');
      var rm = mediaCol.getBoundingClientRect(), rf = fr.getBoundingClientRect();
      if (!rm.height || !rf.height) { alvo.style.removeProperty('transform'); return; }
      /* 27/jul: no desktop a FITA ocupa o pé do palco, então o espaço da obra
         termina no topo dela — centrar contra a base do palco jogaria a obra por
         baixo das cenas. No mobile a fita é irmã do palco e não entra na conta. */
      var baseUtil = rm.bottom;
      if (stageBar && !window.matchMedia('(max-width: 959px)').matches) {
        var rb = stageBar.getBoundingClientRect();
        if (rb.height > 4 && rb.top > rm.top) baseUtil = rb.top;
      }
      var dy = Math.round(((baseUtil - rf.bottom) - (rf.top - rm.top)) / 2);
      if (Math.abs(dy) < 1) { alvo.style.setProperty('transform', 'none', 'important'); return; }
      alvo.style.setProperty('transform', 'translateY(' + dy + 'px)', 'important');
    }
    window.addEventListener('resize', function () { requestAnimationFrame(centraObra); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(centraObra, 60); });
    setTimeout(centraObra, 500);
    setTimeout(centraObra, 1400);
    /* mais um passe tardio: a fita muda de altura depois que as fotos das cenas
       carregam, e isso move a base útil do palco — sem este tique a obra ficava
       centrada contra uma medida que ainda ia mudar (27/jul) */
    setTimeout(centraObra, 2600);
    if (window.ResizeObserver && stageBar) new ResizeObserver(function () {
      requestAnimationFrame(centraObra);
    }).observe(stageBar);

    function getArtSrc() {
      var a = slide.querySelector('.pp26__art');
      return a ? (a.currentSrc || a.src) : '';
    }

    function curSize() {
      var s = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]:checked');
      return s ? s.value : null;
    }

    function curState() {
      var frame = slide.querySelector('.pp26__frame');
      return {
        type: (frame && frame.dataset.frameType) || 'padrao',
        color: (frame && frame.dataset.frameColor) || 'mel'
      };
    }

    function frameGeo(st) {
      if (/sem.?moldura/.test(st.type)) return null;
      var tipo = /canvas/.test(st.type) ? 'canvas' : (/caixa/.test(st.type) ? 'caixa' : 'padrao');
      var geo = AMB_GEO[tipo];
      if (/slim/.test(st.type)) geo = Object.assign({}, geo, { profile: 1.4 });
      var cor = AMB_COR_SLUG[st.color] || 'marrom';
      return Object.assign({ tipo: tipo, cor: cor, wood: AMB_WOOD[cor] }, geo);
    }

    function layout() {
      var cw = amb.clientWidth, ch = amb.clientHeight;
      if (!cw || !ch) return;
      var d = parseTamanho(curSize() || '');
      if (!d) return;
      var orient = slide.dataset.orientation || 'vertical';
      if (orient === 'horizontal' && d.h > d.w) { var t = d.w; d.w = d.h; d.h = t; }
      /* a bancada impõe a PROPORÇÃO, não só a ordem dos lados: trocar w por h não
         muda nada num produto de tamanhos quadrados (30×30, 50×50…), que é o caso
         da maioria. 0.72 é a proporção corrente do catálogo (30×42, 50×70). */
      if (formaForcada) {
        var lado = Math.max(d.w, d.h);
        if (formaForcada === 'quadrado') { d.w = lado; d.h = lado; }
        else if (formaForcada === 'vertical') { d.w = lado * 0.72; d.h = lado; }
        else { d.w = lado; d.h = lado * 0.72; }
      }

      var st = curState();
      var g = frameGeo(st);
      var profCm = g ? g.profile : 0;

      var paspCm = (g && !g.gapDark && /paspatur/.test(st.type)) ? AMB_PASPATUR_CM : 0;
      var gapCm = g ? (g.gapDark ? g.gap : paspCm) : 0;
      var depthCm = g ? g.depth : 0;

      var img = curEnv.img, cal = curEnv.cal;
      var zoom = cal.zoom || 1;
      var fx = cal.focalX != null ? cal.focalX : 0.5;
      var fy = cal.focalY != null ? cal.focalY : 0.5;
      var s = Math.max(cw / img.w, ch / img.h) * zoom;
      var imgW = img.w * s, imgH = img.h * s;
      var dx = (cw - imgW) * fx;
      var dy = (ch - imgH) * fy;
      var scale = cal.pxPerCm * s;

      photo.style.objectPosition = (fx * 100).toFixed(1) + '% ' + (fy * 100).toFixed(1) + '%';
      photo.style.transformOrigin = (fx * 100).toFixed(1) + '% ' + (fy * 100).toFixed(1) + '%';
      photo.style.transform = zoom !== 1 ? 'scale(' + zoom + ')' : '';

      var wcm = d.w + 2 * gapCm + 2 * profCm;
      var hcm = d.h + 2 * gapCm + 2 * profCm;
      var w = wcm * scale, h = hcm * scale;
      var ax = dx + cal.anchorX * imgW;

      var baseY = dy + cal.anchorY * imgH;
      var ay = baseY - h / 2;

      var ceilY = dy + curEnv.ceilY * imgH + 0.02 * imgH;
      if (ay - h / 2 < ceilY) ay = ceilY + h / 2;

      var furnY = dy + curEnv.furnitureY * imgH;
      var pL = ax - w / 2, pR = ax + w / 2;
      (curEnv.noTouch || []).forEach(function (b) {
        var bx0 = dx + b.x0 * imgW, bx1 = dx + b.x1 * imgW, by0 = dy + b.y0 * imgH;
        if (pR > bx0 && pL < bx1) furnY = Math.min(furnY, by0);
      });
      if (ay + h / 2 > furnY) ay = furnY - h / 2;

      /* (16/out) TRAVA DE ENCAIXE: quadro mais alto que a parede livre (teto →
         móvel) encolhe só o necessário pra caber, em vez de atravessar o teto.
         Hoje só o 100x140 vertical cai aqui (144 cm contra 114–130 cm livres nas
         fotos atuais) — ponte até os cômodos novos, renderizados com parede pra
         ele. A escala inteira encolhe junto: perfil, paspatur e sombra seguem
         na proporção do quadro. */
      var livre = furnY - ceilY;
      if (livre > 0 && h > livre) {
        var encaixe = livre / h;
        scale *= encaixe; w *= encaixe; h *= encaixe;
        ay = furnY - h / 2;
      }

      /* 27/jul — TENTATIVA REVERTIDA: travar a escrita da geometria durante o
         percurso (?troca=c). A intuição está certa — as travas de teto/móvel são
         regra de REPOUSO, não de trajeto, e é o layout() rodando no meio da
         transição que produz o pinball. Mas bloquear a escrita aqui congelou o
         quadro na medida ANTIGA sobre a parede nova: pior que hesitar, fica errado.
         O caminho é outro: calcular o alvo uma vez no início da transição e fazer
         as chamadas seguintes escreverem NESSE alvo, em vez de recalcular. */
      if (alvoPercurso && alvoPercurso.el === quadro) {
        /* percurso em curso: o destino já foi decidido — reescrever aqui só faria
           a animação recomeçar rumo a um ponto ligeiramente outro (as travas de
           móvel mudam o resultado conforme a medida intermediária) */
        quadro.style.width = alvoPercurso.geo.width;
        quadro.style.height = alvoPercurso.geo.height;
        quadro.style.left = alvoPercurso.geo.left;
        quadro.style.top = alvoPercurso.geo.top;
      } else {
        quadro.style.width = w.toFixed(1) + 'px';
        quadro.style.height = h.toFixed(1) + 'px';
        quadro.style.left = (ax - w / 2).toFixed(1) + 'px';
        quadro.style.top = (ay - h / 2).toFixed(1) + 'px';
      }
      quadro.classList.toggle('jun26-amb-quadro--poster', !g);

      /* a camada que entra deslizando não mexe no estado do ?ambedit (26/jul) */
      if (!peeking) {
        lastGeo = { dx: dx, dy: dy, imgW: imgW, imgH: imgH, w: w, h: h, s: s };
        zonesRender();
        guidesRender();
      }

      if (g) {
        wood.style.display = '';
        grain.style.display = '';
        var fw = profCm * scale;
        var gw = gapCm * scale;
        var c = g.wood;

        var c = g.wood;

        if (g.gapDark && g.cor === 'preta') c = [64, 64, 64];

        wood.style.borderWidth = fw.toFixed(1) + 'px';
        wood.style.borderTopColor = ambShade(c, 0);
        wood.style.borderLeftColor = ambShade(c, -3);
        wood.style.borderRightColor = ambShade(c, -11);
        wood.style.borderBottomColor = ambShade(c, -16);

        var isPaspBg = paspCm > 0 && !g.gapDark;

        wood.style.background = g.gapDark ? '#0c0b0a' : (isPaspBg ? '#F9F8F4' : '#2c2723');

        wood.classList.toggle('jun26-amb-wood--canvasgap', g.gapDark);

        artwin.style.inset = (fw + gw).toFixed(1) + 'px';
        artwin.style.borderRadius = (g.innerR * scale).toFixed(1) + 'px';
        var isPasp = paspCm > 0 && !g.gapDark;
        var isFramed = !g.gapDark;
        artwin.classList.toggle('jun26-amb-artwin--float', g.gapDark);

        artwin.classList.toggle('jun26-amb-artwin--framed', isFramed && !isPasp);
        artwin.classList.toggle('jun26-amb-artwin--pasp', isPasp);

        if (isPasp) artwin.style.setProperty('--mth', (0.5 * scale).toFixed(1) + 'px');

        if (isFramed && !isPasp) {
          artwin.style.setProperty('--rsh', Math.max(2, depthCm * 0.5 * scale).toFixed(1) + 'px');
        }

        wood.classList.toggle('jun26-amb-wood--recess', isFramed);
        if (isFramed) {
          wood.style.setProperty('--psh', (0.5 * scale).toFixed(1) + 'px');

          wood.style.setProperty('--lip', ambShade(c, -42));
          wood.style.setProperty('--lipw', Math.max(1, 0.18 * scale).toFixed(1) + 'px');
        }

        var isPet = (g.cor === 'preta' || g.cor === 'branca');
        grain.classList.toggle('jun26-amb-grain--pet', isPet);
        grain.style.opacity = isPasp ? '0' : (g.gapDark
          ? (isPet ? '0.14' : '0.10')
          : (isPet ? '0.11' : '0.07'));

        var sd = depthCm * scale;
        quadro.style.filter =
          'drop-shadow(' + (-sd * 0.05).toFixed(1) + 'px ' + (sd * 0.12).toFixed(1) + 'px ' + (sd * 0.16).toFixed(1) + 'px rgba(0,0,0,0.20))';
        cast.style.display = 'block';
        cast.style.transform =
          'translate(' + (-sd * 0.18).toFixed(1) + 'px,' + (sd * 0.5).toFixed(1) + 'px) scale(1.012)';
        cast.style.filter = 'blur(' + Math.max(2, sd * 0.6).toFixed(1) + 'px)';
        cast.style.borderRadius = '2px';

        if (g.glass) {
          glass.style.display = '';
          glass.style.inset = fw.toFixed(1) + 'px';
          glass.style.backgroundImage = 'url(' + base + 'reflexo-' + orient + '.webp)';
        } else {
          glass.style.display = 'none';
        }

        if (g.tipo === 'canvas') {
          tex.style.display = '';
          tex.style.backgroundImage = 'url(' + base + 'jun26-amb-canvas-tex.webp)';
          tex.style.backgroundSize = (10 * scale).toFixed(1) + 'px';
          tex.style.opacity = AMB_TEX_OP;
          vao.style.display = 'none';
        } else {
          tex.style.display = 'none';
          vao.style.display = 'none';
        }
      } else {

        wood.style.display = 'none';
        grain.style.display = 'none';
        glass.style.display = 'none';
        tex.style.display = 'none';
        vao.style.display = 'none';
        cast.style.display = 'none';
        quadro.style.filter = 'drop-shadow(0 0.5px 1px rgba(0,0,0,0.14))';

        artwin.style.inset = '0px';
        artwin.style.borderRadius = '0px';
        artwin.classList.remove('jun26-amb-artwin--framed', 'jun26-amb-artwin--pasp', 'jun26-amb-artwin--float');
      }

      if (!art.src) art.src = getArtSrc();
      pintaMini();
    }

    /* ── A OBRA DENTRO DA MINIATURA ────────────────────────────────────────────
       27/jul: mesma conta do palco, na escala do dedal. Cada miniatura enquadra
       a foto EM VOLTA DA OBRA (não no meio da parede), então a fileira compara
       resultados em vez de oferecer cômodos vazios. A posição do fundo é
       calculada por ambiente pra que a peça caia no mesmo ponto do dedal. */
    var MINI_ALVO_X = 0.5, MINI_ALVO_Y = 0.47;
    function pintaMini() {
      if (!isRedesign || typeof ddMenu === 'undefined' || !ddMenu) return;
      var opts = [].slice.call(ddMenu.querySelectorAll('.jun26-env-dd__opt'));
      if (!opts.length) return;

      /* 3/ago (pdp2026, P26·44/45): o TRILHO VIVO registra os tiles dele nesta
         lista — mesma anatomia interna (cena + art), mesma conta de composição,
         pintados na mesma passada que as miniaturas. Fora do ?view=pdp2026 a
         lista não existe e nada muda. */
      if (root.dataset.pdp2026 && window.__pdp26Tiles && window.__pdp26Tiles.length) {
        opts = opts.concat(window.__pdp26Tiles.filter(function (t) { return t.isConnected; }));
      }

      /* 27/jul: as cenas ACOMPANHAM o tamanho escolhido — as cinco, juntas. Chegou
         a ficar fixa no maior pra matar o samba, mas o samba não vinha de elas
         mudarem: vinha do salto seco. Com o deslize (ver .rd-mini-anima no CSS)
         elas crescem na mesma curva do quadro no palco, e a fita lê como
         consequência do gesto em vez de um segundo evento. */
      var d = parseTamanho(curSize() || '');
      if (!d) return;
      var orient = slide.dataset.orientation || 'vertical';
      if (orient === 'horizontal' && d.h > d.w) { var t = d.w; d.w = d.h; d.h = t; }

      var st = curState(), g = frameGeo(st);
      var profCm = g ? g.profile : 0;
      var paspCm = (g && !g.gapDark && /paspatur/.test(st.type)) ? AMB_PASPATUR_CM : 0;
      var gapCm = g ? (g.gapDark ? g.gap : paspCm) : 0;
      var wcm = d.w + 2 * gapCm + 2 * profCm;
      var hcm = d.h + 2 * gapCm + 2 * profCm;
      var src = getArtSrc();
      var fio = g ? ambShade(g.gapDark && g.cor === 'preta' ? [64, 64, 64] : g.wood, -6) : '';

      /* 28/jul: O CÔMODO NÃO SE MEXE. O enquadramento do fundo saía da obra
         ESCOLHIDA, então o tamanho maior empurrava a sala pra baixo (a cena do
         sofá ia de 76% pra 44% de background-position entre o PP e o GG).
         Trocar de tamanho parecia mover o cômodo, não o quadro — e mover cinco
         cômodos ao mesmo tempo é o que dava a angústia.
         Agora o fundo é enquadrado SEMPRE pelo MAIOR tamanho da régua: é o pior
         caso, o que pede mais parede, e o que serve ele serve todos os outros.
         O que cresce e encolhe é só a obra — que é do que a escolha trata.
         Mesma leitura do palco grande: a foto fica parada, a peça é que muda. */
      var dMax = null;
      [].forEach.call(document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input[type="radio"]'), function (r) {
        if (r.disabled) return;
        /* mesmo filtro da régua: tamanho que a loja não vende fica fora da conta */
        var lab = r.parentElement && r.parentElement.querySelector('label.jun26-size-chip');
        if (lab && !lab.getClientRects().length) return;
        var p = parseTamanho(r.value || '');
        if (!p) return;
        if (!dMax || p.w * p.h > dMax.w * dMax.h) dMax = p;
      });
      if (!dMax) dMax = { w: d.w, h: d.h };
      if (orient === 'horizontal' && dMax.h > dMax.w) { var tM = dMax.w; dMax.w = dMax.h; dMax.h = tM; }
      var hcmRef = dMax.h + 2 * gapCm + 2 * profCm;

      /* 28/jul: A ONDA. As cinco mudavam de tamanho no mesmo instante — e cinco
         movimentos iguais, simultâneos, leem como repaint da página, não como
         resposta ao gesto. O índice abaixo é a DISTÂNCIA de cada cena até a
         ATIVA (0, 1, 2), e vira atraso no CSS: a mudança nasce onde o olho já
         está e se espalha pras pontas. Como são no máximo 2 passos, a cauda
         inteira fica em ~100ms — lê propagação, não lentidão. */
      var iAtiva = -1;
      for (var ia = 0; ia < opts.length; ia++) {
        if (opts[ia].classList.contains('is-on')) { iAtiva = ia; break; }
      }

      /* 3/ago (pdp2026): nos TILES do trilho a cena é grande o bastante pra
         moldura existir DE VERDADE — madeira com espessura física e as mesmas
         quinas de luz do ambientado (topo claro, pé escuro). No dedal do menu
         a moldura segue virando fio: lá ela não cabe em pixel. O vão do canvas
         e o paspatur entram como anel interno (inset) sobre a arte. */
      function vesteTile(mini, escalaPx) {
        var bordaPx = Math.max(1.2, profCm * escalaPx);
        var gapPx = gapCm * escalaPx;
        mini.style.boxSizing = 'border-box';
        mini.style.backgroundClip = 'padding-box';
        mini.style.borderStyle = 'solid';
        mini.style.borderWidth = bordaPx.toFixed(2) + 'px';
        mini.style.borderTopColor = ambShade(g.wood, 0);
        mini.style.borderLeftColor = ambShade(g.wood, -3);
        mini.style.borderRightColor = ambShade(g.wood, -11);
        mini.style.borderBottomColor = ambShade(g.wood, -16);
        mini.style.boxShadow = (gapPx > 0.4
          ? 'inset 0 0 0 ' + gapPx.toFixed(2) + 'px ' + (g.gapDark ? '#151310' : '#FFFFFF') + ', '
          : '') + '0 2px 6px rgba(0,0,0,0.28)';
      }
      function despeTile(mini) {
        mini.style.border = 'none';
        mini.style.backgroundClip = '';
        mini.style.boxSizing = '';
      }

      opts.forEach(function (b, i) {
        b.style.setProperty('--rd-mini-i', iAtiva < 0 ? '0' : String(Math.abs(i - iAtiva)));
        var env = AMB_ENVS.filter(function (e) { return e.id === b.dataset.mode; })[0];
        var ehTile = b.classList.contains('pdp26-trilho__tile');
        var mini = b.querySelector('.rd-envth__art');
        var cena = b.querySelector('.rd-envth__cena') || b;
        if (!mini) return;
        var cw = cena.clientWidth || b.clientWidth, ch = cena.clientHeight || b.clientHeight;
        if (!cw || !ch) return;

        /* a miniatura da VISTA DO QUADRO: a peça sozinha no fundo do palco, na
           mesma proporção real. Não é um cômodo — é a obra em exposição. */
        if (b.dataset.mode === 'quadro') {
          var hq = ch * 0.62, wq = hq * (wcm / hcm);
          if (wq > cw * 0.68) { wq = cw * 0.68; hq = wq * (hcm / wcm); }
          mini.style.left = ((cw - wq) / 2).toFixed(2) + 'px';
          mini.style.top = ((ch - hq) / 2).toFixed(2) + 'px';
          mini.style.width = wq.toFixed(2) + 'px';
          mini.style.height = hq.toFixed(2) + 'px';
          mini.style.backgroundImage = src ? 'url("' + src + '")' : '';
          if (ehTile && g && profCm > 0) {
            vesteTile(mini, hq / hcm);
          } else {
            if (ehTile) despeTile(mini);
            mini.style.boxShadow = g
              ? ('0 0 0 1px ' + fio + ', 0 1px 3px rgba(0,0,0,0.30)')
              : '0 1px 3px rgba(0,0,0,0.24)';
          }
          return;
        }
        if (!env) return;

        var img = env.img, cal = env.cal;
        var s = Math.max(cw / img.w, ch / img.h);
        var imgW = img.w * s, imgH = img.h * s;
        var escala = cal.pxPerCm * s;
        var w = wcm * escala, h = hcm * escala;

        /* onde o fundo precisa estar pra obra cair no alvo do dedal — a conta
           usa hRef (o MAIOR tamanho), não a obra escolhida: é isso que trava o
           cômodo no lugar quando o tamanho muda (28/jul) */
        var hRef = hcmRef * escala;
        var dxAlvo = MINI_ALVO_X * cw - cal.anchorX * imgW;
        var dyAlvo = MINI_ALVO_Y * ch + hRef / 2 - cal.anchorY * imgH;
        /* 3/ago (pdp2026): no TILE o corte ancora na LINHA DOS MÓVEIS a 72%
           da altura — é o móvel que diz "quarto"/"jantar", e o corpo dele
           (mesa, cama) precisa aparecer, não só a beirada (pedidos ao vivo:
           "deixa o quarto visível", "quero ver mais a mesa"). */
        if (ehTile) dyAlvo = 0.72 * ch - env.furnitureY * imgH;
        var px = (cw - imgW) ? dxAlvo / (cw - imgW) : 0.5;
        var py = (ch - imgH) ? dyAlvo / (ch - imgH) : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        var dx = (cw - imgW) * px, dy = (ch - imgH) * py;

        /* mesmos limites do palco: nem no teto, nem dentro do móvel */
        var ax = dx + cal.anchorX * imgW;
        var ay = dy + cal.anchorY * imgH - h / 2;
        /* 3/ago (pdp2026): no TILE grande o quadro CENTRA na cena — o alvo do
           dedal (0.47 + metade do maior tamanho) deixava a peça alta conforme
           o corte; teto e móvel continuam clampando logo abaixo. */
        if (ehTile) ay = ch * 0.5;
        var ceilY = dy + env.ceilY * imgH + 0.02 * imgH;
        if (ay - h / 2 < ceilY) ay = ceilY + h / 2;
        var furnY = dy + env.furnitureY * imgH;
        var pL = ax - w / 2, pR = ax + w / 2;
        (env.noTouch || []).forEach(function (nb) {
          var bx0 = dx + nb.x0 * imgW, bx1 = dx + nb.x1 * imgW, by0 = dy + nb.y0 * imgH;
          if (pR > bx0 && pL < bx1) furnY = Math.min(furnY, by0);
        });
        if (ay + h / 2 > furnY) ay = furnY - h / 2;
        /* (16/out) mesma trava de encaixe do palco */
        var livreM = furnY - ceilY;
        if (livreM > 0 && h > livreM) {
          var encM = livreM / h;
          escala *= encM; w *= encM; h *= encM;
          ay = furnY - h / 2;
        }

        cena.style.setProperty('background-position', (px * 100).toFixed(2) + '% ' + (py * 100).toFixed(2) + '%', 'important');
        mini.style.left = (ax - w / 2).toFixed(2) + 'px';
        mini.style.top = (ay - h / 2).toFixed(2) + 'px';
        mini.style.width = Math.max(3, w).toFixed(2) + 'px';
        mini.style.height = Math.max(3, h).toFixed(2) + 'px';
        mini.style.backgroundImage = src ? 'url("' + src + '")' : '';
        if (ehTile && g && profCm > 0) {
          vesteTile(mini, escala);
          return;
        }
        if (ehTile) despeTile(mini);
        /* no dedal a moldura não cabe em pixel: ela vira o fio que contorna a arte */
        mini.style.boxShadow = g
          ? ('0 0 0 1px ' + fio + ', 0 1px 2px rgba(0,0,0,0.42)')
          : '0 1px 2px rgba(0,0,0,0.34)';
      });
      /* 27/jul: a obra dentro das cenas só ANIMA a partir da segunda pintura. Na
         primeira ela nasce — e nascer animando faria as cinco crescerem do canto
         superior esquerdo toda vez que a página abre. */
      if (!ddMenu.classList.contains('rd-mini-anima')) {
        requestAnimationFrame(function () { ddMenu.classList.add('rd-mini-anima'); });
      }
    }

    /* 3/ago (pdp2026, fatia 3): a PONTE — fita e trilho vivos moram no
       pdp2026.js, mas o palco (modos, cenas, repintura) é deste motor. Só o
       necessário atravessa aqui; fora do ?view=pdp2026 a ponte não existe.
       Contrato: envs (lista viva do AMB_ENVS), srcDe(env), setMode(id|'quadro'),
       modo(), pinta() — repinta miniaturas E os tiles registrados em
       window.__pdp26Tiles (ver pintaMini acima). */
    if (root.dataset.pdp2026) {
      window.__pdp26Amb = {
        envs: AMB_ENVS,
        srcDe: envSrc,
        setMode: setMode,
        /* (4/ago) o caminho ANIMADO, exposto: os traços do pdp2026 chamavam
           os botões do dropdown por clique sintético e esbarravam em estados
           is-on velhos — o clique era engolido e a troca caía no swap seco.
           Daqui se entra direto na máquina (com o crossfade do mobile). */
        vai: function (id) {
          var i = slTrack().indexOf(id === 'quadro' ? 'quadro' : id);
          return i >= 0 && slGo(i, SL_MODO_BOTAO);
        },
        /* (4/ago) a ALAVANCA do scrubber: a barra dirige a máquina de deslize
           — a mesma do arrasto — com progresso contínuo ("a revelação
           precisa ocorrer conforme o scroll lateral"). comeca/move/solta
           espelham slBegin/slDrag/slEnd; w/idx/n dão a régua. */
        arrastaBar: {
          comeca: function (to, dir) {
            if (slBusy) return null;
            var st = slBegin(to, 'slide', dir);
            return st || null;
          },
          move: function (st, px) { try { slDrag(st, px); } catch (e) {} },
          solta: function (st, commit) { try { slEnd(st, commit); } catch (e) {} },
          w: function () { return slW(); },
          idx: function () { return slIdx(); },
          n: function () { return slTrack().length; }
        },
        modo: function () { return mode; },
        pinta: pintaMini
      };
      root.dispatchEvent(new CustomEvent('pdp26:palco-pronto'));
    }

    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) {

        setMode(curEnv.id);
      }
      /* tamanho e acabamento também mudam o que a miniatura mostra */
      if (typeof pintaMini === 'function') setTimeout(pintaMini, 60);
      /* 27/jul — ENQUADRAR, NÃO TELEPORTAR.
         Tamanho é a única escolha que só existe em relação à parede, e é a mais
         comparativa de todas: ninguém escolhe M no absoluto, escolhe M em vez de
         P. Até aqui, trocar o tamanho no celular não mostrava nada — o palco fica
         pinado no topo, mas coberto pela folha assim que você desce até os chips.
         Agora a PRIMEIRA troca posiciona a tela num enquadramento onde a fatia de
         baixo do palco e os chips convivem; da segunda em diante nada mais rola,
         e dá pra ir e voltar entre os tamanhos comparando de verdade. */
      if (e.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) {
        /* a régua não pode fechar no mesmo gesto que a usou */
        if (typeof fitaCompara !== 'undefined') fitaCompara.on = true;
        setTimeout(enquadraTamanho, 40);
      }
      if (mode !== 'quadro') setTimeout(layout, 400);
    }, true);

    var FATIA_PALCO = 340;   /* quanto de palco fica à mostra no enquadramento */
    var alvoEnquadrado = null;
    function enquadraTamanho() {
      if (!isRedesign || !window.matchMedia('(max-width: 959px)').matches) return;
      /* (4/ago) na PDP 2026 o palco é STICKY: ele já está à vista o tempo
         todo, então rolar a página ao trocar de tamanho só tira a régua de
         baixo do polegar da pessoa. O enquadramento existia para a PDP
         antiga, onde o palco saía de cena ao descer. */
      if (root.dataset.pdp2026) return;
      var fs = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
      if (!fs) return;
      /* 27/jul — VAI PRO PALCO INTEIRO, não pra um recorte dele.
         A versão anterior enquadrava chips + uma fatia de foto. Deixou de fazer
         sentido quando a régua de tamanho desceu pra cima do sticky: agora não é
         preciso manter os chips à vista, porque a régua está no pé da tela, no
         polegar. Então a rolagem entrega o que interessa — a OBRA INTEIRA no
         palco, com as cenas logo abaixo dela — e a pessoa continua trocando de
         tamanho pela régua, sem a tela se mexer de novo. */
      var alvo = 0;
      if (Math.abs(window.scrollY - alvo) < 44) { alvoEnquadrado = alvo; return; }
      alvoEnquadrado = alvo;
      window.scrollTo({ top: alvo, behavior: 'smooth' });
    }

    /* (crossfade da moldura: tentado e removido em 27/jul. Ao remover, esta linha
       foi junto por engano e o `frameImg is not defined` derrubou o resto do
       setupAmbientado — sumindo com doca, nota, mini e bloco da obra.) */
    var frameImg = slide.querySelector('.pp26__frame');
    if (frameImg) {

      new MutationObserver(function () {
        /* 27/jul: a miniatura carrega a moldura escolhida — trocar pra PRETA tem
           que escurecer o fio das cinco na hora. Antes isso só acontecia dentro do
           ambientado, porque o repinte pegava carona no layout(). */
        if (typeof pintaMini === 'function') requestAnimationFrame(pintaMini);
        if (mode !== 'quadro') layout();
      }).observe(frameImg, { attributes: true, attributeFilter: ['data-frame-type', 'data-frame-color'] });
    }
    window.addEventListener('resize', function () {
      if (mode !== 'quadro') requestAnimationFrame(layout);
    });
    photo.addEventListener('load', function () { if (mode !== 'quadro') layout(); });

    if (ambeditOn) {
      setMode(curEnv.id);
      var panel = document.createElement('div');
      panel.className = 'jun26-ambedit';
      panel.innerHTML =
        '<strong>AMBIENTADO · <em data-env></em><button type="button" class="jun26-ambedit-min" data-act="min" aria-label="minimizar">–</button></strong>' +
        '<details class="jun26-ambedit-sec" open><summary>escala & posição</summary>' +
        '<label>escala do quadro <input type="range" min="3" max="14" step="0.05" data-k="pxPerCm"><span></span></label>' +
        '<label>âncora X <input type="range" min="0.2" max="0.8" step="0.005" data-k="anchorX"><span></span></label>' +
        '<label>pé do quadro Y <input type="range" min="0.15" max="0.85" step="0.005" data-k="anchorY"><span></span></label>' +
        '<label>móveis Y <input type="range" min="0.3" max="0.95" step="0.005" data-k="furnitureY"><span></span></label>' +
        '<label>teto Y <input type="range" min="0" max="0.4" step="0.005" data-k="ceilY"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>enquadramento</summary>' +
        '<label>zoom <input type="range" min="1" max="2.5" step="0.01" data-k="zoom"><span></span></label>' +
        '<label>foco X <input type="range" min="0" max="1" step="0.005" data-k="focalX"><span></span></label>' +
        '<label>foco Y <input type="range" min="0" max="1" step="0.005" data-k="focalY"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>cores da foto</summary>' +
        '<label>brilho <input type="range" min="50" max="150" step="1" data-fx="brilho"><span></span></label>' +
        '<label>contraste <input type="range" min="50" max="150" step="1" data-fx="contraste"><span></span></label>' +
        '<label>saturação <input type="range" min="0" max="200" step="1" data-fx="saturacao"><span></span></label>' +
        '<label>calor (amarelo) <input type="range" min="0" max="30" step="1" data-fx="calor"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>cores das molduras</summary>' +
        '<label>madeira escura <input type="color" data-wood="marrom"></label>' +
        '<label>preta <input type="color" data-wood="preta"></label>' +
        '<label>madeira clara <input type="color" data-wood="clara"></label>' +
        '<label>branca <input type="color" data-wood="branca"></label>' +
        '<label>trama do canvas <input type="range" min="0" max="60" step="1" data-tex="op"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec" open data-sec="zonas"><summary>zonas no-touch (<span data-ntcount>0</span>)</summary>' +
        '<div class="jun26-ambedit-ntlist" data-ntlist></div>' +
        '</details>' +
        '<button type="button" data-act="copy">copiar valores</button>' +
        '<button type="button" data-act="reset">reset</button>' +
        '<textarea class="jun26-ambedit-out" readonly></textarea>';
      document.body.appendChild(panel);
      var outBox = panel.querySelector('.jun26-ambedit-out');

      (function () {
        var header = panel.querySelector('strong');
        if (!header) return;
        header.style.cursor = 'move';
        var drag = false, sx, sy, startLeft, startTop;
        header.addEventListener('mousedown', function (e) {
          if (e.target.dataset.act === 'min') return;
          var r = panel.getBoundingClientRect();
          panel.style.left = r.left + 'px';
          panel.style.top = r.top + 'px';
          panel.style.right = 'auto';
          panel.style.bottom = 'auto';
          drag = true; sx = e.clientX; sy = e.clientY; startLeft = r.left; startTop = r.top;
          e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!drag) return;

          var nt = Math.max(0, Math.min(window.innerHeight - 80, startTop + e.clientY - sy));
          panel.style.left = Math.max(0, startLeft + e.clientX - sx) + 'px';
          panel.style.top = nt + 'px';
          panel.style.maxHeight = (window.innerHeight - nt - 14) + 'px';
        });
        window.addEventListener('mouseup', function () { drag = false; });
      })();
      var CALDEF = { zoom: 1, focalX: 0.5, focalY: 0.5 };
      var envVal = function (k) {
        if (k === 'furnitureY' || k === 'ceilY') return curEnv[k];
        var v = curEnv.cal[k];
        return v != null ? v : (CALDEF[k] != null ? CALDEF[k] : 0);
      };
      var rgbToHex = function (a) { return '#' + a.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); };
      var hexToRgb = function (h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; };
      var syncPanel = function () {
        var lbl = panel.querySelector('[data-env]');
        if (lbl) lbl.textContent = curEnv.label;
        panel.querySelectorAll('input[data-k]').forEach(function (inp) {
          var k = inp.dataset.k;
          inp.value = envVal(k);
          inp.nextElementSibling.textContent = (+envVal(k)).toFixed(k === 'pxPerCm' ? 2 : 3);
        });
        if (!curEnv.fx) curEnv.fx = Object.assign({}, AMB_FX_DEF);
        panel.querySelectorAll('input[data-fx]').forEach(function (inp) {
          var k = inp.dataset.fx;
          var v = curEnv.fx[k] != null ? curEnv.fx[k] : AMB_FX_DEF[k];
          inp.value = v;
          inp.nextElementSibling.textContent = v;
        });
        panel.querySelectorAll('input[data-wood]').forEach(function (inp) {
          if (AMB_WOOD[inp.dataset.wood]) inp.value = rgbToHex(AMB_WOOD[inp.dataset.wood]);
        });
        var texInp = panel.querySelector('input[data-tex]');
        if (texInp) { texInp.value = Math.round(AMB_TEX_OP * 100); texInp.nextElementSibling.textContent = Math.round(AMB_TEX_OP * 100); }
      };
      ambeditSync = syncPanel;
      syncPanel();

      root.classList.add('jun26-amb-editing');
      ['nw', 'ne', 'sw', 'se'].forEach(function (pos) {
        var hd = document.createElement('div');
        hd.className = 'jun26-amb-handle jun26-amb-handle--' + pos;
        hd.dataset.handle = pos;
        quadro.appendChild(hd);
      });
      var dragState = null;
      quadro.addEventListener('mousedown', function (e) {
        if (mode === 'quadro' || !lastGeo) return;
        if (e.target.dataset && e.target.dataset.handle) {
          var r = quadro.getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          dragState = {
            type: 'resize', cx: cx, cy: cy,
            d0: Math.hypot(e.clientX - cx, e.clientY - cy) || 1,
            px0: curEnv.cal.pxPerCm
          };
        } else {
          dragState = {
            type: 'move', x0: e.clientX, y0: e.clientY,
            ax0: curEnv.cal.anchorX, ay0: curEnv.cal.anchorY
          };
        }
        e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragState || !lastGeo) return;
        if (dragState.type === 'move') {
          curEnv.cal.anchorX = Math.max(0.05, Math.min(0.95, dragState.ax0 + (e.clientX - dragState.x0) / lastGeo.imgW));
          curEnv.cal.anchorY = Math.max(0.1, Math.min(0.95, dragState.ay0 + (e.clientY - dragState.y0) / lastGeo.imgH));
        } else {
          var d = Math.hypot(e.clientX - dragState.cx, e.clientY - dragState.cy);
          curEnv.cal.pxPerCm = Math.max(3, Math.min(14, dragState.px0 * d / dragState.d0));
        }
        localStorage.setItem('jun26_amb_cal_' + curEnv.id, JSON.stringify(curEnv.cal));
        layout(); syncPanel();
      });
      window.addEventListener('mouseup', function () { dragState = null; });

      function ntClamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
      var zonesEl = document.createElement('div');
      zonesEl.className = 'jun26-amb-zones';
      amb.appendChild(zonesEl);
      function saveNT() { localStorage.setItem('jun26_amb_nt_' + curEnv.id, JSON.stringify(curEnv.noTouch || [])); }
      zonesRender = function () {
        var nt = curEnv.noTouch || [];

        var cnt = panel.querySelector('[data-ntcount]'); if (cnt) cnt.textContent = nt.length;
        var list = panel.querySelector('[data-ntlist]');
        if (list) {
          list.innerHTML = '';
          nt.forEach(function (b, i) {
            var row = document.createElement('div');
            row.className = 'jun26-ambedit-ntrow';
            row.innerHTML = '<span>zona ' + (i + 1) + '</span>' +
              '<button type="button" data-ntsel="' + i + '">ver</button>' +
              '<button type="button" data-ntdel="' + i + '">×</button>';
            list.appendChild(row);
          });
        }
        if (!lastGeo) return;
        zonesEl.innerHTML = '';
        nt.forEach(function (b, i) {
          var el = document.createElement('div');
          el.className = 'jun26-amb-zone';
          el.dataset.i = i;
          el.style.left = (lastGeo.dx + b.x0 * lastGeo.imgW).toFixed(1) + 'px';
          el.style.top = (lastGeo.dy + b.y0 * lastGeo.imgH).toFixed(1) + 'px';
          el.style.width = ((b.x1 - b.x0) * lastGeo.imgW).toFixed(1) + 'px';
          el.style.height = ((b.y1 - b.y0) * lastGeo.imgH).toFixed(1) + 'px';
          var lbl = document.createElement('span');
          lbl.className = 'jun26-amb-zone-lbl'; lbl.textContent = i + 1;
          var rm = document.createElement('button');
          rm.className = 'jun26-amb-zone-x'; rm.type = 'button'; rm.textContent = '×'; rm.dataset.rm = i;
          var hd = document.createElement('div');
          hd.className = 'jun26-amb-zone-h'; hd.dataset.rz = i;
          el.appendChild(lbl); el.appendChild(rm); el.appendChild(hd);
          zonesEl.appendChild(el);
        });
      };
      var zDrag = null;
      zonesEl.addEventListener('mousedown', function (e) {
        var d = e.target.dataset;
        if (d.rm != null) { curEnv.noTouch.splice(+d.rm, 1); saveNT(); layout(); e.preventDefault(); e.stopPropagation(); return; }
        var i = d.rz != null ? +d.rz : (d.i != null ? +d.i : -1);
        if (i < 0) return;
        zDrag = { type: d.rz != null ? 'resize' : 'move', i: i, x0: e.clientX, y0: e.clientY, box: Object.assign({}, curEnv.noTouch[i]) };
        e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!zDrag || !lastGeo) return;
        var dxf = (e.clientX - zDrag.x0) / lastGeo.imgW, dyf = (e.clientY - zDrag.y0) / lastGeo.imgH;
        var b = curEnv.noTouch[zDrag.i], o = zDrag.box;
        if (zDrag.type === 'move') {
          var wv = o.x1 - o.x0, hv = o.y1 - o.y0;
          b.x0 = ntClamp(o.x0 + dxf, 0, 1 - wv); b.y0 = ntClamp(o.y0 + dyf, 0, 1 - hv);
          b.x1 = b.x0 + wv; b.y1 = b.y0 + hv;
        } else {
          b.x1 = ntClamp(o.x1 + dxf, b.x0 + 0.03, 1); b.y1 = ntClamp(o.y1 + dyf, b.y0 + 0.03, 1);
        }
        saveNT(); layout();
      });
      window.addEventListener('mouseup', function () { zDrag = null; });

      var guidesEl = document.createElement('div');
      guidesEl.className = 'jun26-amb-guides';
      amb.appendChild(guidesEl);
      guidesRender = function () {
        if (!lastGeo) return;
        guidesEl.innerHTML = '';
        [['furnitureY', 'móveis'], ['ceilY', 'teto']].forEach(function (g) {
          var el = document.createElement('div');
          el.className = 'jun26-amb-guide jun26-amb-guide--' + g[0];
          el.dataset.guide = g[0];
          el.style.top = (lastGeo.dy + curEnv[g[0]] * lastGeo.imgH).toFixed(1) + 'px';
          el.innerHTML = '<span class="jun26-amb-guide-lbl">' + g[1] + '</span>';
          guidesEl.appendChild(el);
        });
      };
      var gDrag = null;
      guidesEl.addEventListener('mousedown', function (e) {
        var t = e.target;
        var k = t.dataset.guide || (t.parentElement && t.parentElement.dataset.guide);
        if (!k) return;
        gDrag = k; e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!gDrag || !lastGeo) return;
        var r = amb.getBoundingClientRect();
        var frac = Math.max(0, Math.min(0.98, (e.clientY - r.top - lastGeo.dy) / lastGeo.imgH));
        curEnv[gDrag] = +frac.toFixed(3);
        localStorage.setItem('jun26_amb_lines_' + curEnv.id, JSON.stringify({ furnitureY: curEnv.furnitureY, ceilY: curEnv.ceilY }));
        layout(); syncPanel();
      });
      window.addEventListener('mouseup', function () { gDrag = null; });

      var addZ = document.createElement('button');
      addZ.type = 'button'; addZ.textContent = '+ zona (no-touch)';
      (panel.querySelector('[data-sec="zonas"]') || panel).appendChild(addZ);
      addZ.addEventListener('click', function () {
        curEnv.noTouch = curEnv.noTouch || [];
        curEnv.noTouch.push({ x0: 0.36, y0: 0.45, x1: 0.64, y1: 0.6 });
        saveNT(); layout();
      });

      var ntList = panel.querySelector('[data-ntlist]');
      if (ntList) ntList.addEventListener('click', function (e) {
        var d = e.target.dataset;
        if (d.ntdel != null) { curEnv.noTouch.splice(+d.ntdel, 1); saveNT(); layout(); }
        else if (d.ntsel != null) {
          var z = zonesEl.children[+d.ntsel];
          if (z) { z.classList.add('jun26-amb-zone--flash'); setTimeout(function () { z.classList.remove('jun26-amb-zone--flash'); }, 900); }
        }
      });

      panel.addEventListener('input', function (e) {
        var t = e.target;
        if (t.dataset.k) {
          var k = t.dataset.k, v = parseFloat(t.value);
          if (k === 'furnitureY' || k === 'ceilY') {
            curEnv[k] = v;
            localStorage.setItem('jun26_amb_lines_' + curEnv.id, JSON.stringify({ furnitureY: curEnv.furnitureY, ceilY: curEnv.ceilY }));
          } else {
            curEnv.cal[k] = v;
            localStorage.setItem('jun26_amb_cal_' + curEnv.id, JSON.stringify(curEnv.cal));
          }
          t.nextElementSibling.textContent = v.toFixed(k === 'pxPerCm' ? 2 : 3);
          layout();
        } else if (t.dataset.fx) {
          var fk = t.dataset.fx, fv = parseFloat(t.value);
          if (!curEnv.fx) curEnv.fx = Object.assign({}, AMB_FX_DEF);
          curEnv.fx[fk] = fv;
          t.nextElementSibling.textContent = fv;
          localStorage.setItem('jun26_amb_fx_' + curEnv.id, JSON.stringify(curEnv.fx));
          applyPhotoFilter();
        } else if (t.dataset.wood) {

          AMB_WOOD[t.dataset.wood] = hexToRgb(t.value);
          localStorage.setItem('jun26_amb_wood', JSON.stringify(AMB_WOOD));
          layout();
        } else if (t.dataset.tex) {

          AMB_TEX_OP = parseFloat(t.value) / 100;
          t.nextElementSibling.textContent = t.value;
          localStorage.setItem('jun26_amb_tex', AMB_TEX_OP);
          layout();
        }
      });

      var copyText = function (t) {
        if (outBox) { outBox.value = t; outBox.focus(); outBox.select(); }
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t); } catch (e) {  }
        return ok;
      };
      panel.addEventListener('click', function (e) {
        var act = e.target.dataset.act;
        if (act === 'min') {
          var min = panel.classList.toggle('jun26-ambedit--min');
          e.target.textContent = min ? '+' : '–';
          return;
        }
        if (act === 'copy') {
          var c = curEnv.cal, f = curEnv.fx || AMB_FX_DEF;

          var editor = '— Editor de tema —' +
            '\nEscala do quadro: ' + Math.round(c.pxPerCm * 10) +
            '\nPosição horizontal: ' + Math.round(c.anchorX * 100) +
            '\nAltura do pé do quadro: ' + Math.round(c.anchorY * 100) +
            '\nLinha dos móveis: ' + Math.round(curEnv.furnitureY * 100) +
            '\nLinha do teto: ' + Math.round(curEnv.ceilY * 100) +
            '\nZoom: ' + Math.round((c.zoom || 1) * 100) +
            '  Foco X: ' + Math.round((c.focalX != null ? c.focalX : 0.5) * 100) +
            '  Foco Y: ' + Math.round((c.focalY != null ? c.focalY : 0.5) * 100) +
            '\nBrilho: ' + f.brilho + '  Contraste: ' + f.contraste +
            '  Saturação: ' + f.saturacao + '  Calor: ' + f.calor +
            '\nZonas no-touch: ' + ((curEnv.noTouch && curEnv.noTouch.length) || 0);
          var nt = curEnv.noTouch && curEnv.noTouch.length ? (',\n  noTouch: ' + JSON.stringify(curEnv.noTouch)) : '';
          var out = "{ id: '" + curEnv.id + "', label: '" + curEnv.label +
            "', asset: '" + (curEnv.asset || curEnv.assetUrl || '') + "',\n  img: { w: " + curEnv.img.w +
            ', h: ' + curEnv.img.h + ' },\n  cal: ' + JSON.stringify(c) +
            ',\n  furnitureY: ' + curEnv.furnitureY + ', ceilY: ' + curEnv.ceilY +
            ',\n  fx: ' + JSON.stringify(f) + nt + ' }\n\n' + editor +
            '\n\n// cores das molduras (GLOBAL — vale pra todos os ambientes):\nvar AMB_WOOD = ' + JSON.stringify(AMB_WOOD) + ';' +
            '\nvar AMB_TEX_OP = ' + AMB_TEX_OP + '; // transparência da trama do canvas';
          var ok = copyText(out);
          console.log('[ambedit ' + curEnv.id + ']\n' + out);
          e.target.textContent = ok ? 'copiado ✓' : 'copie do campo ↓';
          setTimeout(function () { e.target.textContent = 'copiar valores'; }, 1600);
        } else if (act === 'reset') {
          localStorage.removeItem('jun26_amb_cal_' + curEnv.id);
          localStorage.removeItem('jun26_amb_fx_' + curEnv.id);
          localStorage.removeItem('jun26_amb_nt_' + curEnv.id);
          curEnv.fx = Object.assign({}, AMB_FX_DEF);
          curEnv.noTouch = [];
          syncPanel();
          layout();
          applyPhotoFilter();
        }
      });
    }
  }

  function inferStateFromSelection(molduraFs) {
    var current = molduraFs.querySelector('input:checked');
    return inferStateFromVariant(current ? current.value : 'padrão');
  }

  function inferStateFromVariant(value) {
    var s = { primario: 'padrão', profundidade: false, fino: false, paspatur: false };
    switch (value) {
      case 'canvas': s.primario = 'canvas'; break;
      case 'sem moldura': s.primario = 'sem moldura'; break;
      case 'padrão': break;
      case 'padrão com paspatur': s.paspatur = true; break;
      case 'caixa': s.profundidade = true; break;
      case 'caixa com paspatur': s.profundidade = true; s.paspatur = true; break;
      case 'slim': s.fino = true; break;
      case 'slim com paspatur': s.fino = true; s.paspatur = true; break;
    }
    return s;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';
  if (!/[?&]rendercheck/.test(location.search)) return;
  function assetBase() {
    var l = document.querySelector('link[href*="jun26"]');
    return l ? l.href.replace(/jun26[^\/]*\.css.*$/, '') : '/';
  }

  var FRAMES = {
    vertical:   { url: 'frame-render-vert.png',  OL: 0.1321, OT: 0.0811, OW: 0.6957, OH: 0.8129, FR: 0.0532 },
    horizontal: { url: 'frame-render-horiz.png', OL: 0.1351, OT: 0.1456, OW: 0.7448, OH: 0.6817, FR: 0.0373 },
    quadrado:   { url: 'frame-render-quad.png',  OL: 0.1760, OT: 0.2091, OW: 0.6749, OH: 0.6183, FR: 0.0445 }
  };
  var CSS_PERFIL_CM = 2.0;
  function orientNow() {
    var g = document.querySelector('pp26-gallery');
    var o = (g && g.dataset.orientation) || 'vertical';
    return FRAMES[o] ? o : 'vertical';
  }
  function pickerSizes() {
    return [].slice.call(document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input')).map(function (i) { return i.value; });
  }
  var STORE = 'jun26_rendercheck';
  function load() { try { return JSON.parse(localStorage.getItem(STORE) || '{}'); } catch (e) { return {}; } }
  function save(v) { localStorage.setItem(STORE, JSON.stringify(v)); }

  function start() {
    if (document.getElementById('jun26-rc-stage')) return;
    var tamFs = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])');
    var artEl = document.querySelector('.pp26__art') || document.querySelector('.jun26-amb-art');
    if (!tamFs || !artEl) return setTimeout(start, 400);

    var ORIENT = orientNow();
    var CFG = FRAMES[ORIENT];
    var OL = CFG.OL, OT = CFG.OT, OW = CFG.OW, OH = CFG.OH, FR = CFG.FR;
    var FRAME_URL = assetBase() + CFG.url;
    var measure = { renderCm: 0, cssCm: CSS_PERFIL_CM };

    [].slice.call(document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input')).forEach(function (i) {
      i.style.display = ''; var l = i.nextElementSibling; if (l) l.style.display = '';
      var c = i.parentElement; if (c) c.style.display = '';
    });

    var stage = document.createElement('div');
    stage.id = 'jun26-rc-stage';
    stage.style.cssText = 'position:fixed;left:0;top:56px;width:calc(100vw - 266px);height:calc(100vh - 56px);z-index:99990;background:#e7e3db;overflow:hidden;font-family:Archivo,Arial,sans-serif';
    stage.innerHTML =
      '<div class="rc-a"      style="position:absolute;background-size:cover;background-position:center"></div>' +
      '<div class="rc-f"      style="position:absolute;background-size:100% 100%;background-repeat:no-repeat"></div>' +
      '<div class="rc-cssbox" style="position:absolute;background:#1a1a1a"></div>' +
      '<div class="rc-cssa"   style="position:absolute;background-size:cover;background-position:center"></div>' +
      '<div class="rc-rl" style="position:absolute;text-align:center;font-weight:800;font-size:15px;color:#222">render</div>' +
      '<div class="rc-cl" style="position:absolute;text-align:center;font-weight:800;font-size:15px;color:#222">css (perfil 2 cm)</div>' +
      '<div class="rc-size" style="position:absolute;left:0;right:0;top:20px;text-align:center;font-weight:800;font-size:18px;color:#333"></div>';
    document.body.appendChild(stage);
    var A = stage.querySelector('.rc-a'), F = stage.querySelector('.rc-f'),
        CB = stage.querySelector('.rc-cssbox'), CA = stage.querySelector('.rc-cssa'),
        RL = stage.querySelector('.rc-rl'), CL = stage.querySelector('.rc-cl'), SZ = stage.querySelector('.rc-size');
    F.style.backgroundImage = 'url(' + FRAME_URL + ')';

    function sizeCm(v) { var p = v.split('x'); var w = +p[0], h = +p[1]; return ORIENT === 'horizontal' ? Math.max(w, h) : w; }
    function renderBorderCm(v) { return FR * sizeCm(v); }
    function curArt() { var a = document.querySelector('.pp26__art') || document.querySelector('.jun26-amb-art'); return a ? (a.currentSrc || a.src) : ''; }
    function curSize() { var s = document.querySelector(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input:checked'); return s ? s.value : ''; }

    var lastArt = '';
    function sync() {
      var v = curSize(); if (!v) return;
      var p = v.split('x'); var w = +p[0], h = +p[1];
      if (ORIENT === 'horizontal') { var t = w; w = h; h = t; }
      var ow = stage.clientWidth, oh = stage.clientHeight, ar2 = w / h;
      var availW = ow * 0.92, availH = oh * 0.78;
      function pairWFor(ah) { var aw = ah * ar2, cb = CSS_PERFIL_CM * (ah / h); return aw / OW + Math.max(24, aw * 0.14) + (aw + 2 * cb); }
      var AH = availH; var pw = pairWFor(AH); if (pw > availW) AH = AH * (availW / pw);
      var aw = AH * ar2, cssB = CSS_PERFIL_CM * (AH / h);
      var rFullW = aw / OW, rFullH = AH / OH, gap = Math.max(24, aw * 0.14);
      var cssOW = aw + 2 * cssB, cssOH = AH + 2 * cssB;
      var pairW = rFullW + gap + cssOW, pairH = Math.max(rFullH, cssOH);
      var x0 = (ow - pairW) / 2, y0 = (oh - pairH) / 2 + 16;
      var rTop = y0 + (pairH - rFullH) / 2;
      A.style.left = (x0 + OL * rFullW) + 'px'; A.style.top = (rTop + OT * rFullH) + 'px'; A.style.width = aw + 'px'; A.style.height = AH + 'px';
      F.style.left = x0 + 'px'; F.style.top = rTop + 'px'; F.style.width = rFullW + 'px'; F.style.height = rFullH + 'px';
      var cx0 = x0 + rFullW + gap, cTop = y0 + (pairH - cssOH) / 2;
      CB.style.left = cx0 + 'px'; CB.style.top = cTop + 'px'; CB.style.width = cssOW + 'px'; CB.style.height = cssOH + 'px';
      CA.style.left = (cx0 + cssB) + 'px'; CA.style.top = (cTop + cssB) + 'px'; CA.style.width = aw + 'px'; CA.style.height = AH + 'px';
      var src = curArt(); if (src && src !== lastArt) { A.style.backgroundImage = 'url(' + src + ')'; CA.style.backgroundImage = 'url(' + src + ')'; lastArt = src; }
      RL.style.left = x0 + 'px'; RL.style.top = (rTop - 26) + 'px'; RL.style.width = rFullW + 'px';
      CL.style.left = cx0 + 'px'; CL.style.top = (cTop - 26) + 'px'; CL.style.width = cssOW + 'px';
      SZ.textContent = ORIENT + ' · ' + v.replace('x', ' × ') + ' cm';
      measure.renderCm = renderBorderCm(v);
    }
    setInterval(sync, 150); sync();

    var panel = document.createElement('div');
    panel.id = 'jun26-rc-panel';
    panel.style.cssText = 'position:fixed;top:70px;right:18px;z-index:99999;background:#fff;border:1px solid #111;border-radius:8px;padding:12px;width:236px;font:12px Archivo,system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.18);max-height:86vh;overflow:auto';
    document.body.appendChild(panel);
    var verdicts = load();
    function selectSize(s) {
      var inp = [].slice.call(document.querySelectorAll(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"]) input')).filter(function (i) { return i.value === s; })[0];
      if (inp) { var lbl = document.querySelector('label[for="' + inp.id + '"]'); (lbl || inp).click(); inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    function btn(s, v, label, on, c) {
      return '<button data-s="' + s + '" data-v="' + v + '" style="flex:1;cursor:pointer;border:1px solid ' + (on ? c : '#ddd') + ';background:' + (on ? c + '22' : '#fff') + ';color:' + (on ? c : '#444') + ';border-radius:4px;padding:3px 0;font-size:11px;font-weight:' + (on ? '700' : '400') + '">' + label + '</button>';
    }
    function render() {
      var cur = curSize(), nOk = 0, nF = 0, nG = 0;
      var SIZES = pickerSizes();
      var html = '<div style="font-weight:800;letter-spacing:.06em;text-transform:uppercase;font-size:10px;color:#888;margin-bottom:8px">render × css · check · ' + orientNow() + '</div>';
      SIZES.forEach(function (s) {
        var v = verdicts[s] || '';
        if (v === 'ok') nOk++; if (v === 'fina') nF++; if (v === 'grossa') nG++;
        var on = s === cur;
        var rc = renderBorderCm(s), sg = suggestFor(s);
        var diff = Math.round((rc / CSS_PERFIL_CM - 1) * 100);
        var diffTxt = diff === 0 ? 'igual ao css' : (diff > 0 ? ('+' + diff + '% (mais grossa)') : (diff + '% (mais fina)'));
        html += '<div style="' + (on ? 'background:#f3eee6;border-radius:5px;padding:3px 4px;margin-bottom:3px' : 'padding:0 4px;margin-bottom:3px') + '">'
          + '<div style="display:flex;align-items:center;gap:4px">'
          + '<span style="width:50px;font-weight:' + (on ? '800' : '600') + '">' + s.replace('x', '×') + '</span>'
          + btn(s, 'ok', 'ok', v === 'ok', '#3f7d4f')
          + btn(s, 'fina', '+fina', v === 'fina', '#b4503c')
          + btn(s, 'grossa', '+grossa', v === 'grossa', '#c0392b')
          + '</div>'
          + '<div style="font-size:9.5px;color:#999;padding-left:50px;margin-top:1px">'
          + 'render <b>' + rc.toFixed(1).replace('.', ',') + 'cm</b> vs 2,0cm · <span style="color:' + (sg === 'ok' ? '#3f7d4f' : '#b4503c') + '">' + diffTxt + '</span> → régua: <b>' + (sg === 'ok' ? 'ok' : '+' + sg) + '</b></div>'
          + '</div>';
      });
      var extra = (nF > 0 ? 1 : 0) + (nG > 0 ? 1 : 0);
      html += '<div style="border-top:1px solid #eee;margin-top:8px;padding-top:8px;font-size:11px">'
        + '<div>ok: <b>' + nOk + '</b> · +fina: <b>' + nF + '</b> · +grossa: <b>' + nG + '</b></div>'
        + '<div style="margin-top:4px;font-weight:800;color:#b4503c">precisa de ~' + extra + ' moldura(s) a mais</div>'
        + '<div style="display:flex;gap:6px;margin-top:8px">'
        + '<button id="rc-auto" style="flex:1;cursor:pointer;border:1px solid #111;background:#fff;border-radius:5px;padding:5px 0;font-size:11px;font-weight:700">aplicar régua</button>'
        + '<button id="rc-dl" style="flex:1;cursor:pointer;border:1px solid #111;background:#fff;border-radius:5px;padding:5px 0;font-size:11px;font-weight:700">baixar atual</button>'
        + '</div>'
        + '<button id="rc-dlall" style="width:100%;margin-top:6px;cursor:pointer;border:1px solid #111;background:#111;color:#fff;border-radius:5px;padding:7px 0;font-size:11px;font-weight:800">baixar TODAS lado a lado</button>'
        + '<div style="color:#999;margin-top:6px;font-size:10px">verde = aprovado · clique num tamanho p/ ver no stage</div>'
        + '</div>';
      panel.innerHTML = html;
      [].slice.call(panel.querySelectorAll('button[data-s]')).forEach(function (b) {
        b.addEventListener('click', function () {
          var s = b.dataset.s, v = b.dataset.v;
          verdicts[s] = (verdicts[s] === v) ? '' : v; save(verdicts);
          selectSize(s); render();
        });
      });
      var au = panel.querySelector('#rc-auto'); if (au) au.addEventListener('click', function () {
        pickerSizes().forEach(function (s) { var sg = suggestFor(s); verdicts[s] = sg; });
        save(verdicts); render();
      });
      var dl = panel.querySelector('#rc-dl'); if (dl) dl.addEventListener('click', downloadImg);
      var dla = panel.querySelector('#rc-dlall'); if (dla) dla.addEventListener('click', downloadAll);
    }
    function suggestFor(s) { var r = renderBorderCm(s) / CSS_PERFIL_CM; return r < 0.85 ? 'grossa' : (r > 1.15 ? 'fina' : 'ok'); }
    function verdictOf(s) { return verdicts[s] || suggestFor(s); }
    function stamp(cx, x, y, v) {
      var ok = v === 'ok';
      cx.textAlign = 'right'; cx.font = '800 17px Archivo,Arial';
      cx.fillStyle = ok ? '#3f7d4f' : '#c0392b';
      cx.fillText(ok ? '✓ APROVADO' : ('✗ +' + v), x, y);
    }
    function downloadAll() {
      var artImg = new Image(), frImg = new Image(), n = 0;
      function go() {
        if (++n < 2) return;
        var sizes = pickerSizes(), AH = 300, gap = 26, ipad = 28, labH = 50, cols = 2, mg = 26, titleH = 64;
        var cells = sizes.map(function (s) {
          var p = s.split('x'); var wcm = +p[0], hcm = +p[1];
          if (ORIENT === 'horizontal') { var t = wcm; wcm = hcm; hcm = t; }
          var SC = AH / hcm, aw = wcm * SC, ah = hcm * SC, cssB = CSS_PERFIL_CM * SC;
          return { s: s, aw: aw, ah: ah, cssB: cssB, rFullW: aw / OW, rFullH: ah / OH, v: verdictOf(s) };
        });
        var cW = 0, cH = 0;
        cells.forEach(function (c) { cW = Math.max(cW, c.rFullW + gap + c.aw + 2 * c.cssB); cH = Math.max(cH, Math.max(c.rFullH, c.ah + 2 * c.cssB)); });
        var cellW = cW + ipad * 2, cellH = labH + cH + 26, rows = Math.ceil(cells.length / cols);
        var cw = cols * cellW + (cols + 1) * mg, ch = titleH + rows * cellH + (rows + 1) * mg;
        var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
        var cx = cv.getContext('2d');
        cx.fillStyle = '#f3efe8'; cx.fillRect(0, 0, cw, ch);
        cx.fillStyle = '#222'; cx.textAlign = 'left'; cx.font = '800 26px Archivo,Arial';
        cx.fillText('render × css · ' + ORIENT + ' · perfil de referência 2,0 cm', mg, 42);
        cells.forEach(function (c, idx) {
          var col = idx % cols, row = (idx - col) / cols;
          var cellX = mg + col * (cellW + mg), cellY = titleH + mg + row * (cellH + mg);
          cx.fillStyle = '#fff'; cx.fillRect(cellX, cellY, cellW, cellH);
          cx.textAlign = 'left'; cx.font = '800 20px Archivo,Arial'; cx.fillStyle = '#222';
          cx.fillText(c.s.replace('x', ' × ') + ' cm', cellX + ipad, cellY + 30);
          stamp(cx, cellX + cellW - ipad, cellY + 30, c.v);
          var ox = cellX + ipad, oy = cellY + labH, maxH = Math.max(c.rFullH, c.ah + 2 * c.cssB);
          var rOpenY = oy + (maxH - c.rFullH) / 2;
          cx.drawImage(artImg, ox + OL * c.rFullW, rOpenY + OT * c.rFullH, c.aw, c.ah);
          cx.drawImage(frImg, ox, rOpenY, c.rFullW, c.rFullH);
          var rx = ox + c.rFullW + gap, cy = oy + (maxH - (c.ah + 2 * c.cssB)) / 2;
          cx.fillStyle = '#1a1a1a'; cx.fillRect(rx, cy, c.aw + 2 * c.cssB, c.ah + 2 * c.cssB);
          cx.drawImage(artImg, rx + c.cssB, cy + c.cssB, c.aw, c.ah);
          cx.textAlign = 'center'; cx.font = '700 13px Archivo,Arial'; cx.fillStyle = '#999';
          cx.fillText('render', ox + c.rFullW / 2, cellY + cellH - 9);
          cx.fillText('css', rx + (c.aw + 2 * c.cssB) / 2, cellY + cellH - 9);
        });
        cv.toBlob(function (blob) {
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob);
          a.download = 'render-vs-css-' + ORIENT + '-TODAS.png'; document.body.appendChild(a); a.click(); a.remove();
        });
      }
      artImg.onload = go; frImg.onload = go; artImg.onerror = go; frImg.onerror = go;
      artImg.src = curArt(); frImg.src = FRAME_URL;
    }
    function downloadImg() {
      var cs = curSize(); if (!cs) return;
      var p = cs.split('x'); var wcm = +p[0], hcm = +p[1];
      if (ORIENT === 'horizontal') { var t = wcm; wcm = hcm; hcm = t; }
      var SC = 620 / hcm, aw = wcm * SC, ah = hcm * SC, cssB = CSS_PERFIL_CM * SC;
      var rFullW = aw / OW, rFullH = ah / OH;
      var pad = 60, gap = 56, headH = 150;
      var leftW = rFullW, rightW = aw + 2 * cssB;
      var chMax = Math.max(rFullH, ah + 2 * cssB);
      var cw = pad * 2 + leftW + gap + rightW, ch = headH + chMax + pad;
      var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
      var cx = cv.getContext('2d');
      cx.fillStyle = '#e7e3db'; cx.fillRect(0, 0, cw, ch);
      var artImg = new Image(), frImg = new Image(), n = 0;
      function go() {
        if (++n < 2) return;
        cx.fillStyle = '#333'; cx.textAlign = 'center'; cx.font = '800 30px Archivo,Arial';
        cx.fillText(ORIENT + ' · ' + cs.replace('x', ' × ') + ' cm', cw / 2, 48);
        var vv = verdictOf(cs);
        cx.font = '800 22px Archivo,Arial'; cx.fillStyle = vv === 'ok' ? '#3f7d4f' : '#c0392b';
        cx.fillText(vv === 'ok' ? '✓ APROVADO' : ('✗ +' + vv + ' · render ' + renderBorderCm(cs).toFixed(1).replace('.', ',') + 'cm vs 2,0cm'), cw / 2, 86);
        var lx = pad, rx = pad + leftW + gap;
        var rOpenY = headH + (chMax - rFullH) / 2;
        cx.drawImage(artImg, lx + OL * rFullW, rOpenY + OT * rFullH, aw, ah);
        cx.drawImage(frImg, lx, rOpenY, rFullW, rFullH);
        var cy = headH + (chMax - (ah + 2 * cssB)) / 2;
        cx.fillStyle = '#1a1a1a'; cx.fillRect(rx, cy, aw + 2 * cssB, ah + 2 * cssB);
        cx.drawImage(artImg, rx + cssB, cy + cssB, aw, ah);
        cx.fillStyle = '#222'; cx.font = '800 24px Archivo,Arial';
        cx.fillText('render', lx + rFullW / 2, headH - 16);
        cx.fillText('css', rx + (aw + 2 * cssB) / 2, headH - 16);
        cv.toBlob(function (blob) {
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob);
          a.download = 'render-vs-css-' + ORIENT + '-' + cs + '.png'; document.body.appendChild(a); a.click(); a.remove();
        });
      }
      artImg.onload = go; frImg.onload = go;
      artImg.onerror = go; frImg.onerror = go;
      artImg.src = curArt(); frImg.src = FRAME_URL;
    }
    render();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest(':is([data-handle="escolha-o-tamanho-(cm)"],[data-pdp26-opcao="escolha-o-tamanho-(cm)"])')) setTimeout(render, 300);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 800); });
  else setTimeout(start, 800);
})();

